export const ninger = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.23312725722424,
              23.573608165288434
            ],
            [
              101.23240740114565,
              23.562762079861407
            ],
            [
              101.23434188386442,
              23.557841912766097
            ],
            [
              101.23957619799934,
              23.554359001054834
            ],
            [
              101.2609725228923,
              23.525389728545985
            ],
            [
              101.26391505047357,
              23.51105821248788
            ],
            [
              101.26275164513892,
              23.49530321829854
            ],
            [
              101.27191779961139,
              23.46732516465189
            ],
            [
              101.27174423193883,
              23.459814863352808
            ],
            [
              101.27771540283825,
              23.43490346319065
            ],
            [
              101.28187264839661,
              23.36569927132228
            ],
            [
              101.25317690560891,
              23.321941947587305
            ],
            [
              101.25495555148122,
              23.292606073315593
            ],
            [
              101.2415454551185,
              23.2755887617548
            ],
            [
              101.24219555733818,
              23.268064111024657
            ],
            [
              101.24774221685317,
              23.261190874430497
            ],
            [
              101.26005349202607,
              23.25904794284563
            ],
            [
              101.26006747984576,
              23.259044937582466
            ],
            [
              101.2600794693842,
              23.259042932892513
            ],
            [
              101.26036322019917,
              23.258993820846637
            ],
            [
              101.26037620873781,
              23.258990815875478
            ],
            [
              101.26038919724316,
              23.258988810595497
            ],
            [
              101.26722924392324,
              23.25779821306699
            ],
            [
              101.27954622150804,
              23.262061677892945
            ],
            [
              101.29013572282987,
              23.261848279615606
            ],
            [
              101.30295663930129,
              23.252577008291816
            ],
            [
              101.3132426801641,
              23.238846035125093
            ],
            [
              101.3213674848924,
              23.237930069014507
            ],
            [
              101.33534309223622,
              23.242908880149688
            ],
            [
              101.34180119370227,
              23.240521642209092
            ],
            [
              101.34653179598997,
              23.23366337375134
            ],
            [
              101.34858081921925,
              23.216339552675425
            ],
            [
              101.34752141158428,
              23.20584298157338
            ],
            [
              101.34628065592504,
              23.187081778520813
            ],
            [
              101.34736495451817,
              23.16301472239105
            ],
            [
              101.34476088465244,
              23.15630684425285
            ],
            [
              101.33728713729413,
              23.149694046061203
            ],
            [
              101.32792074639485,
              23.131849685845438
            ],
            [
              101.33415332565257,
              23.11970265131476
            ],
            [
              101.35967367563805,
              23.09664076349092
            ],
            [
              101.37093261745358,
              23.09039835271414
            ],
            [
              101.38075150416186,
              23.09245178978161
            ],
            [
              101.4064917409044,
              23.114465437289144
            ],
            [
              101.4390111913773,
              23.112288497663133
            ],
            [
              101.45113043112778,
              23.1082783738838
            ],
            [
              101.47442008903481,
              23.095013674411042
            ],
            [
              101.48877854430417,
              23.08268717161294
            ],
            [
              101.5085262592014,
              23.057469748351735
            ],
            [
              101.51461059859726,
              23.040055941907443
            ],
            [
              101.5135255639143,
              23.028807514042033
            ],
            [
              101.48891667741263,
              23.020312637651298
            ],
            [
              101.46803995656575,
              22.99746039934534
            ],
            [
              101.46764935701101,
              22.980935325780326
            ],
            [
              101.47237960008766,
              22.974823581666666
            ],
            [
              101.48526180100218,
              22.969288583237354
            ],
            [
              101.48586088377922,
              22.96026011814634
            ],
            [
              101.4936825496402,
              22.947317787398664
            ],
            [
              101.51040848167601,
              22.932681876769447
            ],
            [
              101.51667603127602,
              22.92277921943661
            ],
            [
              101.51868556268461,
              22.905445971507902
            ],
            [
              101.5216446996736,
              22.893360129030707
            ],
            [
              101.52404077995104,
              22.89105368044483
            ],
            [
              101.53621940663868,
              22.890792520336777
            ],
            [
              101.54961172244703,
              22.873215323813135
            ],
            [
              101.57782170865342,
              22.863584723616583
            ],
            [
              101.58982349414602,
              22.855814472283217
            ],
            [
              101.58463537672876,
              22.843145035689293
            ],
            [
              101.56723128742934,
              22.829244064721664
            ],
            [
              101.56631109164499,
              22.824754450054744
            ],
            [
              101.57444355605523,
              22.81658882112498
            ],
            [
              101.58700240294937,
              22.81376268648015
            ],
            [
              101.59108210025501,
              22.80885174158859
            ],
            [
              101.59019593205942,
              22.80469993218047
            ],
            [
              101.56795123491452,
              22.792402712854066
            ],
            [
              101.57449743412808,
              22.784645655790722
            ],
            [
              101.57572069403385,
              22.7852386361152
            ],
            [
              101.57711704936736,
              22.78581170708132
            ],
            [
              101.57834517531182,
              22.78594469765751
            ],
            [
              101.57911587702858,
              22.78480468285247
            ],
            [
              101.57926104483235,
              22.78307835519241
            ],
            [
              101.5795663160746,
              22.78250477452294
            ],
            [
              101.57955135494645,
              22.780502408160757
            ],
            [
              101.58093850310755,
              22.779062880959383
            ],
            [
              101.58231954127967,
              22.778199077764246
            ],
            [
              101.58293697370823,
              22.777911553335116
            ],
            [
              101.58617992830224,
              22.777195515040333
            ],
            [
              101.58972649151288,
              22.77660705547357
            ],
            [
              101.59126799796518,
              22.775887695977847
            ],
            [
              101.59249635097578,
              22.77417049186612
            ],
            [
              101.59372462620118,
              22.772734129605457
            ],
            [
              101.59618092216837,
              22.771574662941404
            ],
            [
              101.59787497272933,
              22.770427983764115
            ],
            [
              101.59848497031503,
              22.769561209894817
            ],
            [
              101.5983859983102,
              22.7686694959612
            ],
            [
              101.59802003087962,
              22.767989734287337
            ],
            [
              101.59738608650464,
              22.766276298016514
            ],
            [
              101.59737914158191,
              22.764126960262974
            ],
            [
              101.59798916385395,
              22.76283732417894
            ],
            [
              101.59998009498536,
              22.759538113491733
            ],
            [
              101.60089499735786,
              22.758242348892242
            ],
            [
              101.60335252603898,
              22.755657528254282
            ],
            [
              101.60718923778157,
              22.752355069711204
            ],
            [
              101.61010384757273,
              22.749338458271755
            ],
            [
              101.61102734110096,
              22.748040291419738
            ],
            [
              101.61210268276068,
              22.747462780388645
            ],
            [
              101.614711911971,
              22.745165611061836
            ],
            [
              101.61578809596895,
              22.74445398305905
            ],
            [
              101.61702309360697,
              22.744018098258003
            ],
            [
              101.6173208397799,
              22.74404083954006
            ],
            [
              101.61825204861435,
              22.743150286330728
            ],
            [
              101.61824407035364,
              22.74258145686109
            ],
            [
              101.61731290987693,
              22.741577554001783
            ],
            [
              101.61298728801106,
              22.739879372048133
            ],
            [
              101.6120569105923,
              22.73973903498673
            ],
            [
              101.60509946894877,
              22.736606480245456
            ],
            [
              101.60371092023982,
              22.736332029139756
            ],
            [
              101.60077358138477,
              22.736198795297728
            ],
            [
              101.5972258490761,
              22.7364920977099
            ],
            [
              101.5963028298427,
              22.73635314686928
            ],
            [
              101.59383057097467,
              22.73650194710622
            ],
            [
              101.58997858692143,
              22.737232953800593
            ],
            [
              101.58797178573995,
              22.73809503690172
            ],
            [
              101.58628596212674,
              22.738962085574848
            ],
            [
              101.58534845091447,
              22.7392505557891
            ],
            [
              101.58442489927305,
              22.739822913147986
            ],
            [
              101.58350231886689,
              22.739966354392536
            ],
            [
              101.5824255837624,
              22.74039857828184
            ],
            [
              101.58134279273528,
              22.74069578411776
            ],
            [
              101.57887879608077,
              22.74098888931662
            ],
            [
              101.57717826013237,
              22.740844521485105
            ],
            [
              101.57054098766429,
              22.739725108695104
            ],
            [
              101.56795960423693,
              22.73956101433991
            ],
            [
              101.5640249390699,
              22.73660850984713
            ],
            [
              101.56096504998571,
              22.7347624243342
            ],
            [
              101.56042419567956,
              22.732416223279976
            ],
            [
              101.56089008110759,
              22.728654994740157
            ],
            [
              101.56413940696166,
              22.725279796962024
            ],
            [
              101.56428465613475,
              22.724277275200453
            ],
            [
              101.5650478514116,
              22.722848737099607
            ],
            [
              101.5656577810441,
              22.72198081324552
            ],
            [
              101.56903659767902,
              22.71839015318937
            ],
            [
              101.56949521749198,
              22.717675898542506
            ],
            [
              101.5698006347794,
              22.71681648992872
            ],
            [
              101.57041043326952,
              22.715955433954168
            ],
            [
              101.57071583406149,
              22.715239974226343
            ],
            [
              101.57086804511256,
              22.71438037212486
            ],
            [
              101.57132662661091,
              22.713660079395307
            ],
            [
              101.57208858844837,
              22.711798403538488
            ],
            [
              101.57224078988938,
              22.71093778944495
            ],
            [
              101.57285153204187,
              22.70964677324291
            ],
            [
              101.57314891514994,
              22.707925521813785
            ],
            [
              101.57205768391582,
              22.70664567597152
            ],
            [
              101.57172228978627,
              22.706434359513487
            ],
            [
              101.57037159361128,
              22.70779148074744
            ],
            [
              101.56836596900962,
              22.707939013360974
            ],
            [
              101.56758791757588,
              22.707377165192906
            ],
            [
              101.56619100171312,
              22.70479996784664
            ],
            [
              101.5655661087928,
              22.703944329299393
            ],
            [
              101.56494819443468,
              22.70365654270961
            ],
            [
              101.56248334250168,
              22.703948887963275
            ],
            [
              101.56063727121463,
              22.704672859454686
            ],
            [
              101.55986694291124,
              22.705107521121285
            ],
            [
              101.55708996791095,
              22.705830706857462
            ],
            [
              101.55586165825959,
              22.706410414136215
            ],
            [
              101.55524346902808,
              22.706835204330986
            ],
            [
              101.55339784434489,
              22.70741567650458
            ],
            [
              101.55200104431219,
              22.706562244866227
            ],
            [
              101.5509258309747,
              22.70613726464506
            ],
            [
              101.54999485794605,
              22.70656731563147
            ],
            [
              101.548919532174,
              22.70728796850408
            ],
            [
              101.54692008660577,
              22.70887243078142
            ],
            [
              101.5463107078142,
              22.70915307055742
            ],
            [
              101.54492252610014,
              22.70944601169401
            ],
            [
              101.54122172543525,
              22.709881628992523
            ],
            [
              101.54013805713345,
              22.71017904730616
            ],
            [
              101.53659908984957,
              22.710905427063715
            ],
            [
              101.53505005316305,
              22.71091261714824
            ],
            [
              101.53397419396563,
              22.711479787646965
            ],
            [
              101.53244105069442,
              22.71277657493511
            ],
            [
              101.53121267466443,
              22.714213050914204
            ],
            [
              101.53044254267311,
              22.71492886870448
            ],
            [
              101.52921412174041,
              22.71564946598845
            ],
            [
              101.52645224133528,
              22.719378128415862
            ],
            [
              101.52614735632602,
              22.719951153829754
            ],
            [
              101.52476635614455,
              22.72124305746498
            ],
            [
              101.52414856091401,
              22.721535287452255
            ],
            [
              101.51942862818998,
              22.722615825145283
            ],
            [
              101.51823105182245,
              22.722051569984327
            ],
            [
              101.51359601982428,
              22.719411883998696
            ],
            [
              101.5099929744452,
              22.71565827342566
            ],
            [
              101.50570471094902,
              22.710056946417396
            ],
            [
              101.50021860789168,
              22.703051212189777
            ],
            [
              101.49499346344098,
              22.695593397086437
            ],
            [
              101.48944627625205,
              22.69041501477998
            ],
            [
              101.48583523220933,
              22.687118083084908
            ],
            [
              101.48265861791862,
              22.685434170403898
            ],
            [
              101.47575722811716,
              22.68434070078358
            ],
            [
              101.46985458884188,
              22.68281486033474
            ],
            [
              101.46392575178297,
              22.682202533020657
            ],
            [
              101.45994969984726,
              22.68232865029044
            ],
            [
              101.45599121511849,
              22.682224322393314
            ],
            [
              101.45172858020464,
              22.68371247332257
            ],
            [
              101.44843859151248,
              22.685688102790763
            ],
            [
              101.44400272978315,
              22.692896712765695
            ],
            [
              101.44133775260642,
              22.699003370139582
            ],
            [
              101.43868110997309,
              22.704654392488507
            ],
            [
              101.43521752144329,
              22.712342892394553
            ],
            [
              101.4320930072569,
              22.717295020855353
            ],
            [
              101.4240457788724,
              22.7205152805407
            ],
            [
              101.4162668620065,
              22.72374457053631
            ],
            [
              101.40716071680502,
              22.729225524137593
            ],
            [
              101.40062402541483,
              22.732256710172997
            ],
            [
              101.39403439789487,
              22.736887330109276
            ],
            [
              101.39189051675064,
              22.741863614701487
            ],
            [
              101.39274986965367,
              22.746007116333875
            ],
            [
              101.39557122770942,
              22.75111484483333
            ],
            [
              101.39783811557956,
              22.757582539559852
            ],
            [
              101.39521607995528,
              22.762317558462474
            ],
            [
              101.39210868270206,
              22.766582167398727
            ],
            [
              101.38427786742844,
              22.770952896249156
            ],
            [
              101.37668239167219,
              22.77578462520019
            ],
            [
              101.3726188907574,
              22.778879838636048
            ],
            [
              101.36527538917488,
              22.783491314636617
            ],
            [
              101.35861726903393,
              22.79017661251511
            ],
            [
              101.35594430882729,
              22.79605578666314
            ],
            [
              101.35750608446531,
              22.80181741766189
            ],
            [
              101.35908692134757,
              22.806438443297324
            ],
            [
              101.35913864442851,
              22.81284715695559
            ],
            [
              101.35897381699306,
              22.81787664941157
            ],
            [
              101.35906949472427,
              22.822911730676864
            ],
            [
              101.36039785679446,
              22.82798095529554
            ],
            [
              101.36035468140827,
              22.83713371453546
            ],
            [
              101.36014588543244,
              22.84376459317814
            ],
            [
              101.3564477892528,
              22.85075761793449
            ],
            [
              101.35012041998931,
              22.86248652797587
            ],
            [
              101.34569282524114,
              22.869005717315364
            ],
            [
              101.33911358099343,
              22.872949139814597
            ],
            [
              101.33382686154899,
              22.87509823278681
            ],
            [
              101.3262836439374,
              22.87809741209557
            ],
            [
              101.31656172722111,
              22.879438366720134
            ],
            [
              101.3046610318492,
              22.87912003086993
            ],
            [
              101.29285587120269,
              22.875826366547177
            ],
            [
              101.28524312237734,
              22.873330895285168
            ],
            [
              101.28132881632837,
              22.871395445693636
            ],
            [
              101.27303037632842,
              22.867053727285583
            ],
            [
              101.2669110816638,
              22.86436963091294
            ],
            [
              101.26402927742785,
              22.8613156304728
            ],
            [
              101.25817871031953,
              22.857952703244855
            ],
            [
              101.25284050852402,
              22.85437648810993
            ],
            [
              101.2481618544105,
              22.853105338617997
            ],
            [
              101.2424765021826,
              22.852490903123304
            ],
            [
              101.2345606607222,
              22.8518172026441
            ],
            [
              101.2271656600804,
              22.850243964052254
            ],
            [
              101.22200108270486,
              22.848956944962023
            ],
            [
              101.2153864843899,
              22.84603000049641
            ],
            [
              101.21265233752304,
              22.838632420910415
            ],
            [
              101.2121310462838,
              22.83175226191062
            ],
            [
              101.21394471248999,
              22.82951330464644
            ],
            [
              101.21983036488356,
              22.823954872629145
            ],
            [
              101.22670529517067,
              22.818653031649564
            ],
            [
              101.23351845948159,
              22.815175875919877
            ],
            [
              101.23787696649252,
              22.811199338026306
            ],
            [
              101.24142578041656,
              22.80992595214886
            ],
            [
              101.24432426825658,
              22.80852704143352
            ],
            [
              101.24950358311106,
              22.803570027796763
            ],
            [
              101.24907579197604,
              22.802874278529416
            ],
            [
              101.24880693379174,
              22.801892616744794
            ],
            [
              101.24848414483044,
              22.7990155904073
            ],
            [
              101.2479733584656,
              22.798719686552115
            ],
            [
              101.24711268314837,
              22.798665676643964
            ],
            [
              101.2462369791281,
              22.79876158694558
            ],
            [
              101.24497234779508,
              22.79907834601895
            ],
            [
              101.2442955188959,
              22.799247192327375
            ],
            [
              101.24306977977932,
              22.7996488374646
            ],
            [
              101.24190896651244,
              22.800229381416028
            ],
            [
              101.2395441919928,
              22.801025425223706
            ],
            [
              101.23855521387105,
              22.801627871884588
            ],
            [
              101.23659811866581,
              22.80379933620427
            ],
            [
              101.2357380389167,
              22.80440173517346
            ],
            [
              101.23489994851491,
              22.804423315674416
            ],
            [
              101.23421186018645,
              22.80420803132982
            ],
            [
              101.23322268936687,
              22.80435843581246
            ],
            [
              101.23244853273327,
              22.80435898486261
            ],
            [
              101.23193241907978,
              22.80422971632715
            ],
            [
              101.23124426316798,
              22.803627489517858
            ],
            [
              101.2307071167807,
              22.803627140977902
            ],
            [
              101.2301259416971,
              22.803799693519057
            ],
            [
              101.22816923523055,
              22.805326776709435
            ],
            [
              101.22715983360247,
              22.805433967198656
            ],
            [
              101.22642752840896,
              22.80515447969492
            ],
            [
              101.22569718787585,
              22.805519755472247
            ],
            [
              101.22444953380946,
              22.80721910808909
            ],
            [
              101.22330992730035,
              22.807283066334183
            ],
            [
              101.22236439891499,
              22.806982290361724
            ],
            [
              101.2210095795776,
              22.806875016397324
            ],
            [
              101.21965569115922,
              22.807047588132818
            ],
            [
              101.21864499194008,
              22.807025535458664
            ],
            [
              101.21754720952052,
              22.806424553174907
            ],
            [
              101.21698879073703,
              22.806337964163163
            ],
            [
              101.21642935152423,
              22.806617239309976
            ],
            [
              101.21584887646767,
              22.807241362574974
            ],
            [
              101.21533345916039,
              22.807283750762966
            ],
            [
              101.21483805578126,
              22.807112227920182
            ],
            [
              101.21408543791955,
              22.806488543869712
            ],
            [
              101.21318270621359,
              22.804510120559662
            ],
            [
              101.21109683293216,
              22.803327895032965
            ],
            [
              101.21062439683527,
              22.802833450720716
            ],
            [
              101.20843024520224,
              22.80216675394109
            ],
            [
              101.20509771221245,
              22.801651247780445
            ],
            [
              101.20374318937608,
              22.801607281012487
            ],
            [
              101.20174386820028,
              22.801199414659393
            ],
            [
              101.1999597079762,
              22.80119965733004
            ],
            [
              101.19836771541813,
              22.801393073899156
            ],
            [
              101.19703499495269,
              22.801973729534506
            ],
            [
              101.19570122466125,
              22.803027188028334
            ],
            [
              101.1949061598519,
              22.803392745819416
            ],
            [
              101.19428232021282,
              22.803521659718637
            ],
            [
              101.19312174624959,
              22.803500709462647
            ],
            [
              101.19256297006307,
              22.803866634479622
            ],
            [
              101.19228257547404,
              22.804167053322978
            ],
            [
              101.19204621840402,
              22.805307260163502
            ],
            [
              101.19191700521246,
              22.806596598105642
            ],
            [
              101.19217533638108,
              22.807607694755625
            ],
            [
              101.19228346255022,
              22.808489577180183
            ],
            [
              101.1921752817858,
              22.809671985355024
            ],
            [
              101.19258381479088,
              22.810833283087778
            ],
            [
              101.19322867885977,
              22.81158611934916
            ],
            [
              101.19372434427864,
              22.81192983835601
            ],
            [
              101.19456247931167,
              22.811757305143882
            ],
            [
              101.19542262426772,
              22.81182171377838
            ],
            [
              101.19572401192474,
              22.812231070239157
            ],
            [
              101.19578808165825,
              22.812789982252323
            ],
            [
              101.19555175320237,
              22.813413375769926
            ],
            [
              101.19380939940477,
              22.814209190955506
            ],
            [
              101.19329367444986,
              22.815112005530764
            ],
            [
              101.19236937899693,
              22.816144072906518
            ],
            [
              101.19215406043269,
              22.816940426209317
            ],
            [
              101.19161629180644,
              22.817779209208858
            ],
            [
              101.1916813454296,
              22.819176830760505
            ],
            [
              101.19213294315941,
              22.820273220326662
            ],
            [
              101.19303614765943,
              22.82173524515437
            ],
            [
              101.19310022451702,
              22.82214420941134
            ],
            [
              101.192927964276,
              22.823068589771395
            ],
            [
              101.19307814946264,
              22.82384257054711
            ],
            [
              101.19355176411969,
              22.82502495260935
            ],
            [
              101.19419661551868,
              22.82584274727334
            ],
            [
              101.19443292049006,
              22.82633696719397
            ],
            [
              101.19423964340548,
              22.826982413157413
            ],
            [
              101.19363781003514,
              22.827713139626216
            ],
            [
              101.19299289471498,
              22.829068562557758
            ],
            [
              101.1923479585265,
              22.830938792121756
            ],
            [
              101.19221876241772,
              22.831605331275018
            ],
            [
              101.19245507390559,
              22.832164533834135
            ],
            [
              101.19361665177,
              22.832616343240563
            ],
            [
              101.19378787390912,
              22.833002492665475
            ],
            [
              101.19368071491162,
              22.833519125392566
            ],
            [
              101.19332322192096,
              22.833769430742844
            ],
            [
              101.19295772310886,
              22.833739821475948
            ],
            [
              101.18956397743786,
              22.83377894752276
            ],
            [
              101.18876580736062,
              22.834850156396396
            ],
            [
              101.18795262555048,
              22.835201590044598
            ],
            [
              101.18703228334697,
              22.835366890829008
            ],
            [
              101.18655257478828,
              22.835626937765436
            ],
            [
              101.18609687948903,
              22.836611761784752
            ],
            [
              101.18575534776573,
              22.83768775535737
            ],
            [
              101.18544086769884,
              22.838271974999472
            ],
            [
              101.18520751778213,
              22.838439492079782
            ],
            [
              101.18403877373541,
              22.838610307781334
            ],
            [
              101.1826787503488,
              22.83790007930539
            ],
            [
              101.18223508229543,
              22.837823291940513
            ],
            [
              101.18193161989346,
              22.83793769154618
            ],
            [
              101.18135973691352,
              22.838506429093353
            ],
            [
              101.18082391114018,
              22.83888729897948
            ],
            [
              101.18042329527992,
              22.839057494261652
            ],
            [
              101.17749978368686,
              22.839676813766285
            ],
            [
              101.1762208009314,
              22.83970839974461
            ],
            [
              101.17554374473995,
              22.83986306820801
            ],
            [
              101.17514011679748,
              22.83986030819514
            ],
            [
              101.17486168827584,
              22.83967185173789
            ],
            [
              101.17442702583375,
              22.839114234726505
            ],
            [
              101.17407347260044,
              22.8391875399664
            ],
            [
              101.17357966155839,
              22.84071104934871
            ],
            [
              101.17294862955671,
              22.842464212544137
            ],
            [
              101.17267318993333,
              22.842814562396175
            ],
            [
              101.17240276432649,
              22.842929008231845
            ],
            [
              101.17202717970876,
              22.842839329727013
            ],
            [
              101.1715574628462,
              22.84218567971643
            ],
            [
              101.17121393274054,
              22.841924124583226
            ],
            [
              101.17050582177244,
              22.842070728387075
            ],
            [
              101.16996698090499,
              22.84201772620779
            ],
            [
              101.16953030848147,
              22.8416440353788
            ],
            [
              101.16842559358858,
              22.841262081446015
            ],
            [
              101.16729583151913,
              22.841286932558834
            ],
            [
              101.16620414011317,
              22.841029961643073
            ],
            [
              101.16472693041428,
              22.840254512400758
            ],
            [
              101.16362124093936,
              22.839804600450236
            ],
            [
              101.16333781078869,
              22.839626134396926
            ],
            [
              101.16274091670427,
              22.838876290830246
            ],
            [
              101.16195873592616,
              22.838384009428587
            ],
            [
              101.16069983477644,
              22.8380058045518
            ],
            [
              101.15952106301602,
              22.83781968963801
            ],
            [
              101.1583823616107,
              22.837752616785387
            ],
            [
              101.1579937726339,
              22.83816075512588
            ],
            [
              101.15777142892289,
              22.83867316100743
            ],
            [
              101.15756912529433,
              22.83881773810324
            ],
            [
              101.15726367222423,
              22.838869161225706
            ],
            [
              101.15663574854564,
              22.83881803559584
            ],
            [
              101.15553314270896,
              22.838573126014847
            ],
            [
              101.15392281798484,
              22.838544242857377
            ],
            [
              101.15372052544276,
              22.838656840570934
            ],
            [
              101.15370650008396,
              22.838854743346822
            ],
            [
              101.15449061608008,
              22.839205018408524
            ],
            [
              101.15464182475277,
              22.839554162318315
            ],
            [
              101.15413206000666,
              22.840709825757084
            ],
            [
              101.1543213015605,
              22.841843749118446
            ],
            [
              101.15375544377468,
              22.843563105491704
            ],
            [
              101.1523644332874,
              22.844890146963557
            ],
            [
              101.15063899939183,
              22.845904747022765
            ],
            [
              101.1493412103566,
              22.84637432780678
            ],
            [
              101.14864426452424,
              22.84654207105049
            ],
            [
              101.14505356423359,
              22.846625020384607
            ],
            [
              101.14433765266844,
              22.84689574897217
            ],
            [
              101.1442144921732,
              22.847121464969046
            ],
            [
              101.14397118031518,
              22.847410962643256
            ],
            [
              101.14370684289237,
              22.847730416382575
            ],
            [
              101.14343950470393,
              22.847999885187683
            ],
            [
              101.14325727725203,
              22.84810455322377
            ],
            [
              101.14285677987657,
              22.848341823366116
            ],
            [
              101.1418635713683,
              22.848611146359687
            ],
            [
              101.14075726504302,
              22.848480463537967
            ],
            [
              101.13829144320212,
              22.849012508066213
            ],
            [
              101.13710713868484,
              22.849517567413802
            ],
            [
              101.13631829522362,
              22.84970934794009
            ],
            [
              101.13575769972583,
              22.85009739734459
            ],
            [
              101.13547940251642,
              22.850472860391832
            ],
            [
              101.13510300984946,
              22.85076821639881
            ],
            [
              101.13393784817916,
              22.850665625381346
            ],
            [
              101.13309603848343,
              22.850433557620203
            ],
            [
              101.13220419378146,
              22.850579302078856
            ],
            [
              101.13172975201016,
              22.850749608759852
            ],
            [
              101.1309099980776,
              22.851318323728204
            ],
            [
              101.13056769565186,
              22.85133287597179
            ],
            [
              101.13022540407849,
              22.85108652890331
            ],
            [
              101.12990112904934,
              22.850939171221523
            ],
            [
              101.12942872718718,
              22.850997554033032
            ],
            [
              101.12870011683151,
              22.851274545614313
            ],
            [
              101.1280205528207,
              22.85193247058203
            ],
            [
              101.12765826555386,
              22.85202399993505
            ],
            [
              101.12702478074453,
              22.851937278892308
            ],
            [
              101.12654641839995,
              22.85207366745032
            ],
            [
              101.12620215629359,
              22.852404145169558
            ],
            [
              101.12598298404255,
              22.852893710298677
            ],
            [
              101.12566374978114,
              22.85310426732515
            ],
            [
              101.12473710700348,
              22.853100230163392
            ],
            [
              101.12323312538375,
              22.8532605446076
            ],
            [
              101.12118890925993,
              22.854083149689917
            ],
            [
              101.12084372222033,
              22.85412179699803
            ],
            [
              101.1205735832685,
              22.853995582469075
            ],
            [
              101.11984021564109,
              22.853822949340508
            ],
            [
              101.11822446797233,
              22.85388045812512
            ],
            [
              101.11742913580105,
              22.85398772918029
            ],
            [
              101.11584853853604,
              22.854675171896556
            ],
            [
              101.11502828013295,
              22.854614556801316
            ],
            [
              101.11387595997513,
              22.854686676763396
            ],
            [
              101.11329882646598,
              22.854503337314355
            ],
            [
              101.11241064182815,
              22.854467747639163
            ],
            [
              101.1113104716969,
              22.853984224412002
            ],
            [
              101.11066538649862,
              22.854057806030806
            ],
            [
              101.10970727906967,
              22.854693018085378
            ],
            [
              101.10914324052392,
              22.854848653127853
            ],
            [
              101.10859221895313,
              22.85490634431995
            ],
            [
              101.10827621514115,
              22.854847207334767
            ],
            [
              101.1079622190862,
              22.854665121454296
            ],
            [
              101.10772522056953,
              22.854689998451274
            ],
            [
              101.1076312185434,
              22.854821904553877
            ],
            [
              101.1075362033865,
              22.855453623056547
            ],
            [
              101.10738920064163,
              22.855696463688147
            ],
            [
              101.1070562053286,
              22.855976207373526
            ],
            [
              101.10641723341858,
              22.856322799637002
            ],
            [
              101.1051793524213,
              22.856547225598245
            ],
            [
              101.10480139888145,
              22.856754011031306
            ],
            [
              101.10449943451994,
              22.857146758279416
            ],
            [
              101.10231087574154,
              22.85786784024032
            ],
            [
              101.1011711896207,
              22.858384389353535
            ],
            [
              101.10092028645654,
              22.857775569798996
            ],
            [
              101.10077533632588,
              22.857697572123225
            ],
            [
              101.10003759089312,
              22.85783739579855
            ],
            [
              101.09983466818454,
              22.85777339000329
            ],
            [
              101.09828234549109,
              22.85648670435747
            ],
            [
              101.097507720196,
              22.856069815507787
            ],
            [
              101.09701596776924,
              22.855995828033457
            ],
            [
              101.09603448433603,
              22.856298715514875
            ],
            [
              101.09570666477876,
              22.856488654001524
            ],
            [
              101.09513198044291,
              22.85730737482065
            ],
            [
              101.09466925400677,
              22.857678268950874
            ],
            [
              101.09332312901515,
              22.858010296082558
            ],
            [
              101.09208001212168,
              22.858433348840464
            ],
            [
              101.09110476754464,
              22.858401575639686
            ],
            [
              101.0904912618637,
              22.858556674147653
            ],
            [
              101.08973787960477,
              22.85928361578883
            ],
            [
              101.0894501151678,
              22.859847492042576
            ],
            [
              101.0892143170705,
              22.860093474962635
            ],
            [
              101.08781158368267,
              22.861224550265526
            ],
            [
              101.08622015157421,
              22.862008931577446
            ],
            [
              101.08487758248805,
              22.862264496177527
            ],
            [
              101.08372587697683,
              22.862630989692807
            ],
            [
              101.08343521671827,
              22.862624161418907
            ],
            [
              101.08282095455304,
              22.862383622704147
            ],
            [
              101.08215578420784,
              22.861766276735445
            ],
            [
              101.08054485875451,
              22.861208588222137
            ],
            [
              101.08021329972205,
              22.861164845824828
            ],
            [
              101.07910480283911,
              22.86140959515203
            ],
            [
              101.07864245043807,
              22.861409962634895
            ],
            [
              101.07783759307492,
              22.861774487537843
            ],
            [
              101.0760871986069,
              22.862174878503478
            ],
            [
              101.07534136978593,
              22.861776728649254
            ],
            [
              101.0746724296167,
              22.86193031882946
            ],
            [
              101.0741163391625,
              22.86161699182036
            ],
            [
              101.0730830476021,
              22.86183797469608
            ],
            [
              101.0722734211534,
              22.862060759247207
            ],
            [
              101.07114539723405,
              22.862020033972797
            ],
            [
              101.06799921940049,
              22.862374708413512
            ],
            [
              101.06588037799209,
              22.863653031892742
            ],
            [
              101.06354419680784,
              22.865456666551793
            ],
            [
              101.0616662304322,
              22.86777461955305
            ],
            [
              101.06135985799594,
              22.869865296140226
            ],
            [
              101.06138774540683,
              22.871741532244886
            ],
            [
              101.05237171303376,
              22.87173327284518
            ],
            [
              101.04161608202872,
              22.88020279775009
            ],
            [
              101.02843009507593,
              22.88036573899324
            ],
            [
              101.01935862273666,
              22.87296681968962
            ],
            [
              100.99895986898835,
              22.87790486544742
            ],
            [
              100.98793579441616,
              22.88744044006858
            ],
            [
              100.9850892337502,
              22.901583337131598
            ],
            [
              100.98332859973533,
              22.91209533086587
            ],
            [
              100.97001280066576,
              22.920481715637415
            ],
            [
              100.9591109580236,
              22.931987981353313
            ],
            [
              100.94693299853232,
              22.932131834332235
            ],
            [
              100.92860887117378,
              22.927056778082964
            ],
            [
              100.9204418655944,
              22.92965740706974
            ],
            [
              100.91456480134161,
              22.937050777292555
            ],
            [
              100.90872393445149,
              22.947661225115954
            ],
            [
              100.90382785917053,
              22.95367291548817
            ],
            [
              100.90348808879699,
              22.954074790897995
            ],
            [
              100.9033081942551,
              22.954884474900897
            ],
            [
              100.90279451965048,
              22.95578315154693
            ],
            [
              100.90258063622167,
              22.95681074174062
            ],
            [
              100.90268853580706,
              22.958095198909003
            ],
            [
              100.90230275872717,
              22.959250746052366
            ],
            [
              100.90142526947187,
              22.960577233057105
            ],
            [
              100.90065470325055,
              22.96107003439194
            ],
            [
              100.89838683351516,
              22.96177660860805
            ],
            [
              100.89761615995354,
              22.962119370150887
            ],
            [
              100.89673849198059,
              22.96276096254769
            ],
            [
              100.89633162172986,
              22.96357454703235
            ],
            [
              100.89613966088685,
              22.96479399979487
            ],
            [
              100.89560382769709,
              22.965328661055995
            ],
            [
              100.89500500925637,
              22.96545746363877
            ],
            [
              100.8937213581358,
              22.96507226523103
            ],
            [
              100.89305750334803,
              22.96511503433667
            ],
            [
              100.89198768387884,
              22.9656724194885
            ],
            [
              100.89132377545373,
              22.96577911382666
            ],
            [
              100.89081084051678,
              22.965522006945687
            ],
            [
              100.88978295831005,
              22.96402417021451
            ],
            [
              100.88956897366492,
              22.96385313998286
            ],
            [
              100.88903399081617,
              22.96395983334194
            ],
            [
              100.88858499109901,
              22.964238488120962
            ],
            [
              100.88804996230253,
              22.96532974923107
            ],
            [
              100.8875579143294,
              22.966784870782792
            ],
            [
              100.88691586455269,
              22.967448225719952
            ],
            [
              100.88608079121819,
              22.96753368695779
            ],
            [
              100.88526769503794,
              22.967448206455277
            ],
            [
              100.88428354861597,
              22.96702072570407
            ],
            [
              100.88406951665517,
              22.966699711429772
            ],
            [
              100.8842405721008,
              22.96567225919207
            ],
            [
              100.88406955533652,
              22.965030408440263
            ],
            [
              100.88372649909904,
              22.964559363546776
            ],
            [
              100.88336342764266,
              22.96434519242414
            ],
            [
              100.88067770348403,
              22.963923286387356
            ],
            [
              100.8798744317359,
              22.96372469423556
            ],
            [
              100.87856893533503,
              22.963403680811048
            ],
            [
              100.87690021170043,
              22.96265443757157
            ],
            [
              100.87621488630221,
              22.962226948414838
            ],
            [
              100.8758737140227,
              22.962171633135036
            ],
            [
              100.8749101925284,
              22.962505516749477
            ],
            [
              100.87420380041851,
              22.96222689635836
            ],
            [
              100.8726839152654,
              22.96075086992987
            ],
            [
              100.87225564715814,
              22.960493500805583
            ],
            [
              100.87148514216486,
              22.960300709095815
            ],
            [
              100.86881021777297,
              22.960129606504363
            ],
            [
              100.86784746864252,
              22.95995848127813
            ],
            [
              100.86705583508213,
              22.9595946280867
            ],
            [
              100.86461577638242,
              22.957626235393512
            ],
            [
              100.86343871077841,
              22.95697189799861
            ],
            [
              100.86266999050963,
              22.95663196775159
            ],
            [
              100.86227462159754,
              22.956100631312374
            ],
            [
              100.8622406073401,
              22.95529291881138
            ],
            [
              100.86209047614255,
              22.954650972623497
            ],
            [
              100.86123464934911,
              22.95385907684152
            ],
            [
              100.86067809657231,
              22.953516412552617
            ],
            [
              100.8597361334517,
              22.9532811272818
            ],
            [
              100.85866602184912,
              22.952510849187718
            ],
            [
              100.85810945973387,
              22.95090567288856
            ],
            [
              100.85804540365777,
              22.95032781498869
            ],
            [
              100.85716745582587,
              22.94966474544903
            ],
            [
              100.85629047425404,
              22.94966438514375
            ],
            [
              100.85502801375517,
              22.9502851394191
            ],
            [
              100.85445032995663,
              22.95069204934449
            ],
            [
              100.85265214326947,
              22.952361444460625
            ],
            [
              100.8519462527262,
              22.95355978607441
            ],
            [
              100.85128239888196,
              22.95497309845355
            ],
            [
              100.85079074212372,
              22.95681351302628
            ],
            [
              100.85051238241839,
              22.957240868744794
            ],
            [
              100.84991361684484,
              22.95758371773994
            ],
            [
              100.84886426730154,
              22.95779784608889
            ],
            [
              100.84576114719547,
              22.9589319962417
            ],
            [
              100.84484089792944,
              22.9591033018057
            ],
            [
              100.84351406294843,
              22.959809646717996
            ],
            [
              100.84264985860585,
              22.960069988055626
            ],
            [
              100.84203700167646,
              22.96010886685728
            ],
            [
              100.8414381654255,
              22.959894871912635
            ],
            [
              100.84090341832002,
              22.959553042720554
            ],
            [
              100.84028254169938,
              22.95935999114502
            ],
            [
              100.83961859489568,
              22.959338785006054
            ],
            [
              100.83786405825998,
              22.959766375590895
            ],
            [
              100.83735031550546,
              22.959638477392932
            ],
            [
              100.83666533038316,
              22.959081437284702
            ],
            [
              100.83600238996785,
              22.95781872814052
            ],
            [
              100.8355097098377,
              22.955978573649045
            ],
            [
              100.83559586051567,
              22.954951161419054
            ],
            [
              100.83598044201759,
              22.954223181444405
            ],
            [
              100.83645114421023,
              22.953667289181894
            ],
            [
              100.83762788058007,
              22.952724865072515
            ],
            [
              100.83782216934038,
              22.952427348119667
            ],
            [
              100.83784220593628,
              22.95210451908639
            ],
            [
              100.83756481256862,
              22.951719165381434
            ],
            [
              100.83696494690409,
              22.951420176674066
            ],
            [
              100.83574518710805,
              22.95037134014443
            ],
            [
              100.8348889518554,
              22.94932217400234
            ],
            [
              100.83466863880328,
              22.948809973411343
            ],
            [
              100.83465363222668,
              22.94814522041899
            ],
            [
              100.83508130305724,
              22.946432729480893
            ],
            [
              100.83506029114128,
              22.945620026036067
            ],
            [
              100.83471779964047,
              22.945042623308254
            ],
            [
              100.83431120551994,
              22.944763976156416
            ],
            [
              100.83333876798113,
              22.944613211494726
            ],
            [
              100.83273486743275,
              22.944727027411247
            ],
            [
              100.83210598144822,
              22.945032769228934
            ],
            [
              100.8315501522698,
              22.945106691442007
            ],
            [
              100.82846854478174,
              22.9451058694179
            ],
            [
              100.82786964116204,
              22.945341638500555
            ],
            [
              100.82688514945036,
              22.94596251820963
            ],
            [
              100.82566529868403,
              22.946818855143853
            ],
            [
              100.8251725463345,
              22.947374692910014
            ],
            [
              100.82495921424687,
              22.947889076568387
            ],
            [
              100.82482999882576,
              22.94880845169427
            ],
            [
              100.82482997661216,
              22.94975106135354
            ],
            [
              100.82433821968145,
              22.950585785710178
            ],
            [
              100.82372228340307,
              22.951156385315368
            ],
            [
              100.8238344400856,
              22.95163639819588
            ],
            [
              100.82397161076248,
              22.95311504405596
            ],
            [
              100.82413484347782,
              22.953619143322733
            ],
            [
              100.82480683407776,
              22.954333117411302
            ],
            [
              100.82524246667155,
              22.955218573726647
            ],
            [
              100.8253325897158,
              22.95573552946755
            ],
            [
              100.82534358754027,
              22.956529220422176
            ],
            [
              100.82523640887054,
              22.957288701879193
            ],
            [
              100.82529446366925,
              22.958661240775196
            ],
            [
              100.82510517031261,
              22.959059716827074
            ],
            [
              100.82421682184037,
              22.9597567468349
            ],
            [
              100.82268448697542,
              22.96149712874186
            ],
            [
              100.82256423889652,
              22.964397692662164
            ],
            [
              100.82264935251817,
              22.96497461243173
            ],
            [
              100.82288770217018,
              22.965259942909558
            ],
            [
              100.82320116778176,
              22.96540147534596
            ],
            [
              100.8250319150508,
              22.965236004091288
            ],
            [
              100.8253844406508,
              22.96537561276334
            ],
            [
              100.82633884095895,
              22.966736850785555
            ],
            [
              100.82615554538724,
              22.967606140737715
            ],
            [
              100.82570184054019,
              22.96862185761361
            ],
            [
              100.82582801290675,
              22.969343794655178
            ],
            [
              100.82575689511923,
              22.969813463707737
            ],
            [
              100.82548748308523,
              22.97014181657833
            ],
            [
              100.82459713618164,
              22.970620932025476
            ],
            [
              100.82340132195935,
              22.971573274112636
            ],
            [
              100.82246090159998,
              22.972157255571357
            ],
            [
              100.82141934855719,
              22.972101317681894
            ],
            [
              100.82122605711933,
              22.972247892864377
            ],
            [
              100.82111288257201,
              22.972502573539405
            ],
            [
              100.82108180877223,
              22.973670026460074
            ],
            [
              100.82096162006137,
              22.97408562660109
            ],
            [
              100.82052094563527,
              22.974892461228116
            ],
            [
              100.81998413224757,
              22.975584164805664
            ],
            [
              100.81999113069342,
              22.976089966009003
            ],
            [
              100.82023247529777,
              22.97666517738935
            ],
            [
              100.82059099527676,
              22.97720162518939
            ],
            [
              100.82059499523272,
              22.97745552627396
            ],
            [
              100.82013429714996,
              22.978038417710433
            ],
            [
              100.82002112237086,
              22.978328084134315
            ],
            [
              100.82018435186932,
              22.978868163647263
            ],
            [
              100.81991894436442,
              22.97944842286777
            ],
            [
              100.81984882673096,
              22.98002704881469
            ],
            [
              100.81997200513435,
              22.980208203590895
            ],
            [
              100.82055586719116,
              22.980417210852252
            ],
            [
              100.82067504101347,
              22.980559374917526
            ],
            [
              100.82032951889974,
              22.980924573294757
            ],
            [
              100.81971059108487,
              22.98132924359991
            ],
            [
              100.81971459019236,
              22.981618129859328
            ],
            [
              100.82007210769255,
              22.98215557405744
            ],
            [
              100.82054580281913,
              22.98251131319588
            ],
            [
              100.82125184599948,
              22.982827506781792
            ],
            [
              100.82137101931123,
              22.98300765525373
            ],
            [
              100.82137501845631,
              22.98329654149489
            ],
            [
              100.82126184384448,
              22.983550222167082
            ],
            [
              100.82053173761639,
              22.98438849866524
            ],
            [
              100.82028235251165,
              22.985006771138195
            ],
            [
              100.81703055328431,
              22.985097666469894
            ],
            [
              100.81439872013826,
              22.98552263661088
            ],
            [
              100.8089890576579,
              22.987084234448904
            ],
            [
              100.80867562394013,
              22.987230619396033
            ],
            [
              100.80697528479809,
              22.988515101010158
            ],
            [
              100.8043427404159,
              22.991091493556123
            ],
            [
              100.80372392186337,
              22.991811143961044
            ],
            [
              100.800169417728,
              22.993521544202256
            ],
            [
              100.79893292491037,
              22.99351755713855
            ],
            [
              100.79839828633004,
              22.9936526500477
            ],
            [
              100.79727093008061,
              22.995214219838253
            ],
            [
              100.79647998361632,
              22.99681731746868
            ],
            [
              100.79636381682646,
              22.998269527112807
            ],
            [
              100.79660805571663,
              22.999922208505957
            ],
            [
              100.797239737619,
              23.00177740872481
            ],
            [
              100.79755909178388,
              23.002465618332682
            ],
            [
              100.79800962013246,
              23.002395356094073
            ],
            [
              100.79869444007632,
              23.00194363092117
            ],
            [
              100.79951041962909,
              23.001855972827745
            ],
            [
              100.80000201952355,
              23.001680839272566
            ],
            [
              100.80085507720331,
              23.001175438932428
            ],
            [
              100.8018583465671,
              23.000302455436923
            ],
            [
              100.80218075583684,
              23.000142056881096
            ],
            [
              100.80264734668576,
              23.000119842298798
            ],
            [
              100.80266036126136,
              23.00020182948793
            ],
            [
              100.80058969433823,
              23.003526747421244
            ],
            [
              100.80032134186293,
              23.004508896767923
            ],
            [
              100.80073284193755,
              23.00472647480584
            ],
            [
              100.80302270510265,
              23.005144084418717
            ],
            [
              100.80311881896017,
              23.005520086833034
            ],
            [
              100.80243894590605,
              23.00586280699192
            ],
            [
              100.80164693276592,
              23.00656619839524
            ],
            [
              100.80048347920382,
              23.007085073746403
            ],
            [
              100.80017709383444,
              23.00752239177129
            ],
            [
              100.79995379427791,
              23.00867754312815
            ],
            [
              100.80001386147732,
              23.008924536088635
            ],
            [
              100.80058254791187,
              23.009309296924783
            ],
            [
              100.80070068207868,
              23.00977829167843
            ],
            [
              100.80062457347496,
              23.010405902905696
            ],
            [
              100.80034020274881,
              23.01132205391294
            ],
            [
              100.79935095762374,
              23.013187670276526
            ],
            [
              100.7990125250877,
              23.014300659164906
            ],
            [
              100.79886231235305,
              23.015698829933267
            ],
            [
              100.79887730225386,
              23.016873358681377
            ],
            [
              100.79852180967826,
              23.019801558874743
            ],
            [
              100.79830053883408,
              23.020182047805793
            ],
            [
              100.79796613927681,
              23.02043341378296
            ],
            [
              100.79768480846201,
              23.020501942443325
            ],
            [
              100.7947104386869,
              23.02054935034752
            ],
            [
              100.79410477569874,
              23.020673391626968
            ],
            [
              100.79372836436552,
              23.020912731764472
            ],
            [
              100.79307864718679,
              23.021977326247324
            ],
            [
              100.79189838636071,
              23.023309052976547
            ],
            [
              100.79171919508354,
              23.023637657601526
            ],
            [
              100.79141085173539,
              23.024880693802682
            ],
            [
              100.79127270699263,
              23.02509140857861
            ],
            [
              100.79069912442817,
              23.025423458061177
            ],
            [
              100.78818769145533,
              23.026378606351777
            ],
            [
              100.78759314944855,
              23.026267860821267
            ],
            [
              100.78656423006716,
              23.026305496832645
            ],
            [
              100.78328148069842,
              23.027543873193572
            ],
            [
              100.78219063310543,
              23.028260277674196
            ],
            [
              100.78162921520673,
              23.028475534930465
            ],
            [
              100.78123492999904,
              23.02853205880605
            ],
            [
              100.78075459331292,
              23.02843355556932
            ],
            [
              100.78036731853226,
              23.028720001004444
            ],
            [
              100.77990199775785,
              23.028942392026106
            ],
            [
              100.77972586943548,
              23.02939200951132
            ],
            [
              100.78034426614585,
              23.030247332738025
            ],
            [
              100.78030422102908,
              23.030986977044716
            ],
            [
              100.78048133029712,
              23.031499958885973
            ],
            [
              100.78119481594221,
              23.032099512434478
            ],
            [
              100.7814059598237,
              23.03240162679999
            ],
            [
              100.78147498058165,
              23.03361019794545
            ],
            [
              100.78199535002547,
              23.034037620046533
            ],
            [
              100.78228855548919,
              23.034549747464887
            ],
            [
              100.78282195563939,
              23.03467132626829
            ],
            [
              100.78325828541843,
              23.034945732490336
            ],
            [
              100.78385676003921,
              23.034793520860745
            ],
            [
              100.7843141277882,
              23.034778087987224
            ],
            [
              100.78566123245724,
              23.03537852188938
            ],
            [
              100.78613461416953,
              23.036400697252216
            ],
            [
              100.78612056122913,
              23.038104963583717
            ],
            [
              100.78618861580925,
              23.038285975025758
            ],
            [
              100.78740867351968,
              23.039185186768933
            ],
            [
              100.78725652848964,
              23.039522844665033
            ],
            [
              100.78759181976658,
              23.040000086909206
            ],
            [
              100.7875547740151,
              23.0405078248603
            ],
            [
              100.7876608635581,
              23.040791846260017
            ],
            [
              100.78768987651961,
              23.041353649118708
            ],
            [
              100.78783299934278,
              23.041678702999587
            ],
            [
              100.78803017914842,
              23.041723946963806
            ],
            [
              100.78816431193908,
              23.041343286057895
            ],
            [
              100.78832947014212,
              23.041125598991947
            ],
            [
              100.78843156529375,
              23.04111773966252
            ],
            [
              100.78878489082089,
              23.041343122702706
            ],
            [
              100.78892901645834,
              23.0417761368753
            ],
            [
              100.7894865429307,
              23.041987810532714
            ],
            [
              100.78971075026578,
              23.042357964239265
            ],
            [
              100.7900050314977,
              23.04255129061905
            ],
            [
              100.79030532443048,
              23.04260168755132
            ],
            [
              100.7914274490731,
              23.042436339442126
            ],
            [
              100.79231635156128,
              23.04281345744467
            ],
            [
              100.7926266675625,
              23.043108783729387
            ],
            [
              100.79264067037667,
              23.04360359671853
            ],
            [
              100.79281484176414,
              23.044067655965176
            ],
            [
              100.79302105563161,
              23.044200901463075
            ],
            [
              100.79341547294445,
              23.044236465751663
            ],
            [
              100.79371979470727,
              23.04438585259474
            ],
            [
              100.79387595258731,
              23.044802909354154
            ],
            [
              100.79453465122592,
              23.045473611140256
            ],
            [
              100.79453864726345,
              23.045822471044495
            ],
            [
              100.79426634301032,
              23.04613593229242
            ],
            [
              100.79353554297543,
              23.046666625090015
            ],
            [
              100.79285481638111,
              23.04688753338067
            ],
            [
              100.79243537889704,
              23.046842941931427
            ],
            [
              100.79195288738175,
              23.046536373756553
            ],
            [
              100.79084877864457,
              23.04612897226482
            ],
            [
              100.7892552257041,
              23.045986817623753
            ],
            [
              100.78814618191215,
              23.046078277618047
            ],
            [
              100.78717830925595,
              23.045753130196125
            ],
            [
              100.78625448,
              23.04634768003832
            ],
            [
              100.7849513613073,
              23.04684881640189
            ],
            [
              100.78415769378371,
              23.047624508162755
            ],
            [
              100.78373135147764,
              23.047693958237
            ],
            [
              100.78333304018409,
              23.04761550922909
            ],
            [
              100.7829127202916,
              23.047397097216336
            ],
            [
              100.78071214150594,
              23.046053110185383
            ],
            [
              100.77992560732272,
              23.04589430104498
            ],
            [
              100.77957937505725,
              23.045971889153932
            ],
            [
              100.77884787685839,
              23.04699067335563
            ],
            [
              100.77852266820831,
              23.047146262707237
            ],
            [
              100.77728291817114,
              23.04720595121233
            ],
            [
              100.77698174144197,
              23.047319598518467
            ],
            [
              100.77605620686597,
              23.04812334282702
            ],
            [
              100.77586609421925,
              23.048558975182488
            ],
            [
              100.77587308409316,
              23.049136740335427
            ],
            [
              100.7752187259706,
              23.049794835866297
            ],
            [
              100.77482550813166,
              23.05059912826629
            ],
            [
              100.77428518695768,
              23.052982630593384
            ],
            [
              100.77413510240959,
              23.053526265918144
            ],
            [
              100.77325666932131,
              23.05480094297038
            ],
            [
              100.77300753147092,
              23.055996224817054
            ],
            [
              100.772819444849,
              23.056232961680703
            ],
            [
              100.77215216704435,
              23.056270372362697
            ],
            [
              100.77190606414628,
              23.056471080906
            ],
            [
              100.77191706341888,
              23.05668200222865
            ],
            [
              100.77229620025767,
              23.057320057421336
            ],
            [
              100.77233520480486,
              23.057794892895146
            ],
            [
              100.77215612299119,
              23.058171583464475
            ],
            [
              100.7717439476711,
              23.05868102440671
            ],
            [
              100.77148781901872,
              23.059947284635836
            ],
            [
              100.77072653359065,
              23.060259535929003
            ],
            [
              100.77050144920958,
              23.060520248324735
            ],
            [
              100.7707615245835,
              23.06114719467055
            ],
            [
              100.77079350848345,
              23.062287746087485
            ],
            [
              100.7716027710942,
              23.063766791845502
            ],
            [
              100.77166877115526,
              23.064820409212043
            ],
            [
              100.77147369020894,
              23.065088136426763
            ],
            [
              100.77085346089515,
              23.06515460351917
            ],
            [
              100.77063838177759,
              23.065297372124164
            ],
            [
              100.77056934951325,
              23.06564417330736
            ],
            [
              100.770708387931,
              23.066059111940298
            ],
            [
              100.7706743719472,
              23.06622901430523
            ],
            [
              100.77015218048602,
              23.066814359601857
            ],
            [
              100.76998311451477,
              23.067259043889628
            ],
            [
              100.76991307715244,
              23.067873735005342
            ],
            [
              100.77008109386209,
              23.06944721342314
            ],
            [
              100.76997805666184,
              23.069599070638542
            ],
            [
              100.76954091344119,
              23.06981664561191
            ],
            [
              100.76938786197182,
              23.07001744679833
            ],
            [
              100.76915374501428,
              23.071985457404914
            ],
            [
              100.76835444972767,
              23.075013622461967
            ],
            [
              100.76842545750542,
              23.075472484191184
            ],
            [
              100.7688535515301,
              23.076443395164112
            ],
            [
              100.76885154097003,
              23.076859222315413
            ],
            [
              100.76812433209459,
              23.07742646369908
            ],
            [
              100.76800029079689,
              23.077841205207733
            ],
            [
              100.7679992782191,
              23.078353993367895
            ],
            [
              100.76812729979412,
              23.078801899512534
            ],
            [
              100.76803525743058,
              23.07959450830099
            ],
            [
              100.76765914661179,
              23.08037892275802
            ],
            [
              100.76692796566854,
              23.081102128581808
            ],
            [
              100.76658387336485,
              23.08203051996836
            ],
            [
              100.76512059000702,
              23.08352698654861
            ],
            [
              100.76500856484884,
              23.083925755807112
            ],
            [
              100.7649925490838,
              23.084490514716116
            ],
            [
              100.76521255335147,
              23.085598193207595
            ],
            [
              100.76473147740664,
              23.086046722537613
            ],
            [
              100.7640233928489,
              23.08624723321769
            ],
            [
              100.76371535715423,
              23.086539941934127
            ],
            [
              100.76369731650733,
              23.088165267285447
            ],
            [
              100.76349629326756,
              23.088442044255526
            ],
            [
              100.76242121663641,
              23.089046234594395
            ],
            [
              100.76051919756644,
              23.0898620096423
            ],
            [
              100.76009121540592,
              23.08993879602295
            ],
            [
              100.75856834454206,
              23.08992021018581
            ],
            [
              100.75778944135324,
              23.090108863099168
            ],
            [
              100.75744248636008,
              23.090437615953736
            ],
            [
              100.75740648690908,
              23.090654516003518
            ],
            [
              100.7576094403728,
              23.091266331779085
            ],
            [
              100.75759943490856,
              23.09155720994472
            ],
            [
              100.75746145262467,
              23.091715101091737
            ],
            [
              100.75726548171968,
              23.091829992295775
            ],
            [
              100.75675956960501,
              23.09188981459189
            ],
            [
              100.75589675226949,
              23.091609689458995
            ],
            [
              100.75570379215819,
              23.091756579908985
            ],
            [
              100.75555481449345,
              23.092264335619923
            ],
            [
              100.75532186762443,
              23.09237523364628
            ],
            [
              100.75508692603329,
              23.092378177236636
            ],
            [
              100.7548899810649,
              23.092199205468667
            ],
            [
              100.75459607843477,
              23.091418459700957
            ],
            [
              100.754396137254,
              23.091278475134846
            ],
            [
              100.75425617830214,
              23.091225468501207
            ],
            [
              100.75379331206523,
              23.091366322943323
            ],
            [
              100.75314851894029,
              23.09130623819389
            ],
            [
              100.75276264823438,
              23.091375152261104
            ],
            [
              100.75249973265714,
              23.09171797634837
            ],
            [
              100.7521728211319,
              23.092992415891946
            ],
            [
              100.75194389749744,
              23.093392226626158
            ],
            [
              100.75151506326414,
              23.093433165651653
            ],
            [
              100.75128015943703,
              23.093363172828496
            ],
            [
              100.75016865497223,
              23.092606408561547
            ],
            [
              100.74981282554944,
              23.09230651747637
            ],
            [
              100.7498118283204,
              23.092210556538642
            ],
            [
              100.75016867062688,
              23.091954674061128
            ],
            [
              100.75069444967585,
              23.09149389023451
            ],
            [
              100.75054152357563,
              23.091179009268497
            ],
            [
              100.75016869014678,
              23.091142005318726
            ],
            [
              100.74892728104366,
              23.09119595807127
            ],
            [
              100.74858543947607,
              23.09184469698013
            ],
            [
              100.74831257742672,
              23.09202562912111
            ],
            [
              100.74796076611028,
              23.09199365390086
            ],
            [
              100.7476229614129,
              23.091570841931517
            ],
            [
              100.74752501605447,
              23.091566848929162
            ],
            [
              100.74721418910573,
              23.091675823972196
            ],
            [
              100.74663051983286,
              23.092079705867047
            ],
            [
              100.74636168095485,
              23.092092726331575
            ],
            [
              100.74621777061185,
              23.09200777586912
            ],
            [
              100.74552222850531,
              23.091065243300314
            ],
            [
              100.74423110400086,
              23.090408714336434
            ],
            [
              100.74356058982484,
              23.089874063028788
            ],
            [
              100.74312192625382,
              23.089157450212635
            ],
            [
              100.74272922284419,
              23.088980613310476
            ],
            [
              100.74096961349228,
              23.08878317269404
            ],
            [
              100.74022125182644,
              23.08830960516167
            ],
            [
              100.73986656505213,
              23.08796486667601
            ],
            [
              100.73971070819054,
              23.087650049874178
            ],
            [
              100.73953189800974,
              23.086270677806525
            ],
            [
              100.73906432302722,
              23.085890005715065
            ],
            [
              100.73911628321085,
              23.085605102848483
            ],
            [
              100.73974774365831,
              23.084823193927985
            ],
            [
              100.73974574970983,
              23.08464326835861
            ],
            [
              100.73945102034249,
              23.084142578733232
            ],
            [
              100.73911132872192,
              23.083891806776073
            ],
            [
              100.73870569674206,
              23.083851978297915
            ],
            [
              100.7381981609404,
              23.084030108093863
            ],
            [
              100.73740489564933,
              23.084777138148276
            ],
            [
              100.73694034173587,
              23.085035240170885
            ],
            [
              100.73564865042121,
              23.08475997266937
            ],
            [
              100.7342061776973,
              23.084920671493865
            ],
            [
              100.73373270727309,
              23.08452809996208
            ],
            [
              100.73305948066131,
              23.083740817277917
            ],
            [
              100.73188185333375,
              23.083284734018303
            ],
            [
              100.73104686764275,
              23.082587567732812
            ],
            [
              100.73064137800756,
              23.081904123271755
            ],
            [
              100.73051856369501,
              23.08044680644088
            ],
            [
              100.73012306191747,
              23.08008922901879
            ],
            [
              100.7296556450691,
              23.080221507486364
            ],
            [
              100.72938199399337,
              23.080143737923258
            ],
            [
              100.72929412436794,
              23.0793761178973
            ],
            [
              100.7291742836506,
              23.079124309609863
            ],
            [
              100.72894258626764,
              23.078924563602087
            ],
            [
              100.72866394822503,
              23.07887779196332
            ],
            [
              100.7275773705701,
              23.07939442087493
            ],
            [
              100.72734268780965,
              23.07932563632445
            ],
            [
              100.72725980835966,
              23.078964851313163
            ],
            [
              100.72744557422936,
              23.078276985585042
            ],
            [
              100.72740263977614,
              23.077952153616952
            ],
            [
              100.7273017792441,
              23.077808293667985
            ],
            [
              100.72637905289118,
              23.077313253230976
            ],
            [
              100.72606349921885,
              23.07699165088989
            ],
            [
              100.72547433377753,
              23.07674525664404
            ],
            [
              100.7244128516439,
              23.07702807840612
            ],
            [
              100.72279722693173,
              23.07796619302152
            ],
            [
              100.72217616689252,
              23.078225686315168
            ],
            [
              100.72178975536833,
              23.078518945405754
            ],
            [
              100.72150619533572,
              23.07853122218461
            ],
            [
              100.72089415931555,
              23.07835191324586
            ],
            [
              100.72022522287364,
              23.078354600674828
            ],
            [
              100.71998661070839,
              23.078154931967653
            ],
            [
              100.71986282766939,
              23.077420364410344
            ],
            [
              100.71924583950175,
              23.077009188782245
            ],
            [
              100.71906813570853,
              23.07678947021232
            ],
            [
              100.71886549219386,
              23.07580609448595
            ],
            [
              100.71866483535513,
              23.075302520209817
            ],
            [
              100.71835336138717,
              23.074912022274837
            ],
            [
              100.71805685993483,
              23.074758413063375
            ],
            [
              100.71771741865858,
              23.075238593150527
            ],
            [
              100.71753771165052,
              23.07567561457831
            ],
            [
              100.71738094977468,
              23.076828316140972
            ],
            [
              100.71720424386733,
              23.077087409527294
            ],
            [
              100.71693071141672,
              23.077054734702905
            ],
            [
              100.71571382983541,
              23.076525367351795
            ],
            [
              100.71493421766894,
              23.07594153780766
            ],
            [
              100.71434326627094,
              23.076179156713575
            ],
            [
              100.71395695181579,
              23.07658046551036
            ],
            [
              100.71353171699185,
              23.07680190131176
            ],
            [
              100.71333507593934,
              23.076768160728236
            ],
            [
              100.71274916374863,
              23.076191136738622
            ],
            [
              100.71242376856264,
              23.076031616734074
            ],
            [
              100.71225208475805,
              23.07612479809305
            ],
            [
              100.71204745071991,
              23.07674580517728
            ],
            [
              100.71177794620299,
              23.077074018194228
            ],
            [
              100.71130083958408,
              23.077193590487372
            ],
            [
              100.71053030193973,
              23.077159621757996
            ],
            [
              100.70971386402749,
              23.077385624422032
            ],
            [
              100.7095481872443,
              23.07726689791228
            ],
            [
              100.70936555240928,
              23.0767993389882
            ],
            [
              100.70895636420252,
              23.076165160248117
            ],
            [
              100.70820585472386,
              23.07545149304099
            ],
            [
              100.70804119460361,
              23.074838975567264
            ],
            [
              100.7078435920228,
              23.074588355750393
            ],
            [
              100.70753220934358,
              23.07466376283095
            ],
            [
              100.7067527493697,
              23.075565498750475
            ],
            [
              100.70641541699005,
              23.07612275328225
            ],
            [
              100.70588548268266,
              23.076541347387916
            ],
            [
              100.70695727734439,
              23.078139145994435
            ],
            [
              100.70817183947075,
              23.078940103240065
            ],
            [
              100.7124496354323,
              23.079630101843126
            ],
            [
              100.71612104286494,
              23.079768553735057
            ],
            [
              100.71719718695964,
              23.0799892231528
            ],
            [
              100.7178321029041,
              23.080403338140556
            ],
            [
              100.71832925264765,
              23.081176469511583
            ],
            [
              100.71907394838273,
              23.084267390335775
            ],
            [
              100.71879837086085,
              23.085564156968953
            ],
            [
              100.71860564739227,
              23.087330643819616
            ],
            [
              100.71860563908835,
              23.087680500762357
            ],
            [
              100.71868550105086,
              23.08792831236765
            ],
            [
              100.72067313218987,
              23.094187657986648
            ],
            [
              100.73958941288329,
              23.10439229464357
            ],
            [
              100.75764990893893,
              23.113103526946265
            ],
            [
              100.78287612672416,
              23.112679255389864
            ],
            [
              100.80819789255733,
              23.11675776791671
            ],
            [
              100.81820686557813,
              23.129359962547777
            ],
            [
              100.82478658788038,
              23.133002903439618
            ],
            [
              100.85153940490417,
              23.139676011168874
            ],
            [
              100.86523758329102,
              23.161607283863212
            ],
            [
              100.87198151565427,
              23.17351017049596
            ],
            [
              100.87064525398765,
              23.188560166073387
            ],
            [
              100.87313684949461,
              23.190769192704067
            ],
            [
              100.8837343952027,
              23.18425411726635
            ],
            [
              100.90757914223396,
              23.198117367669475
            ],
            [
              100.9272657449673,
              23.20934679783279
            ],
            [
              100.93129293559926,
              23.20702246563362
            ],
            [
              100.93811498627291,
              23.203183516269277
            ],
            [
              100.94222087976064,
              23.205281673281817
            ],
            [
              100.95329619193141,
              23.20813027430778
            ],
            [
              100.96237569843127,
              23.20799780750037
            ],
            [
              100.97052679908727,
              23.213830487346147
            ],
            [
              100.97220781755139,
              23.215448339286624
            ],
            [
              100.97238817492423,
              23.215495826119508
            ],
            [
              100.97360580950969,
              23.21611724178483
            ],
            [
              100.97748064140883,
              23.22070776403912
            ],
            [
              100.97887647104281,
              23.222134282178423
            ],
            [
              100.9804257099652,
              23.222999511199998
            ],
            [
              100.98151663754449,
              23.223283238226117
            ],
            [
              100.98213433108245,
              23.223140478426544
            ],
            [
              100.98306485481461,
              23.222568936314534
            ],
            [
              100.98600184749449,
              23.219137389241826
            ],
            [
              100.98739856486353,
              23.217992605557217
            ],
            [
              100.98863486140888,
              23.21741709393668
            ],
            [
              100.98956530131899,
              23.217423294289297
            ],
            [
              100.99003049703312,
              23.218283603027523
            ],
            [
              100.9917398895386,
              23.220003862919388
            ],
            [
              100.993754073947,
              23.222297991425762
            ],
            [
              100.99391442282936,
              23.22358707526509
            ],
            [
              100.9932957359785,
              23.226446005180023
            ],
            [
              100.9925176611159,
              23.22930842169482
            ],
            [
              100.9923651611734,
              23.232749759719052
            ],
            [
              100.99249165658651,
              23.233443151282856
            ],
            [
              100.9922983600383,
              23.23505321517486
            ],
            [
              100.99231824843334,
              23.236437708166843
            ],
            [
              100.99257622380227,
              23.237674528960326
            ],
            [
              100.9932575547591,
              23.23940690853028
            ],
            [
              100.99360019941518,
              23.240758437764875
            ],
            [
              100.9936579496355,
              23.241825923006147
            ],
            [
              100.99358620583074,
              23.24263388441064
            ],
            [
              100.99370971392405,
              23.24324831503402
            ],
            [
              100.99411213234076,
              23.244396730560947
            ],
            [
              100.99422267723149,
              23.245521040792365
            ],
            [
              100.99423656432855,
              23.247858266100604
            ],
            [
              100.99436705196533,
              23.24820276218334
            ],
            [
              100.99534625107904,
              23.248978544206267
            ],
            [
              100.99571480160789,
              23.249983110904846
            ],
            [
              100.99612314826506,
              23.252940953869643
            ],
            [
              100.99567880644462,
              23.255263592823592
            ],
            [
              100.99574853149667,
              23.255480314459824
            ],
            [
              100.99635020237312,
              23.255622440365826
            ],
            [
              101.00247061147172,
              23.258770940836555
            ],
            [
              101.00886794657333,
              23.260784966946726
            ],
            [
              101.01754819919248,
              23.261947954535273
            ],
            [
              101.02518741247076,
              23.263998721095618
            ],
            [
              101.0301092081111,
              23.26573992133159
            ],
            [
              101.03729734900152,
              23.26663137720395
            ],
            [
              101.04577844017717,
              23.26595701577334
            ],
            [
              101.0521935789693,
              23.267971275516473
            ],
            [
              101.05654237240235,
              23.271754142531027
            ],
            [
              101.06262811712168,
              23.27581701302586
            ],
            [
              101.06946914938486,
              23.2796735868643
            ],
            [
              101.07308063520676,
              23.283204493088565
            ],
            [
              101.07978239613972,
              23.283854247621754
            ],
            [
              101.0874303884856,
              23.285898239261257
            ],
            [
              101.09628453357008,
              23.28935343987093
            ],
            [
              101.10614736363048,
              23.291917727287338
            ],
            [
              101.11299571509893,
              23.29577244704579
            ],
            [
              101.11534923082422,
              23.29972811394251
            ],
            [
              101.11791902760169,
              23.305060835901465
            ],
            [
              101.11942050572208,
              23.31219636696194
            ],
            [
              101.11895211013518,
              23.318587357661826
            ],
            [
              101.11593067170217,
              23.326967776980386
            ],
            [
              101.11326577430194,
              23.33215658473966
            ],
            [
              101.10705000155582,
              23.339300416128882
            ],
            [
              101.10342935042745,
              23.34331918630411
            ],
            [
              101.09687546905276,
              23.352972116506393
            ],
            [
              101.0926649065586,
              23.359486126763468
            ],
            [
              101.08835941242836,
              23.361879809777996
            ],
            [
              101.08573793648922,
              23.365469225296604
            ],
            [
              101.08233471409021,
              23.370403199671717
            ],
            [
              101.0791147596832,
              23.37717825154091
            ],
            [
              101.07771662636495,
              23.381941553683877
            ],
            [
              101.0755207966706,
              23.38782952322436
            ],
            [
              101.07333319662332,
              23.393486778437058
            ],
            [
              101.07163095687255,
              23.39961566489382
            ],
            [
              101.06971228330754,
              23.404823118362692
            ],
            [
              101.06794241670826,
              23.413007165511324
            ],
            [
              101.06443430166617,
              23.42068692049051
            ],
            [
              101.06087482877616,
              23.43019414258362
            ],
            [
              101.05875763666873,
              23.433797181276535
            ],
            [
              101.05428645583726,
              23.440988290815255
            ],
            [
              101.04929555787679,
              23.448397279764194
            ],
            [
              101.04666487461789,
              23.45220942594293
            ],
            [
              101.04426075673639,
              23.457174238373195
            ],
            [
              101.04451181648616,
              23.464503124221633
            ],
            [
              101.04436414248997,
              23.468615167116067
            ],
            [
              101.04407777015318,
              23.47684529951245
            ],
            [
              101.04278440482088,
              23.485729757296475
            ],
            [
              101.03992888549487,
              23.496399961424043
            ],
            [
              101.03632625926026,
              23.49972856572254
            ],
            [
              101.03286250051075,
              23.50626314398873
            ],
            [
              101.03040565325354,
              23.512369444007557
            ],
            [
              101.03029295360285,
              23.515570714637175
            ],
            [
              101.03156943551014,
              23.522011360674522
            ],
            [
              101.03333132859726,
              23.528925865173527
            ],
            [
              101.02992872138927,
              23.53363077631613
            ],
            [
              101.02696783683815,
              23.539951844026533
            ],
            [
              101.02379097287027,
              23.54535173455916
            ],
            [
              101.02073579678232,
              23.554416676594883
            ],
            [
              101.01975521457649,
              23.561021791043796
            ],
            [
              101.01517197026133,
              23.571184670487636
            ],
            [
              101.01081417284081,
              23.582040354244686
            ],
            [
              101.01399108308392,
              23.5837300629605
            ],
            [
              101.01798414801019,
              23.583843411880473
            ],
            [
              101.02676043551855,
              23.582493647203112
            ],
            [
              101.03308877524987,
              23.57993072712394
            ],
            [
              101.03886102679904,
              23.578722330852564
            ],
            [
              101.04512893761205,
              23.577984913863887
            ],
            [
              101.05033716304567,
              23.578818069654748
            ],
            [
              101.05598834445114,
              23.581266568520626
            ],
            [
              101.06139745897951,
              23.583707719891915
            ],
            [
              101.0655554392536,
              23.586340813925197
            ],
            [
              101.0724912914201,
              23.587909392989804
            ],
            [
              101.0782472125358,
              23.5871578478771
            ],
            [
              101.08297794982616,
              23.58751949295752
            ],
            [
              101.09172033000888,
              23.58707986206772
            ],
            [
              101.09649522533965,
              23.586299279994442
            ],
            [
              101.10379561334243,
              23.58444626344899
            ],
            [
              101.1152463232076,
              23.58499655191944
            ],
            [
              101.11968205555904,
              23.58672147642965
            ],
            [
              101.12575059215769,
              23.591693208616874
            ],
            [
              101.12989078080713,
              23.594556457022282
            ],
            [
              101.13641908933484,
              23.59359523840084
            ],
            [
              101.13740916251881,
              23.593241650410185
            ],
            [
              101.13602950683098,
              23.59980828452645
            ],
            [
              101.13985666953369,
              23.60182417480726
            ],
            [
              101.14220734611591,
              23.605633242183565
            ],
            [
              101.14263184886406,
              23.60614397213849
            ],
            [
              101.14269292412693,
              23.606124067259785
            ],
            [
              101.14301037576752,
              23.603880331441015
            ],
            [
              101.14357810212937,
              23.60303015308464
            ],
            [
              101.14366923733004,
              23.60224421736896
            ],
            [
              101.14387049988554,
              23.601839500353194
            ],
            [
              101.14559972404575,
              23.600868227861767
            ],
            [
              101.14580199387916,
              23.60055853062623
            ],
            [
              101.1459762418761,
              23.59975273718992
            ],
            [
              101.14601833028459,
              23.598526683360497
            ],
            [
              101.1455217545962,
              23.596111623076656
            ],
            [
              101.14557883712982,
              23.595785685769368
            ],
            [
              101.1462487321586,
              23.594818703801426
            ],
            [
              101.14723204654759,
              23.593992271102834
            ],
            [
              101.14747337981652,
              23.59351063236229
            ],
            [
              101.14754449492578,
              23.592762682559464
            ],
            [
              101.14737630943618,
              23.591386272256855
            ],
            [
              101.14765470063955,
              23.590617672412872
            ],
            [
              101.14779291288482,
              23.589601815234385
            ],
            [
              101.14757463074412,
              23.589284418055758
            ],
            [
              101.14483508885138,
              23.588360779308317
            ],
            [
              101.14374972493763,
              23.588196999335903
            ],
            [
              101.1420696591527,
              23.588238317578824
            ],
            [
              101.14144691863811,
              23.58796231353484
            ],
            [
              101.14087725818793,
              23.58739937585386
            ],
            [
              101.14068103592378,
              23.587084044222788
            ],
            [
              101.14116863483224,
              23.5862427309118
            ],
            [
              101.14489330402839,
              23.583240444152185
            ],
            [
              101.14442676724833,
              23.581234522138256
            ],
            [
              101.14411438936494,
              23.58066096937824
            ],
            [
              101.14302306313806,
              23.579512121723603
            ],
            [
              101.14068828075258,
              23.578515367476363
            ],
            [
              101.13897933456178,
              23.577654688285563
            ],
            [
              101.13742264305908,
              23.576367272541745
            ],
            [
              101.13633151583903,
              23.57479356893644
            ],
            [
              101.13602123552567,
              23.57311200571861
            ],
            [
              101.13537959142494,
              23.57228703340748
            ],
            [
              101.13381809910149,
              23.569390659592656
            ],
            [
              101.13312445081378,
              23.56842664963963
            ],
            [
              101.13490723369513,
              23.56774107436308
            ],
            [
              101.13600436552066,
              23.56776263602965
            ],
            [
              101.13654493189505,
              23.56792042597875
            ],
            [
              101.13775121636532,
              23.568602235996106
            ],
            [
              101.13802751938766,
              23.568644648666204
            ],
            [
              101.14055640807344,
              23.568287464252894
            ],
            [
              101.14434805110702,
              23.56731742743619
            ],
            [
              101.14560065312394,
              23.567171473327384
            ],
            [
              101.14771742199214,
              23.567436028936108
            ],
            [
              101.14811995476161,
              23.5676327231087
            ],
            [
              101.14836427292984,
              23.567997160842904
            ],
            [
              101.14863963824949,
              23.568213643613152
            ],
            [
              101.14920740398196,
              23.568370625253998
            ],
            [
              101.15174090840262,
              23.56846403062966
            ],
            [
              101.15287951417169,
              23.56866905169614
            ],
            [
              101.15396105382631,
              23.56902199781776
            ],
            [
              101.15501758433115,
              23.569006890919074
            ],
            [
              101.15660692287021,
              23.56870974650472
            ],
            [
              101.15750525203985,
              23.568788388183084
            ],
            [
              101.15840558961058,
              23.569015050952107
            ],
            [
              101.15906857706425,
              23.569299287697103
            ],
            [
              101.1598146877101,
              23.569840698359258
            ],
            [
              101.16030540949176,
              23.570623656417233
            ],
            [
              101.16067795274014,
              23.57144540046937
            ],
            [
              101.16108452547819,
              23.573130267814957
            ],
            [
              101.16103339929543,
              23.574894294680384
            ],
            [
              101.16156217872037,
              23.575894348624992
            ],
            [
              101.16278502410567,
              23.576956705991222
            ],
            [
              101.1640589678436,
              23.577708146529485
            ],
            [
              101.16468993850297,
              23.577929347446297
            ],
            [
              101.16772860791195,
              23.578456068918186
            ],
            [
              101.16858595184539,
              23.578462692230346
            ],
            [
              101.1719282121305,
              23.578066992773252
            ],
            [
              101.17551983106375,
              23.578522810569343
            ],
            [
              101.17742678710357,
              23.579147439778446
            ],
            [
              101.17822202340162,
              23.57908092289905
            ],
            [
              101.18055865269619,
              23.578154201949687
            ],
            [
              101.18183560839957,
              23.578027551163395
            ],
            [
              101.18260377185426,
              23.5781789743275
            ],
            [
              101.18371343754927,
              23.578584034171275
            ],
            [
              101.18497431040262,
              23.579203371485082
            ],
            [
              101.18712544979982,
              23.580754356371447
            ],
            [
              101.18948386490356,
              23.580879536456457
            ],
            [
              101.21787684024544,
              23.582344075790978
            ],
            [
              101.23312725722424,
              23.573608165288434
            ]
          ]
        ]
      },
      "properties": {
        "name": "宁洱哈尼族彝族自治县"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.0641008329136,
              23.00734847314303
            ],
            [
              101.06384383299566,
              23.006005502640072
            ],
            [
              101.06358583325283,
              23.00521552007085
            ],
            [
              101.0631568329074,
              23.00458353399325
            ],
            [
              101.06307083269367,
              23.004267540671435
            ],
            [
              101.06272783346034,
              23.00395154826347
            ],
            [
              101.06221283290121,
              23.003398559975935
            ],
            [
              101.06178383345413,
              23.002924570101758
            ],
            [
              101.0613548331087,
              23.002608577029985
            ],
            [
              101.06109683336587,
              23.002450581043533
            ],
            [
              101.06049583349132,
              23.002134587688914
            ],
            [
              101.06015283335965,
              23.001897592394158
            ],
            [
              101.05989483271846,
              23.001818594421348
            ],
            [
              101.0595518334851,
              23.0015815993986
            ],
            [
              101.05937983305766,
              23.001344604786635
            ],
            [
              101.05920883335345,
              23.001028612150236
            ],
            [
              101.05895083271226,
              23.00079161739417
            ],
            [
              101.05877983300805,
              23.000712618774063
            ],
            [
              101.05826483334724,
              23.000317627460575
            ],
            [
              101.05800683270604,
              23.000238629389937
            ],
            [
              101.05766383347269,
              23.000080632283062
            ],
            [
              101.05723483312731,
              22.99984363751632
            ],
            [
              101.0568908331707,
              22.99960664316039
            ],
            [
              101.05637583350989,
              22.999289650031223
            ],
            [
              101.05603283337823,
              22.998973656718604
            ],
            [
              101.0559468331645,
              22.998973656718604
            ],
            [
              101.0555178328191,
              22.998657663493162
            ],
            [
              101.05534583328996,
              22.99818367433534
            ],
            [
              101.05500283315828,
              22.997867680914496
            ],
            [
              101.05465983302662,
              22.997235695161482
            ],
            [
              101.05431583307004,
              22.9969987003615
            ],
            [
              101.05397283293834,
              22.99691970200242
            ],
            [
              101.05405883315208,
              22.996287715946128
            ],
            [
              101.05337183306382,
              22.99573472768397
            ],
            [
              101.05217083313967,
              22.99526073818673
            ],
            [
              101.05183083338105,
              22.99435275816697
            ],
            [
              101.05118683295049,
              22.993986765586822
            ],
            [
              101.05067183328968,
              22.99372477159048
            ],
            [
              101.05012083274553,
              22.993763770997287
            ],
            [
              101.0497718327661,
              22.993793769960835
            ],
            [
              101.04925183308242,
              22.99368077247942
            ],
            [
              101.04796483294453,
              22.99304878614679
            ],
            [
              101.04727783285628,
              22.99265379473729
            ],
            [
              101.04667683298173,
              22.992415800381373
            ],
            [
              101.04624883335953,
              22.989808857411738
            ],
            [
              101.04418883291969,
              22.98759590556086
            ],
            [
              101.04247183350981,
              22.98807089531482
            ],
            [
              101.04118483337196,
              22.98759590556086
            ],
            [
              101.03989683340912,
              22.987200913914617
            ],
            [
              101.03818083292585,
              22.98467296930134
            ],
            [
              101.0365498328314,
              22.981591037199532
            ],
            [
              101.03663583304512,
              22.978114113338506
            ],
            [
              101.0392108331458,
              22.97558516833052
            ],
            [
              101.03912483293206,
              22.97345221470916
            ],
            [
              101.03594883295685,
              22.971002268809677
            ],
            [
              101.03062783305127,
              22.970054289095668
            ],
            [
              101.02882483342768,
              22.97037028224525
            ],
            [
              101.02676483298781,
              22.971002268809677
            ],
            [
              101.02470483344625,
              22.97092327013379
            ],
            [
              101.0173228332759,
              22.97321422043281
            ],
            [
              101.01277383294908,
              22.97882509749253
            ],
            [
              101.0093408330559,
              22.9764541493719
            ],
            [
              101.0066798327415,
              22.97376820818572
            ],
            [
              101.00556483303107,
              22.97503218049323
            ],
            [
              101.00487783294282,
              22.97550616985214
            ],
            [
              101.00367583319374,
              22.97542717132758
            ],
            [
              101.00264583297377,
              22.97511117842164
            ],
            [
              101.00187383339507,
              22.9744791920473
            ],
            [
              101.00101483287935,
              22.97432119623256
            ],
            [
              100.99955583321233,
              22.97432119623256
            ],
            [
              100.99758183298621,
              22.974242197842383
            ],
            [
              100.99689583272283,
              22.974637189331496
            ],
            [
              100.99646583345084,
              22.97590116095522
            ],
            [
              100.99595083289172,
              22.977087135503822
            ],
            [
              100.9962088335329,
              22.977798120099255
            ],
            [
              100.9954358332309,
              22.97882509749253
            ],
            [
              100.99517883331293,
              22.980247066155528
            ],
            [
              100.9948358331813,
              22.982223023392187
            ],
            [
              100.99406283287931,
              22.982697013164064
            ],
            [
              100.9922608330806,
              22.981275043821583
            ],
            [
              100.99071583319987,
              22.979773076885603
            ],
            [
              100.98762583343836,
              22.978667100969588
            ],
            [
              100.98487883291027,
              22.97819311111933
            ],
            [
              100.9828188333687,
              22.97795611681125
            ],
            [
              100.98135983280338,
              22.97819311111933
            ],
            [
              100.97990083313636,
              22.978114113338506
            ],
            [
              100.97852783278475,
              22.97716613388507
            ],
            [
              100.97790883336687,
              22.976952138718076
            ],
            [
              100.97715483333145,
              22.97669114383305
            ],
            [
              100.97612483311153,
              22.976533147296124
            ],
            [
              100.9756098334507,
              22.97519017713094
            ],
            [
              100.97449383301705,
              22.974084200923496
            ],
            [
              100.97200483313009,
              22.973135222222645
            ],
            [
              100.96874283294113,
              22.97234523923571
            ],
            [
              100.9677128327212,
              22.972740230479285
            ],
            [
              100.967541833017,
              22.974005202394782
            ],
            [
              100.96831383349408,
              22.978430105838783
            ],
            [
              100.96908683289772,
              22.982618014708553
            ],
            [
              100.96857183323692,
              22.98380298834436
            ],
            [
              100.96737083331277,
              22.985698947531347
            ],
            [
              100.96616883356367,
              22.98648993001001
            ],
            [
              100.96565383300458,
              22.98759590556086
            ],
            [
              100.96552883333109,
              22.990004853172817
            ],
            [
              100.96548183347547,
              22.99091383327994
            ],
            [
              100.96608283334996,
              22.990992831018286
            ],
            [
              100.96694083314244,
              22.992020808774157
            ],
            [
              100.96668383322451,
              22.992810791660094
            ],
            [
              100.96591183274745,
              22.993521776192452
            ],
            [
              100.96565383300458,
              22.994785748087335
            ],
            [
              100.96539683308664,
              22.996049720553245
            ],
            [
              100.9649668329163,
              22.99715569636664
            ],
            [
              100.96539683308664,
              22.99842066870884
            ],
            [
              100.9648818334258,
              22.999447646410136
            ],
            [
              100.96393683269638,
              23.000000634347284
            ],
            [
              100.96282183298595,
              23.000632620385932
            ],
            [
              100.95973183322444,
              23.000158630720918
            ],
            [
              100.95758583346917,
              23.000000634347284
            ],
            [
              100.95543983281559,
              23.000000634347284
            ],
            [
              100.95389483293485,
              22.999131653467373
            ],
            [
              100.95329383306031,
              22.999526644943703
            ],
            [
              100.95260783279699,
              22.99992163609112
            ],
            [
              100.95192083270872,
              23.0011856084298
            ],
            [
              100.95131983283414,
              23.002686575660753
            ],
            [
              100.94986083316715,
              23.00545151481429
            ],
            [
              100.94745583294578,
              23.00805845833424
            ],
            [
              100.94462383292716,
              23.011139390238732
            ],
            [
              100.94419383275687,
              23.012720356257958
            ],
            [
              100.94290683351728,
              23.015485295673958
            ],
            [
              100.94264983270102,
              23.01753925057004
            ],
            [
              100.94333583296435,
              23.019356210384966
            ],
            [
              100.94393683283889,
              23.02022419123949
            ],
            [
              100.94462383292716,
              23.020935176029344
            ],
            [
              100.94324983275065,
              23.02188315487833
            ],
            [
              100.94264983270102,
              23.02306812940174
            ],
            [
              100.94213483304019,
              23.024332101495652
            ],
            [
              100.9417048328699,
              23.025754070301733
            ],
            [
              100.93921583298295,
              23.027176038990586
            ],
            [
              100.94093283329114,
              23.02954598709276
            ],
            [
              100.94127583342281,
              23.03278391669609
            ],
            [
              100.9438508335235,
              23.033809893713237
            ],
            [
              100.94505283327256,
              23.03483687148108
            ],
            [
              100.9441948334801,
              23.03696982478003
            ],
            [
              100.94299283283267,
              23.039260774240994
            ],
            [
              100.94711283281411,
              23.044867651400537
            ],
            [
              100.95294883327881,
              23.04668461148795
            ],
            [
              100.95217683280175,
              23.048422573913502
            ],
            [
              100.95406483281417,
              23.05395045270493
            ],
            [
              100.95432283345534,
              23.054977429833016
            ],
            [
              100.95372183268249,
              23.055767412566947
            ],
            [
              100.95243383271969,
              23.056083405850263
            ],
            [
              100.9515758329272,
              23.05774136924494
            ],
            [
              100.95094883311342,
              23.058087361564958
            ],
            [
              100.95080483317335,
              23.058167359748634
            ],
            [
              100.94942983317192,
              23.05892634331251
            ],
            [
              100.94616883280791,
              23.06066330547954
            ],
            [
              100.94573883353591,
              23.06208527430728
            ],
            [
              100.9447948335297,
              23.06350624290538
            ],
            [
              100.94187683329736,
              23.0656381958024
            ],
            [
              100.94187683329736,
              23.0684811339123
            ],
            [
              100.94093483294095,
              23.07156306619854
            ],
            [
              100.93947583327396,
              23.07606396714342
            ],
            [
              100.94033383306645,
              23.081985837113972
            ],
            [
              100.94179283273343,
              23.082933816768474
            ],
            [
              100.94429683268903,
              23.085594758073476
            ],
            [
              100.94589383334662,
              23.087291720973692
            ],
            [
              100.9467708334057,
              23.088223700375025
            ],
            [
              100.95543983281559,
              23.086644735358547
            ],
            [
              100.94934583350634,
              23.09311859293682
            ],
            [
              100.94977483295345,
              23.094066571748964
            ],
            [
              100.94934483278313,
              23.09461955967496
            ],
            [
              100.94711383353734,
              23.096593516317544
            ],
            [
              100.9452248328017,
              23.09833047868524
            ],
            [
              100.94376583313468,
              23.100304435338536
            ],
            [
              100.94213483304019,
              23.10109341809403
            ],
            [
              100.94093383311605,
              23.10172540410496
            ],
            [
              100.94084783290232,
              23.10338336749693
            ],
            [
              100.94033283324151,
              23.105593318676068
            ],
            [
              100.93998983310983,
              23.107725271777152
            ],
            [
              100.93604083283266,
              23.111198195413287
            ],
            [
              100.93363783315942,
              23.113567143738297
            ],
            [
              100.93955983293954,
              23.114119131812714
            ],
            [
              100.94101983332978,
              23.114514123108602
            ],
            [
              100.93337983341655,
              23.11980300688016
            ],
            [
              100.9322638329829,
              23.12240794912701
            ],
            [
              100.93220883273129,
              23.123638922068057
            ],
            [
              100.93209183345377,
              23.126275864269424
            ],
            [
              100.93046183318421,
              23.129827785943483
            ],
            [
              100.93071883310218,
              23.131405751698644
            ],
            [
              100.93054783339792,
              23.132984716628112
            ],
            [
              100.93063283288842,
              23.134799676249024
            ],
            [
              100.93131983297667,
              23.136536638246966
            ],
            [
              100.93372283354825,
              23.138983584228043
            ],
            [
              100.93775683331592,
              23.142456508342068
            ],
            [
              100.93870083332213,
              23.14308849451247
            ],
            [
              100.93784283352967,
              23.144035473654995
            ],
            [
              100.93586883330349,
              23.14687641058899
            ],
            [
              100.9308908335296,
              23.148218381398163
            ],
            [
              100.93054683267468,
              23.149875344949788
            ],
            [
              100.93028983275674,
              23.151927299639006
            ],
            [
              100.92900183279399,
              23.1539792542913
            ],
            [
              100.926512832907,
              23.156504198487553
            ],
            [
              100.92385283331588,
              23.158793148428483
            ],
            [
              100.92402383302009,
              23.16060810877659
            ],
            [
              100.9259978332462,
              23.163449046158934
            ],
            [
              100.92428083293802,
              23.16944591417343
            ],
            [
              100.91998983325236,
              23.173706819833157
            ],
            [
              100.9178438334971,
              23.176231764520985
            ],
            [
              100.91604183280008,
              23.177651733102024
            ],
            [
              100.91629883271803,
              23.179387694446206
            ],
            [
              100.91638483293175,
              23.180649667033208
            ],
            [
              100.91647083314547,
              23.18285961811231
            ],
            [
              100.91612783301379,
              23.185226565946405
            ],
            [
              100.91552683313927,
              23.187119524457064
            ],
            [
              100.91449683291933,
              23.188539493095313
            ],
            [
              100.91312383346606,
              23.189565470414497
            ],
            [
              100.91226483295034,
              23.190038459597584
            ],
            [
              100.91011883319506,
              23.190038459597584
            ],
            [
              100.90797383326468,
              23.190038459597584
            ],
            [
              100.90514083342117,
              23.19011745845192
            ],
            [
              100.90273783284961,
              23.19082744277925
            ],
            [
              100.90013783353291,
              23.193900374756453
            ],
            [
              100.90742383344377,
              23.19813528111383
            ],
            [
              100.92713783307099,
              23.209383033185816
            ],
            [
              100.93042383354938,
              23.20749407464074
            ],
            [
              100.93117283356192,
              23.20706308425184
            ],
            [
              100.93801083286083,
              23.203232168669285
            ],
            [
              100.94212583281937,
              23.20533812215629
            ],
            [
              100.95323283296095,
              23.208210058959637
            ],
            [
              100.96234083276201,
              23.208099061384768
            ],
            [
              100.96841183340335,
              23.2124469656327
            ],
            [
              100.97051883280058,
              23.21395493211092
            ],
            [
              100.97220683279643,
              23.215577896061998
            ],
            [
              100.97238783344474,
              23.215625895104623
            ],
            [
              100.97360883346037,
              23.216251881452457
            ],
            [
              100.97749783346312,
              23.220854779779984
            ],
            [
              100.97889983322871,
              23.22228574859126
            ],
            [
              100.98045383333032,
              23.223154729317557
            ],
            [
              100.98154883294926,
              23.22344272266173
            ],
            [
              100.98216883309034,
              23.223300725912107
            ],
            [
              100.98310383287573,
              23.222731738508934
            ],
            [
              100.98605183324531,
              23.219308814172713
            ],
            [
              100.98745383301092,
              23.21816683940693
            ],
            [
              100.98869383329315,
              23.217594852318822
            ],
            [
              100.98962883307854,
              23.217603851798334
            ],
            [
              100.99009483323384,
              23.21846583252699
            ],
            [
              100.99181083281881,
              23.220191794935822
            ],
            [
              100.99383283272553,
              23.2224927440563
            ],
            [
              100.99399383328232,
              23.223782715300324
            ],
            [
              100.99337383314123,
              23.2266416525349
            ],
            [
              100.99259183351671,
              23.229502588975844
            ],
            [
              100.99243983318074,
              23.232943513025813
            ],
            [
              100.99256583267913,
              23.2336374976425
            ],
            [
              100.9923718334087,
              23.23524746248168
            ],
            [
              100.99239283332507,
              23.236632431711367
            ],
            [
              100.99265083306796,
              23.237871404417035
            ],
            [
              100.99333483278315,
              23.239606365700894
            ],
            [
              100.99367983346298,
              23.24095933602899
            ],
            [
              100.99373683336435,
              23.24202631191832
            ],
            [
              100.99366583321925,
              23.24283529478834
            ],
            [
              100.99378983306781,
              23.243449280933916
            ],
            [
              100.99419383329884,
              23.244600255808237
            ],
            [
              100.99430383290371,
              23.245724230480167
            ],
            [
              100.99431783314742,
              23.24806217852251
            ],
            [
              100.99444883356699,
              23.248407171288026
            ],
            [
              100.99543183303295,
              23.249186153734954
            ],
            [
              100.99580283275372,
              23.25019313175036
            ],
            [
              100.99621183300764,
              23.253152066515714
            ],
            [
              100.99576683276871,
              23.25547501519058
            ],
            [
              100.99583583326398,
              23.255692010030657
            ],
            [
              100.99644083333648,
              23.25583500727402
            ],
            [
              101.00258383304953,
              23.25900393723247
            ],
            [
              101.00900583332016,
              23.2610368916583
            ],
            [
              101.01771983293591,
              23.26222586534784
            ],
            [
              101.02538583278839,
              23.264299819849157
            ],
            [
              101.03032583292745,
              23.26605378069551
            ],
            [
              101.0375368333936,
              23.266964760983075
            ],
            [
              101.04604383332016,
              23.266308775720216
            ],
            [
              101.05247683346144,
              23.268336730760968
            ],
            [
              101.05683783346726,
              23.272128646633497
            ],
            [
              101.06293683279937,
              23.276202556756818
            ],
            [
              101.06771783292979,
              23.27889949649252
            ],
            [
              101.06979183271504,
              23.28006947114393
            ],
            [
              101.07340983345445,
              23.2836053926784
            ],
            [
              101.08012183325498,
              23.2842613785785
            ],
            [
              101.08777883288664,
              23.28631133245637
            ],
            [
              101.08813083323915,
              23.28467836931146
            ],
            [
              101.08813083323915,
              23.280815454697333
            ],
            [
              101.08864583289996,
              23.27687354161178
            ],
            [
              101.08924583294957,
              23.27545457347037
            ],
            [
              101.09010483346529,
              23.27403460490508
            ],
            [
              101.09139183270486,
              23.271275665167312
            ],
            [
              101.09250783313853,
              23.269619702170644
            ],
            [
              101.09345183314474,
              23.26654477025696
            ],
            [
              101.09328083344052,
              23.266071780544777
            ],
            [
              101.09319483322678,
              23.265046803639695
            ],
            [
              101.09328083344052,
              23.264415817244274
            ],
            [
              101.094138833233,
              23.26323384332878
            ],
            [
              101.09431083276212,
              23.262444861248998
            ],
            [
              101.09422483344673,
              23.26165587862506
            ],
            [
              101.09422483344673,
              23.260630900769616
            ],
            [
              101.09405283301926,
              23.25984291840456
            ],
            [
              101.09370982390443,
              23.258817941463587
            ],
            [
              101.09259383335225,
              23.256924983063005
            ],
            [
              101.09225083322055,
              23.256136000780025
            ],
            [
              101.09207883279309,
              23.25479602990652
            ],
            [
              101.09276583288134,
              23.25400704740485
            ],
            [
              101.09353783335845,
              23.25314006682891
            ],
            [
              101.09439583315094,
              23.2521150895265
            ],
            [
              101.09465383289377,
              23.25132610684305
            ],
            [
              101.09516883345293,
              23.24880216253133
            ],
            [
              101.09491083281173,
              23.24706720115945
            ],
            [
              101.09242183292481,
              23.245411237852483
            ],
            [
              101.09122083300065,
              23.242178309256712
            ],
            [
              101.09044783269866,
              23.240285350726584
            ],
            [
              101.08976083350869,
              23.23807739922205
            ],
            [
              101.08958983290619,
              23.236499434815652
            ],
            [
              101.08907483324533,
              23.23531646063513
            ],
            [
              101.0896758331199,
              23.234922469539157
            ],
            [
              101.09061983312611,
              23.234922469539157
            ],
            [
              101.09250783313853,
              23.233818494020788
            ],
            [
              101.09353783335845,
              23.232950513008774
            ],
            [
              101.09465383289377,
              23.232319526628892
            ],
            [
              101.09585483281796,
              23.2313725474166
            ],
            [
              101.09654183290618,
              23.229558587796582
            ],
            [
              101.09688483303789,
              23.229164596213813
            ],
            [
              101.09842983291863,
              23.22845461248989
            ],
            [
              101.0986878335598,
              23.227429634570342
            ],
            [
              101.0986878335598,
              23.225851669756924
            ],
            [
              101.09885983308894,
              23.22419570651232
            ],
            [
              101.09834483342811,
              23.22316972920121
            ],
            [
              101.09791483325783,
              23.22230274801955
            ],
            [
              101.09782983286901,
              23.221828758535874
            ],
            [
              101.0982588332144,
              23.219857802337774
            ],
            [
              101.09903083279316,
              23.218910823069322
            ],
            [
              101.09980383309515,
              23.218200838484353
            ],
            [
              101.10091883280559,
              23.217017864791575
            ],
            [
              101.10031883275596,
              23.216228881814736
            ],
            [
              101.09937483274976,
              23.21472991508515
            ],
            [
              101.09465383289377,
              23.212047974098535
            ],
            [
              101.09319483322678,
              23.210076018244983
            ],
            [
              101.09328083344052,
              23.20905004063077
            ],
            [
              101.09388083349012,
              23.208104061359318
            ],
            [
              101.09499683302548,
              23.207236080806204
            ],
            [
              101.09602683324542,
              23.205974108101486
            ],
            [
              101.09722883299446,
              23.204159148773353
            ],
            [
              101.09782983286901,
              23.20250318494606
            ],
            [
              101.09842983291863,
              23.195008350461723
            ],
            [
              101.09928883343433,
              23.194377364026323
            ],
            [
              101.09997483279936,
              23.19358838197103
            ],
            [
              101.10074783310137,
              23.192405407564806
            ],
            [
              101.10083383331508,
              23.191537426640405
            ],
            [
              101.10160583289384,
              23.19011745845192
            ],
            [
              101.10237883319584,
              23.18830249855072
            ],
            [
              101.1022928329821,
              23.18775051045475
            ],
            [
              101.1022928329821,
              23.187513515338
            ],
            [
              101.101863833535,
              23.18680353158613
            ],
            [
              101.10117683344674,
              23.186093546543184
            ],
            [
              101.1010048330193,
              23.185541559240914
            ],
            [
              101.10083383331508,
              23.184988571309923
            ],
            [
              101.10083383331508,
              23.184594579598457
            ],
            [
              101.10083383331508,
              23.184120590149064
            ],
            [
              101.10074783310137,
              23.182937616233687
            ],
            [
              101.10083383331508,
              23.182148633584887
            ],
            [
              101.1010048330193,
              23.182148633584887
            ],
            [
              101.10109083323302,
              23.182069635804893
            ],
            [
              101.10126283276217,
              23.181832640533415
            ],
            [
              101.1017778333213,
              23.181438649437464
            ],
            [
              101.1015198326801,
              23.180412672549796
            ],
            [
              101.10126283276217,
              23.17970268744898
            ],
            [
              101.10109083323302,
              23.179228698011173
            ],
            [
              101.1010048330193,
              23.178518714060665
            ],
            [
              101.10143483318963,
              23.177650733044548
            ],
            [
              101.10203483323923,
              23.177650733044548
            ],
            [
              101.10280783354119,
              23.177335740166615
            ],
            [
              101.10418083299452,
              23.177887727464668
            ],
            [
              101.1053828327436,
              23.177808729646543
            ],
            [
              101.10606883300692,
              23.177808729646543
            ],
            [
              101.1064128329635,
              23.177256742022625
            ],
            [
              101.10735683296977,
              23.17630976237666
            ],
            [
              101.10778583331512,
              23.17630976237666
            ],
            [
              101.10838683318968,
              23.17544178189857
            ],
            [
              101.10915883276843,
              23.174731797677538
            ],
            [
              101.11010283277464,
              23.17417880966714
            ],
            [
              101.11104783350405,
              23.17417880966714
            ],
            [
              101.11199183351027,
              23.173468825353304
            ],
            [
              101.11345183300222,
              23.17141787044795
            ],
            [
              101.11345183300222,
              23.171101877660185
            ],
            [
              101.1129368333414,
              23.170470891609863
            ],
            [
              101.11259283338481,
              23.169996901686073
            ],
            [
              101.1121638330394,
              23.169207918725064
            ],
            [
              101.11207783282569,
              23.16833993844403
            ],
            [
              101.11267883270023,
              23.16770895176428
            ],
            [
              101.11362277880751,
              23.16699896782345
            ],
            [
              101.11370883292017,
              23.166287983279023
            ],
            [
              101.11379483313388,
              23.16518400736784
            ],
            [
              101.11422383347927,
              23.164316026603995
            ],
            [
              101.11508183327173,
              23.16392103581767
            ],
            [
              101.11594083288912,
              23.16344804599533
            ],
            [
              101.11688483289532,
              23.161475089443147
            ],
            [
              101.11714283353652,
              23.156029209291063
            ],
            [
              101.1170568333228,
              23.155161228666085
            ],
            [
              101.1170568333228,
              23.15413525110412
            ],
            [
              101.11679883268162,
              23.152399289424558
            ],
            [
              101.11619883353032,
              23.15192629938941
            ],
            [
              101.11533983301463,
              23.15097932066124
            ],
            [
              101.11508283309666,
              23.149479353438853
            ],
            [
              101.11482483335382,
              23.147111406039144
            ],
            [
              101.11388083334761,
              23.144270468304025
            ],
            [
              101.1130858333043,
              23.142807500532605
            ],
            [
              101.11001883310905,
              23.137167624703583
            ],
            [
              101.10958883293871,
              23.136536638246966
            ],
            [
              101.10907383327792,
              23.134957673007218
            ],
            [
              101.1097608333662,
              23.134247688989188
            ],
            [
              101.11027583302699,
              23.134247688989188
            ],
            [
              101.11156383298979,
              23.134326686890653
            ],
            [
              101.11302283355512,
              23.134800676626433
            ],
            [
              101.11430983279467,
              23.135036671316495
            ],
            [
              101.11628383302083,
              23.134957673007218
            ],
            [
              101.11782883290155,
              23.135747655658093
            ],
            [
              101.11911683286435,
              23.1360626488647
            ],
            [
              101.12091883356139,
              23.136457639995278
            ],
            [
              101.12297883310292,
              23.136852631614463
            ],
            [
              101.124180832852,
              23.136931629633466
            ],
            [
              101.12555383320361,
              23.137088625997556
            ],
            [
              101.12675583295265,
              23.137167624703583
            ],
            [
              101.12701283287063,
              23.136536638246966
            ],
            [
              101.12735583300228,
              23.13558965900458
            ],
            [
              101.12778583317262,
              23.134326686890653
            ],
            [
              101.12864383296511,
              23.13369470072385
            ],
            [
              101.12975983339877,
              23.133852697131704
            ],
            [
              101.13061783319125,
              23.133852697131704
            ],
            [
              101.13173383272657,
              23.133852697131704
            ],
            [
              101.13302083286445,
              23.134326686890653
            ],
            [
              101.1340508330844,
              23.134089692220588
            ],
            [
              101.1344798334298,
              23.13306371444744
            ],
            [
              101.13499483309062,
              23.130221777677697
            ],
            [
              101.1349098327018,
              23.129116801610937
            ],
            [
              101.13499483309062,
              23.128248821025334
            ],
            [
              101.13499583291551,
              23.12666985569635
            ],
            [
              101.13551083347464,
              23.126274863828417
            ],
            [
              101.13628283305339,
              23.126038869418334
            ],
            [
              101.13714183267078,
              23.12572287618307
            ],
            [
              101.13799983336159,
              23.12532788483156
            ],
            [
              101.13877183294034,
              23.12532788483156
            ],
            [
              101.13877183294034,
              23.124696898851077
            ],
            [
              101.13868583272662,
              23.123591923540733
            ],
            [
              101.13860083323614,
              23.12311793385172
            ],
            [
              101.13851483302241,
              23.12303893513204
            ],
            [
              101.13791383314786,
              23.12256494596801
            ],
            [
              101.1373128332733,
              23.122249952457434
            ],
            [
              101.13628283305339,
              23.122012957930433
            ],
            [
              101.135853832708,
              23.121301973490272
            ],
            [
              101.13516683351807,
              23.120117999525338
            ],
            [
              101.13413683329816,
              23.11854003401952
            ],
            [
              101.1346518329589,
              23.11767105307819
            ],
            [
              101.13516683351807,
              23.116724074499228
            ],
            [
              101.13705483353048,
              23.116250084511837
            ],
            [
              101.13799983336159,
              23.11585609305961
            ],
            [
              101.13877183294034,
              23.115540100631193
            ],
            [
              101.13971583294656,
              23.115066110593737
            ],
            [
              101.14040283303481,
              23.114356126234
            ],
            [
              101.14100383290936,
              23.113724140180782
            ],
            [
              101.14108883329813,
              23.11333014875031
            ],
            [
              101.1412608328273,
              23.111909179672438
            ],
            [
              101.14100383290936,
              23.110803204275502
            ],
            [
              101.14040283303481,
              23.109698228594684
            ],
            [
              101.13954483324233,
              23.10851425472861
            ],
            [
              101.13877183294034,
              23.1072512822406
            ],
            [
              101.13851483302241,
              23.10654029810368
            ],
            [
              101.13851483302241,
              23.10598831026746
            ],
            [
              101.13842883280866,
              23.10504033130563
            ],
            [
              101.1381708330658,
              23.104251348599863
            ],
            [
              101.13799983336159,
              23.103461365605583
            ],
            [
              101.13568183317885,
              23.102909377508254
            ],
            [
              101.1345658327452,
              23.102672382712893
            ],
            [
              101.13422283351186,
              23.102119394883317
            ],
            [
              101.1335358334236,
              23.10117241568176
            ],
            [
              101.13130483327947,
              23.10117241568176
            ],
            [
              101.13018883284583,
              23.10117241568176
            ],
            [
              101.12950183275758,
              23.100382433582567
            ],
            [
              101.12950183275758,
              23.098566473057172
            ],
            [
              101.12941583344217,
              23.096119527159203
            ],
            [
              101.1273568328272,
              23.091697624033102
            ],
            [
              101.12787183338635,
              23.091065637951502
            ],
            [
              101.12907283331049,
              23.09051265027441
            ],
            [
              101.13130483327947,
              23.08996066268616
            ],
            [
              101.13242083281484,
              23.08980266584843
            ],
            [
              101.13267783273278,
              23.08980266584843
            ],
            [
              101.13293583337395,
              23.089644668824914
            ],
            [
              101.13353683324847,
              23.089486672442014
            ],
            [
              101.1349098327018,
              23.089486672442014
            ],
            [
              101.13688383292792,
              23.08885468670579
            ],
            [
              101.13774183272041,
              23.088696690220555
            ],
            [
              101.1381708330658,
              23.08806570397443
            ],
            [
              101.13885783315408,
              23.08743371816744
            ],
            [
              101.13980183316028,
              23.08774971061602
            ],
            [
              101.14040283303481,
              23.087907707388087
            ],
            [
              101.14134683304103,
              23.087907707388087
            ],
            [
              101.14186183270185,
              23.087907707388087
            ],
            [
              101.14194783291558,
              23.087196723343496
            ],
            [
              101.14177583338642,
              23.085696756254876
            ],
            [
              101.1416048327839,
              23.084670778847965
            ],
            [
              101.14151883346848,
              23.083011815178686
            ],
            [
              101.14186183270185,
              23.081590846028785
            ],
            [
              101.14237683326097,
              23.080090879197595
            ],
            [
              101.14272083321751,
              23.07874790815927
            ],
            [
              101.14194783291558,
              23.07716894341587
            ],
            [
              101.14066083277767,
              23.07590597050174
            ],
            [
              101.14031683282107,
              23.0751159878149
            ],
            [
              101.139887833374,
              23.073379026273
            ],
            [
              101.14074583316649,
              23.07258904361975
            ],
            [
              101.14186183270185,
              23.070852081677078
            ],
            [
              101.14263483300381,
              23.069667107664042
            ],
            [
              101.14409383267083,
              23.068957123080985
            ],
            [
              101.14503783267703,
              23.068799127182487
            ],
            [
              101.14555283323614,
              23.06816714090636
            ],
            [
              101.14555283323614,
              23.0669031685392
            ],
            [
              101.1461538331107,
              23.06556119812721
            ],
            [
              101.14718383333064,
              23.065324202773635
            ],
            [
              101.14829983286599,
              23.065087208655648
            ],
            [
              101.14872883321138,
              23.062402266899237
            ],
            [
              101.14864383282256,
              23.062165272594246
            ],
            [
              101.14847183329343,
              23.061534285837006
            ],
            [
              101.14795683273434,
              23.060349312413983
            ],
            [
              101.14795683273434,
              23.059322334942753
            ],
            [
              101.14812883316178,
              23.05813836035058
            ],
            [
              101.14890083274054,
              23.057032384685904
            ],
            [
              101.14967383304251,
              23.056163404398376
            ],
            [
              101.15044583351958,
              23.055610416201045
            ],
            [
              101.1519048331866,
              23.054268445595014
            ],
            [
              101.15113283270951,
              23.05316246954551
            ],
            [
              101.14984583346995,
              23.051898497600924
            ],
            [
              101.14864383282256,
              23.050319531869075
            ],
            [
              101.14907283316798,
              23.049845542451518
            ],
            [
              101.15001683317419,
              23.049055559687723
            ],
            [
              101.15070383326243,
              23.048581569954038
            ],
            [
              101.15139083335069,
              23.047791587214647
            ],
            [
              101.15224883314318,
              23.046844608132933
            ],
            [
              101.15216283292943,
              23.046212622096377
            ],
            [
              101.15302083272192,
              23.045264643267327
            ],
            [
              101.15422283336932,
              23.044316663552298
            ],
            [
              101.1550808331618,
              23.04360567976057
            ],
            [
              101.15576783325005,
              23.042420705598836
            ],
            [
              101.15550983350722,
              23.04123673118005
            ],
            [
              101.15430883268475,
              23.039972758902437
            ],
            [
              101.15319283314936,
              23.039340772863103
            ],
            [
              101.1523348333569,
              23.038471791661618
            ],
            [
              101.15147583284119,
              23.037918804388543
            ],
            [
              101.15096083318039,
              23.036970825059093
            ],
            [
              101.15044583351958,
              23.035549855835807
            ],
            [
              101.15018883270331,
              23.034364881912442
            ],
            [
              101.1492448326971,
              23.03152094397974
            ],
            [
              101.14684083319897,
              23.029625985695315
            ],
            [
              101.14529583331822,
              23.02946798911229
            ],
            [
              101.14443783352571,
              23.029388990751332
            ],
            [
              101.14272083321751,
              23.028678006726178
            ],
            [
              101.14263483300381,
              23.02859900790223
            ],
            [
              101.14246383329959,
              23.02804602062534
            ],
            [
              101.14272083321751,
              23.02694004422634
            ],
            [
              101.14306483317412,
              23.025913066638513
            ],
            [
              101.14392283296661,
              23.02433310186851
            ],
            [
              101.1438368327529,
              23.023227125599103
            ],
            [
              101.14280683343127,
              23.02196315389435
            ],
            [
              101.14212083316795,
              23.02141016585468
            ],
            [
              101.1416908329976,
              23.021015173954215
            ],
            [
              101.141090832948,
              23.020225191642844
            ],
            [
              101.1407468329914,
              23.019514207243525
            ],
            [
              101.14031783354436,
              23.01809323836675
            ],
            [
              101.1394598328535,
              23.017540250166494
            ],
            [
              101.13825783310445,
              23.016908263946483
            ],
            [
              101.13731383309823,
              23.016513272915407
            ],
            [
              101.1362838328783,
              23.01619727942302
            ],
            [
              101.13551183329955,
              23.015723289863335
            ],
            [
              101.13439583286586,
              23.01524930029157
            ],
            [
              101.13302183268938,
              23.015170302694454
            ],
            [
              101.13199183336775,
              23.01556529352447
            ],
            [
              101.130876832759,
              23.015723289863335
            ],
            [
              101.13010383335534,
              23.016434274405
            ],
            [
              101.12907383313541,
              23.01682926566744
            ],
            [
              101.1277008327838,
              23.01682926566744
            ],
            [
              101.1258988329851,
              23.01682926566744
            ],
            [
              101.12383883344354,
              23.01635527667516
            ],
            [
              101.12126383334287,
              23.01619727942302
            ],
            [
              101.11997583338008,
              23.015723289863335
            ],
            [
              101.1187748334559,
              23.015170302694454
            ],
            [
              101.11714383336147,
              23.014775310707755
            ],
            [
              101.11551283326699,
              23.014459318104553
            ],
            [
              101.11491183339245,
              23.01327434400378
            ],
            [
              101.11396783338624,
              23.01311634727685
            ],
            [
              101.11310983269543,
              23.012800354094626
            ],
            [
              101.11242283350549,
              23.01224636605589
            ],
            [
              101.1102768328519,
              23.012721355890143
            ],
            [
              101.10898983271403,
              23.013590336902507
            ],
            [
              101.10847483305321,
              23.013669335424908
            ],
            [
              101.10787383317867,
              23.013669335424908
            ],
            [
              101.10701583338619,
              23.01351133833379
            ],
            [
              101.10598583316624,
              23.012958350364855
            ],
            [
              101.10495583294632,
              23.012721355890143
            ],
            [
              101.10375483302218,
              23.012168367990082
            ],
            [
              101.10323983336134,
              23.011694378329025
            ],
            [
              101.10289583340479,
              23.011615380303695
            ],
            [
              101.10246683305935,
              23.011141390353366
            ],
            [
              101.10195183339856,
              23.01090439599395
            ],
            [
              101.10152283305312,
              23.01090439599395
            ],
            [
              101.10074983275118,
              23.01122038865625
            ],
            [
              101.10032083330411,
              23.01122038865625
            ],
            [
              101.09980583274495,
              23.011299386912928
            ],
            [
              101.0993768332979,
              23.011299386912928
            ],
            [
              101.09869083303452,
              23.01122038865625
            ],
            [
              101.09808983315997,
              23.01122038865625
            ],
            [
              101.09740283307175,
              23.01122038865625
            ],
            [
              101.09620083332267,
              23.01090439599395
            ],
            [
              101.0953428335302,
              23.01090439599395
            ],
            [
              101.0944848328394,
              23.010746398971825
            ],
            [
              101.09371183343572,
              23.010509403918544
            ],
            [
              101.09233883308411,
              23.01043040602615
            ],
            [
              101.09122283354874,
              23.010825397506014
            ],
            [
              101.09096583273252,
              23.010825397506014
            ],
            [
              101.09045083307167,
              23.011536382232094
            ],
            [
              101.08967783276968,
              23.012247366518412
            ],
            [
              101.08933483353633,
              23.012405362609485
            ],
            [
              101.08813283288899,
              23.012721355890143
            ],
            [
              101.08770383344188,
              23.012642357639375
            ],
            [
              101.08684583275108,
              23.01311634727685
            ],
            [
              101.08607283334743,
              23.01335334188444
            ],
            [
              101.08572983321575,
              23.01335334188444
            ],
            [
              101.08487183342324,
              23.01343234054567
            ],
            [
              101.08418483333502,
              23.01311634727685
            ],
            [
              101.08332683354253,
              23.01311634727685
            ],
            [
              101.08238283353633,
              23.01327434400378
            ],
            [
              101.08135283331639,
              23.01335334188444
            ],
            [
              101.08040883331017,
              23.01335334188444
            ],
            [
              101.07980783343564,
              23.01335334188444
            ],
            [
              101.07869183300198,
              23.012879352252867
            ],
            [
              101.07731883354867,
              23.012089369415488
            ],
            [
              101.07628883332873,
              23.011615380303695
            ],
            [
              101.07568783345421,
              23.011378385123287
            ],
            [
              101.07500083336593,
              23.01122038865625
            ],
            [
              101.07371383322807,
              23.011536382232094
            ],
            [
              101.07265283304599,
              23.011398384579156
            ],
            [
              101.07225483356103,
              23.011694378329025
            ],
            [
              101.07045283286405,
              23.01003441456459
            ],
            [
              101.0702808333349,
              23.009718421604983
            ],
            [
              101.06985183298949,
              23.009481427226447
            ],
            [
              101.06899283337212,
              23.009481427226447
            ],
            [
              101.06787783276337,
              23.00956042484766
            ],
            [
              101.06684783344173,
              23.00956042484766
            ],
            [
              101.06598883292605,
              23.009323430191575
            ],
            [
              101.06555983347896,
              23.009086435119187
            ],
            [
              101.0648738332156,
              23.00877044241986
            ],
            [
              101.06444383304527,
              23.008059458000975
            ],
            [
              101.0641008329136,
              23.00734847314303
            ]
          ]
        ]
      },
      "properties": {
        "name": "宁洱镇"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.22533383328128,
              23.114469124096136
            ],
            [
              101.22241483322402,
              23.11289115827445
            ],
            [
              101.22018383307991,
              23.11036421379893
            ],
            [
              101.21726583284759,
              23.108312259379925
            ],
            [
              101.21589183267106,
              23.106417300898283
            ],
            [
              101.21520583330604,
              23.10531232465352
            ],
            [
              101.21331683346868,
              23.10404935262264
            ],
            [
              101.21091383289715,
              23.101364412198226
            ],
            [
              101.21039883323633,
              23.101049418517956
            ],
            [
              101.20936883301641,
              23.1002594356954
            ],
            [
              101.20868283275306,
              23.099628450037027
            ],
            [
              101.20765283343144,
              23.098680470806254
            ],
            [
              101.20748083300396,
              23.097891487925516
            ],
            [
              101.20576383269578,
              23.096627515691758
            ],
            [
              101.20353283345004,
              23.09552253988873
            ],
            [
              101.20164383271437,
              23.095364543806184
            ],
            [
              101.20044283279023,
              23.095838533149063
            ],
            [
              101.19906883351199,
              23.095680536611802
            ],
            [
              101.19718083349957,
              23.09520654671153
            ],
            [
              101.1963228328088,
              23.094575561283804
            ],
            [
              101.19477783292807,
              23.095838533149063
            ],
            [
              101.1932328330473,
              23.097891487925516
            ],
            [
              101.19220283282739,
              23.09915446001843
            ],
            [
              101.18997083285839,
              23.099470452999128
            ],
            [
              101.18636683326098,
              23.10041743263161
            ],
            [
              101.18464983295281,
              23.101680404937873
            ],
            [
              101.18344783320372,
              23.10389135665365
            ],
            [
              101.18001483331057,
              23.104996332196286
            ],
            [
              101.17675283312164,
              23.104680338995514
            ],
            [
              101.17177483334774,
              23.10389135665365
            ],
            [
              101.16559583275134,
              23.102154394306023
            ],
            [
              101.1635358332098,
              23.10404935262264
            ],
            [
              101.16267683269409,
              23.104996332196286
            ],
            [
              101.1604458334483,
              23.10689129007365
            ],
            [
              101.15666883270025,
              23.109259238636405
            ],
            [
              101.15426583302704,
              23.11068020684389
            ],
            [
              101.15186283335382,
              23.11036421379893
            ],
            [
              101.14945883295735,
              23.11020721755834
            ],
            [
              101.14739883341583,
              23.112101175710315
            ],
            [
              101.14482383331513,
              23.11273316196829
            ],
            [
              101.14100383290936,
              23.113724140180782
            ],
            [
              101.14040283303481,
              23.114356126234
            ],
            [
              101.13971583294656,
              23.115066110593737
            ],
            [
              101.13877183294034,
              23.115540100631193
            ],
            [
              101.13799983336159,
              23.11585609305961
            ],
            [
              101.13705483353048,
              23.116250084511837
            ],
            [
              101.13516683351807,
              23.116724074499228
            ],
            [
              101.1346518329589,
              23.11767105307819
            ],
            [
              101.13413683329816,
              23.11854003401952
            ],
            [
              101.13516683351807,
              23.120117999525338
            ],
            [
              101.135853832708,
              23.121301973490272
            ],
            [
              101.13628283305339,
              23.122012957930433
            ],
            [
              101.1373128332733,
              23.122249952457434
            ],
            [
              101.13791383314786,
              23.12256494596801
            ],
            [
              101.13851483302241,
              23.12303893513204
            ],
            [
              101.13860083323614,
              23.12311793385172
            ],
            [
              101.13868583272662,
              23.123591923540733
            ],
            [
              101.13877183294034,
              23.124696898851077
            ],
            [
              101.13877183294034,
              23.12532788483156
            ],
            [
              101.13799983336159,
              23.12532788483156
            ],
            [
              101.13714183267078,
              23.12572287618307
            ],
            [
              101.13628283305339,
              23.126038869418334
            ],
            [
              101.13551083347464,
              23.126274863828417
            ],
            [
              101.13499583291551,
              23.12666985569635
            ],
            [
              101.13499483309062,
              23.128248821025334
            ],
            [
              101.1349098327018,
              23.129116801610937
            ],
            [
              101.13499483309062,
              23.130221777677697
            ],
            [
              101.1344798334298,
              23.13306371444744
            ],
            [
              101.1340508330844,
              23.134089692220588
            ],
            [
              101.13302083286445,
              23.134326686890653
            ],
            [
              101.13173383272657,
              23.133852697131704
            ],
            [
              101.13061783319125,
              23.133852697131704
            ],
            [
              101.12975983339877,
              23.133852697131704
            ],
            [
              101.12864383296511,
              23.13369470072385
            ],
            [
              101.12778583317262,
              23.134326686890653
            ],
            [
              101.12735583300228,
              23.13558965900458
            ],
            [
              101.12701283287063,
              23.136536638246966
            ],
            [
              101.12675583295265,
              23.137167624703583
            ],
            [
              101.12555383320361,
              23.137088625997556
            ],
            [
              101.124180832852,
              23.136931629633466
            ],
            [
              101.12297883310292,
              23.136852631614463
            ],
            [
              101.12091883356139,
              23.136457639995278
            ],
            [
              101.11911683286435,
              23.1360626488647
            ],
            [
              101.11782883290155,
              23.135747655658093
            ],
            [
              101.11628383302083,
              23.134957673007218
            ],
            [
              101.11430983279467,
              23.135036671316495
            ],
            [
              101.11302283355512,
              23.134800676626433
            ],
            [
              101.11156383298979,
              23.134326686890653
            ],
            [
              101.11027583302699,
              23.134247688989188
            ],
            [
              101.1097608333662,
              23.134247688989188
            ],
            [
              101.10907383327792,
              23.134957673007218
            ],
            [
              101.10958883293871,
              23.136536638246966
            ],
            [
              101.11001883310905,
              23.137167624703583
            ],
            [
              101.1130858333043,
              23.142807500532605
            ],
            [
              101.11388083334761,
              23.144270468304025
            ],
            [
              101.11482483335382,
              23.147111406039144
            ],
            [
              101.11508283309666,
              23.149479353438853
            ],
            [
              101.11533983301463,
              23.15097932066124
            ],
            [
              101.11619883353032,
              23.15192629938941
            ],
            [
              101.11679883268162,
              23.152399289424558
            ],
            [
              101.1170568333228,
              23.15413525110412
            ],
            [
              101.1170568333228,
              23.155161228666085
            ],
            [
              101.11714283353652,
              23.156029209291063
            ],
            [
              101.11688483289532,
              23.161475089443147
            ],
            [
              101.11594083288912,
              23.16344804599533
            ],
            [
              101.11508183327173,
              23.16392103581767
            ],
            [
              101.11422383347927,
              23.164316026603995
            ],
            [
              101.11379483313388,
              23.16518400736784
            ],
            [
              101.11370883292017,
              23.166287983279023
            ],
            [
              101.11362277880751,
              23.16699896782345
            ],
            [
              101.11267883270023,
              23.16770895176428
            ],
            [
              101.11207783282569,
              23.16833993844403
            ],
            [
              101.1121638330394,
              23.169207918725064
            ],
            [
              101.11259283338481,
              23.169996901686073
            ],
            [
              101.1129368333414,
              23.170470891609863
            ],
            [
              101.11345183300222,
              23.171101877660185
            ],
            [
              101.11345183300222,
              23.17141787044795
            ],
            [
              101.11199183351027,
              23.173468825353304
            ],
            [
              101.11104783350405,
              23.17417880966714
            ],
            [
              101.11010283277464,
              23.17417880966714
            ],
            [
              101.10915883276843,
              23.174731797677538
            ],
            [
              101.10838683318968,
              23.17544178189857
            ],
            [
              101.10778583331512,
              23.17630976237666
            ],
            [
              101.10735683296977,
              23.17630976237666
            ],
            [
              101.1064128329635,
              23.177256742022625
            ],
            [
              101.10606883300692,
              23.177808729646543
            ],
            [
              101.1053828327436,
              23.177808729646543
            ],
            [
              101.10418083299452,
              23.177887727464668
            ],
            [
              101.10280783354119,
              23.177335740166615
            ],
            [
              101.10203483323923,
              23.177650733044548
            ],
            [
              101.10143483318963,
              23.177650733044548
            ],
            [
              101.1010048330193,
              23.178518714060665
            ],
            [
              101.10109083323302,
              23.179228698011173
            ],
            [
              101.10126283276217,
              23.17970268744898
            ],
            [
              101.1015198326801,
              23.180412672549796
            ],
            [
              101.1017778333213,
              23.181438649437464
            ],
            [
              101.10126283276217,
              23.181832640533415
            ],
            [
              101.10109083323302,
              23.182069635804893
            ],
            [
              101.1010048330193,
              23.182148633584887
            ],
            [
              101.10083383331508,
              23.182148633584887
            ],
            [
              101.10074783310137,
              23.182937616233687
            ],
            [
              101.10083383331508,
              23.184120590149064
            ],
            [
              101.10083383331508,
              23.184594579598457
            ],
            [
              101.10083383331508,
              23.184988571309923
            ],
            [
              101.1010048330193,
              23.185541559240914
            ],
            [
              101.10117683344674,
              23.186093546543184
            ],
            [
              101.101863833535,
              23.18680353158613
            ],
            [
              101.1022928329821,
              23.187513515338
            ],
            [
              101.1022928329821,
              23.18775051045475
            ],
            [
              101.10237883319584,
              23.18830249855072
            ],
            [
              101.10160583289384,
              23.19011745845192
            ],
            [
              101.10083383331508,
              23.191537426640405
            ],
            [
              101.10074783310137,
              23.192405407564806
            ],
            [
              101.09997483279936,
              23.19358838197103
            ],
            [
              101.09928883343433,
              23.194377364026323
            ],
            [
              101.09842983291863,
              23.195008350461723
            ],
            [
              101.09782983286901,
              23.20250318494606
            ],
            [
              101.09722883299446,
              23.204159148773353
            ],
            [
              101.09602683324542,
              23.205974108101486
            ],
            [
              101.09499683302548,
              23.207236080806204
            ],
            [
              101.09388083349012,
              23.208104061359318
            ],
            [
              101.09328083344052,
              23.20905004063077
            ],
            [
              101.09319483322678,
              23.210076018244983
            ],
            [
              101.09465383289377,
              23.212047974098535
            ],
            [
              101.09937483274976,
              23.21472991508515
            ],
            [
              101.10031883275596,
              23.216228881814736
            ],
            [
              101.10091883280559,
              23.217017864791575
            ],
            [
              101.09980383309515,
              23.218200838484353
            ],
            [
              101.09903083279316,
              23.218910823069322
            ],
            [
              101.0982588332144,
              23.219857802337774
            ],
            [
              101.09782983286901,
              23.221828758535874
            ],
            [
              101.09791483325783,
              23.22230274801955
            ],
            [
              101.09834483342811,
              23.22316972920121
            ],
            [
              101.09885983308894,
              23.22419570651232
            ],
            [
              101.0986878335598,
              23.225851669756924
            ],
            [
              101.0986878335598,
              23.227429634570342
            ],
            [
              101.09842983291863,
              23.22845461248989
            ],
            [
              101.09688483303789,
              23.229164596213813
            ],
            [
              101.09654183290618,
              23.229558587796582
            ],
            [
              101.09585483281796,
              23.2313725474166
            ],
            [
              101.09465383289377,
              23.232319526628892
            ],
            [
              101.09353783335845,
              23.232950513008774
            ],
            [
              101.09250783313853,
              23.233818494020788
            ],
            [
              101.09061983312611,
              23.234922469539157
            ],
            [
              101.0896758331199,
              23.234922469539157
            ],
            [
              101.08907483324533,
              23.23531646063513
            ],
            [
              101.08958983290619,
              23.236499434815652
            ],
            [
              101.08976083350869,
              23.23807739922205
            ],
            [
              101.09044783269866,
              23.240285350726584
            ],
            [
              101.09122083300065,
              23.242178309256712
            ],
            [
              101.09242183292481,
              23.245411237852483
            ],
            [
              101.09491083281173,
              23.24706720115945
            ],
            [
              101.09516883345293,
              23.24880216253133
            ],
            [
              101.09465383289377,
              23.25132610684305
            ],
            [
              101.09439583315094,
              23.2521150895265
            ],
            [
              101.09353783335845,
              23.25314006682891
            ],
            [
              101.09276583288134,
              23.25400704740485
            ],
            [
              101.09207883279309,
              23.25479602990652
            ],
            [
              101.09225083322055,
              23.256136000780025
            ],
            [
              101.09259383335225,
              23.256924983063005
            ],
            [
              101.09370982390443,
              23.258817941463587
            ],
            [
              101.09405283301926,
              23.25984291840456
            ],
            [
              101.09422483344673,
              23.260630900769616
            ],
            [
              101.09422483344673,
              23.26165587862506
            ],
            [
              101.09431083276212,
              23.262444861248998
            ],
            [
              101.094138833233,
              23.26323384332878
            ],
            [
              101.09328083344052,
              23.264415817244274
            ],
            [
              101.09319483322678,
              23.265046803639695
            ],
            [
              101.09328083344052,
              23.266071780544777
            ],
            [
              101.09345183314474,
              23.26654477025696
            ],
            [
              101.09250783313853,
              23.269619702170644
            ],
            [
              101.09139183270486,
              23.271275665167312
            ],
            [
              101.09010483346529,
              23.27403460490508
            ],
            [
              101.08924583294957,
              23.27545457347037
            ],
            [
              101.08864583289996,
              23.27687354161178
            ],
            [
              101.08813083323915,
              23.280815454697333
            ],
            [
              101.08813083323915,
              23.28467836931146
            ],
            [
              101.08777883288664,
              23.28631133245637
            ],
            [
              101.09664083353871,
              23.28976925652613
            ],
            [
              101.10650583284993,
              23.292331199707878
            ],
            [
              101.11335483291784,
              23.29618311437202
            ],
            [
              101.11570683343572,
              23.300139026958746
            ],
            [
              101.1214768328799,
              23.29875105769167
            ],
            [
              101.12422283268478,
              23.296229113292725
            ],
            [
              101.12799983343285,
              23.30064301574648
            ],
            [
              101.12799983343285,
              23.30316595974787
            ],
            [
              101.12902983275447,
              23.304742924366572
            ],
            [
              101.13108983319432,
              23.30379694568126
            ],
            [
              101.13417983295582,
              23.30064301574648
            ],
            [
              101.13864283306893,
              23.300013029669746
            ],
            [
              101.1448228334902,
              23.300328022668484
            ],
            [
              101.14722583316342,
              23.302534973296474
            ],
            [
              101.14962883283664,
              23.303480952706295
            ],
            [
              101.15203183340819,
              23.30379694568126
            ],
            [
              101.15306183272982,
              23.304742924366572
            ],
            [
              101.15546583312629,
              23.307264869069403
            ],
            [
              101.15615183338961,
              23.307264869069403
            ],
            [
              101.15786883279948,
              23.306634883003653
            ],
            [
              101.15924183315111,
              23.303480952706295
            ],
            [
              101.16439183335245,
              23.303480952706295
            ],
            [
              101.16713783315735,
              23.30411193879552
            ],
            [
              101.17194483322707,
              23.305372910318788
            ],
            [
              101.17745883347645,
              23.30633788944514
            ],
            [
              101.17915483296994,
              23.306634883003653
            ],
            [
              101.18327483295138,
              23.307579861395723
            ],
            [
              101.18945383354772,
              23.30852584040009
            ],
            [
              101.19563383307074,
              23.312624750348448
            ],
            [
              101.19700783324724,
              23.313570728937297
            ],
            [
              101.20318683294529,
              23.31577768007703
            ],
            [
              101.21382983347968,
              23.316723659330094
            ],
            [
              101.22378683285238,
              23.318930610098032
            ],
            [
              101.22824983296549,
              23.321768546962605
            ],
            [
              101.23168283285865,
              23.324290491257152
            ],
            [
              101.23408583343017,
              23.33185632400399
            ],
            [
              101.24026583295317,
              23.33816118375116
            ],
            [
              101.24095283304143,
              23.33847717676353
            ],
            [
              101.24301283348132,
              23.34225909304026
            ],
            [
              101.24953583313595,
              23.344151051243422
            ],
            [
              101.25371283301877,
              23.344827036215026
            ],
            [
              101.25537183270235,
              23.345096030092428
            ],
            [
              101.26086583286028,
              23.345727015725625
            ],
            [
              101.2653288329734,
              23.346042009257253
            ],
            [
              101.26931883325842,
              23.34642900002795
            ],
            [
              101.25340883324515,
              23.322180538276246
            ],
            [
              101.25371283301877,
              23.31716664967918
            ],
            [
              101.25491383294292,
              23.297377087771313
            ],
            [
              101.25518883330253,
              23.29283818842544
            ],
            [
              101.24177183337417,
              23.275816564692718
            ],
            [
              101.24242283347743,
              23.268290731281333
            ],
            [
              101.24797083316373,
              23.261414884055768
            ],
            [
              101.26028883327518,
              23.259272931395227
            ],
            [
              101.26030283351888,
              23.259269931405026
            ],
            [
              101.26031583303939,
              23.259268931133164
            ],
            [
              101.26059883289659,
              23.259218932386585
            ],
            [
              101.26061283314027,
              23.259216932667428
            ],
            [
              101.26062483283583,
              23.259214932122905
            ],
            [
              101.26747183325392,
              23.258026958266964
            ],
            [
              101.27184383313042,
              23.25954292528495
            ],
            [
              101.2798058332589,
              23.262302863917558
            ],
            [
              101.29041383273487,
              23.262103868669758
            ],
            [
              101.30326083275087,
              23.252850073381573
            ],
            [
              101.31356983337436,
              23.23913337617275
            ],
            [
              101.32171383307777,
              23.238232395744635
            ],
            [
              101.33572283355817,
              23.243238285859036
            ],
            [
              101.33976983284634,
              23.241752318092473
            ],
            [
              101.34219583298409,
              23.240862338398056
            ],
            [
              101.34693783275645,
              23.234011489085912
            ],
            [
              101.34898983280038,
              23.216684872277828
            ],
            [
              101.3479288335166,
              23.206183103762037
            ],
            [
              101.34680283303724,
              23.189209477878492
            ],
            [
              101.34668383321154,
              23.18741351774978
            ],
            [
              101.34776983350797,
              23.163340048105884
            ],
            [
              101.34618483344425,
              23.159262138218452
            ],
            [
              101.34515983324721,
              23.15662519641923
            ],
            [
              101.33766883329687,
              23.149997342524184
            ],
            [
              101.336414832771,
              23.14761039479367
            ],
            [
              101.32827983328843,
              23.132127735704373
            ],
            [
              101.33396683289189,
              23.121076978089732
            ],
            [
              101.32849883267325,
              23.11763205402599
            ],
            [
              101.32712483339505,
              23.11731606082155
            ],
            [
              101.3231808331407,
              23.11683907139067
            ],
            [
              101.32112083270084,
              23.11683907139067
            ],
            [
              101.31854583349846,
              23.11683907139067
            ],
            [
              101.31579883297036,
              23.11636508180937
            ],
            [
              101.31408183356046,
              23.11194517957012
            ],
            [
              101.3123658330772,
              23.111787182976826
            ],
            [
              101.30944783284482,
              23.11083920364353
            ],
            [
              101.30790283296409,
              23.109418234640113
            ],
            [
              101.30687283274416,
              23.10799726629674
            ],
            [
              101.30532783286341,
              23.10657629696214
            ],
            [
              101.30309583289441,
              23.10689229065915
            ],
            [
              101.30000583313293,
              23.106261303938012
            ],
            [
              101.29880483320878,
              23.10420834901126
            ],
            [
              101.29554283301982,
              23.101682404533943
            ],
            [
              101.29193783269922,
              23.099785446250674
            ],
            [
              101.28884783293769,
              23.09552253988873
            ],
            [
              101.28695983292529,
              23.095048550257378
            ],
            [
              101.28301183337135,
              23.09552253988873
            ],
            [
              101.28146683349058,
              23.095838533149063
            ],
            [
              101.2783768328308,
              23.09631252247243
            ],
            [
              101.27683183295005,
              23.09520654671153
            ],
            [
              101.27459983298104,
              23.095996529500542
            ],
            [
              101.27408483332025,
              23.095048550257378
            ],
            [
              101.2706518334271,
              23.09520654671153
            ],
            [
              101.26687583340225,
              23.094890553617468
            ],
            [
              101.26412883287414,
              23.095364543806184
            ],
            [
              101.26189783273001,
              23.09631252247243
            ],
            [
              101.25847583270749,
              23.09631252247243
            ],
            [
              101.25760583321946,
              23.09631252247243
            ],
            [
              101.25520283354625,
              23.095838533149063
            ],
            [
              101.25194083335731,
              23.095048550257378
            ],
            [
              101.24661983345172,
              23.09615452649255
            ],
            [
              101.24490283314351,
              23.094732557618066
            ],
            [
              101.24335783326279,
              23.0944175640877
            ],
            [
              101.23975283294219,
              23.094890553617468
            ],
            [
              101.23855183301802,
              23.098206481574262
            ],
            [
              101.23666283318069,
              23.100575429381937
            ],
            [
              101.23391683337579,
              23.10610130773609
            ],
            [
              101.23048383348264,
              23.10957523097701
            ],
            [
              101.2272218332937,
              23.11020721755834
            ],
            [
              101.22842383304278,
              23.114154130586392
            ],
            [
              101.22739383282284,
              23.11478511656716
            ],
            [
              101.22533383328128,
              23.114469124096136
            ]
          ]
        ]
      },
      "properties": {
        "name": "磨黑镇"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              100.93220883273129,
              23.123638922068057
            ],
            [
              100.9322638329829,
              23.12240794912701
            ],
            [
              100.93337983341655,
              23.11980300688016
            ],
            [
              100.94101983332978,
              23.114514123108602
            ],
            [
              100.93955983293954,
              23.114119131812714
            ],
            [
              100.93363783315942,
              23.113567143738297
            ],
            [
              100.93604083283266,
              23.111198195413287
            ],
            [
              100.93998983310983,
              23.107725271777152
            ],
            [
              100.94033283324151,
              23.105593318676068
            ],
            [
              100.94084783290232,
              23.10338336749693
            ],
            [
              100.94093383311605,
              23.10172540410496
            ],
            [
              100.94213483304019,
              23.10109341809403
            ],
            [
              100.94376583313468,
              23.100304435338536
            ],
            [
              100.9452248328017,
              23.09833047868524
            ],
            [
              100.94711383353734,
              23.096593516317544
            ],
            [
              100.94934483278313,
              23.09461955967496
            ],
            [
              100.94977483295345,
              23.094066571748964
            ],
            [
              100.94934583350634,
              23.09311859293682
            ],
            [
              100.95543983281559,
              23.086644735358547
            ],
            [
              100.9467708334057,
              23.088223700375025
            ],
            [
              100.94589383334662,
              23.087291720973692
            ],
            [
              100.94429683268903,
              23.085594758073476
            ],
            [
              100.94179283273343,
              23.082933816768474
            ],
            [
              100.94033383306645,
              23.081985837113972
            ],
            [
              100.93947583327396,
              23.07606396714342
            ],
            [
              100.94093483294095,
              23.07156306619854
            ],
            [
              100.94187683329736,
              23.0684811339123
            ],
            [
              100.94187683329736,
              23.0656381958024
            ],
            [
              100.9447948335297,
              23.06350624290538
            ],
            [
              100.94573883353591,
              23.06208527430728
            ],
            [
              100.94616883280791,
              23.06066330547954
            ],
            [
              100.94942983317192,
              23.05892634331251
            ],
            [
              100.95080483317335,
              23.058167359748634
            ],
            [
              100.95094883311342,
              23.058087361564958
            ],
            [
              100.9515758329272,
              23.05774136924494
            ],
            [
              100.95243383271969,
              23.056083405850263
            ],
            [
              100.95372183268249,
              23.055767412566947
            ],
            [
              100.95432283345534,
              23.054977429833016
            ],
            [
              100.95406483281417,
              23.05395045270493
            ],
            [
              100.95217683280175,
              23.048422573913502
            ],
            [
              100.95294883327881,
              23.04668461148795
            ],
            [
              100.94711283281411,
              23.044867651400537
            ],
            [
              100.94299283283267,
              23.039260774240994
            ],
            [
              100.9441948334801,
              23.03696982478003
            ],
            [
              100.94505283327256,
              23.03483687148108
            ],
            [
              100.9438508335235,
              23.033809893713237
            ],
            [
              100.94127583342281,
              23.03278391669609
            ],
            [
              100.94093283329114,
              23.02954598709276
            ],
            [
              100.93921583298295,
              23.027176038990586
            ],
            [
              100.9417048328699,
              23.025754070301733
            ],
            [
              100.94213483304019,
              23.024332101495652
            ],
            [
              100.94264983270102,
              23.02306812940174
            ],
            [
              100.94324983275065,
              23.02188315487833
            ],
            [
              100.94462383292716,
              23.020935176029344
            ],
            [
              100.94393683283889,
              23.02022419123949
            ],
            [
              100.94333583296435,
              23.019356210384966
            ],
            [
              100.94264983270102,
              23.01753925057004
            ],
            [
              100.94290683351728,
              23.015485295673958
            ],
            [
              100.94419383275687,
              23.012720356257958
            ],
            [
              100.94462383292716,
              23.011139390238732
            ],
            [
              100.94745583294578,
              23.00805845833424
            ],
            [
              100.94986083316715,
              23.00545151481429
            ],
            [
              100.95131983283414,
              23.002686575660753
            ],
            [
              100.95192083270872,
              23.0011856084298
            ],
            [
              100.95260783279699,
              22.99992163609112
            ],
            [
              100.95329383306031,
              22.999526644943703
            ],
            [
              100.95389483293485,
              22.999131653467373
            ],
            [
              100.95543983281559,
              23.000000634347284
            ],
            [
              100.95758583346917,
              23.000000634347284
            ],
            [
              100.95973183322444,
              23.000158630720918
            ],
            [
              100.96282183298595,
              23.000632620385932
            ],
            [
              100.96393683269638,
              23.000000634347284
            ],
            [
              100.9648818334258,
              22.999447646410136
            ],
            [
              100.96539683308664,
              22.99842066870884
            ],
            [
              100.9649668329163,
              22.99715569636664
            ],
            [
              100.96539683308664,
              22.996049720553245
            ],
            [
              100.96565383300458,
              22.994785748087335
            ],
            [
              100.96591183274745,
              22.993521776192452
            ],
            [
              100.96668383322451,
              22.992810791660094
            ],
            [
              100.96694083314244,
              22.992020808774157
            ],
            [
              100.96608283334996,
              22.990992831018286
            ],
            [
              100.96548183347547,
              22.99091383327994
            ],
            [
              100.96552883333109,
              22.990004853172817
            ],
            [
              100.96346583341652,
              22.988344888937245
            ],
            [
              100.96312183345994,
              22.98747590829416
            ],
            [
              100.96269283311453,
              22.986684925800645
            ],
            [
              100.96200683285117,
              22.986447930676224
            ],
            [
              100.96046183297042,
              22.985578949406325
            ],
            [
              100.9571998327815,
              22.983919986029623
            ],
            [
              100.95513983323993,
              22.983209001395632
            ],
            [
              100.95393883331579,
              22.982418018726257
            ],
            [
              100.95179283356049,
              22.981707034457582
            ],
            [
              100.95007583325233,
              22.981075048332222
            ],
            [
              100.94956083269318,
              22.980127068976845
            ],
            [
              100.94724383323367,
              22.979100091554926
            ],
            [
              100.94484083356045,
              22.979258087571573
            ],
            [
              100.94381083334054,
              22.977756120544388
            ],
            [
              100.94329583278139,
              22.976571146804634
            ],
            [
              100.94200783281862,
              22.975702165688546
            ],
            [
              100.93685783351559,
              22.975069179685768
            ],
            [
              100.93496983350313,
              22.973884205542863
            ],
            [
              100.93290983306326,
              22.970407281059842
            ],
            [
              100.93222283297501,
              22.968431324742912
            ],
            [
              100.93042083317636,
              22.96803633331462
            ],
            [
              100.92578583353409,
              22.966060376254273
            ],
            [
              100.92252483317006,
              22.964954400614406
            ],
            [
              100.91866183310658,
              22.962741448661266
            ],
            [
              100.91840483318865,
              22.96195146614535
            ],
            [
              100.9191768327674,
              22.961556474811047
            ],
            [
              100.9201208327736,
              22.961239481726825
            ],
            [
              100.92097983328934,
              22.957999552924313
            ],
            [
              100.92200983350926,
              22.955075616761434
            ],
            [
              100.91926283298116,
              22.956972575305983
            ],
            [
              100.91771783310038,
              22.956972575305983
            ],
            [
              100.91668783288046,
              22.956893576704655
            ],
            [
              100.91540083274258,
              22.956181592129088
            ],
            [
              100.9108518333141,
              22.956814578057234
            ],
            [
              100.90887683326302,
              22.957367565966067
            ],
            [
              100.90801883347054,
              22.958631538583866
            ],
            [
              100.90681783354638,
              22.958631538583866
            ],
            [
              100.9060448332444,
              22.957841556048013
            ],
            [
              100.90587283281694,
              22.956102593892993
            ],
            [
              100.90484283349534,
              22.95547060799777
            ],
            [
              100.90263083271951,
              22.955707602847717
            ],
            [
              100.90241683335758,
              22.95673558019082
            ],
            [
              100.90252383348769,
              22.95801955201315
            ],
            [
              100.9021378328,
              22.95917552707924
            ],
            [
              100.90125983291603,
              22.960503498075614
            ],
            [
              100.90048983298709,
              22.96099548736586
            ],
            [
              100.89821983338325,
              22.961702471365523
            ],
            [
              100.8974488327311,
              22.96204546438431
            ],
            [
              100.8965708328471,
              22.96268745018759
            ],
            [
              100.89616483296629,
              22.963501432458845
            ],
            [
              100.89597183352073,
              22.96472240536317
            ],
            [
              100.8954368328701,
              22.96525739431918
            ],
            [
              100.8948378335437,
              22.965386391310133
            ],
            [
              100.8935528330557,
              22.965001399938984
            ],
            [
              100.89288983325683,
              22.965044398479655
            ],
            [
              100.89181883302902,
              22.96560138657295
            ],
            [
              100.8911558332302,
              22.96570838449959
            ],
            [
              100.8906418333943,
              22.96545238931908
            ],
            [
              100.88961483354744,
              22.963953422699486
            ],
            [
              100.88940083328717,
              22.963782426234424
            ],
            [
              100.88886583353488,
              22.96388942394627
            ],
            [
              100.8884158332731,
              22.964168417759485
            ],
            [
              100.8878808335208,
              22.965260394269833
            ],
            [
              100.8873888334262,
              22.966717362438267
            ],
            [
              100.8867468335438,
              22.96738134768616
            ],
            [
              100.88591283314243,
              22.967467345721317
            ],
            [
              100.88509883283255,
              22.96738234765402
            ],
            [
              100.8841148335417,
              22.966954356602876
            ],
            [
              100.88390083328147,
              22.966633363872834
            ],
            [
              100.88407183298573,
              22.96560538649695
            ],
            [
              100.88390083328147,
              22.964963400486365
            ],
            [
              100.88355883297469,
              22.96449241051944
            ],
            [
              100.88319483292663,
              22.964279415129113
            ],
            [
              100.880510833046,
              22.963858424138643
            ],
            [
              100.8797078335051,
              22.96366142850354
            ],
            [
              100.8784028329256,
              22.963341436224848
            ],
            [
              100.87673383319625,
              22.962593452394838
            ],
            [
              100.87604983348103,
              22.962165461900494
            ],
            [
              100.8757088329992,
              22.962110462362855
            ],
            [
              100.87474483290151,
              22.962445455139335
            ],
            [
              100.874038833445,
              22.96216746108621
            ],
            [
              100.8725198335035,
              22.960692494037037
            ],
            [
              100.8720928328079,
              22.960435499267096
            ],
            [
              100.871322832879,
              22.960244503732408
            ],
            [
              100.86864983286901,
              22.960076506778766
            ],
            [
              100.86768683349455,
              22.95990551120139
            ],
            [
              100.86689583275091,
              22.95954351888314
            ],
            [
              100.86445783291758,
              22.957576562155403
            ],
            [
              100.86328283293267,
              22.956923576409288
            ],
            [
              100.8625148335519,
              22.956585583046976
            ],
            [
              100.86211883281844,
              22.95605459473279
            ],
            [
              100.86208483338159,
              22.95524661265472
            ],
            [
              100.86193483269545,
              22.954603627038157
            ],
            [
              100.86107983327601,
              22.95381364413954
            ],
            [
              100.86052383270899,
              22.953471651823012
            ],
            [
              100.85958283307586,
              22.95323765658197
            ],
            [
              100.85851383339617,
              22.952468673139396
            ],
            [
              100.85795883355239,
              22.950863708636728
            ],
            [
              100.85789383325505,
              22.950285720739988
            ],
            [
              100.85701783302089,
              22.949622735207935
            ],
            [
              100.85614083296184,
              22.949624735406232
            ],
            [
              100.85487983276323,
              22.95024772211612
            ],
            [
              100.85430283317811,
              22.950654712830175
            ],
            [
              100.85250783305216,
              22.952327676113075
            ],
            [
              100.8518018326973,
              22.953527649980693
            ],
            [
              100.8511398327234,
              22.9549426196223
            ],
            [
              100.85064783352713,
              22.956784579155592
            ],
            [
              100.85036983279448,
              22.95721356935095
            ],
            [
              100.84977183329298,
              22.95755656217387
            ],
            [
              100.84872383352969,
              22.957772557516535
            ],
            [
              100.84562483354739,
              22.958912532552525
            ],
            [
              100.8447058327572,
              22.95908552861668
            ],
            [
              100.84338083298452,
              22.95979451355018
            ],
            [
              100.84251783316918,
              22.960056507994096
            ],
            [
              100.8419068332489,
              22.96009750640941
            ],
            [
              100.84130783302416,
              22.959884511540963
            ],
            [
              100.8407738330968,
              22.959542518857337
            ],
            [
              100.84015383295568,
              22.95935052286146
            ],
            [
              100.83949183298178,
              22.95933052314226
            ],
            [
              100.83773883268856,
              22.95976251360676
            ],
            [
              100.83722583267757,
              22.959634517066114
            ],
            [
              100.83654283278729,
              22.959079529268447
            ],
            [
              100.83587983298847,
              22.957817556778576
            ],
            [
              100.83538783289386,
              22.955976596474752
            ],
            [
              100.8354738331076,
              22.95494961921379
            ],
            [
              100.83585883307207,
              22.95422063488012
            ],
            [
              100.83632883342531,
              22.95366264699514
            ],
            [
              100.83750383341021,
              22.952718667622992
            ],
            [
              100.83769783268067,
              22.952420674344214
            ],
            [
              100.83771783277217,
              22.952097681698568
            ],
            [
              100.83743983293782,
              22.951712689723617
            ],
            [
              100.83684083271312,
              22.951413696624794
            ],
            [
              100.83562283307053,
              22.950366719251285
            ],
            [
              100.83476883347596,
              22.949319742048505
            ],
            [
              100.83454783354306,
              22.948806753582165
            ],
            [
              100.83453283347443,
              22.94814276813858
            ],
            [
              100.83496083309664,
              22.946428805165485
            ],
            [
              100.8349388333553,
              22.94561482273736
            ],
            [
              100.83459683304854,
              22.945037835716832
            ],
            [
              100.83419083316767,
              22.944759841462197
            ],
            [
              100.8332208332222,
              22.944610845240867
            ],
            [
              100.83261783279953,
              22.94472684196344
            ],
            [
              100.8319888333359,
              22.945032835878774
            ],
            [
              100.83143483331703,
              22.945107834257545
            ],
            [
              100.8283568332511,
              22.945113834225314
            ],
            [
              100.82775883285133,
              22.945350829017105
            ],
            [
              100.82677583338533,
              22.945972815423275
            ],
            [
              100.82555783284445,
              22.946831796132628
            ],
            [
              100.82506683347309,
              22.947389784062484
            ],
            [
              100.82485283321283,
              22.947903773049045
            ],
            [
              100.82472483316633,
              22.94882475299269
            ],
            [
              100.82472483316633,
              22.949766732038537
            ],
            [
              100.82423283307173,
              22.95060271385107
            ],
            [
              100.82361783295349,
              22.951175701609795
            ],
            [
              100.82373083293142,
              22.951654691473614
            ],
            [
              100.82386783319875,
              22.9531336589348
            ],
            [
              100.82402983268214,
              22.953637647742024
            ],
            [
              100.8247018327018,
              22.95435163260067
            ],
            [
              100.82513683289496,
              22.955236612905658
            ],
            [
              100.82522683330666,
              22.955752601969525
            ],
            [
              100.82523783317731,
              22.956547584538203
            ],
            [
              100.82513083304715,
              22.95730756757426
            ],
            [
              100.8251878329486,
              22.958679537656778
            ],
            [
              100.82499883280273,
              22.959079529268447
            ],
            [
              100.82411283342113,
              22.959777513968913
            ],
            [
              100.82258183288577,
              22.961522475262225
            ],
            [
              100.82246183323518,
              22.964423412072737
            ],
            [
              100.82254783344891,
              22.96500039995355
            ],
            [
              100.82278483327536,
              22.965286393012253
            ],
            [
              100.82309883309473,
              22.965426390608556
            ],
            [
              100.82492583300778,
              22.96525739431918
            ],
            [
              100.8252788331852,
              22.96539739111835
            ],
            [
              100.82623183341222,
              22.96675736134292
            ],
            [
              100.82604883311411,
              22.967626342069604
            ],
            [
              100.8255948335527,
              22.96864432020918
            ],
            [
              100.82572183287598,
              22.969365304088317
            ],
            [
              100.82564983290595,
              22.969835293671593
            ],
            [
              100.82538183311736,
              22.970164286648263
            ],
            [
              100.82449283336271,
              22.970645276143234
            ],
            [
              100.82329783328635,
              22.971601255341316
            ],
            [
              100.82235883330304,
              22.97218724258051
            ],
            [
              100.82131983286226,
              22.972133243744118
            ],
            [
              100.82112683341674,
              22.972280240388066
            ],
            [
              100.82101383343881,
              22.97253423518576
            ],
            [
              100.82098283347666,
              22.97370220927425
            ],
            [
              100.82086283292776,
              22.97411820062156
            ],
            [
              100.8204228327117,
              22.974926182415103
            ],
            [
              100.8198868331345,
              22.975620167557864
            ],
            [
              100.81989283298228,
              22.976125156818558
            ],
            [
              100.82013483283163,
              22.976700143750637
            ],
            [
              100.8204928330319,
              22.977237132233764
            ],
            [
              100.82049583340493,
              22.977490126919946
            ],
            [
              100.82003683292233,
              22.978074113659375
            ],
            [
              100.81992383294441,
              22.97836510743658
            ],
            [
              100.82008683315104,
              22.97890409568472
            ],
            [
              100.81982183283718,
              22.979486083172773
            ],
            [
              100.8197518334153,
              22.98006507018601
            ],
            [
              100.81987483343893,
              22.98024506641019
            ],
            [
              100.82045783287181,
              22.980453062097496
            ],
            [
              100.82057683269751,
              22.98059605848159
            ],
            [
              100.8202308330911,
              22.980961051093374
            ],
            [
              100.81961283349811,
              22.98136704212693
            ],
            [
              100.81961683279776,
              22.981656035703875
            ],
            [
              100.81997483299806,
              22.98219302351251
            ],
            [
              100.82044683300114,
              22.98254801573492
            ],
            [
              100.82115183353109,
              22.982864009443457
            ],
            [
              100.8212718331817,
              22.98304300539466
            ],
            [
              100.82127483355471,
              22.983331998694467
            ],
            [
              100.82116183267851,
              22.983585993394136
            ],
            [
              100.82043283275745,
              22.984426974552534
            ],
            [
              100.82018383323543,
              22.985044961336573
            ],
            [
              100.81693683311511,
              22.98514195956485
            ],
            [
              100.81430883331097,
              22.985571949746717
            ],
            [
              100.80890683321454,
              22.987144915646127
            ],
            [
              100.80859483304502,
              22.987290912678137
            ],
            [
              100.80689583317849,
              22.98857988441901
            ],
            [
              100.80426683354943,
              22.991160827583357
            ],
            [
              100.80364983288308,
              22.991882811840092
            ],
            [
              100.80009883298914,
              22.993599774285133
            ],
            [
              100.7988638327298,
              22.993596774136698
            ],
            [
              100.79833083352564,
              22.993732771427315
            ],
            [
              100.79720483304622,
              22.995297736800456
            ],
            [
              100.79641383320089,
              22.996902702129635
            ],
            [
              100.79629783284994,
              22.99835567000378
            ],
            [
              100.7965418332474,
              23.00000763408588
            ],
            [
              100.79717283325917,
              23.001862593360805
            ],
            [
              100.79749183310138,
              23.002550578294546
            ],
            [
              100.7979418333632,
              23.00247958002244
            ],
            [
              100.79862583307839,
              23.002026589957957
            ],
            [
              100.79944083321318,
              23.00193859217165
            ],
            [
              100.79993183348287,
              23.00176159588668
            ],
            [
              100.80078383342759,
              23.001254607121453
            ],
            [
              100.80178683298502,
              23.00037962605008
            ],
            [
              100.80210783337536,
              23.000218629933837
            ],
            [
              100.80257383353072,
              23.000195629646083
            ],
            [
              100.80258783287609,
              23.000277628568842
            ],
            [
              100.80051983293862,
              23.00360855495765
            ],
            [
              100.8002508333251,
              23.004591534013436
            ],
            [
              100.80066183322883,
              23.00480752941827
            ],
            [
              100.80294883344939,
              23.005222520365848
            ],
            [
              100.80304483281056,
              23.005598511580246
            ],
            [
              100.80236683294315,
              23.00594150396267
            ],
            [
              100.80157483327291,
              23.006647488752765
            ],
            [
              100.80041283280849,
              23.007168477491657
            ],
            [
              100.80010683338503,
              23.007605467978838
            ],
            [
              100.79988383290394,
              23.008761442985897
            ],
            [
              100.79994383317846,
              23.00900843688016
            ],
            [
              100.800511833441,
              23.00939342851348
            ],
            [
              100.8006308332667,
              23.009861418416474
            ],
            [
              100.80055483309869,
              23.010489405157738
            ],
            [
              100.80027083341659,
              23.011407384664064
            ],
            [
              100.79928183320453,
              23.01327434400378
            ],
            [
              100.79894483292063,
              23.014388319484095
            ],
            [
              100.79879383330791,
              23.01578728886142
            ],
            [
              100.79880983320142,
              23.016962263067924
            ],
            [
              100.79845383354927,
              23.019892199123138
            ],
            [
              100.79823383344124,
              23.020273190325476
            ],
            [
              100.79789883280718,
              23.0205261853904
            ],
            [
              100.7976178334981,
              23.02059518328561
            ],
            [
              100.79464683356231,
              23.02064618221049
            ],
            [
              100.79404283331473,
              23.020771179266827
            ],
            [
              100.79366583284785,
              23.021011174017765
            ],
            [
              100.79349483314364,
              23.021293168420456
            ],
            [
              100.79301783311764,
              23.022077151232008
            ],
            [
              100.79183783310991,
              23.023411122009644
            ],
            [
              100.79165883300975,
              23.02374011425129
            ],
            [
              100.79135183286307,
              23.024984087567585
            ],
            [
              100.79121383277082,
              23.025195082383625
            ],
            [
              100.7906398335588,
              23.02552907539909
            ],
            [
              100.78813083268203,
              23.026488054810322
            ],
            [
              100.7875378332034,
              23.026378056845857
            ],
            [
              100.78650983353164,
              23.026417055908965
            ],
            [
              100.78322883307612,
              23.02765902862991
            ],
            [
              100.78213883348003,
              23.02837801333229
            ],
            [
              100.78157783289016,
              23.02859400867627
            ],
            [
              100.78118483342809,
              23.028651007447266
            ],
            [
              100.78070383320414,
              23.028552009218306
            ],
            [
              100.78031783341474,
              23.02884000311275
            ],
            [
              100.77985283308438,
              23.029061998089766
            ],
            [
              100.77967583353235,
              23.02951298846142
            ],
            [
              100.78029483295023,
              23.030366969605858
            ],
            [
              100.78025483276727,
              23.031106953253687
            ],
            [
              100.78043183321758,
              23.03161994168148
            ],
            [
              100.7811438334202,
              23.032219929077733
            ],
            [
              100.7813548333074,
              23.032521921985037
            ],
            [
              100.78142483272929,
              23.033729895940738
            ],
            [
              100.78194483331129,
              23.034156886643075
            ],
            [
              100.78223683338933,
              23.03466987503503
            ],
            [
              100.7827708333167,
              23.0347898724923
            ],
            [
              100.7832068333348,
              23.03506486660664
            ],
            [
              100.78380383301138,
              23.034911869604766
            ],
            [
              100.78426083294586,
              23.034895869854214
            ],
            [
              100.7856078333582,
              23.03549385696576
            ],
            [
              100.78608083318622,
              23.036515834541053
            ],
            [
              100.78606683294252,
              23.03822079775092
            ],
            [
              100.78613483271458,
              23.038402792996834
            ],
            [
              100.78735383308039,
              23.039299773709548
            ],
            [
              100.7872018327444,
              23.039637766701805
            ],
            [
              100.7875358335536,
              23.040115755867287
            ],
            [
              100.78749883284534,
              23.040622744860222
            ],
            [
              100.78760483315055,
              23.040906738411895
            ],
            [
              100.78763383346289,
              23.041469725797477
            ],
            [
              100.78777683267971,
              23.041793719033638
            ],
            [
              100.78797483304639,
              23.041838718399973
            ],
            [
              100.78810783311582,
              23.04145872640123
            ],
            [
              100.78827283297225,
              23.041239731095565
            ],
            [
              100.7883748330795,
              23.041231731596227
            ],
            [
              100.78872783325693,
              23.041457726155492
            ],
            [
              100.78887283302188,
              23.041889716726804
            ],
            [
              100.78942983341379,
              23.04210071235472
            ],
            [
              100.78965383282147,
              23.042471704531945
            ],
            [
              100.78994783344763,
              23.042663699710154
            ],
            [
              100.79024783302329,
              23.0427136991415
            ],
            [
              100.79136883347982,
              23.042547702776588
            ],
            [
              100.79225583268631,
              23.042922694662302
            ],
            [
              100.79256583320601,
              23.043218687811187
            ],
            [
              100.79257983344974,
              23.043713677257752
            ],
            [
              100.79275383352702,
              23.044177666989373
            ],
            [
              100.79295983339134,
              23.044309663633666
            ],
            [
              100.79335383267833,
              23.04434566344748
            ],
            [
              100.79365783335024,
              23.04449366019299
            ],
            [
              100.79381383298585,
              23.044910650952986
            ],
            [
              100.79447183276179,
              23.045581635789148
            ],
            [
              100.79447683278467,
              23.04592962837125
            ],
            [
              100.7942038329732,
              23.04624462138741
            ],
            [
              100.79347383322722,
              23.046775609623747
            ],
            [
              100.79279483353491,
              23.046997604808897
            ],
            [
              100.79237483341034,
              23.04695360571782
            ],
            [
              100.79189383318639,
              23.046647612918687
            ],
            [
              100.79078983334662,
              23.046242621793578
            ],
            [
              100.78919783271188,
              23.04610162431587
            ],
            [
              100.78809083339735,
              23.04619562265074
            ],
            [
              100.78712283310172,
              23.045871630083305
            ],
            [
              100.7861998330119,
              23.046467616829755
            ],
            [
              100.78489783280544,
              23.046969605689576
            ],
            [
              100.78410483331027,
              23.047747588382933
            ],
            [
              100.78367983316282,
              23.047816587220733
            ],
            [
              100.78328183277956,
              23.047738589071002
            ],
            [
              100.7828618335533,
              23.047520593430484
            ],
            [
              100.78066183337138,
              23.04617962258705
            ],
            [
              100.7798768333738,
              23.04602162640244
            ],
            [
              100.77952983304417,
              23.04609962471991
            ],
            [
              100.77879983329821,
              23.047119602439043
            ],
            [
              100.77847383288497,
              23.047274599207743
            ],
            [
              100.77723483332596,
              23.04733559749783
            ],
            [
              100.7769338330271,
              23.04744959486514
            ],
            [
              100.77600883328745,
              23.048255577776487
            ],
            [
              100.77581883331666,
              23.04869156797831
            ],
            [
              100.77582683281426,
              23.04926955539891
            ],
            [
              100.77517183341135,
              23.04992754093897
            ],
            [
              100.7747798328759,
              23.050733523071212
            ],
            [
              100.77423883327582,
              23.053118470815637
            ],
            [
              100.77408983331291,
              23.05366145860594
            ],
            [
              100.77321083270571,
              23.054937430625817
            ],
            [
              100.77296183318369,
              23.056133404431794
            ],
            [
              100.77277383286271,
              23.056371399574402
            ],
            [
              100.77210683286592,
              23.056409398912706
            ],
            [
              100.77186183354185,
              23.056610394429416
            ],
            [
              100.7718728334125,
              23.05682138930978
            ],
            [
              100.77225083280598,
              23.057459375907214
            ],
            [
              100.77228983316402,
              23.057933364968843
            ],
            [
              100.77211183288883,
              23.058310357230777
            ],
            [
              100.77169983316014,
              23.058820345851995
            ],
            [
              100.7714428332422,
              23.060088317704675
            ],
            [
              100.77068183353411,
              23.060400311169037
            ],
            [
              100.77045783322811,
              23.060661305273307
            ],
            [
              100.7707178335191,
              23.061288291597208
            ],
            [
              100.77074983330616,
              23.062429266851748
            ],
            [
              100.77155883269484,
              23.063908233931503
            ],
            [
              100.77162383299218,
              23.06496221139106
            ],
            [
              100.77142883299852,
              23.065230205397185
            ],
            [
              100.7708088328574,
              23.065297203402043
            ],
            [
              100.77059383277225,
              23.065440200746885
            ],
            [
              100.77052483317526,
              23.065788193240103
            ],
            [
              100.77066483291733,
              23.066202183978145
            ],
            [
              100.77062983275727,
              23.066372180349
            ],
            [
              100.77010883324866,
              23.066959167571614
            ],
            [
              100.76993883336935,
              23.067403157126655
            ],
            [
              100.76986883304919,
              23.068018143689827
            ],
            [
              100.77003783310354,
              23.06959210906219
            ],
            [
              100.76993383334646,
              23.06974410629532
            ],
            [
              100.76949683350345,
              23.0699631015175
            ],
            [
              100.76934483316748,
              23.070164096626197
            ],
            [
              100.76910983299086,
              23.072132053592924
            ],
            [
              100.76831183347285,
              23.075161986781268
            ],
            [
              100.76838283271964,
              23.07562097724085
            ],
            [
              100.7688098334152,
              23.07659195596537
            ],
            [
              100.76880783286705,
              23.077008946456367
            ],
            [
              100.76808183331906,
              23.077576933974555
            ],
            [
              100.76795783347049,
              23.07799092479418
            ],
            [
              100.76795583292234,
              23.07850391393194
            ],
            [
              100.76808383296887,
              23.078952904057637
            ],
            [
              100.76799283273228,
              23.0797448864403
            ],
            [
              100.76761583316375,
              23.080529869428943
            ],
            [
              100.76688483269457,
              23.081254853326264
            ],
            [
              100.76654183346119,
              23.08218283266303
            ],
            [
              100.76507783287299,
              23.083680800256673
            ],
            [
              100.76496583271995,
              23.084079791528715
            ],
            [
              100.76494983282647,
              23.08464477915284
            ],
            [
              100.76517083275941,
              23.085753754816
            ],
            [
              100.76468883271056,
              23.086201744782223
            ],
            [
              100.76398183342913,
              23.086403740323036
            ],
            [
              100.76367283273433,
              23.08669573406055
            ],
            [
              100.76365483319097,
              23.08832169862451
            ],
            [
              100.76345383334953,
              23.08859869224452
            ],
            [
              100.76237883292374,
              23.08920367882784
            ],
            [
              100.76047683356596,
              23.090020660746273
            ],
            [
              100.76004883304546,
              23.09009765929176
            ],
            [
              100.75852583290605,
              23.090079659721585
            ],
            [
              100.75774783347951,
              23.09026865591458
            ],
            [
              100.75740083314986,
              23.090597648408732
            ],
            [
              100.75736483316484,
              23.090815643669792
            ],
            [
              100.75756783355443,
              23.09142663026197
            ],
            [
              100.7575578335087,
              23.0917186238295
            ],
            [
              100.75741883269318,
              23.091875620196376
            ],
            [
              100.75722383269952,
              23.09199161757845
            ],
            [
              100.75671683343464,
              23.09205061651481
            ],
            [
              100.75585483344419,
              23.09177162282881
            ],
            [
              100.75566083327544,
              23.091918619600914
            ],
            [
              100.75551183331251,
              23.09242560844856
            ],
            [
              100.75527883278569,
              23.092536606025515
            ],
            [
              100.75504483333229,
              23.092539605623745
            ],
            [
              100.75484683296555,
              23.092361609513638
            ],
            [
              100.7545528332377,
              23.091580626524088
            ],
            [
              100.75435283322113,
              23.091440630154835
            ],
            [
              100.75421383330398,
              23.091386631150318
            ],
            [
              100.75374983279846,
              23.09152762827578
            ],
            [
              100.75310483344133,
              23.091468629109798
            ],
            [
              100.75271883275364,
              23.091536627964196
            ],
            [
              100.7524558329879,
              23.091879620506685
            ],
            [
              100.75212883274976,
              23.09315459208702
            ],
            [
              100.7518998333192,
              23.09355458318951
            ],
            [
              100.75147083297381,
              23.093595582340402
            ],
            [
              100.75123583279715,
              23.09352658384284
            ],
            [
              100.75012383345981,
              23.09276960023904
            ],
            [
              100.7497678329093,
              23.092468606850762
            ],
            [
              100.74976683308441,
              23.092372609707176
            ],
            [
              100.75012383345981,
              23.09211661533628
            ],
            [
              100.75064983299126,
              23.091655625256838
            ],
            [
              100.7504968328304,
              23.09134163182561
            ],
            [
              100.75012383345981,
              23.09130463314081
            ],
            [
              100.74888283335267,
              23.091357631477052
            ],
            [
              100.74853983322096,
              23.092006617282475
            ],
            [
              100.74826683340953,
              23.0921876134689
            ],
            [
              100.74791583288192,
              23.092155614361733
            ],
            [
              100.7475778327731,
              23.091732623691914
            ],
            [
              100.74747883303891,
              23.09172862337724
            ],
            [
              100.74716883341752,
              23.091838620832263
            ],
            [
              100.74658483326141,
              23.092241612151536
            ],
            [
              100.74631483292468,
              23.09225461209128
            ],
            [
              100.74617183280957,
              23.092169614178633
            ],
            [
              100.74547483267551,
              23.0912276344605
            ],
            [
              100.744183833238,
              23.0905696492723
            ],
            [
              100.74351283304325,
              23.0900356606703
            ],
            [
              100.74307383355048,
              23.089317676257036
            ],
            [
              100.74268083319004,
              23.089140679902584
            ],
            [
              100.74091983339926,
              23.088942684740882
            ],
            [
              100.74016983356182,
              23.088469694934723
            ],
            [
              100.73981483283626,
              23.088123702256297
            ],
            [
              100.73965883320064,
              23.087808709761894
            ],
            [
              100.73948083292541,
              23.0864287397664
            ],
            [
              100.73901283312024,
              23.0860477481415
            ],
            [
              100.73906383317389,
              23.08576275406469
            ],
            [
              100.73969683283546,
              23.08498177156934
            ],
            [
              100.73969383336076,
              23.08480077559536
            ],
            [
              100.73939883290961,
              23.08430078640021
            ],
            [
              100.73905883315099,
              23.084048792073187
            ],
            [
              100.73865383309506,
              23.084008793245037
            ],
            [
              100.73814483328202,
              23.08418678884799
            ],
            [
              100.73735183288856,
              23.084933772811397
            ],
            [
              100.73688583273325,
              23.08519176665679
            ],
            [
              100.73559283274757,
              23.08491677329886
            ],
            [
              100.73414883314916,
              23.085075769190556
            ],
            [
              100.73367483349625,
              23.08468377786724
            ],
            [
              100.73300083292848,
              23.083895795375582
            ],
            [
              100.73182283346884,
              23.08343780582461
            ],
            [
              100.73098583269446,
              23.082740820422956
            ],
            [
              100.7305808335368,
              23.082056835639573
            ],
            [
              100.73045683278994,
              23.080597868032328
            ],
            [
              100.73006183277971,
              23.080240875394136
            ],
            [
              100.72959383297457,
              23.08037287303256
            ],
            [
              100.72931983333817,
              23.080294874744197
            ],
            [
              100.72923183347463,
              23.07952589144344
            ],
            [
              100.72911083310083,
              23.079274897221943
            ],
            [
              100.72887883329719,
              23.079073901679475
            ],
            [
              100.72859983273966,
              23.079026902431725
            ],
            [
              100.7275118327934,
              23.079543890773962
            ],
            [
              100.72727683351506,
              23.079473892537465
            ],
            [
              100.72719383277607,
              23.07911290035701
            ],
            [
              100.72738083327214,
              23.078424915414793
            ],
            [
              100.7273368328912,
              23.078099922773962
            ],
            [
              100.72723583350722,
              23.077955925689455
            ],
            [
              100.72631283341738,
              23.077459936571618
            ],
            [
              100.72599583322497,
              23.077137944019828
            ],
            [
              100.72540683304601,
              23.07689094940317
            ],
            [
              100.72434283338917,
              23.077173943317785
            ],
            [
              100.7227248328152,
              23.078109922508396
            ],
            [
              100.72210283302428,
              23.078368917023653
            ],
            [
              100.72171583340999,
              23.078661910000534
            ],
            [
              100.72143283355277,
              23.07867491042724
            ],
            [
              100.72081883325944,
              23.078493914226804
            ],
            [
              100.72014983271451,
              23.078496914138427
            ],
            [
              100.71991083323823,
              23.078295918259453
            ],
            [
              100.7197858335648,
              23.077560934335718
            ],
            [
              100.7191678330735,
              23.07714894380632
            ],
            [
              100.71899083352146,
              23.07692894873165
            ],
            [
              100.71878783313188,
              23.075944970098032
            ],
            [
              100.71858583346555,
              23.07544098105546
            ],
            [
              100.718273833296,
              23.07504998973752
            ],
            [
              100.71797783301997,
              23.07489699271764
            ],
            [
              100.71763783326135,
              23.075376982298604
            ],
            [
              100.71745683351139,
              23.075812973071674
            ],
            [
              100.71729983315257,
              23.07696594724103
            ],
            [
              100.71712283270223,
              23.07722594228671
            ],
            [
              100.71684883306585,
              23.077191942963147
            ],
            [
              100.71562983270003,
              23.07666195404921
            ],
            [
              100.71484983272533,
              23.076075967006304
            ],
            [
              100.71425683324674,
              23.076313961586383
            ],
            [
              100.71387083345736,
              23.07671495319986
            ],
            [
              100.71344383276178,
              23.076935948606756
            ],
            [
              100.71324783294315,
              23.076901949209887
            ],
            [
              100.71265983348746,
              23.076322961466925
            ],
            [
              100.7123338330742,
              23.076162965153777
            ],
            [
              100.71216183354508,
              23.076256963155455
            ],
            [
              100.71195683350564,
              23.076877949630454
            ],
            [
              100.7116878329938,
              23.07720494270551
            ],
            [
              100.71120983314296,
              23.077323939462442
            ],
            [
              100.71043683284097,
              23.077289940163666
            ],
            [
              100.70961883323145,
              23.07751393538561
            ],
            [
              100.70945283355009,
              23.077395937949113
            ],
            [
              100.709269833252,
              23.07692694876726
            ],
            [
              100.70885983317316,
              23.076292962689234
            ],
            [
              100.70810783278758,
              23.07557697841592
            ],
            [
              100.70794383275603,
              23.074964991690095
            ],
            [
              100.70774483346271,
              23.07471299722159
            ],
            [
              100.7074328332932,
              23.07478899544566
            ],
            [
              100.70665183349361,
              23.075688975847257
            ],
            [
              100.70631483320973,
              23.076245963295975
            ],
            [
              100.70578383275709,
              23.076663954017523
            ],
            [
              100.70685683353307,
              23.07826491912322
            ],
            [
              100.70807383335071,
              23.079066901089213
            ],
            [
              100.7123608328384,
              23.079762886567956
            ],
            [
              100.71603783312905,
              23.079905883410202
            ],
            [
              100.71711683285446,
              23.080127878489833
            ],
            [
              100.71775283288905,
              23.08054286884861
            ],
            [
              100.71824983300655,
              23.08131685186578
            ],
            [
              100.71899683336922,
              23.084409784223112
            ],
            [
              100.71871983335983,
              23.08570775534117
            ],
            [
              100.71852683301597,
              23.0874747167066
            ],
            [
              100.71852683301597,
              23.087824709007563
            ],
            [
              100.71860683338191,
              23.08807170337042
            ],
            [
              100.7205988331514,
              23.09433556627505
            ],
            [
              100.73575183275628,
              23.10251338615846
            ],
            [
              100.73953783282681,
              23.104557341739095
            ],
            [
              100.74291983356464,
              23.10618830545183
            ],
            [
              100.75760783283908,
              23.113272149784144
            ],
            [
              100.78282583266999,
              23.11282815971731
            ],
            [
              100.80811983356716,
              23.11687007071546
            ],
            [
              100.81017783345888,
              23.119462013929994
            ],
            [
              100.81811483347305,
              23.12945879439867
            ],
            [
              100.82095683353742,
              23.131030759583375
            ],
            [
              100.82355783267903,
              23.132468727855123
            ],
            [
              100.82468483298334,
              23.13309171463586
            ],
            [
              100.85140083283933,
              23.1397175686972
            ],
            [
              100.85949583303717,
              23.152685282685358
            ],
            [
              100.86508383290646,
              23.161636085845736
            ],
            [
              100.87182383319443,
              23.173534823760807
            ],
            [
              100.87048783355104,
              23.188591491842182
            ],
            [
              100.87297783326288,
              23.190798443139684
            ],
            [
              100.88357183339349,
              23.184271587313475
            ],
            [
              100.90013783353291,
              23.193900374756453
            ],
            [
              100.90273783284961,
              23.19082744277925
            ],
            [
              100.90514083342117,
              23.19011745845192
            ],
            [
              100.90797383326468,
              23.190038459597584
            ],
            [
              100.91011883319506,
              23.190038459597584
            ],
            [
              100.91226483295034,
              23.190038459597584
            ],
            [
              100.91312383346606,
              23.189565470414497
            ],
            [
              100.91449683291933,
              23.188539493095313
            ],
            [
              100.91552683313927,
              23.187119524457064
            ],
            [
              100.91612783301379,
              23.185226565946405
            ],
            [
              100.91647083314547,
              23.18285961811231
            ],
            [
              100.91638483293175,
              23.180649667033208
            ],
            [
              100.91629883271803,
              23.179387694446206
            ],
            [
              100.91604183280008,
              23.177651733102024
            ],
            [
              100.9178438334971,
              23.176231764520985
            ],
            [
              100.91998983325236,
              23.173706819833157
            ],
            [
              100.92428083293802,
              23.16944591417343
            ],
            [
              100.9259978332462,
              23.163449046158934
            ],
            [
              100.92402383302009,
              23.16060810877659
            ],
            [
              100.92385283331588,
              23.158793148428483
            ],
            [
              100.926512832907,
              23.156504198487553
            ],
            [
              100.92900183279399,
              23.1539792542913
            ],
            [
              100.93028983275674,
              23.151927299639006
            ],
            [
              100.93054683267468,
              23.149875344949788
            ],
            [
              100.9308908335296,
              23.148218381398163
            ],
            [
              100.93586883330349,
              23.14687641058899
            ],
            [
              100.93784283352967,
              23.144035473654995
            ],
            [
              100.93870083332213,
              23.14308849451247
            ],
            [
              100.93775683331592,
              23.142456508342068
            ],
            [
              100.93372283354825,
              23.138983584228043
            ],
            [
              100.93131983297667,
              23.136536638246966
            ],
            [
              100.93063283288842,
              23.134799676249024
            ],
            [
              100.93054783339792,
              23.132984716628112
            ],
            [
              100.93071883310218,
              23.131405751698644
            ],
            [
              100.93046183318421,
              23.129827785943483
            ],
            [
              100.93209183345377,
              23.126275864269424
            ],
            [
              100.93220883273129,
              23.123638922068057
            ]
          ]
        ]
      },
      "properties": {
        "name": "德化镇"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.16046783318963,
              22.891969992808715
            ],
            [
              101.16181583342687,
              22.890727020050896
            ],
            [
              101.16353283283674,
              22.890094033967486
            ],
            [
              101.16816783337731,
              22.890411026405047
            ],
            [
              101.17194383340214,
              22.890569023319976
            ],
            [
              101.17709383270518,
              22.890569023319976
            ],
            [
              101.18464683347807,
              22.8908850165979
            ],
            [
              101.1911698331327,
              22.891991992765956
            ],
            [
              101.19460283302585,
              22.892782975091286
            ],
            [
              101.19769283278737,
              22.892782975091286
            ],
            [
              101.19906683296385,
              22.89136000649199
            ],
            [
              101.19889483343475,
              22.888671064481258
            ],
            [
              101.19837983287564,
              22.886457112661063
            ],
            [
              101.20129783310799,
              22.88455915425138
            ],
            [
              101.20438783286944,
              22.883136185496355
            ],
            [
              101.20335783354784,
              22.88171221612207
            ],
            [
              101.20232783332791,
              22.880131250853392
            ],
            [
              101.20267083345958,
              22.8787072814117
            ],
            [
              101.2000968331838,
              22.877284312566886
            ],
            [
              101.19820783334649,
              22.87459537148064
            ],
            [
              101.19666283346572,
              22.872064426228704
            ],
            [
              101.19374483323338,
              22.869850474259184
            ],
            [
              101.19386683343212,
              22.868952494291214
            ],
            [
              101.19408783336503,
              22.867319529157875
            ],
            [
              101.19494683298247,
              22.86542157060795
            ],
            [
              101.19219983335262,
              22.865263574227175
            ],
            [
              101.19322983267426,
              22.86320761881159
            ],
            [
              101.19322983267426,
              22.859727694814385
            ],
            [
              101.19065483347192,
              22.859569698435205
            ],
            [
              101.1911698331327,
              22.85861971890082
            ],
            [
              101.18859483303206,
              22.857986732976954
            ],
            [
              101.18567683279967,
              22.857512743011196
            ],
            [
              101.18258683303821,
              22.85545578791333
            ],
            [
              101.17949683327669,
              22.85466480504135
            ],
            [
              101.17829483352766,
              22.851500873886824
            ],
            [
              101.17486183273616,
              22.848336942778943
            ],
            [
              101.17348883328283,
              22.845490004694714
            ],
            [
              101.17268383319383,
              22.843088056275388
            ],
            [
              101.17230883327512,
              22.842999058626127
            ],
            [
              101.17183883292185,
              22.842347072471565
            ],
            [
              101.17149583279014,
              22.842086078280836
            ],
            [
              101.17078983333363,
              22.84223407530508
            ],
            [
              101.1702518332083,
              22.8421820761452
            ],
            [
              101.1698148333653,
              22.84180808411751
            ],
            [
              101.16871183335043,
              22.841428092302312
            ],
            [
              101.16758383322122,
              22.84145509168392
            ],
            [
              101.16649383272681,
              22.841200097862703
            ],
            [
              101.16501883316624,
              22.840428114651267
            ],
            [
              101.16391483332649,
              22.839979124252604
            ],
            [
              101.1636318334693,
              22.839802128220335
            ],
            [
              101.16303683344252,
              22.839052143950845
            ],
            [
              101.16225483291971,
              22.83856215525139
            ],
            [
              101.16099783291902,
              22.838185162927154
            ],
            [
              101.15982083328434,
              22.83800216730636
            ],
            [
              101.15868483275918,
              22.837936168513185
            ],
            [
              101.15829583349507,
              22.83834515950286
            ],
            [
              101.15807383283891,
              22.83885814852783
            ],
            [
              101.15787183317255,
              22.839003145491457
            ],
            [
              101.15756683267568,
              22.839055144210754
            ],
            [
              101.15694083268681,
              22.839006144924582
            ],
            [
              101.15583983322009,
              22.83876215080138
            ],
            [
              101.15423083286692,
              22.838736150974313
            ],
            [
              101.15402883320057,
              22.838849148562755
            ],
            [
              101.15401483295685,
              22.839047144345397
            ],
            [
              101.1547978333046,
              22.839396136895854
            ],
            [
              101.15494883291734,
              22.839745129378876
            ],
            [
              101.15443983310429,
              22.84090210374073
            ],
            [
              101.15462983307509,
              22.84203707925851
            ],
            [
              101.15406383336065,
              22.843758042299754
            ],
            [
              101.15267483311551,
              22.845088013131416
            ],
            [
              101.15095283278448,
              22.846104991057576
            ],
            [
              101.14965583349915,
              22.846576980997497
            ],
            [
              101.14895983319006,
              22.846746977109706
            ],
            [
              101.145373833136,
              22.846834974760505
            ],
            [
              101.14465883345866,
              22.847106969246614
            ],
            [
              101.14453583343501,
              22.847332964494864
            ],
            [
              101.14429283286246,
              22.847623957607215
            ],
            [
              101.14402983309671,
              22.8479429506955
            ],
            [
              101.14376183330812,
              22.848212945410353
            ],
            [
              101.14357983283494,
              22.848317943256244
            ],
            [
              101.14317983280186,
              22.84855593752156
            ],
            [
              101.14218883293998,
              22.84882693186189
            ],
            [
              101.14108283345037,
              22.848698934877298
            ],
            [
              101.13862083332761,
              22.849233923193488
            ],
            [
              101.13743683312192,
              22.84974091166562
            ],
            [
              101.13664883275128,
              22.84993390811613
            ],
            [
              101.13608883288462,
              22.850323899382662
            ],
            [
              101.1358118328752,
              22.850698891171923
            ],
            [
              101.13543483330666,
              22.850994884525676
            ],
            [
              101.13427083319243,
              22.850893887089647
            ],
            [
              101.1334308329433,
              22.85066389195995
            ],
            [
              101.13253983353884,
              22.850809888755098
            ],
            [
              101.13206483316267,
              22.85098188454026
            ],
            [
              101.13124583282995,
              22.851550872805312
            ],
            [
              101.13090383342148,
              22.851566871892423
            ],
            [
              101.13056183311473,
              22.85131987796274
            ],
            [
              101.13023883307453,
              22.851172880889884
            ],
            [
              101.12976683307143,
              22.851232879072345
            ],
            [
              101.12903883297528,
              22.851509873842524
            ],
            [
              101.12835983328299,
              22.852168859045427
            ],
            [
              101.1279968330598,
              22.852260857284566
            ],
            [
              101.1273638333982,
              22.852175858976633
            ],
            [
              101.12688683337224,
              22.85231285590185
            ],
            [
              101.1265418326924,
              22.852642848605484
            ],
            [
              101.12632383313253,
              22.853132837899235
            ],
            [
              101.12600383346542,
              22.853344833324638
            ],
            [
              101.12507783300254,
              22.853340833398377
            ],
            [
              101.12357483295456,
              22.85350283031719
            ],
            [
              101.12153283295639,
              22.854327812458976
            ],
            [
              101.12118683334998,
              22.8543668114517
            ],
            [
              101.12091683301325,
              22.85424081383784
            ],
            [
              101.12018483271909,
              22.854068818036595
            ],
            [
              101.11856983341652,
              22.854127816620842
            ],
            [
              101.1177738335483,
              22.85423681393794
            ],
            [
              101.11619383350747,
              22.854924799125925
            ],
            [
              101.11537483317471,
              22.85486480008945
            ],
            [
              101.11422183293114,
              22.854938798704183
            ],
            [
              101.11364483334607,
              22.854755803275868
            ],
            [
              101.11275683341633,
              22.85471980348127
            ],
            [
              101.1116568328762,
              22.854237813912924
            ],
            [
              101.11101283334398,
              22.854311812868968
            ],
            [
              101.11005383326913,
              22.854946798462507
            ],
            [
              101.10949083302944,
              22.85510279531157
            ],
            [
              101.10893883355871,
              22.855161794274853
            ],
            [
              101.1086228331912,
              22.855101795342925
            ],
            [
              101.10830983319677,
              22.85491979927624
            ],
            [
              101.1080728333703,
              22.854944798522965
            ],
            [
              101.10797883276067,
              22.85507679612507
            ],
            [
              101.10788383322442,
              22.855708782391737
            ],
            [
              101.1077368329113,
              22.855952776738278
            ],
            [
              101.10740283300048,
              22.856231770917784
            ],
            [
              101.10676483331602,
              22.85657976328247
            ],
            [
              101.10552583285872,
              22.856803758600567
            ],
            [
              101.10514783346525,
              22.857010753494965
            ],
            [
              101.10484583334147,
              22.857404744961507
            ],
            [
              101.10265683303018,
              22.85812572973319
            ],
            [
              101.10151783303031,
              22.85864271840973
            ],
            [
              101.1012668329601,
              22.858034731271417
            ],
            [
              101.10112083337026,
              22.857955732948493
            ],
            [
              101.10038383305327,
              22.8580967304574
            ],
            [
              101.10018083356202,
              22.85803173143021
            ],
            [
              101.09862683346046,
              22.856745759478713
            ],
            [
              101.09785283333352,
              22.8563287686888
            ],
            [
              101.09736083323894,
              22.85625377004284
            ],
            [
              101.09637783287467,
              22.856557763382394
            ],
            [
              101.09604983281164,
              22.85674675943524
            ],
            [
              101.09547483287635,
              22.85756574205339
            ],
            [
              101.09501283291898,
              22.857936733942264
            ],
            [
              101.09366483268174,
              22.85826872612865
            ],
            [
              101.09242183292481,
              22.85869271718471
            ],
            [
              101.09144483330662,
              22.858659718260167
            ],
            [
              101.09083083301329,
              22.85881571415908
            ],
            [
              101.0900768329779,
              22.859541698575732
            ],
            [
              101.08978883309778,
              22.860105686119017
            ],
            [
              101.08955283309623,
              22.860352681467756
            ],
            [
              101.0881488327825,
              22.861482656431278
            ],
            [
              101.08655683304605,
              22.862266639118833
            ],
            [
              101.0852128330068,
              22.862521633991136
            ],
            [
              101.08405983276322,
              22.862887626038606
            ],
            [
              101.08376783268518,
              22.862880625831316
            ],
            [
              101.08315283346523,
              22.862639631245397
            ],
            [
              101.08248683329339,
              22.862021644600944
            ],
            [
              101.08087383274226,
              22.861462657168495
            ],
            [
              101.08054183337956,
              22.86141965803999
            ],
            [
              101.07943183279365,
              22.861662652974726
            ],
            [
              101.07896883301137,
              22.861663652895082
            ],
            [
              101.07816383292237,
              22.862027644934827
            ],
            [
              101.07641083352748,
              22.862426636330657
            ],
            [
              101.07566283333985,
              22.862027644934827
            ],
            [
              101.07499383279496,
              22.86218064135699
            ],
            [
              101.07443683330132,
              22.861865648243228
            ],
            [
              101.07340083323365,
              22.862085643458133
            ],
            [
              101.07259083312172,
              22.862308638891466
            ],
            [
              101.07145983351776,
              22.862266639118833
            ],
            [
              101.0683088327586,
              22.862616631585187
            ],
            [
              101.06618483274463,
              22.86389360430761
            ],
            [
              101.06384383299566,
              22.865693565151915
            ],
            [
              101.061961832831,
              22.868010514781943
            ],
            [
              101.06174983311892,
              22.869452483007255
            ],
            [
              101.06217383344148,
              22.870123468898747
            ],
            [
              101.06268883310224,
              22.87075645456785
            ],
            [
              101.06311783344768,
              22.871309442740767
            ],
            [
              101.06320383276307,
              22.87206142669729
            ],
            [
              101.06380483353593,
              22.873049404538488
            ],
            [
              101.06397683306507,
              22.873484395643484
            ],
            [
              101.06221683309916,
              22.874275378218123
            ],
            [
              101.06019983321532,
              22.875185358090523
            ],
            [
              101.05964183299847,
              22.87672732465432
            ],
            [
              101.05908383278167,
              22.87751730757279
            ],
            [
              101.05745383341043,
              22.878901277070618
            ],
            [
              101.05590883352968,
              22.87989025625028
            ],
            [
              101.05363383300464,
              22.88099723187939
            ],
            [
              101.0487418334445,
              22.881435222505644
            ],
            [
              101.04723983322141,
              22.881277225717394
            ],
            [
              101.04655283313316,
              22.88183121385748
            ],
            [
              101.04663883334688,
              22.88281919179255
            ],
            [
              101.04650983347545,
              22.88451915506996
            ],
            [
              101.04620983300148,
              22.88566612987895
            ],
            [
              101.04565183278469,
              22.88681310492696
            ],
            [
              101.04530883355132,
              22.887089099422724
            ],
            [
              101.04479383299218,
              22.886931102594406
            ],
            [
              101.0443648335451,
              22.88712909867441
            ],
            [
              101.04389183281876,
              22.88701010061775
            ],
            [
              101.04367783345683,
              22.886299116752244
            ],
            [
              101.04346283337169,
              22.88598212298632
            ],
            [
              101.0426478332369,
              22.885626131023745
            ],
            [
              101.04170383323067,
              22.885785127458718
            ],
            [
              101.03925783300144,
              22.885785127458718
            ],
            [
              101.0369398328187,
              22.88499414489859
            ],
            [
              101.03500883314858,
              22.885073143221703
            ],
            [
              101.03380683339954,
              22.88455915425138
            ],
            [
              101.03307783347847,
              22.88424316114175
            ],
            [
              101.03174683295964,
              22.883768171168075
            ],
            [
              101.03028783329265,
              22.88325418304978
            ],
            [
              101.02968783324302,
              22.88301718807723
            ],
            [
              101.0287858330696,
              22.882503198770696
            ],
            [
              101.02801383349082,
              22.882463199811095
            ],
            [
              101.02728383284658,
              22.882187205840925
            ],
            [
              101.02651183326782,
              22.882187205840925
            ],
            [
              101.02530983351873,
              22.881870212404078
            ],
            [
              101.02466583308816,
              22.881317225026454
            ],
            [
              101.02329283273656,
              22.8810402306041
            ],
            [
              101.02226283341496,
              22.880842235574253
            ],
            [
              101.02118983353733,
              22.87981425758187
            ],
            [
              101.02041783306024,
              22.87906327413766
            ],
            [
              101.01968783331428,
              22.87847028677828
            ],
            [
              101.01955883344284,
              22.878114294980552
            ],
            [
              101.01925883296889,
              22.877798301767566
            ],
            [
              101.01891583283722,
              22.877244313725036
            ],
            [
              101.01891583283722,
              22.876928320142802
            ],
            [
              101.01891583283722,
              22.876414331787352
            ],
            [
              101.01891583283722,
              22.875662347930255
            ],
            [
              101.01840083317643,
              22.874793366515238
            ],
            [
              101.01779983330186,
              22.874397375329732
            ],
            [
              101.01655483299679,
              22.874516372854515
            ],
            [
              101.01551983275398,
              22.874061382680697
            ],
            [
              100.99904983287404,
              22.877985297640958
            ],
            [
              100.98798383274037,
              22.88749109004184
            ],
            [
              100.98512683350567,
              22.90163178266559
            ],
            [
              100.98335983296874,
              22.912141553292173
            ],
            [
              100.9809818334099,
              22.91362852085971
            ],
            [
              100.9767858332605,
              22.91625046374224
            ],
            [
              100.96999683346706,
              22.920493371241196
            ],
            [
              100.95905783355504,
              22.93197612074699
            ],
            [
              100.94684383320062,
              22.932093117768908
            ],
            [
              100.92847783291234,
              22.926986229481635
            ],
            [
              100.92029583267579,
              22.929579173132066
            ],
            [
              100.91441183342884,
              22.936972011323377
            ],
            [
              100.90856383326859,
              22.94758277977617
            ],
            [
              100.90366383331248,
              22.953595648953247
            ],
            [
              100.90332483337878,
              22.953998640082485
            ],
            [
              100.90314483345372,
              22.95480862229161
            ],
            [
              100.90263083271951,
              22.955707602847717
            ],
            [
              100.90484283349534,
              22.95547060799777
            ],
            [
              100.90587283281694,
              22.956102593892993
            ],
            [
              100.9060448332444,
              22.957841556048013
            ],
            [
              100.90681783354638,
              22.958631538583866
            ],
            [
              100.90801883347054,
              22.958631538583866
            ],
            [
              100.90887683326302,
              22.957367565966067
            ],
            [
              100.9108518333141,
              22.956814578057234
            ],
            [
              100.91540083274258,
              22.956181592129088
            ],
            [
              100.91668783288046,
              22.956893576704655
            ],
            [
              100.91771783310038,
              22.956972575305983
            ],
            [
              100.91926283298116,
              22.956972575305983
            ],
            [
              100.92200983350926,
              22.955075616761434
            ],
            [
              100.92097983328934,
              22.957999552924313
            ],
            [
              100.9201208327736,
              22.961239481726825
            ],
            [
              100.9191768327674,
              22.961556474811047
            ],
            [
              100.91840483318865,
              22.96195146614535
            ],
            [
              100.91866183310658,
              22.962741448661266
            ],
            [
              100.92252483317006,
              22.964954400614406
            ],
            [
              100.92578583353409,
              22.966060376254273
            ],
            [
              100.93042083317636,
              22.96803633331462
            ],
            [
              100.93222283297501,
              22.968431324742912
            ],
            [
              100.93290983306326,
              22.970407281059842
            ],
            [
              100.93496983350313,
              22.973884205542863
            ],
            [
              100.93685783351559,
              22.975069179685768
            ],
            [
              100.94200783281862,
              22.975702165688546
            ],
            [
              100.94329583278139,
              22.976571146804634
            ],
            [
              100.94381083334054,
              22.977756120544388
            ],
            [
              100.94484083356045,
              22.979258087571573
            ],
            [
              100.94724383323367,
              22.979100091554926
            ],
            [
              100.94956083269318,
              22.980127068976845
            ],
            [
              100.95007583325233,
              22.981075048332222
            ],
            [
              100.95179283356049,
              22.981707034457582
            ],
            [
              100.95393883331579,
              22.982418018726257
            ],
            [
              100.95513983323993,
              22.983209001395632
            ],
            [
              100.9571998327815,
              22.983919986029623
            ],
            [
              100.96046183297042,
              22.985578949406325
            ],
            [
              100.96200683285117,
              22.986447930676224
            ],
            [
              100.96269283311453,
              22.986684925800645
            ],
            [
              100.96312183345994,
              22.98747590829416
            ],
            [
              100.96346583341652,
              22.988344888937245
            ],
            [
              100.96552883333109,
              22.990004853172817
            ],
            [
              100.96565383300458,
              22.98759590556086
            ],
            [
              100.96616883356367,
              22.98648993001001
            ],
            [
              100.96737083331277,
              22.985698947531347
            ],
            [
              100.96857183323692,
              22.98380298834436
            ],
            [
              100.96908683289772,
              22.982618014708553
            ],
            [
              100.96831383349408,
              22.978430105838783
            ],
            [
              100.967541833017,
              22.974005202394782
            ],
            [
              100.9677128327212,
              22.972740230479285
            ],
            [
              100.96874283294113,
              22.97234523923571
            ],
            [
              100.97200483313009,
              22.973135222222645
            ],
            [
              100.97449383301705,
              22.974084200923496
            ],
            [
              100.9756098334507,
              22.97519017713094
            ],
            [
              100.97612483311153,
              22.976533147296124
            ],
            [
              100.97715483333145,
              22.97669114383305
            ],
            [
              100.97790883336687,
              22.976952138718076
            ],
            [
              100.97852783278475,
              22.97716613388507
            ],
            [
              100.97990083313636,
              22.978114113338506
            ],
            [
              100.98135983280338,
              22.97819311111933
            ],
            [
              100.9828188333687,
              22.97795611681125
            ],
            [
              100.98487883291027,
              22.97819311111933
            ],
            [
              100.98762583343836,
              22.978667100969588
            ],
            [
              100.99071583319987,
              22.979773076885603
            ],
            [
              100.9922608330806,
              22.981275043821583
            ],
            [
              100.99406283287931,
              22.982697013164064
            ],
            [
              100.9948358331813,
              22.982223023392187
            ],
            [
              100.99517883331293,
              22.980247066155528
            ],
            [
              100.9954358332309,
              22.97882509749253
            ],
            [
              100.9962088335329,
              22.977798120099255
            ],
            [
              100.99595083289172,
              22.977087135503822
            ],
            [
              100.99646583345084,
              22.97590116095522
            ],
            [
              100.99689583272283,
              22.974637189331496
            ],
            [
              100.99758183298621,
              22.974242197842383
            ],
            [
              100.99955583321233,
              22.97432119623256
            ],
            [
              101.00101483287935,
              22.97432119623256
            ],
            [
              101.00187383339507,
              22.9744791920473
            ],
            [
              101.00264583297377,
              22.97511117842164
            ],
            [
              101.00367583319374,
              22.97542717132758
            ],
            [
              101.00487783294282,
              22.97550616985214
            ],
            [
              101.00556483303107,
              22.97503218049323
            ],
            [
              101.0066798327415,
              22.97376820818572
            ],
            [
              101.0093408330559,
              22.9764541493719
            ],
            [
              101.01277383294908,
              22.97882509749253
            ],
            [
              101.0173228332759,
              22.97321422043281
            ],
            [
              101.02470483344625,
              22.97092327013379
            ],
            [
              101.02676483298781,
              22.971002268809677
            ],
            [
              101.02882483342768,
              22.97037028224525
            ],
            [
              101.03062783305127,
              22.970054289095668
            ],
            [
              101.03594883295685,
              22.971002268809677
            ],
            [
              101.03912483293206,
              22.97345221470916
            ],
            [
              101.0392108331458,
              22.97558516833052
            ],
            [
              101.03663583304512,
              22.978114113338506
            ],
            [
              101.0365498328314,
              22.981591037199532
            ],
            [
              101.03818083292585,
              22.98467296930134
            ],
            [
              101.03989683340912,
              22.987200913914617
            ],
            [
              101.04118483337196,
              22.98759590556086
            ],
            [
              101.04247183350981,
              22.98807089531482
            ],
            [
              101.04418883291969,
              22.98759590556086
            ],
            [
              101.04624883335953,
              22.989808857411738
            ],
            [
              101.04667683298173,
              22.992415800381373
            ],
            [
              101.04727783285628,
              22.99265379473729
            ],
            [
              101.04796483294453,
              22.99304878614679
            ],
            [
              101.04925183308242,
              22.99368077247942
            ],
            [
              101.0497718327661,
              22.993793769960835
            ],
            [
              101.05012083274553,
              22.993763770997287
            ],
            [
              101.05067183328968,
              22.99372477159048
            ],
            [
              101.05118683295049,
              22.993986765586822
            ],
            [
              101.05183083338105,
              22.99435275816697
            ],
            [
              101.05217083313967,
              22.99526073818673
            ],
            [
              101.05337183306382,
              22.99573472768397
            ],
            [
              101.05405883315208,
              22.996287715946128
            ],
            [
              101.05397283293834,
              22.99691970200242
            ],
            [
              101.05431583307004,
              22.9969987003615
            ],
            [
              101.05465983302662,
              22.997235695161482
            ],
            [
              101.05500283315828,
              22.997867680914496
            ],
            [
              101.05534583328996,
              22.99818367433534
            ],
            [
              101.0555178328191,
              22.998657663493162
            ],
            [
              101.0559468331645,
              22.998973656718604
            ],
            [
              101.05603283337823,
              22.998973656718604
            ],
            [
              101.05637583350989,
              22.999289650031223
            ],
            [
              101.0568908331707,
              22.99960664316039
            ],
            [
              101.05723483312731,
              22.99984363751632
            ],
            [
              101.05766383347269,
              23.000080632283062
            ],
            [
              101.05800683270604,
              23.000238629389937
            ],
            [
              101.05826483334724,
              23.000317627460575
            ],
            [
              101.05877983300805,
              23.000712618774063
            ],
            [
              101.05895083271226,
              23.00079161739417
            ],
            [
              101.05920883335345,
              23.001028612150236
            ],
            [
              101.05937983305766,
              23.001344604786635
            ],
            [
              101.0595518334851,
              23.0015815993986
            ],
            [
              101.05989483271846,
              23.001818594421348
            ],
            [
              101.06015283335965,
              23.001897592394158
            ],
            [
              101.06049583349132,
              23.002134587688914
            ],
            [
              101.06109683336587,
              23.002450581043533
            ],
            [
              101.0613548331087,
              23.002608577029985
            ],
            [
              101.06178383345413,
              23.002924570101758
            ],
            [
              101.06221283290121,
              23.003398559975935
            ],
            [
              101.06272783346034,
              23.00395154826347
            ],
            [
              101.06307083269367,
              23.004267540671435
            ],
            [
              101.0631568329074,
              23.00458353399325
            ],
            [
              101.06358583325283,
              23.00521552007085
            ],
            [
              101.06384383299566,
              23.006005502640072
            ],
            [
              101.0641008329136,
              23.00734847314303
            ],
            [
              101.06444383304527,
              23.008059458000975
            ],
            [
              101.0648738332156,
              23.00877044241986
            ],
            [
              101.06555983347896,
              23.009086435119187
            ],
            [
              101.06598883292605,
              23.009323430191575
            ],
            [
              101.06684783344173,
              23.00956042484766
            ],
            [
              101.06787783276337,
              23.00956042484766
            ],
            [
              101.06899283337212,
              23.009481427226447
            ],
            [
              101.06985183298949,
              23.009481427226447
            ],
            [
              101.0702808333349,
              23.009718421604983
            ],
            [
              101.07045283286405,
              23.01003441456459
            ],
            [
              101.07225483356103,
              23.011694378329025
            ],
            [
              101.07265283304599,
              23.011398384579156
            ],
            [
              101.07371383322807,
              23.011536382232094
            ],
            [
              101.07500083336593,
              23.01122038865625
            ],
            [
              101.07568783345421,
              23.011378385123287
            ],
            [
              101.07628883332873,
              23.011615380303695
            ],
            [
              101.07731883354867,
              23.012089369415488
            ],
            [
              101.07869183300198,
              23.012879352252867
            ],
            [
              101.07980783343564,
              23.01335334188444
            ],
            [
              101.08040883331017,
              23.01335334188444
            ],
            [
              101.08135283331639,
              23.01335334188444
            ],
            [
              101.08238283353633,
              23.01327434400378
            ],
            [
              101.08332683354253,
              23.01311634727685
            ],
            [
              101.08418483333502,
              23.01311634727685
            ],
            [
              101.08487183342324,
              23.01343234054567
            ],
            [
              101.08572983321575,
              23.01335334188444
            ],
            [
              101.08607283334743,
              23.01335334188444
            ],
            [
              101.08684583275108,
              23.01311634727685
            ],
            [
              101.08770383344188,
              23.012642357639375
            ],
            [
              101.08813283288899,
              23.012721355890143
            ],
            [
              101.08933483353633,
              23.012405362609485
            ],
            [
              101.08967783276968,
              23.012247366518412
            ],
            [
              101.09045083307167,
              23.011536382232094
            ],
            [
              101.09096583273252,
              23.010825397506014
            ],
            [
              101.09122283354874,
              23.010825397506014
            ],
            [
              101.09233883308411,
              23.01043040602615
            ],
            [
              101.09371183343572,
              23.010509403918544
            ],
            [
              101.0944848328394,
              23.010746398971825
            ],
            [
              101.0953428335302,
              23.01090439599395
            ],
            [
              101.09620083332267,
              23.01090439599395
            ],
            [
              101.09740283307175,
              23.01122038865625
            ],
            [
              101.09808983315997,
              23.01122038865625
            ],
            [
              101.09869083303452,
              23.01122038865625
            ],
            [
              101.0993768332979,
              23.011299386912928
            ],
            [
              101.09980583274495,
              23.011299386912928
            ],
            [
              101.10032083330411,
              23.01122038865625
            ],
            [
              101.10074983275118,
              23.01122038865625
            ],
            [
              101.10152283305312,
              23.01090439599395
            ],
            [
              101.10195183339856,
              23.01090439599395
            ],
            [
              101.10246683305935,
              23.011141390353366
            ],
            [
              101.10289583340479,
              23.011615380303695
            ],
            [
              101.10323983336134,
              23.011694378329025
            ],
            [
              101.10375483302218,
              23.012168367990082
            ],
            [
              101.10495583294632,
              23.012721355890143
            ],
            [
              101.10598583316624,
              23.012958350364855
            ],
            [
              101.10701583338619,
              23.01351133833379
            ],
            [
              101.10787383317867,
              23.013669335424908
            ],
            [
              101.10847483305321,
              23.013669335424908
            ],
            [
              101.10898983271403,
              23.013590336902507
            ],
            [
              101.1102768328519,
              23.012721355890143
            ],
            [
              101.11242283350549,
              23.01224636605589
            ],
            [
              101.11310983269543,
              23.012800354094626
            ],
            [
              101.11396783338624,
              23.01311634727685
            ],
            [
              101.11491183339245,
              23.01327434400378
            ],
            [
              101.11551283326699,
              23.014459318104553
            ],
            [
              101.11714383336147,
              23.014775310707755
            ],
            [
              101.1187748334559,
              23.015170302694454
            ],
            [
              101.11997583338008,
              23.015723289863335
            ],
            [
              101.12126383334287,
              23.01619727942302
            ],
            [
              101.12383883344354,
              23.01635527667516
            ],
            [
              101.1258988329851,
              23.01682926566744
            ],
            [
              101.1277008327838,
              23.01682926566744
            ],
            [
              101.12907383313541,
              23.01682926566744
            ],
            [
              101.13010383335534,
              23.016434274405
            ],
            [
              101.130876832759,
              23.015723289863335
            ],
            [
              101.13199183336775,
              23.01556529352447
            ],
            [
              101.13302183268938,
              23.015170302694454
            ],
            [
              101.13439583286586,
              23.01524930029157
            ],
            [
              101.13551183329955,
              23.015723289863335
            ],
            [
              101.1362838328783,
              23.01619727942302
            ],
            [
              101.13731383309823,
              23.016513272915407
            ],
            [
              101.13825783310445,
              23.016908263946483
            ],
            [
              101.1394598328535,
              23.017540250166494
            ],
            [
              101.14031783354436,
              23.01809323836675
            ],
            [
              101.14344883331368,
              23.015443296266696
            ],
            [
              101.14756783347019,
              23.01212536874029
            ],
            [
              101.14945683330754,
              23.00943942760357
            ],
            [
              101.14945683330754,
              23.004225541906322
            ],
            [
              101.15151683284905,
              22.999484645530217
            ],
            [
              101.15563683283051,
              22.999010655968583
            ],
            [
              101.16044283307527,
              23.00280357269553
            ],
            [
              101.16267483304429,
              23.00280357269553
            ],
            [
              101.16507783271749,
              23.00327756299467
            ],
            [
              101.17022783291887,
              23.001538600909495
            ],
            [
              101.17160083327042,
              22.99980063847355
            ],
            [
              101.17297383272374,
              22.992373801236557
            ],
            [
              101.1731458331512,
              22.98763290462077
            ],
            [
              101.17330883335782,
              22.98759290610599
            ],
            [
              101.1736108334816,
              22.987519906945966
            ],
            [
              101.17640783334014,
              22.986842922043547
            ],
            [
              101.17863883348423,
              22.987000918928658
            ],
            [
              101.17881883340931,
              22.986824922732147
            ],
            [
              101.18121383268657,
              22.984472973880354
            ],
            [
              101.18327383312648,
              22.98320800154486
            ],
            [
              101.18378883278726,
              22.980996049755312
            ],
            [
              101.18293083299477,
              22.978151112514286
            ],
            [
              101.1843038333464,
              22.975148177592544
            ],
            [
              101.18361683325814,
              22.972777229472207
            ],
            [
              101.18190083277484,
              22.97135526077956
            ],
            [
              101.18018383336496,
              22.96961629871985
            ],
            [
              101.17709383270518,
              22.969142309383024
            ],
            [
              101.17434783290028,
              22.96851032322091
            ],
            [
              101.17125783313878,
              22.97024828467397
            ],
            [
              101.16868283303809,
              22.97024828467397
            ],
            [
              101.16507783271749,
              22.969774295071854
            ],
            [
              101.1600998329436,
              22.9675623434007
            ],
            [
              101.16215983338347,
              22.964875402539963
            ],
            [
              101.16336083330759,
              22.963610429557374
            ],
            [
              101.16627983336487,
              22.96313644066995
            ],
            [
              101.16816783337731,
              22.96187146796218
            ],
            [
              101.16971283325802,
              22.959817512445
            ],
            [
              101.16936883330145,
              22.95681357883839
            ],
            [
              101.16868283303809,
              22.953336654617964
            ],
            [
              101.1678248332456,
              22.951755689180324
            ],
            [
              101.17108583271133,
              22.948593758307545
            ],
            [
              101.17263083349039,
              22.946380805882217
            ],
            [
              101.17228783335871,
              22.943693865318235
            ],
            [
              101.17383283323949,
              22.94195490249948
            ],
            [
              101.1753778331202,
              22.941480913017447
            ],
            [
              101.17606383338354,
              22.940057944370658
            ],
            [
              101.17829583335255,
              22.937370003024064
            ],
            [
              101.18138583311406,
              22.936422023386154
            ],
            [
              101.18378783296235,
              22.935631040872963
            ],
            [
              101.18344483283069,
              22.93389207872564
            ],
            [
              101.18275783274244,
              22.93215311658432
            ],
            [
              101.1813848332891,
              22.930256158463088
            ],
            [
              101.18018283354007,
              22.930098161463373
            ],
            [
              101.17966783298093,
              22.92804320660224
            ],
            [
              101.17846683305677,
              22.927094226769235
            ],
            [
              101.17880983318844,
              22.925671258343762
            ],
            [
              101.17640683351523,
              22.92535526504704
            ],
            [
              101.17554883282442,
              22.92535526504704
            ],
            [
              101.17314483332628,
              22.924723278724468
            ],
            [
              101.17142883284299,
              22.925039271840603
            ],
            [
              101.16902483334484,
              22.92488127537467
            ],
            [
              101.16765183299329,
              22.92424828903646
            ],
            [
              101.16730883286158,
              22.921244354520294
            ],
            [
              101.16627883353996,
              22.91792442717478
            ],
            [
              101.16507683289258,
              22.916975447623514
            ],
            [
              101.16404683267265,
              22.916659454732127
            ],
            [
              101.16250183279189,
              22.916185465254724
            ],
            [
              101.1616438329994,
              22.916026468874012
            ],
            [
              101.15958383345787,
              22.914762496449082
            ],
            [
              101.15615083356471,
              22.914287506597002
            ],
            [
              101.15597883313727,
              22.914287506597002
            ],
            [
              101.15494883291734,
              22.911441568807593
            ],
            [
              101.15536783321697,
              22.910747583853734
            ],
            [
              101.15587683303,
              22.90990360192628
            ],
            [
              101.15752383301803,
              22.90717266180727
            ],
            [
              101.16078583320694,
              22.90511670640397
            ],
            [
              101.16456183323177,
              22.902270768088393
            ],
            [
              101.16473383276092,
              22.899739823333537
            ],
            [
              101.16524883332,
              22.897684868275167
            ],
            [
              101.1637038334393,
              22.895786909667315
            ],
            [
              101.15992783341446,
              22.892466982095353
            ],
            [
              101.16016283269278,
              22.89225098687853
            ],
            [
              101.16046783318963,
              22.891969992808715
            ]
          ]
        ]
      },
      "properties": {
        "name": "同心镇"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.3049588327925,
              22.8792562694971
            ],
            [
              101.29312883347595,
              22.875942342009953
            ],
            [
              101.28550183308322,
              22.87343539635165
            ],
            [
              101.28158083329342,
              22.87149443874854
            ],
            [
              101.27326983318547,
              22.8671425331265
            ],
            [
              101.26714283336594,
              22.864452591672688
            ],
            [
              101.26425783274554,
              22.861396658173305
            ],
            [
              101.25840283291257,
              22.858028731588984
            ],
            [
              101.25306083309061,
              22.854449809270783
            ],
            [
              101.24837983341763,
              22.853177837131565
            ],
            [
              101.24269283291582,
              22.85256485044753
            ],
            [
              101.2347758329932,
              22.85189286478227
            ],
            [
              101.22738283295219,
              22.850323899382662
            ],
            [
              101.22222083305526,
              22.849041927418266
            ],
            [
              101.21561083336196,
              22.846119990750783
            ],
            [
              101.21287883290248,
              22.83872315147285
            ],
            [
              101.21235883321876,
              22.831842300959583
            ],
            [
              101.21417083306319,
              22.829599350107674
            ],
            [
              101.22005083301055,
              22.824032470773847
            ],
            [
              101.22692183281973,
              22.818722586164363
            ],
            [
              101.2337328332528,
              22.815239661794596
            ],
            [
              101.23809083288559,
              22.81126074762585
            ],
            [
              101.2416408329546,
              22.809984775465068
            ],
            [
              101.24453883309545,
              22.80858480590672
            ],
            [
              101.24971983325895,
              22.803625914112494
            ],
            [
              101.24929283346171,
              22.80292992926989
            ],
            [
              101.24902283312495,
              22.80194795023595
            ],
            [
              101.24869983308479,
              22.799070012296436
            ],
            [
              101.2481888327236,
              22.798775019031602
            ],
            [
              101.24732883328129,
              22.798721019897805
            ],
            [
              101.24645183322222,
              22.798817018527142
            ],
            [
              101.24518783354891,
              22.79913301139855
            ],
            [
              101.2445108335064,
              22.799302007584178
            ],
            [
              101.24328483346785,
              22.799703998541247
            ],
            [
              101.24212283300348,
              22.800284986178426
            ],
            [
              101.23975783296505,
              22.801081969315604
            ],
            [
              101.23876883275301,
              22.80168495571324
            ],
            [
              101.2368118331436,
              22.80385790909825
            ],
            [
              101.23595183280298,
              22.804460895635255
            ],
            [
              101.23511383310198,
              22.804482894849198
            ],
            [
              101.23442583318881,
              22.804267900120642
            ],
            [
              101.23343683297678,
              22.804419896563804
            ],
            [
              101.23266283284988,
              22.804419896563804
            ],
            [
              101.23214683336415,
              22.80429089970775
            ],
            [
              101.23145883345099,
              22.80368891276495
            ],
            [
              101.23092183315055,
              22.803689912283254
            ],
            [
              101.2303418331924,
              22.80386190882273
            ],
            [
              101.22838583340793,
              22.805390875643287
            ],
            [
              101.22737583327951,
              22.80549987307784
            ],
            [
              101.22664483281031,
              22.805220879219736
            ],
            [
              101.22591383323942,
              22.805586871393054
            ],
            [
              101.22466783310941,
              22.807286833940278
            ],
            [
              101.22352883310955,
              22.8073528326869
            ],
            [
              101.22258283345349,
              22.807052839180347
            ],
            [
              101.22122883336846,
              22.806946841471373
            ],
            [
              101.21987583310833,
              22.807119837533506
            ],
            [
              101.21886583297989,
              22.80709983856001
            ],
            [
              101.21776983353605,
              22.806498851102752
            ],
            [
              101.21721083349429,
              22.80641285286817
            ],
            [
              101.21665283327746,
              22.80669384741874
            ],
            [
              101.21607283331934,
              22.80731783392014
            ],
            [
              101.2155568329353,
              22.807361832250034
            ],
            [
              101.21506283319088,
              22.80718983598783
            ],
            [
              101.2143108328053,
              22.806566850053603
            ],
            [
              101.21340883353022,
              22.804589893158507
            ],
            [
              101.2113248328009,
              22.803408918163104
            ],
            [
              101.21085183297288,
              22.802914928957787
            ],
            [
              101.20866083301178,
              22.802250943630185
            ],
            [
              101.20533183287566,
              22.80173995486166
            ],
            [
              101.20397883351386,
              22.801698955799704
            ],
            [
              101.20198083299829,
              22.80129296430176
            ],
            [
              101.20019883329107,
              22.801295964565647
            ],
            [
              101.19860983302938,
              22.801491960407997
            ],
            [
              101.19727783268567,
              22.80207494776511
            ],
            [
              101.19594683306518,
              22.803131924865628
            ],
            [
              101.19515183302187,
              22.80349891637243
            ],
            [
              101.19452983323094,
              22.80362891349691
            ],
            [
              101.19336983331466,
              22.80360891401107
            ],
            [
              101.1928118330978,
              22.803975905889516
            ],
            [
              101.19253283343856,
              22.804277899401526
            ],
            [
              101.19229683343701,
              22.805417874719648
            ],
            [
              101.19216783356559,
              22.806708846486785
            ],
            [
              101.19242583330846,
              22.80771882493035
            ],
            [
              101.19253283343856,
              22.808600805905048
            ],
            [
              101.19242583330846,
              22.809783780392983
            ],
            [
              101.19283383283916,
              22.810944754722424
            ],
            [
              101.1934778332697,
              22.811696738758766
            ],
            [
              101.19397183301412,
              22.812039730994186
            ],
            [
              101.19480883289019,
              22.811866734554826
            ],
            [
              101.19566783340589,
              22.811929733537298
            ],
            [
              101.19596883280646,
              22.812337724546616
            ],
            [
              101.19603283327889,
              22.812896712633208
            ],
            [
              101.19579683327731,
              22.813521699152275
            ],
            [
              101.19405783322784,
              22.814319681315713
            ],
            [
              101.1935418328438,
              22.815224662009715
            ],
            [
              101.19261883275401,
              22.816258639725763
            ],
            [
              101.19240383356714,
              22.817054621917702
            ],
            [
              101.1918678330916,
              22.817894604321452
            ],
            [
              101.19193183356404,
              22.81929257378127
            ],
            [
              101.19238283275243,
              22.820388549405568
            ],
            [
              101.19328483292584,
              22.821850517676523
            ],
            [
              101.19334883339826,
              22.82225850960181
            ],
            [
              101.19317783279573,
              22.82318348880076
            ],
            [
              101.19332783348189,
              22.82395847190522
            ],
            [
              101.19379983348495,
              22.825140446942825
            ],
            [
              101.19444483284212,
              22.825956428895854
            ],
            [
              101.19468083284367,
              22.826450418164697
            ],
            [
              101.19448783339811,
              22.827096404101688
            ],
            [
              101.1938858328004,
              22.82782938846801
            ],
            [
              101.19324183326816,
              22.829185358529294
            ],
            [
              101.19259783283759,
              22.83105731823382
            ],
            [
              101.19246883296617,
              22.831724303473077
            ],
            [
              101.19270583279264,
              22.832283291453155
            ],
            [
              101.19386483288397,
              22.832733281715814
            ],
            [
              101.19403683331144,
              22.833120273062352
            ],
            [
              101.19392983318133,
              22.833636262296192
            ],
            [
              101.19357283280593,
              22.83388825667376
            ],
            [
              101.19320783293293,
              22.833858257071896
            ],
            [
              101.18981883342074,
              22.833903256058278
            ],
            [
              101.18902083300439,
              22.834976233074364
            ],
            [
              101.18820883324265,
              22.835329224932618
            ],
            [
              101.18729083317568,
              22.835497221629797
            ],
            [
              101.1868118334999,
              22.835758216042787
            ],
            [
              101.18635583339034,
              22.836743194178165
            ],
            [
              101.18601483290848,
              22.83782117080292
            ],
            [
              101.18570083308913,
              22.838406158468622
            ],
            [
              101.18546783346063,
              22.838574154678103
            ],
            [
              101.18430083297335,
              22.838747151124657
            ],
            [
              101.18294283269033,
              22.838038166559322
            ],
            [
              101.18249983299955,
              22.83796316775992
            ],
            [
              101.18219683305087,
              22.838077165256358
            ],
            [
              101.18162583331356,
              22.838647152961443
            ],
            [
              101.18109183338616,
              22.83903014452645
            ],
            [
              101.18069083352815,
              22.839200140964408
            ],
            [
              101.17777183347093,
              22.83982512760084
            ],
            [
              101.17649483337877,
              22.839859127037865
            ],
            [
              101.17581883316116,
              22.840016123062007
            ],
            [
              101.17541583275504,
              22.840013123651158
            ],
            [
              101.17513783292067,
              22.8398261276818
            ],
            [
              101.17470483327567,
              22.83926813931453
            ],
            [
              101.17435083327332,
              22.83934213813788
            ],
            [
              101.17385883317873,
              22.84086710449105
            ],
            [
              101.17322783316698,
              22.84262206700787
            ],
            [
              101.17295383353056,
              22.84297405883877
            ],
            [
              101.17268383319383,
              22.843088056275388
            ],
            [
              101.17348883328283,
              22.845490004694714
            ],
            [
              101.17486183273616,
              22.848336942778943
            ],
            [
              101.17829483352766,
              22.851500873886824
            ],
            [
              101.17949683327669,
              22.85466480504135
            ],
            [
              101.18258683303821,
              22.85545578791333
            ],
            [
              101.18567683279967,
              22.857512743011196
            ],
            [
              101.18859483303206,
              22.857986732976954
            ],
            [
              101.1911698331327,
              22.85861971890082
            ],
            [
              101.19065483347192,
              22.859569698435205
            ],
            [
              101.19322983267426,
              22.859727694814385
            ],
            [
              101.19322983267426,
              22.86320761881159
            ],
            [
              101.19219983335262,
              22.865263574227175
            ],
            [
              101.19494683298247,
              22.86542157060795
            ],
            [
              101.19408783336503,
              22.867319529157875
            ],
            [
              101.19386683343212,
              22.868952494291214
            ],
            [
              101.19374483323338,
              22.869850474259184
            ],
            [
              101.19666283346572,
              22.872064426228704
            ],
            [
              101.19820783334649,
              22.87459537148064
            ],
            [
              101.2000968331838,
              22.877284312566886
            ],
            [
              101.20267083345958,
              22.8787072814117
            ],
            [
              101.20232783332791,
              22.880131250853392
            ],
            [
              101.20335783354784,
              22.88171221612207
            ],
            [
              101.20438783286944,
              22.883136185496355
            ],
            [
              101.20129783310799,
              22.88455915425138
            ],
            [
              101.19837983287564,
              22.886457112661063
            ],
            [
              101.19889483343475,
              22.888671064481258
            ],
            [
              101.19906683296385,
              22.89136000649199
            ],
            [
              101.19769283278737,
              22.892782975091286
            ],
            [
              101.19460283302585,
              22.892782975091286
            ],
            [
              101.1911698331327,
              22.891991992765956
            ],
            [
              101.18464683347807,
              22.8908850165979
            ],
            [
              101.17709383270518,
              22.890569023319976
            ],
            [
              101.17194383340214,
              22.890569023319976
            ],
            [
              101.16816783337731,
              22.890411026405047
            ],
            [
              101.16353283283674,
              22.890094033967486
            ],
            [
              101.16181583342687,
              22.890727020050896
            ],
            [
              101.16046783318963,
              22.891969992808715
            ],
            [
              101.16016283269278,
              22.89225098687853
            ],
            [
              101.15992783341446,
              22.892466982095353
            ],
            [
              101.1637038334393,
              22.895786909667315
            ],
            [
              101.16524883332,
              22.897684868275167
            ],
            [
              101.16473383276092,
              22.899739823333537
            ],
            [
              101.16456183323177,
              22.902270768088393
            ],
            [
              101.16078583320694,
              22.90511670640397
            ],
            [
              101.15752383301803,
              22.90717266180727
            ],
            [
              101.15587683303,
              22.90990360192628
            ],
            [
              101.15536783321697,
              22.910747583853734
            ],
            [
              101.15494883291734,
              22.911441568807593
            ],
            [
              101.15597883313727,
              22.914287506597002
            ],
            [
              101.15615083356471,
              22.914287506597002
            ],
            [
              101.15958383345787,
              22.914762496449082
            ],
            [
              101.1616438329994,
              22.916026468874012
            ],
            [
              101.16250183279189,
              22.916185465254724
            ],
            [
              101.16404683267265,
              22.916659454732127
            ],
            [
              101.16507683289258,
              22.916975447623514
            ],
            [
              101.16627883353996,
              22.91792442717478
            ],
            [
              101.16730883286158,
              22.921244354520294
            ],
            [
              101.16765183299329,
              22.92424828903646
            ],
            [
              101.16902483334484,
              22.92488127537467
            ],
            [
              101.17142883284299,
              22.925039271840603
            ],
            [
              101.17314483332628,
              22.924723278724468
            ],
            [
              101.17554883282442,
              22.92535526504704
            ],
            [
              101.17640683351523,
              22.92535526504704
            ],
            [
              101.17880983318844,
              22.925671258343762
            ],
            [
              101.17846683305677,
              22.927094226769235
            ],
            [
              101.17966783298093,
              22.92804320660224
            ],
            [
              101.18018283354007,
              22.930098161463373
            ],
            [
              101.1813848332891,
              22.930256158463088
            ],
            [
              101.18275783274244,
              22.93215311658432
            ],
            [
              101.18344483283069,
              22.93389207872564
            ],
            [
              101.18378783296235,
              22.935631040872963
            ],
            [
              101.18138583311406,
              22.936422023386154
            ],
            [
              101.17829583335255,
              22.937370003024064
            ],
            [
              101.17606383338354,
              22.940057944370658
            ],
            [
              101.1753778331202,
              22.941480913017447
            ],
            [
              101.17383283323949,
              22.94195490249948
            ],
            [
              101.17228783335871,
              22.943693865318235
            ],
            [
              101.17263083349039,
              22.946380805882217
            ],
            [
              101.17108583271133,
              22.948593758307545
            ],
            [
              101.1678248332456,
              22.951755689180324
            ],
            [
              101.16868283303809,
              22.953336654617964
            ],
            [
              101.16936883330145,
              22.95681357883839
            ],
            [
              101.16971283325802,
              22.959817512445
            ],
            [
              101.16816783337731,
              22.96187146796218
            ],
            [
              101.16627983336487,
              22.96313644066995
            ],
            [
              101.16336083330759,
              22.963610429557374
            ],
            [
              101.16215983338347,
              22.964875402539963
            ],
            [
              101.1600998329436,
              22.9675623434007
            ],
            [
              101.16507783271749,
              22.969774295071854
            ],
            [
              101.16868283303809,
              22.97024828467397
            ],
            [
              101.17125783313878,
              22.97024828467397
            ],
            [
              101.17434783290028,
              22.96851032322091
            ],
            [
              101.17709383270518,
              22.969142309383024
            ],
            [
              101.18018383336496,
              22.96961629871985
            ],
            [
              101.18190083277484,
              22.97135526077956
            ],
            [
              101.18361683325814,
              22.972777229472207
            ],
            [
              101.1843038333464,
              22.975148177592544
            ],
            [
              101.18293083299477,
              22.978151112514286
            ],
            [
              101.18378883278726,
              22.980996049755312
            ],
            [
              101.18327383312648,
              22.98320800154486
            ],
            [
              101.18121383268657,
              22.984472973880354
            ],
            [
              101.17881883340931,
              22.986824922732147
            ],
            [
              101.17863883348423,
              22.987000918928658
            ],
            [
              101.17640783334014,
              22.986842922043547
            ],
            [
              101.1736108334816,
              22.987519906945966
            ],
            [
              101.17330883335782,
              22.98759290610599
            ],
            [
              101.1731458331512,
              22.98763290462077
            ],
            [
              101.17297383272374,
              22.992373801236557
            ],
            [
              101.17160083327042,
              22.99980063847355
            ],
            [
              101.17022783291887,
              23.001538600909495
            ],
            [
              101.16507783271749,
              23.00327756299467
            ],
            [
              101.16267483304429,
              23.00280357269553
            ],
            [
              101.16044283307527,
              23.00280357269553
            ],
            [
              101.15563683283051,
              22.999010655968583
            ],
            [
              101.15151683284905,
              22.999484645530217
            ],
            [
              101.14945683330754,
              23.004225541906322
            ],
            [
              101.14945683330754,
              23.00943942760357
            ],
            [
              101.14756783347019,
              23.01212536874029
            ],
            [
              101.14344883331368,
              23.015443296266696
            ],
            [
              101.14031783354436,
              23.01809323836675
            ],
            [
              101.1407468329914,
              23.019514207243525
            ],
            [
              101.141090832948,
              23.020225191642844
            ],
            [
              101.1416908329976,
              23.021015173954215
            ],
            [
              101.14212083316795,
              23.02141016585468
            ],
            [
              101.14280683343127,
              23.02196315389435
            ],
            [
              101.1438368327529,
              23.023227125599103
            ],
            [
              101.14392283296661,
              23.02433310186851
            ],
            [
              101.14306483317412,
              23.025913066638513
            ],
            [
              101.14272083321751,
              23.02694004422634
            ],
            [
              101.14246383329959,
              23.02804602062534
            ],
            [
              101.14263483300381,
              23.02859900790223
            ],
            [
              101.14272083321751,
              23.028678006726178
            ],
            [
              101.14443783352571,
              23.029388990751332
            ],
            [
              101.14529583331822,
              23.02946798911229
            ],
            [
              101.14684083319897,
              23.029625985695315
            ],
            [
              101.1492448326971,
              23.03152094397974
            ],
            [
              101.15018883270331,
              23.034364881912442
            ],
            [
              101.15044583351958,
              23.035549855835807
            ],
            [
              101.15096083318039,
              23.036970825059093
            ],
            [
              101.15147583284119,
              23.037918804388543
            ],
            [
              101.1523348333569,
              23.038471791661618
            ],
            [
              101.15319283314936,
              23.039340772863103
            ],
            [
              101.15430883268475,
              23.039972758902437
            ],
            [
              101.15550983350722,
              23.04123673118005
            ],
            [
              101.15576783325005,
              23.042420705598836
            ],
            [
              101.1550808331618,
              23.04360567976057
            ],
            [
              101.15422283336932,
              23.044316663552298
            ],
            [
              101.15302083272192,
              23.045264643267327
            ],
            [
              101.15216283292943,
              23.046212622096377
            ],
            [
              101.15224883314318,
              23.046844608132933
            ],
            [
              101.15139083335069,
              23.047791587214647
            ],
            [
              101.15070383326243,
              23.048581569954038
            ],
            [
              101.15001683317419,
              23.049055559687723
            ],
            [
              101.14907283316798,
              23.049845542451518
            ],
            [
              101.14864383282256,
              23.050319531869075
            ],
            [
              101.14984583346995,
              23.051898497600924
            ],
            [
              101.15113283270951,
              23.05316246954551
            ],
            [
              101.1519048331866,
              23.054268445595014
            ],
            [
              101.15044583351958,
              23.055610416201045
            ],
            [
              101.14967383304251,
              23.056163404398376
            ],
            [
              101.14890083274054,
              23.057032384685904
            ],
            [
              101.14812883316178,
              23.05813836035058
            ],
            [
              101.14795683273434,
              23.059322334942753
            ],
            [
              101.14795683273434,
              23.060349312413983
            ],
            [
              101.14847183329343,
              23.061534285837006
            ],
            [
              101.14864383282256,
              23.062165272594246
            ],
            [
              101.14872883321138,
              23.062402266899237
            ],
            [
              101.14829983286599,
              23.065087208655648
            ],
            [
              101.14718383333064,
              23.065324202773635
            ],
            [
              101.1461538331107,
              23.06556119812721
            ],
            [
              101.14555283323614,
              23.0669031685392
            ],
            [
              101.14555283323614,
              23.06816714090636
            ],
            [
              101.14503783267703,
              23.068799127182487
            ],
            [
              101.14409383267083,
              23.068957123080985
            ],
            [
              101.14263483300381,
              23.069667107664042
            ],
            [
              101.14186183270185,
              23.070852081677078
            ],
            [
              101.14074583316649,
              23.07258904361975
            ],
            [
              101.139887833374,
              23.073379026273
            ],
            [
              101.14031683282107,
              23.0751159878149
            ],
            [
              101.14066083277767,
              23.07590597050174
            ],
            [
              101.14194783291558,
              23.07716894341587
            ],
            [
              101.14272083321751,
              23.07874790815927
            ],
            [
              101.14237683326097,
              23.080090879197595
            ],
            [
              101.14186183270185,
              23.081590846028785
            ],
            [
              101.14151883346848,
              23.083011815178686
            ],
            [
              101.1416048327839,
              23.084670778847965
            ],
            [
              101.14177583338642,
              23.085696756254876
            ],
            [
              101.14194783291558,
              23.087196723343496
            ],
            [
              101.14186183270185,
              23.087907707388087
            ],
            [
              101.14134683304103,
              23.087907707388087
            ],
            [
              101.14040283303481,
              23.087907707388087
            ],
            [
              101.13980183316028,
              23.08774971061602
            ],
            [
              101.13885783315408,
              23.08743371816744
            ],
            [
              101.1381708330658,
              23.08806570397443
            ],
            [
              101.13774183272041,
              23.088696690220555
            ],
            [
              101.13688383292792,
              23.08885468670579
            ],
            [
              101.1349098327018,
              23.089486672442014
            ],
            [
              101.13353683324847,
              23.089486672442014
            ],
            [
              101.13293583337395,
              23.089644668824914
            ],
            [
              101.13267783273278,
              23.08980266584843
            ],
            [
              101.13242083281484,
              23.08980266584843
            ],
            [
              101.13130483327947,
              23.08996066268616
            ],
            [
              101.12907283331049,
              23.09051265027441
            ],
            [
              101.12787183338635,
              23.091065637951502
            ],
            [
              101.1273568328272,
              23.091697624033102
            ],
            [
              101.12941583344217,
              23.096119527159203
            ],
            [
              101.12950183275758,
              23.098566473057172
            ],
            [
              101.12950183275758,
              23.100382433582567
            ],
            [
              101.13018883284583,
              23.10117241568176
            ],
            [
              101.13130483327947,
              23.10117241568176
            ],
            [
              101.1335358334236,
              23.10117241568176
            ],
            [
              101.13422283351186,
              23.102119394883317
            ],
            [
              101.1345658327452,
              23.102672382712893
            ],
            [
              101.13568183317885,
              23.102909377508254
            ],
            [
              101.13799983336159,
              23.103461365605583
            ],
            [
              101.1381708330658,
              23.104251348599863
            ],
            [
              101.13842883280866,
              23.10504033130563
            ],
            [
              101.13851483302241,
              23.10598831026746
            ],
            [
              101.13851483302241,
              23.10654029810368
            ],
            [
              101.13877183294034,
              23.1072512822406
            ],
            [
              101.13954483324233,
              23.10851425472861
            ],
            [
              101.14040283303481,
              23.109698228594684
            ],
            [
              101.14100383290936,
              23.110803204275502
            ],
            [
              101.1412608328273,
              23.111909179672438
            ],
            [
              101.14108883329813,
              23.11333014875031
            ],
            [
              101.14100383290936,
              23.113724140180782
            ],
            [
              101.14482383331513,
              23.11273316196829
            ],
            [
              101.14739883341583,
              23.112101175710315
            ],
            [
              101.14945883295735,
              23.11020721755834
            ],
            [
              101.15186283335382,
              23.11036421379893
            ],
            [
              101.15426583302704,
              23.11068020684389
            ],
            [
              101.15666883270025,
              23.109259238636405
            ],
            [
              101.1604458334483,
              23.10689129007365
            ],
            [
              101.16267683269409,
              23.104996332196286
            ],
            [
              101.1635358332098,
              23.10404935262264
            ],
            [
              101.16559583275134,
              23.102154394306023
            ],
            [
              101.17177483334774,
              23.10389135665365
            ],
            [
              101.17675283312164,
              23.104680338995514
            ],
            [
              101.18001483331057,
              23.104996332196286
            ],
            [
              101.18344783320372,
              23.10389135665365
            ],
            [
              101.18464983295281,
              23.101680404937873
            ],
            [
              101.18636683326098,
              23.10041743263161
            ],
            [
              101.18997083285839,
              23.099470452999128
            ],
            [
              101.19220283282739,
              23.09915446001843
            ],
            [
              101.1932328330473,
              23.097891487925516
            ],
            [
              101.19477783292807,
              23.095838533149063
            ],
            [
              101.1963228328088,
              23.094575561283804
            ],
            [
              101.19718083349957,
              23.09520654671153
            ],
            [
              101.19906883351199,
              23.095680536611802
            ],
            [
              101.20044283279023,
              23.095838533149063
            ],
            [
              101.20164383271437,
              23.095364543806184
            ],
            [
              101.20353283345004,
              23.09552253988873
            ],
            [
              101.20576383269578,
              23.096627515691758
            ],
            [
              101.20748083300396,
              23.097891487925516
            ],
            [
              101.20765283343144,
              23.098680470806254
            ],
            [
              101.20868283275306,
              23.099628450037027
            ],
            [
              101.20936883301641,
              23.1002594356954
            ],
            [
              101.21039883323633,
              23.101049418517956
            ],
            [
              101.21091383289715,
              23.101364412198226
            ],
            [
              101.21331683346868,
              23.10404935262264
            ],
            [
              101.21520583330604,
              23.10531232465352
            ],
            [
              101.21589183267106,
              23.106417300898283
            ],
            [
              101.21726583284759,
              23.108312259379925
            ],
            [
              101.22018383307991,
              23.11036421379893
            ],
            [
              101.22241483322402,
              23.11289115827445
            ],
            [
              101.22533383328128,
              23.114469124096136
            ],
            [
              101.22739383282284,
              23.11478511656716
            ],
            [
              101.22842383304278,
              23.114154130586392
            ],
            [
              101.2272218332937,
              23.11020721755834
            ],
            [
              101.23048383348264,
              23.10957523097701
            ],
            [
              101.23391683337579,
              23.10610130773609
            ],
            [
              101.23666283318069,
              23.100575429381937
            ],
            [
              101.23855183301802,
              23.098206481574262
            ],
            [
              101.23975283294219,
              23.094890553617468
            ],
            [
              101.24335783326279,
              23.0944175640877
            ],
            [
              101.24490283314351,
              23.094732557618066
            ],
            [
              101.24661983345172,
              23.09615452649255
            ],
            [
              101.25194083335731,
              23.095048550257378
            ],
            [
              101.25520283354625,
              23.095838533149063
            ],
            [
              101.25760583321946,
              23.09631252247243
            ],
            [
              101.25847583270749,
              23.09631252247243
            ],
            [
              101.26189783273001,
              23.09631252247243
            ],
            [
              101.26412883287414,
              23.095364543806184
            ],
            [
              101.26687583340225,
              23.094890553617468
            ],
            [
              101.2706518334271,
              23.09520654671153
            ],
            [
              101.27408483332025,
              23.095048550257378
            ],
            [
              101.27459983298104,
              23.095996529500542
            ],
            [
              101.27683183295005,
              23.09520654671153
            ],
            [
              101.2783768328308,
              23.09631252247243
            ],
            [
              101.28146683349058,
              23.095838533149063
            ],
            [
              101.28301183337135,
              23.09552253988873
            ],
            [
              101.28695983292529,
              23.095048550257378
            ],
            [
              101.28884783293769,
              23.09552253988873
            ],
            [
              101.29193783269922,
              23.099785446250674
            ],
            [
              101.29554283301982,
              23.101682404533943
            ],
            [
              101.29880483320878,
              23.10420834901126
            ],
            [
              101.30000583313293,
              23.106261303938012
            ],
            [
              101.30309583289441,
              23.10689229065915
            ],
            [
              101.30532783286341,
              23.10657629696214
            ],
            [
              101.30687283274416,
              23.10799726629674
            ],
            [
              101.30790283296409,
              23.109418234640113
            ],
            [
              101.30944783284482,
              23.11083920364353
            ],
            [
              101.3123658330772,
              23.111787182976826
            ],
            [
              101.31408183356046,
              23.11194517957012
            ],
            [
              101.31579883297036,
              23.11636508180937
            ],
            [
              101.31854583349846,
              23.11683907139067
            ],
            [
              101.32112083270084,
              23.11683907139067
            ],
            [
              101.3231808331407,
              23.11683907139067
            ],
            [
              101.32215083292077,
              23.112260172479584
            ],
            [
              101.31871683320267,
              23.10831325912858
            ],
            [
              101.31906083315927,
              23.10562931778841
            ],
            [
              101.32043383351088,
              23.103260369879024
            ],
            [
              101.32249383305243,
              23.100734425751533
            ],
            [
              101.32609883337304,
              23.099786446062804
            ],
            [
              101.32850183304629,
              23.099944442729047
            ],
            [
              101.33090483271951,
              23.09820748139816
            ],
            [
              101.3321068333669,
              23.09694450866547
            ],
            [
              101.33107683314697,
              23.09552353973263
            ],
            [
              101.32884483317794,
              23.093470585131968
            ],
            [
              101.33141983327863,
              23.09283859912529
            ],
            [
              101.3303898330587,
              23.088733689623346
            ],
            [
              101.32884483317794,
              23.08225883162384
            ],
            [
              101.32695683316553,
              23.078626911070494
            ],
            [
              101.32300883271326,
              23.07420500851126
            ],
            [
              101.32112083270084,
              23.072783039672547
            ],
            [
              101.3220878331716,
              23.072217051777738
            ],
            [
              101.32489683272567,
              23.07057208777238
            ],
            [
              101.32832983351715,
              23.0691511194128
            ],
            [
              101.3307338330153,
              23.065834192090264
            ],
            [
              101.33279383345517,
              23.063781237064898
            ],
            [
              101.33553983326004,
              23.065992188164643
            ],
            [
              101.33948783281402,
              23.066624174739466
            ],
            [
              101.34343683309123,
              23.066624174739466
            ],
            [
              101.34824283333599,
              23.065834192090264
            ],
            [
              101.34927283355591,
              23.063781237064898
            ],
            [
              101.34961583278928,
              23.060306312832743
            ],
            [
              101.35081783343666,
              23.059043341129954
            ],
            [
              101.35150483352494,
              23.058569351017795
            ],
            [
              101.34721283311606,
              23.05619940352287
            ],
            [
              101.34257783347384,
              23.0536724586587
            ],
            [
              101.34068983346138,
              23.049407552306096
            ],
            [
              101.3370848331408,
              23.04624862140157
            ],
            [
              101.33399483337931,
              23.043247687116143
            ],
            [
              101.3348538329967,
              23.041035735861513
            ],
            [
              101.33571183278919,
              23.03898278045782
            ],
            [
              101.33691283271335,
              23.03898278045782
            ],
            [
              101.33691283271335,
              23.03740281513785
            ],
            [
              101.33811483336073,
              23.03756081151158
            ],
            [
              101.33845783349241,
              23.035506856602183
            ],
            [
              101.33948783281402,
              23.03345290179858
            ],
            [
              101.33897283315322,
              23.03171594000973
            ],
            [
              101.33965983324146,
              23.030451967705066
            ],
            [
              101.33880183344897,
              23.030451967705066
            ],
            [
              101.33742783327246,
              23.03029397126357
            ],
            [
              101.33639783305254,
              23.029977977824945
            ],
            [
              101.33468183346758,
              23.028556008931048
            ],
            [
              101.33141983327863,
              23.029187995120964
            ],
            [
              101.32935983283878,
              23.027608029877513
            ],
            [
              101.32661383303387,
              23.026186060784976
            ],
            [
              101.32661383303387,
              23.023974109732293
            ],
            [
              101.32850183304629,
              23.0209721750445
            ],
            [
              101.33073283319035,
              23.01781224430809
            ],
            [
              101.32918883313455,
              23.01354633765305
            ],
            [
              101.3259268329456,
              23.012914351736125
            ],
            [
              101.32558383281393,
              23.01101839358393
            ],
            [
              101.32798683338545,
              23.007858461998616
            ],
            [
              101.32987483339787,
              23.008332451906714
            ],
            [
              101.33244983349854,
              23.008490448448345
            ],
            [
              101.3334798328202,
              23.008806441803433
            ],
            [
              101.33502483270091,
              23.008174455180082
            ],
            [
              101.33399483337931,
              23.004856528316253
            ],
            [
              101.33450983304013,
              23.002802572989854
            ],
            [
              101.33777183322904,
              22.99869366309367
            ],
            [
              101.34068983346138,
              22.99679770442469
            ],
            [
              101.34223483334215,
              22.998061677072954
            ],
            [
              101.34807083290855,
              22.99727169431428
            ],
            [
              101.34858583346765,
              22.996955701239465
            ],
            [
              101.34721283311606,
              22.99474374967968
            ],
            [
              101.34532483310365,
              22.993163783711204
            ],
            [
              101.34446583348625,
              22.992372801453627
            ],
            [
              101.33965983324146,
              22.99047784230323
            ],
            [
              101.33880083272577,
              22.989845856692394
            ],
            [
              101.34086083316564,
              22.988580884229975
            ],
            [
              101.3412048331222,
              22.987000918928658
            ],
            [
              101.34000283337315,
              22.984629970389364
            ],
            [
              101.33691283271335,
              22.982418018726257
            ],
            [
              101.3348528331718,
              22.982260022269788
            ],
            [
              101.33244983349854,
              22.980679056770338
            ],
            [
              101.32644183350472,
              22.979573080827
            ],
            [
              101.32472483319654,
              22.980047070798523
            ],
            [
              101.32283683318411,
              22.97941508435166
            ],
            [
              101.31957483299519,
              22.977203132493365
            ],
            [
              101.31888883273182,
              22.975306174094637
            ],
            [
              101.31934983286428,
              22.972194242106436
            ],
            [
              101.31940383329096,
              22.971829250627493
            ],
            [
              101.32060483321509,
              22.966139374463484
            ],
            [
              101.32026183308345,
              22.962662450948187
            ],
            [
              101.31905983333439,
              22.958394543894002
            ],
            [
              101.31751483345361,
              22.955865598907927
            ],
            [
              101.31596983267457,
              22.955074616702593
            ],
            [
              101.31665683276283,
              22.953652647129005
            ],
            [
              101.31837383307104,
              22.951439695547403
            ],
            [
              101.32043383351088,
              22.9446428438047
            ],
            [
              101.31991883295176,
              22.941164920210383
            ],
            [
              101.31991883295176,
              22.939425957993866
            ],
            [
              101.31974683342263,
              22.937528999173598
            ],
            [
              101.31974683342263,
              22.936264026961837
            ],
            [
              101.32232183352329,
              22.93452506467065
            ],
            [
              101.32472483319654,
              22.93341808914395
            ],
            [
              101.32626983307726,
              22.93341808914395
            ],
            [
              101.3276428334289,
              22.932154116812544
            ],
            [
              101.33330783329104,
              22.92804320660224
            ],
            [
              101.33450983304013,
              22.926936230217944
            ],
            [
              101.33553983326004,
              22.925197268122265
            ],
            [
              101.3375998328016,
              22.9236163033415
            ],
            [
              101.33965983324146,
              22.923774299627926
            ],
            [
              101.34412283335456,
              22.923774299627926
            ],
            [
              101.34858583346765,
              22.922509327187566
            ],
            [
              101.35116083267005,
              22.9206123688791
            ],
            [
              101.3527058334491,
              22.91792442717478
            ],
            [
              101.35407883290239,
              22.913813517098866
            ],
            [
              101.35493683269488,
              22.911916557875568
            ],
            [
              101.35631083287137,
              22.90954460949043
            ],
            [
              101.35871383344293,
              22.908121640479877
            ],
            [
              101.35922883310371,
              22.906856668406217
            ],
            [
              101.35699683313473,
              22.907014665198783
            ],
            [
              101.35562383278311,
              22.904800713176662
            ],
            [
              101.35287783297821,
              22.903219747966
            ],
            [
              101.35253383302162,
              22.901321789018116
            ],
            [
              101.35167583322915,
              22.898791844407516
            ],
            [
              101.35150783299962,
              22.898248856288387
            ],
            [
              101.35098883314089,
              22.896577892212346
            ],
            [
              101.3527058334491,
              22.894522937253388
            ],
            [
              101.3537358327707,
              22.8908850165979
            ],
            [
              101.3527058334491,
              22.888829060939205
            ],
            [
              101.3501308333484,
              22.88709009915588
            ],
            [
              101.34601083336698,
              22.88471715053033
            ],
            [
              101.3448088327196,
              22.882978189032496
            ],
            [
              101.34377983322287,
              22.88123822617282
            ],
            [
              101.34154782427073,
              22.880131250853392
            ],
            [
              101.33897283315322,
              22.87997325420295
            ],
            [
              101.33656983348,
              22.878549284759504
            ],
            [
              101.3348528331718,
              22.87760030614834
            ],
            [
              101.3331368326885,
              22.878233291731185
            ],
            [
              101.33124783285119,
              22.878075295355064
            ],
            [
              101.3290168327071,
              22.878233291731185
            ],
            [
              101.32663183347555,
              22.878273291109366
            ],
            [
              101.3168868329166,
              22.8795962625158
            ],
            [
              101.3049588327925,
              22.8792562694971
            ]
          ]
        ]
      },
      "properties": {
        "name": "勐先镇"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.25003183342848,
              23.54078667039966
            ],
            [
              101.25259283328548,
              23.537321747454016
            ],
            [
              101.26121583356296,
              23.525652008953404
            ],
            [
              101.2641608335595,
              23.511322329196478
            ],
            [
              101.26299583272201,
              23.49556568056894
            ],
            [
              101.27010283343112,
              23.473901163935952
            ],
            [
              101.27072383339711,
              23.472009206469373
            ],
            [
              101.26326683288367,
              23.475531128179888
            ],
            [
              101.2625798327954,
              23.476160113713856
            ],
            [
              101.26052083307876,
              23.478680057409754
            ],
            [
              101.25571383300911,
              23.48056901567733
            ],
            [
              101.25262383324761,
              23.482458973494648
            ],
            [
              101.24953383348613,
              23.481513994675677
            ],
            [
              101.24747383304621,
              23.481513994675677
            ],
            [
              101.24541383350471,
              23.481513994675677
            ],
            [
              101.24266783280147,
              23.481199001329955
            ],
            [
              101.2423238328449,
              23.481513994675677
            ],
            [
              101.23820483268835,
              23.480884008055845
            ],
            [
              101.23717483336677,
              23.47773507870639
            ],
            [
              101.23717483336677,
              23.475846121053483
            ],
            [
              101.23751783349844,
              23.47112222593711
            ],
            [
              101.23751783349844,
              23.467343310594707
            ],
            [
              101.23751783349844,
              23.465768345162235
            ],
            [
              101.23648783327852,
              23.46324840208698
            ],
            [
              101.23648783327852,
              23.460729458278017
            ],
            [
              101.23614483314685,
              23.45978447875365
            ],
            [
              101.23545783305858,
              23.458209513781064
            ],
            [
              101.233397833517,
              23.455060583958765
            ],
            [
              101.23236783329709,
              23.455060583958765
            ],
            [
              101.23030783285722,
              23.454115605067205
            ],
            [
              101.22790483318397,
              23.451910654395473
            ],
            [
              101.22550183351079,
              23.45033568946087
            ],
            [
              101.22515783355418,
              23.447185760118273
            ],
            [
              101.22618783287581,
              23.44498180884195
            ],
            [
              101.22653183283239,
              23.442776858173005
            ],
            [
              101.22824783331569,
              23.44120189313412
            ],
            [
              101.22756183305232,
              23.438681949423284
            ],
            [
              101.22756183305232,
              23.435532019181544
            ],
            [
              101.22618783287581,
              23.432381089908766
            ],
            [
              101.22893483340394,
              23.430176138364242
            ],
            [
              101.22927783353562,
              23.429861145345956
            ],
            [
              101.22904083281082,
              23.429253158785098
            ],
            [
              101.22756183305232,
              23.42545124424997
            ],
            [
              101.22275483298266,
              23.424506264620558
            ],
            [
              101.21794883273789,
              23.424821258031105
            ],
            [
              101.216231833328,
              23.427656194636352
            ],
            [
              101.21588883319633,
              23.43080612462214
            ],
            [
              101.21382883275646,
              23.434902033191197
            ],
            [
              101.21382883275646,
              23.437106984208047
            ],
            [
              101.21279883343482,
              23.438681949423284
            ],
            [
              101.21005183290673,
              23.44025691400141
            ],
            [
              101.20867883345343,
              23.443721836591916
            ],
            [
              101.20902183268676,
              23.44687076643181
            ],
            [
              101.20970883277504,
              23.450020696692704
            ],
            [
              101.21073883299496,
              23.45285563340651
            ],
            [
              101.21005183290673,
              23.4553755770681
            ],
            [
              101.21073883299496,
              23.457579527970488
            ],
            [
              101.20902183268676,
              23.4600994721306
            ],
            [
              101.20833483349682,
              23.4638783880398
            ],
            [
              101.20867883345343,
              23.46797229643167
            ],
            [
              101.20833483349682,
              23.471437219448973
            ],
            [
              101.2059318329253,
              23.472067205040744
            ],
            [
              101.20490183270535,
              23.474586149166402
            ],
            [
              101.20249883303212,
              23.474271155756362
            ],
            [
              101.19734883283076,
              23.473326176781846
            ],
            [
              101.1942588330693,
              23.474271155756362
            ],
            [
              101.19254283348434,
              23.47647510673353
            ],
            [
              101.19219883352773,
              23.478365064711536
            ],
            [
              101.19185583339609,
              23.481199001329955
            ],
            [
              101.19013883308787,
              23.481199001329955
            ],
            [
              101.18704883332637,
              23.481828987269083
            ],
            [
              101.18601983293135,
              23.481828987269083
            ],
            [
              101.18395983338979,
              23.47993902948737
            ],
            [
              101.18155583299335,
              23.47993902948737
            ],
            [
              101.17709283288028,
              23.47931004384532
            ],
            [
              101.1753768332953,
              23.4789950501797
            ],
            [
              101.17468983320703,
              23.47993902948737
            ],
            [
              101.17194283267891,
              23.478680057409754
            ],
            [
              101.17194283267891,
              23.47679009982503
            ],
            [
              101.16919683287401,
              23.47679009982503
            ],
            [
              101.16782283269748,
              23.479624036499878
            ],
            [
              101.1695398330057,
              23.481513994675677
            ],
            [
              101.16747983346411,
              23.483087958950026
            ],
            [
              101.16713683333242,
              23.48371794492892
            ],
            [
              101.16541983302423,
              23.48371794492892
            ],
            [
              101.1637038334393,
              23.481199001329955
            ],
            [
              101.16335983348272,
              23.47710509298834
            ],
            [
              101.16335983348272,
              23.47647510673353
            ],
            [
              101.16301683335105,
              23.474586149166402
            ],
            [
              101.1616438329994,
              23.47238119845494
            ],
            [
              101.16026983282292,
              23.470807233321324
            ],
            [
              101.15614983284148,
              23.469232268027582
            ],
            [
              101.15443383325652,
              23.468287289222417
            ],
            [
              101.15237383281664,
              23.4638783880398
            ],
            [
              101.15203083268499,
              23.461359443891297
            ],
            [
              101.15100083336336,
              23.457579527970488
            ],
            [
              101.14928383305515,
              23.455690570250137
            ],
            [
              101.1461938332937,
              23.45096567521602
            ],
            [
              101.14276083340052,
              23.45128066820293
            ],
            [
              101.13967083274072,
              23.45285563340651
            ],
            [
              101.13795383333083,
              23.453800612248862
            ],
            [
              101.1355508327593,
              23.45694954245043
            ],
            [
              101.13452083343769,
              23.457264535174133
            ],
            [
              101.13280383312949,
              23.460729458278017
            ],
            [
              101.13074483341282,
              23.46324840208698
            ],
            [
              101.13005783332459,
              23.46545335295177
            ],
            [
              101.13005783332459,
              23.467028317198928
            ],
            [
              101.12731083279645,
              23.469232268027582
            ],
            [
              101.12662483343144,
              23.470492239953597
            ],
            [
              101.12422083303497,
              23.472067205040744
            ],
            [
              101.12181783336175,
              23.474586149166402
            ],
            [
              101.11872783270194,
              23.4789950501797
            ],
            [
              101.12044483301013,
              23.480884008055845
            ],
            [
              101.1194148327902,
              23.48371794492892
            ],
            [
              101.11864583268621,
              23.48371794492892
            ],
            [
              101.11804183333692,
              23.48371794492892
            ],
            [
              101.11529483280877,
              23.484032938025642
            ],
            [
              101.11117483282737,
              23.485606902720377
            ],
            [
              101.10808483306587,
              23.486236889023786
            ],
            [
              101.10705483284595,
              23.484662924433586
            ],
            [
              101.10396483308443,
              23.482458973494648
            ],
            [
              101.10121883327955,
              23.48056901567733
            ],
            [
              101.09812883351805,
              23.478680057409754
            ],
            [
              101.0960688330782,
              23.476160113713856
            ],
            [
              101.09503883285826,
              23.473956163242228
            ],
            [
              101.0929788333167,
              23.472067205040744
            ],
            [
              101.09091883287682,
              23.470177247481924
            ],
            [
              101.08817283307195,
              23.47238119845494
            ],
            [
              101.0857688326755,
              23.47269619143326
            ],
            [
              101.08302283287058,
              23.473641169976066
            ],
            [
              101.08027583324078,
              23.473956163242228
            ],
            [
              101.07924583302085,
              23.473641169976066
            ],
            [
              101.07752983343586,
              23.473011183659565
            ],
            [
              101.07615583325938,
              23.473326176781846
            ],
            [
              101.07409583281948,
              23.473956163242228
            ],
            [
              101.07169283314626,
              23.473326176781846
            ],
            [
              101.06928983347302,
              23.473011183659565
            ],
            [
              101.06585683268156,
              23.473011183659565
            ],
            [
              101.0610498335102,
              23.473641169976066
            ],
            [
              101.05830283298205,
              23.471437219448973
            ],
            [
              101.052123833284,
              23.470492239953597
            ],
            [
              101.04971983288756,
              23.472067205040744
            ],
            [
              101.04444783338579,
              23.474288155901217
            ],
            [
              101.04434483345364,
              23.47722708975912
            ],
            [
              101.04304683344506,
              23.486108891914228
            ],
            [
              101.04257683309177,
              23.48785985269482
            ],
            [
              101.04018283274107,
              23.49677265362484
            ],
            [
              101.03656883309797,
              23.500093579556033
            ],
            [
              101.033093833372,
              23.506618433552905
            ],
            [
              101.03155983336192,
              23.51041634906531
            ],
            [
              101.03062983270108,
              23.512719297889124
            ],
            [
              101.03051583289827,
              23.515919225874775
            ],
            [
              101.03105983287139,
              23.51865716503714
            ],
            [
              101.03179683318838,
              23.52236408199511
            ],
            [
              101.03356483355019,
              23.529281927472436
            ],
            [
              101.0301508330253,
              23.533977822566687
            ],
            [
              101.02718083291441,
              23.540291681466478
            ],
            [
              101.02399283324361,
              23.545681560391063
            ],
            [
              101.02092583304837,
              23.554737358003525
            ],
            [
              101.01994183285917,
              23.56134021011247
            ],
            [
              101.01534183337704,
              23.57148898311512
            ],
            [
              101.01096783295239,
              23.58232974061848
            ],
            [
              101.01415683334643,
              23.584029702296586
            ],
            [
              101.01816483317482,
              23.584153699339076
            ],
            [
              101.02697283340027,
              23.582828728816832
            ],
            [
              101.03332283280258,
              23.580282786442332
            ],
            [
              101.03911483288631,
              23.57908881307292
            ],
            [
              101.04540083271449,
              23.5783658287293
            ],
            [
              101.050624833434,
              23.57920981051357
            ],
            [
              101.0562908331211,
              23.581668755280965
            ],
            [
              101.06171183348411,
              23.58411970025461
            ],
            [
              101.06587883332118,
              23.586757641452582
            ],
            [
              101.07282883277308,
              23.588335605999543
            ],
            [
              101.07859283326776,
              23.587588622682524
            ],
            [
              101.08333083284217,
              23.587954614167007
            ],
            [
              101.09208083334124,
              23.587517623851852
            ],
            [
              101.09685883309861,
              23.58673764185633
            ],
            [
              101.10416283345117,
              23.584883683416948
            ],
            [
              101.11561183300117,
              23.585427671130873
            ],
            [
              101.12004583280198,
              23.587148632000414
            ],
            [
              101.12179983292008,
              23.588584600316878
            ],
            [
              101.12611083269721,
              23.592114520658527
            ],
            [
              101.13024883312029,
              23.594971456576133
            ],
            [
              101.13676983312511,
              23.59400147862467
            ],
            [
              101.1377598331621,
              23.59364648661981
            ],
            [
              101.13638183278758,
              23.60021533902574
            ],
            [
              101.14020383284318,
              23.602225294443283
            ],
            [
              101.14255283298809,
              23.606030208856687
            ],
            [
              101.14297583348566,
              23.606540197920435
            ],
            [
              101.14303783340993,
              23.60652019804775
            ],
            [
              101.14335383287911,
              23.604276248437248
            ],
            [
              101.1439208333168,
              23.603425267207783
            ],
            [
              101.14401183355339,
              23.602638284926826
            ],
            [
              101.14421283339483,
              23.602233293996267
            ],
            [
              101.14593983285044,
              23.60125931561342
            ],
            [
              101.14614183341513,
              23.600950322616377
            ],
            [
              101.14631583349242,
              23.60014334110047
            ],
            [
              101.14635783332521,
              23.598918368501476
            ],
            [
              101.14586283285759,
              23.596504422295535
            ],
            [
              101.14591983275898,
              23.596178429581705
            ],
            [
              101.14658783347897,
              23.59521045190678
            ],
            [
              101.14757083294494,
              23.594381469975975
            ],
            [
              101.14781183296937,
              23.593899480767465
            ],
            [
              101.14788283311445,
              23.593151497625286
            ],
            [
              101.14771483288499,
              23.591776528275467
            ],
            [
              101.14799283271931,
              23.591006545961573
            ],
            [
              101.14812983298667,
              23.589991568919356
            ],
            [
              101.1479128332517,
              23.589673575981816
            ],
            [
              101.14517583276931,
              23.58875459645334
            ],
            [
              101.14409283284593,
              23.58859360013236
            ],
            [
              101.14241383307089,
              23.588636598693554
            ],
            [
              101.14179183327997,
              23.588361605239825
            ],
            [
              101.14122283319247,
              23.587800617860946
            ],
            [
              101.14102783319879,
              23.587485624517047
            ],
            [
              101.1415148332705,
              23.586643643795398
            ],
            [
              101.14523383339392,
              23.583635710637587
            ],
            [
              101.14476783323863,
              23.581629755664682
            ],
            [
              101.14445683289401,
              23.581057769017683
            ],
            [
              101.14336583347301,
              23.579909794375826
            ],
            [
              101.1410348328715,
              23.578916816934136
            ],
            [
              101.13932783350737,
              23.578058835998426
            ],
            [
              101.13777283268254,
              23.57677386464908
            ],
            [
              101.13668283308648,
              23.5752029002682
            ],
            [
              101.13637283346509,
              23.57352193750332
            ],
            [
              101.13573083268436,
              23.57269695592337
            ],
            [
              101.13417083273495,
              23.569803021048422
            ],
            [
              101.13347883352215,
              23.568840042708075
            ],
            [
              101.13525983340448,
              23.568152057444298
            ],
            [
              101.13635483302342,
              23.568172057401885
            ],
            [
              101.13689483279859,
              23.568329054081236
            ],
            [
              101.1381008327456,
              23.569009038486648
            ],
            [
              101.13837583310521,
              23.56905103729663
            ],
            [
              101.14090283352535,
              23.568691045767192
            ],
            [
              101.14468883269758,
              23.56771406749035
            ],
            [
              101.14594083267535,
              23.567566070509656
            ],
            [
              101.1480548335419,
              23.56782806511773
            ],
            [
              101.14845583339991,
              23.56802306052659
            ],
            [
              101.14870083272399,
              23.56838705222487
            ],
            [
              101.14897483325866,
              23.56860304792555
            ],
            [
              101.14954283352127,
              23.568760044089743
            ],
            [
              101.15207183269284,
              23.56884904223052
            ],
            [
              101.1532098328678,
              23.56905103729663
            ],
            [
              101.15428983331647,
              23.56940203000216
            ],
            [
              101.15534483275245,
              23.569385029785906
            ],
            [
              101.15693183336428,
              23.56908503698999
            ],
            [
              101.15782883351484,
              23.569163035429852
            ],
            [
              101.15872783331521,
              23.569387029763057
            ],
            [
              101.15938883346422,
              23.569671023734678
            ],
            [
              101.16013383327878,
              23.57021001158761
            ],
            [
              101.16062483354847,
              23.57099199458367
            ],
            [
              101.16099583326923,
              23.571812975467463
            ],
            [
              101.1614018331501,
              23.57349693816261
            ],
            [
              101.16135083309646,
              23.575260898669438
            ],
            [
              101.16187983300098,
              23.57626087655841
            ],
            [
              101.1630998331917,
              23.577320852412942
            ],
            [
              101.16437183326094,
              23.57806883604648
            ],
            [
              101.16500283327275,
              23.578288831148242
            ],
            [
              101.16803583313282,
              23.578810819211082
            ],
            [
              101.16889183327548,
              23.57881581920659
            ],
            [
              101.17222883290917,
              23.57841382818222
            ],
            [
              101.1758148329632,
              23.57886281816693
            ],
            [
              101.17771883286913,
              23.579482804383908
            ],
            [
              101.17851383291244,
              23.579415805756845
            ],
            [
              101.18084583333888,
              23.57848382666684
            ],
            [
              101.18212183270781,
              23.57835482919523
            ],
            [
              101.18288783333708,
              23.578505825712384
            ],
            [
              101.1839968331997,
              23.57890881678277
            ],
            [
              101.18525483302527,
              23.579525803460168
            ],
            [
              101.18740383315361,
              23.581072768746818
            ],
            [
              101.18975783332135,
              23.581193766005367
            ],
            [
              101.2181188335155,
              23.582615733540337
            ],
            [
              101.23336183353203,
              23.57386792960262
            ],
            [
              101.2326418329335,
              23.56302317241374
            ],
            [
              101.23364583321413,
              23.560470229771116
            ],
            [
              101.23457683280154,
              23.55810328279357
            ],
            [
              101.23981083356684,
              23.554617360763743
            ],
            [
              101.240278833372,
              23.553983375093047
            ],
            [
              101.25003183342848,
              23.54078667039966
            ]
          ]
        ]
      },
      "properties": {
        "name": "梅子镇"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.17915483296994,
              23.306634883003653
            ],
            [
              101.17745883347645,
              23.30633788944514
            ],
            [
              101.17194483322707,
              23.305372910318788
            ],
            [
              101.16713783315735,
              23.30411193879552
            ],
            [
              101.16439183335245,
              23.303480952706295
            ],
            [
              101.15924183315111,
              23.303480952706295
            ],
            [
              101.15786883279948,
              23.306634883003653
            ],
            [
              101.15615183338961,
              23.307264869069403
            ],
            [
              101.15546583312629,
              23.307264869069403
            ],
            [
              101.15306183272982,
              23.304742924366572
            ],
            [
              101.15203183340819,
              23.30379694568126
            ],
            [
              101.14962883283664,
              23.303480952706295
            ],
            [
              101.14722583316342,
              23.302534973296474
            ],
            [
              101.1448228334902,
              23.300328022668484
            ],
            [
              101.13864283306893,
              23.300013029669746
            ],
            [
              101.13417983295582,
              23.30064301574648
            ],
            [
              101.13108983319432,
              23.30379694568126
            ],
            [
              101.12902983275447,
              23.304742924366572
            ],
            [
              101.12799983343285,
              23.30316595974787
            ],
            [
              101.12799983343285,
              23.30064301574648
            ],
            [
              101.12422283268478,
              23.296229113292725
            ],
            [
              101.1214768328799,
              23.29875105769167
            ],
            [
              101.11570683343572,
              23.300139026958746
            ],
            [
              101.11827583279033,
              23.30546990883892
            ],
            [
              101.11977683318842,
              23.312605750322327
            ],
            [
              101.1193088333833,
              23.318998608810723
            ],
            [
              101.11628883304368,
              23.32738442240104
            ],
            [
              101.11362483325458,
              23.332575307606263
            ],
            [
              101.1087958334436,
              23.338130184628472
            ],
            [
              101.10740983267317,
              23.339724149427806
            ],
            [
              101.10378983318228,
              23.343746059545072
            ],
            [
              101.09723283319245,
              23.353400845354027
            ],
            [
              101.09302083314951,
              23.35991570102203
            ],
            [
              101.08871083319727,
              23.362308647984566
            ],
            [
              101.0860868326928,
              23.365897568152377
            ],
            [
              101.08267983273892,
              23.370831458108714
            ],
            [
              101.08127983352145,
              23.373773392811735
            ],
            [
              101.07945583308314,
              23.37760530783071
            ],
            [
              101.07805583296732,
              23.382368202215087
            ],
            [
              101.07585683350861,
              23.388254071600333
            ],
            [
              101.0751178335418,
              23.390162028528703
            ],
            [
              101.0736658335475,
              23.39390994581538
            ],
            [
              101.07324483269969,
              23.39542391229453
            ],
            [
              101.0723088330894,
              23.398786837328384
            ],
            [
              101.07196083293485,
              23.400037809495362
            ],
            [
              101.07003983331049,
              23.40524469340457
            ],
            [
              101.06826583310085,
              23.41342651172075
            ],
            [
              101.06475183301686,
              23.421102340321138
            ],
            [
              101.06118483322938,
              23.430605129163826
            ],
            [
              101.05906183304035,
              23.434205049151092
            ],
            [
              101.05457983355899,
              23.441388888701024
            ],
            [
              101.04957583294751,
              23.448788723660012
            ],
            [
              101.04693783309763,
              23.452595639197046
            ],
            [
              101.0445268330285,
              23.45755652888554
            ],
            [
              101.04477883292357,
              23.464886364913717
            ],
            [
              101.0446318335088,
              23.468998273694286
            ],
            [
              101.04444783338579,
              23.474288155901217
            ],
            [
              101.04971983288756,
              23.472067205040744
            ],
            [
              101.052123833284,
              23.470492239953597
            ],
            [
              101.05830283298205,
              23.471437219448973
            ],
            [
              101.0610498335102,
              23.473641169976066
            ],
            [
              101.06585683268156,
              23.473011183659565
            ],
            [
              101.06928983347302,
              23.473011183659565
            ],
            [
              101.07169283314626,
              23.473326176781846
            ],
            [
              101.07409583281948,
              23.473956163242228
            ],
            [
              101.07615583325938,
              23.473326176781846
            ],
            [
              101.07752983343586,
              23.473011183659565
            ],
            [
              101.07924583302085,
              23.473641169976066
            ],
            [
              101.08027583324078,
              23.473956163242228
            ],
            [
              101.08302283287058,
              23.473641169976066
            ],
            [
              101.0857688326755,
              23.47269619143326
            ],
            [
              101.08817283307195,
              23.47238119845494
            ],
            [
              101.09091883287682,
              23.470177247481924
            ],
            [
              101.0929788333167,
              23.472067205040744
            ],
            [
              101.09503883285826,
              23.473956163242228
            ],
            [
              101.0960688330782,
              23.476160113713856
            ],
            [
              101.09812883351805,
              23.478680057409754
            ],
            [
              101.10121883327955,
              23.48056901567733
            ],
            [
              101.10396483308443,
              23.482458973494648
            ],
            [
              101.10705483284595,
              23.484662924433586
            ],
            [
              101.10808483306587,
              23.486236889023786
            ],
            [
              101.11117483282737,
              23.485606902720377
            ],
            [
              101.11529483280877,
              23.484032938025642
            ],
            [
              101.11804183333692,
              23.48371794492892
            ],
            [
              101.11864583268621,
              23.48371794492892
            ],
            [
              101.1194148327902,
              23.48371794492892
            ],
            [
              101.12044483301013,
              23.480884008055845
            ],
            [
              101.11872783270194,
              23.4789950501797
            ],
            [
              101.12181783336175,
              23.474586149166402
            ],
            [
              101.12422083303497,
              23.472067205040744
            ],
            [
              101.12662483343144,
              23.470492239953597
            ],
            [
              101.12731083279645,
              23.469232268027582
            ],
            [
              101.13005783332459,
              23.467028317198928
            ],
            [
              101.13005783332459,
              23.46545335295177
            ],
            [
              101.13074483341282,
              23.46324840208698
            ],
            [
              101.13280383312949,
              23.460729458278017
            ],
            [
              101.13452083343769,
              23.457264535174133
            ],
            [
              101.1355508327593,
              23.45694954245043
            ],
            [
              101.13795383333083,
              23.453800612248862
            ],
            [
              101.13967083274072,
              23.45285563340651
            ],
            [
              101.14276083340052,
              23.45128066820293
            ],
            [
              101.1461938332937,
              23.45096567521602
            ],
            [
              101.14928383305515,
              23.455690570250137
            ],
            [
              101.15100083336336,
              23.457579527970488
            ],
            [
              101.15203083268499,
              23.461359443891297
            ],
            [
              101.15237383281664,
              23.4638783880398
            ],
            [
              101.15443383325652,
              23.468287289222417
            ],
            [
              101.15614983284148,
              23.469232268027582
            ],
            [
              101.16026983282292,
              23.470807233321324
            ],
            [
              101.1616438329994,
              23.47238119845494
            ],
            [
              101.16301683335105,
              23.474586149166402
            ],
            [
              101.16335983348272,
              23.47647510673353
            ],
            [
              101.16335983348272,
              23.47710509298834
            ],
            [
              101.1637038334393,
              23.481199001329955
            ],
            [
              101.16541983302423,
              23.48371794492892
            ],
            [
              101.16713683333242,
              23.48371794492892
            ],
            [
              101.16747983346411,
              23.483087958950026
            ],
            [
              101.1695398330057,
              23.481513994675677
            ],
            [
              101.16782283269748,
              23.479624036499878
            ],
            [
              101.16919683287401,
              23.47679009982503
            ],
            [
              101.17194283267891,
              23.47679009982503
            ],
            [
              101.17194283267891,
              23.478680057409754
            ],
            [
              101.17468983320703,
              23.47993902948737
            ],
            [
              101.1753768332953,
              23.4789950501797
            ],
            [
              101.17709283288028,
              23.47931004384532
            ],
            [
              101.18155583299335,
              23.47993902948737
            ],
            [
              101.18395983338979,
              23.47993902948737
            ],
            [
              101.18601983293135,
              23.481828987269083
            ],
            [
              101.18704883332637,
              23.481828987269083
            ],
            [
              101.19013883308787,
              23.481199001329955
            ],
            [
              101.19185583339609,
              23.481199001329955
            ],
            [
              101.19219883352773,
              23.478365064711536
            ],
            [
              101.19254283348434,
              23.47647510673353
            ],
            [
              101.1942588330693,
              23.474271155756362
            ],
            [
              101.19734883283076,
              23.473326176781846
            ],
            [
              101.20249883303212,
              23.474271155756362
            ],
            [
              101.20490183270535,
              23.474586149166402
            ],
            [
              101.2059318329253,
              23.472067205040744
            ],
            [
              101.20833483349682,
              23.471437219448973
            ],
            [
              101.20867883345343,
              23.46797229643167
            ],
            [
              101.20833483349682,
              23.4638783880398
            ],
            [
              101.20902183268676,
              23.4600994721306
            ],
            [
              101.21073883299496,
              23.457579527970488
            ],
            [
              101.21005183290673,
              23.4553755770681
            ],
            [
              101.21073883299496,
              23.45285563340651
            ],
            [
              101.20970883277504,
              23.450020696692704
            ],
            [
              101.20902183268676,
              23.44687076643181
            ],
            [
              101.20867883345343,
              23.443721836591916
            ],
            [
              101.21005183290673,
              23.44025691400141
            ],
            [
              101.21279883343482,
              23.438681949423284
            ],
            [
              101.21382883275646,
              23.437106984208047
            ],
            [
              101.21382883275646,
              23.434902033191197
            ],
            [
              101.21588883319633,
              23.43080612462214
            ],
            [
              101.216231833328,
              23.427656194636352
            ],
            [
              101.21794883273789,
              23.424821258031105
            ],
            [
              101.22275483298266,
              23.424506264620558
            ],
            [
              101.22756183305232,
              23.42545124424997
            ],
            [
              101.22904083281082,
              23.429253158785098
            ],
            [
              101.22927783353562,
              23.429861145345956
            ],
            [
              101.22893483340394,
              23.430176138364242
            ],
            [
              101.22618783287581,
              23.432381089908766
            ],
            [
              101.22756183305232,
              23.435532019181544
            ],
            [
              101.22756183305232,
              23.438681949423284
            ],
            [
              101.22824783331569,
              23.44120189313412
            ],
            [
              101.22653183283239,
              23.442776858173005
            ],
            [
              101.22618783287581,
              23.44498180884195
            ],
            [
              101.22515783355418,
              23.447185760118273
            ],
            [
              101.22550183351079,
              23.45033568946087
            ],
            [
              101.22790483318397,
              23.451910654395473
            ],
            [
              101.23030783285722,
              23.454115605067205
            ],
            [
              101.23236783329709,
              23.455060583958765
            ],
            [
              101.233397833517,
              23.455060583958765
            ],
            [
              101.23545783305858,
              23.458209513781064
            ],
            [
              101.23614483314685,
              23.45978447875365
            ],
            [
              101.23648783327852,
              23.460729458278017
            ],
            [
              101.23648783327852,
              23.46324840208698
            ],
            [
              101.23751783349844,
              23.465768345162235
            ],
            [
              101.23751783349844,
              23.467343310594707
            ],
            [
              101.23751783349844,
              23.47112222593711
            ],
            [
              101.23717483336677,
              23.475846121053483
            ],
            [
              101.23717483336677,
              23.47773507870639
            ],
            [
              101.23820483268835,
              23.480884008055845
            ],
            [
              101.2423238328449,
              23.481513994675677
            ],
            [
              101.24266783280147,
              23.481199001329955
            ],
            [
              101.24541383350471,
              23.481513994675677
            ],
            [
              101.24747383304621,
              23.481513994675677
            ],
            [
              101.24953383348613,
              23.481513994675677
            ],
            [
              101.25262383324761,
              23.482458973494648
            ],
            [
              101.25571383300911,
              23.48056901567733
            ],
            [
              101.26052083307876,
              23.478680057409754
            ],
            [
              101.2625798327954,
              23.476160113713856
            ],
            [
              101.26326683288367,
              23.475531128179888
            ],
            [
              101.27072383339711,
              23.472009206469373
            ],
            [
              101.27217183319348,
              23.467594304749593
            ],
            [
              101.27199783311619,
              23.460082472630187
            ],
            [
              101.27483983318055,
              23.4482457361427
            ],
            [
              101.27797783352095,
              23.43517502710437
            ],
            [
              101.27836383331031,
              23.428760170196046
            ],
            [
              101.28134983331474,
              23.37910927480942
            ],
            [
              101.28213983333517,
              23.36596656619891
            ],
            [
              101.26931883325842,
              23.34642900002795
            ],
            [
              101.2653288329734,
              23.346042009257253
            ],
            [
              101.26086583286028,
              23.345727015725625
            ],
            [
              101.25537183270235,
              23.345096030092428
            ],
            [
              101.25371283301877,
              23.344827036215026
            ],
            [
              101.24953583313595,
              23.344151051243422
            ],
            [
              101.24301283348132,
              23.34225909304026
            ],
            [
              101.24095283304143,
              23.33847717676353
            ],
            [
              101.24026583295317,
              23.33816118375116
            ],
            [
              101.23408583343017,
              23.33185632400399
            ],
            [
              101.23168283285865,
              23.324290491257152
            ],
            [
              101.22824983296549,
              23.321768546962605
            ],
            [
              101.22378683285238,
              23.318930610098032
            ],
            [
              101.21382983347968,
              23.316723659330094
            ],
            [
              101.20318683294529,
              23.31577768007703
            ],
            [
              101.19700783324724,
              23.313570728937297
            ],
            [
              101.19563383307074,
              23.312624750348448
            ],
            [
              101.18945383354772,
              23.30852584040009
            ],
            [
              101.18327483295138,
              23.307579861395723
            ],
            [
              101.17915483296994,
              23.306634883003653
            ]
          ]
        ]
      },
      "properties": {
        "name": "德安乡"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.48860183326185,
              22.9563955879149
            ],
            [
              101.48934983344947,
              22.955150614536983
            ],
            [
              101.49398383326681,
              22.94744178344903
            ],
            [
              101.51065783336121,
              22.932750103432312
            ],
            [
              101.51690483283137,
              22.922825320503232
            ],
            [
              101.51890783336981,
              22.905479698196967
            ],
            [
              101.51663783286763,
              22.90606768541254
            ],
            [
              101.5149208334578,
              22.9059096891715
            ],
            [
              101.51200283322542,
              22.905118706432052
            ],
            [
              101.5095998335522,
              22.904644716321993
            ],
            [
              101.50771083281656,
              22.89847785146516
            ],
            [
              101.50547983267248,
              22.89278497530127
            ],
            [
              101.50118783316191,
              22.88946404738887
            ],
            [
              101.49818183306601,
              22.888079077437055
            ],
            [
              101.49775483326876,
              22.887882081642662
            ],
            [
              101.49466483350726,
              22.88677510588071
            ],
            [
              101.4912318327158,
              22.888515068112316
            ],
            [
              101.48865683351343,
              22.889622043751142
            ],
            [
              101.48470883306113,
              22.891677998981834
            ],
            [
              101.48178983300389,
              22.893891950865154
            ],
            [
              101.47801383297906,
              22.90037481002612
            ],
            [
              101.47629683267085,
              22.902430765326834
            ],
            [
              101.47320683290937,
              22.90448672007796
            ],
            [
              101.47131883289696,
              22.905751692746364
            ],
            [
              101.4678858330038,
              22.9059096891715
            ],
            [
              101.46685583278388,
              22.906225682296956
            ],
            [
              101.46428083268319,
              22.90685866840867
            ],
            [
              101.46273583280244,
              22.906700672261792
            ],
            [
              101.46101883339259,
              22.907648651346307
            ],
            [
              101.45930283290929,
              22.909071620356258
            ],
            [
              101.45638483267693,
              22.90875562724353
            ],
            [
              101.45192083273894,
              22.90875562724353
            ],
            [
              101.44968983349315,
              22.908597630824758
            ],
            [
              101.44865983327321,
              22.908281637434815
            ],
            [
              101.44728683292162,
              22.908123640463682
            ],
            [
              101.44419683316013,
              22.90527670276724
            ],
            [
              101.44282283298358,
              22.90527670276724
            ],
            [
              101.44024783288293,
              22.904328723649847
            ],
            [
              101.43784483320971,
              22.90385373365143
            ],
            [
              101.43561383306557,
              22.90385373365143
            ],
            [
              101.43544183353646,
              22.90385373365143
            ],
            [
              101.43320983356745,
              22.903537740791133
            ],
            [
              101.43080683299591,
              22.903379744084898
            ],
            [
              101.42720183267528,
              22.90306375094769
            ],
            [
              101.42411183291381,
              22.902430765326834
            ],
            [
              101.42102183315235,
              22.903221748022087
            ],
            [
              101.41999183293241,
              22.904644716321993
            ],
            [
              101.41879083300823,
              22.90543469974582
            ],
            [
              101.41844683305166,
              22.905593696137128
            ],
            [
              101.41655883303925,
              22.905593696137128
            ],
            [
              101.41552883281932,
              22.90606768541254
            ],
            [
              101.4136408328069,
              22.907332658227087
            ],
            [
              101.41106583270621,
              22.909862603204733
            ],
            [
              101.40934883329635,
              22.911760561760897
            ],
            [
              101.40814783337214,
              22.911443568742413
            ],
            [
              101.4060878329323,
              22.908913623478224
            ],
            [
              101.40351283283162,
              22.90796564413589
            ],
            [
              101.4005948334976,
              22.90606768541254
            ],
            [
              101.39819083310111,
              22.90416972743037
            ],
            [
              101.3966458332204,
              22.905118706432052
            ],
            [
              101.39510083333965,
              22.905118706432052
            ],
            [
              101.39166783344649,
              22.904802713209445
            ],
            [
              101.39012283356575,
              22.904802713209445
            ],
            [
              101.38874983321415,
              22.904328723649847
            ],
            [
              101.38583183298181,
              22.903221748022087
            ],
            [
              101.38394383296934,
              22.902746758283932
            ],
            [
              101.38239883308864,
              22.90116579229926
            ],
            [
              101.37827883310722,
              22.901007796139787
            ],
            [
              101.37587483271072,
              22.901007796139787
            ],
            [
              101.3738148331692,
              22.903221748022087
            ],
            [
              101.37038183327606,
              22.90527670276724
            ],
            [
              101.36849383326364,
              22.905751692746364
            ],
            [
              101.36712083291204,
              22.90749065446501
            ],
            [
              101.36488883294302,
              22.907332658227087
            ],
            [
              101.36403083315054,
              22.908281637434815
            ],
            [
              101.36300083293061,
              22.908913623478224
            ],
            [
              101.3616278334773,
              22.90875562724353
            ],
            [
              101.35922883310371,
              22.906856668406217
            ],
            [
              101.35871383344293,
              22.908121640479877
            ],
            [
              101.35631083287137,
              22.90954460949043
            ],
            [
              101.35493683269488,
              22.911916557875568
            ],
            [
              101.35407883290239,
              22.913813517098866
            ],
            [
              101.3527058334491,
              22.91792442717478
            ],
            [
              101.35116083267005,
              22.9206123688791
            ],
            [
              101.34858583346765,
              22.922509327187566
            ],
            [
              101.34412283335456,
              22.923774299627926
            ],
            [
              101.33965983324146,
              22.923774299627926
            ],
            [
              101.3375998328016,
              22.9236163033415
            ],
            [
              101.33553983326004,
              22.925197268122265
            ],
            [
              101.33450983304013,
              22.926936230217944
            ],
            [
              101.33330783329104,
              22.92804320660224
            ],
            [
              101.3276428334289,
              22.932154116812544
            ],
            [
              101.32626983307726,
              22.93341808914395
            ],
            [
              101.32472483319654,
              22.93341808914395
            ],
            [
              101.32232183352329,
              22.93452506467065
            ],
            [
              101.31974683342263,
              22.936264026961837
            ],
            [
              101.31974683342263,
              22.937528999173598
            ],
            [
              101.31991883295176,
              22.939425957993866
            ],
            [
              101.31991883295176,
              22.941164920210383
            ],
            [
              101.32043383351088,
              22.9446428438047
            ],
            [
              101.31837383307104,
              22.951439695547403
            ],
            [
              101.31665683276283,
              22.953652647129005
            ],
            [
              101.31596983267457,
              22.955074616702593
            ],
            [
              101.31751483345361,
              22.955865598907927
            ],
            [
              101.31905983333439,
              22.958394543894002
            ],
            [
              101.32026183308345,
              22.962662450948187
            ],
            [
              101.32060483321509,
              22.966139374463484
            ],
            [
              101.31940383329096,
              22.971829250627493
            ],
            [
              101.31934983286428,
              22.972194242106436
            ],
            [
              101.31888883273182,
              22.975306174094637
            ],
            [
              101.31957483299519,
              22.977203132493365
            ],
            [
              101.32283683318411,
              22.97941508435166
            ],
            [
              101.32472483319654,
              22.980047070798523
            ],
            [
              101.32644183350472,
              22.979573080827
            ],
            [
              101.33244983349854,
              22.980679056770338
            ],
            [
              101.3348528331718,
              22.982260022269788
            ],
            [
              101.33691283271335,
              22.982418018726257
            ],
            [
              101.34000283337315,
              22.984629970389364
            ],
            [
              101.3412048331222,
              22.987000918928658
            ],
            [
              101.34086083316564,
              22.988580884229975
            ],
            [
              101.33880083272577,
              22.989845856692394
            ],
            [
              101.33965983324146,
              22.99047784230323
            ],
            [
              101.34446583348625,
              22.992372801453627
            ],
            [
              101.34532483310365,
              22.993163783711204
            ],
            [
              101.34721283311606,
              22.99474374967968
            ],
            [
              101.34858583346765,
              22.996955701239465
            ],
            [
              101.34807083290855,
              22.99727169431428
            ],
            [
              101.34223483334215,
              22.998061677072954
            ],
            [
              101.34068983346138,
              22.99679770442469
            ],
            [
              101.33777183322904,
              22.99869366309367
            ],
            [
              101.33450983304013,
              23.002802572989854
            ],
            [
              101.33399483337931,
              23.004856528316253
            ],
            [
              101.33502483270091,
              23.008174455180082
            ],
            [
              101.3334798328202,
              23.008806441803433
            ],
            [
              101.33244983349854,
              23.008490448448345
            ],
            [
              101.32987483339787,
              23.008332451906714
            ],
            [
              101.32798683338545,
              23.007858461998616
            ],
            [
              101.32558383281393,
              23.01101839358393
            ],
            [
              101.3259268329456,
              23.012914351736125
            ],
            [
              101.32918883313455,
              23.01354633765305
            ],
            [
              101.33073283319035,
              23.01781224430809
            ],
            [
              101.32850183304629,
              23.0209721750445
            ],
            [
              101.32661383303387,
              23.023974109732293
            ],
            [
              101.32661383303387,
              23.026186060784976
            ],
            [
              101.32935983283878,
              23.027608029877513
            ],
            [
              101.33141983327863,
              23.029187995120964
            ],
            [
              101.33468183346758,
              23.028556008931048
            ],
            [
              101.33639783305254,
              23.029977977824945
            ],
            [
              101.33742783327246,
              23.03029397126357
            ],
            [
              101.33880183344897,
              23.030451967705066
            ],
            [
              101.33965983324146,
              23.030451967705066
            ],
            [
              101.33897283315322,
              23.03171594000973
            ],
            [
              101.33948783281402,
              23.03345290179858
            ],
            [
              101.33845783349241,
              23.035506856602183
            ],
            [
              101.33811483336073,
              23.03756081151158
            ],
            [
              101.33691283271335,
              23.03740281513785
            ],
            [
              101.33691283271335,
              23.03898278045782
            ],
            [
              101.33571183278919,
              23.03898278045782
            ],
            [
              101.3348538329967,
              23.041035735861513
            ],
            [
              101.33399483337931,
              23.043247687116143
            ],
            [
              101.3370848331408,
              23.04624862140157
            ],
            [
              101.34068983346138,
              23.049407552306096
            ],
            [
              101.34257783347384,
              23.0536724586587
            ],
            [
              101.34721283311606,
              23.05619940352287
            ],
            [
              101.35150483352494,
              23.058569351017795
            ],
            [
              101.35081783343666,
              23.059043341129954
            ],
            [
              101.34961583278928,
              23.060306312832743
            ],
            [
              101.34927283355591,
              23.063781237064898
            ],
            [
              101.34824283333599,
              23.065834192090264
            ],
            [
              101.34343683309123,
              23.066624174739466
            ],
            [
              101.33948783281402,
              23.066624174739466
            ],
            [
              101.33553983326004,
              23.065992188164643
            ],
            [
              101.33279383345517,
              23.063781237064898
            ],
            [
              101.3307338330153,
              23.065834192090264
            ],
            [
              101.32832983351715,
              23.0691511194128
            ],
            [
              101.32489683272567,
              23.07057208777238
            ],
            [
              101.3220878331716,
              23.072217051777738
            ],
            [
              101.32112083270084,
              23.072783039672547
            ],
            [
              101.32300883271326,
              23.07420500851126
            ],
            [
              101.32695683316553,
              23.078626911070494
            ],
            [
              101.32884483317794,
              23.08225883162384
            ],
            [
              101.3303898330587,
              23.088733689623346
            ],
            [
              101.33141983327863,
              23.09283859912529
            ],
            [
              101.32884483317794,
              23.093470585131968
            ],
            [
              101.33107683314697,
              23.09552353973263
            ],
            [
              101.3321068333669,
              23.09694450866547
            ],
            [
              101.33090483271951,
              23.09820748139816
            ],
            [
              101.32850183304629,
              23.099944442729047
            ],
            [
              101.32609883337304,
              23.099786446062804
            ],
            [
              101.32249383305243,
              23.100734425751533
            ],
            [
              101.32043383351088,
              23.103260369879024
            ],
            [
              101.31906083315927,
              23.10562931778841
            ],
            [
              101.31871683320267,
              23.10831325912858
            ],
            [
              101.32215083292077,
              23.112260172479584
            ],
            [
              101.3231808331407,
              23.11683907139067
            ],
            [
              101.32712483339505,
              23.11731606082155
            ],
            [
              101.32849883267325,
              23.11763205402599
            ],
            [
              101.33396683289189,
              23.121076978089732
            ],
            [
              101.33452683275858,
              23.11998900274476
            ],
            [
              101.36010283278974,
              23.096962508142383
            ],
            [
              101.36824683339142,
              23.092463607517693
            ],
            [
              101.37138083353385,
              23.090731645552815
            ],
            [
              101.3812118334082,
              23.092795600015123
            ],
            [
              101.39217483271138,
              23.102173393705552
            ],
            [
              101.39971983308835,
              23.10862625197779
            ],
            [
              101.4069668335395,
              23.114825116146758
            ],
            [
              101.4394578328625,
              23.11261516488805
            ],
            [
              101.45155383321608,
              23.108580252897585
            ],
            [
              101.45668783352393,
              23.105635318052656
            ],
            [
              101.46211383301151,
              23.102522385937306
            ],
            [
              101.47478483330039,
              23.09525254624046
            ],
            [
              101.47720983271492,
              23.093156591809983
            ],
            [
              101.47734183295941,
              23.09304259433188
            ],
            [
              101.4890988333793,
              23.082879817651914
            ],
            [
              101.50878383269422,
              23.057593373008572
            ],
            [
              101.51466883356271,
              23.040675743323888
            ],
            [
              101.51484983331267,
              23.040154755088345
            ],
            [
              101.51468483345622,
              23.038443792423383
            ],
            [
              101.51376783321422,
              23.028906001523566
            ],
            [
              101.5072118330493,
              23.02665405111767
            ],
            [
              101.48923583274834,
              23.020480185947157
            ],
            [
              101.46841883310627,
              22.997678684849284
            ],
            [
              101.46802883311892,
              22.98114704697408
            ],
            [
              101.47274683350015,
              22.975021180641903
            ],
            [
              101.48559083314306,
              22.96944630275278
            ],
            [
              101.48618683299473,
              22.96041349966957
            ],
            [
              101.48860183326185,
              22.9563955879149
            ]
          ]
        ]
      },
      "properties": {
        "name": "普义乡"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              101.49406183308461,
              22.694491277333892
            ],
            [
              101.4897538327822,
              22.69046936382212
            ],
            [
              101.4861538333828,
              22.687183434730734
            ],
            [
              101.48298683273009,
              22.685508470658966
            ],
            [
              101.47610583287513,
              22.68443349400533
            ],
            [
              101.47021983308005,
              22.682923527094808
            ],
            [
              101.46430683352078,
              22.682327539917985
            ],
            [
              101.46034083352512,
              22.682462536670226
            ],
            [
              101.45639183324792,
              22.682367538754658
            ],
            [
              101.45213883319711,
              22.683866506616347
            ],
            [
              101.44885583309178,
              22.68584846369821
            ],
            [
              101.44442883296368,
              22.69306730773491
            ],
            [
              101.44176883337254,
              22.69918017544097
            ],
            [
              101.43911783310388,
              22.704837053631035
            ],
            [
              101.43565983309637,
              22.71253388736045
            ],
            [
              101.43253883337273,
              22.71749177989363
            ],
            [
              101.42450083307627,
              22.720722709895476
            ],
            [
              101.41672883291857,
              22.723958640349167
            ],
            [
              101.40762483331545,
              22.72944552148457
            ],
            [
              101.40108783341711,
              22.732478455566774
            ],
            [
              101.39594183341372,
              22.736095377020614
            ],
            [
              101.39449683309209,
              22.737110355361096
            ],
            [
              101.39235183316171,
              22.74208624809967
            ],
            [
              101.39321183350232,
              22.74623115769923
            ],
            [
              101.39603483330012,
              22.751342047346572
            ],
            [
              101.39830183342922,
              22.757810907029622
            ],
            [
              101.39567883274964,
              22.762547804947786
            ],
            [
              101.3925698327216,
              22.76681171225867
            ],
            [
              101.38473283316492,
              22.771179617676946
            ],
            [
              101.38200483290333,
              22.772911580218953
            ],
            [
              101.37712883323667,
              22.77600751263028
            ],
            [
              101.37306083313379,
              22.779098445885175
            ],
            [
              101.36570483290271,
              22.783702346293172
            ],
            [
              101.35903483293497,
              22.79038120122928
            ],
            [
              101.35635683290212,
              22.796257073624616
            ],
            [
              101.35673183282081,
              22.79763804397895
            ],
            [
              101.35792283269927,
              22.802023948530284
            ],
            [
              101.35950583311316,
              22.80664784822374
            ],
            [
              101.3595578329917,
              22.81305870885122
            ],
            [
              101.35939283313526,
              22.818090599470164
            ],
            [
              101.35948883339474,
              22.823126490450417
            ],
            [
              101.36081983301523,
              22.82820038033388
            ],
            [
              101.3607768333575,
              22.83735518087893
            ],
            [
              101.36056783312014,
              22.84398903674215
            ],
            [
              101.35686383306535,
              22.850977885372302
            ],
            [
              101.35052283298558,
              22.862701629986134
            ],
            [
              101.34608583281174,
              22.869215487949585
            ],
            [
              101.33949183301196,
              22.8731474025553
            ],
            [
              101.33419283284772,
              22.875287356329427
            ],
            [
              101.32663183347555,
              22.878273291109366
            ],
            [
              101.3290168327071,
              22.878233291731185
            ],
            [
              101.33124783285119,
              22.878075295355064
            ],
            [
              101.3331368326885,
              22.878233291731185
            ],
            [
              101.3348528331718,
              22.87760030614834
            ],
            [
              101.33656983348,
              22.878549284759504
            ],
            [
              101.33897283315322,
              22.87997325420295
            ],
            [
              101.34154782427073,
              22.880131250853392
            ],
            [
              101.34377983322287,
              22.88123822617282
            ],
            [
              101.3448088327196,
              22.882978189032496
            ],
            [
              101.34601083336698,
              22.88471715053033
            ],
            [
              101.3501308333484,
              22.88709009915588
            ],
            [
              101.3527058334491,
              22.888829060939205
            ],
            [
              101.3537358327707,
              22.8908850165979
            ],
            [
              101.3527058334491,
              22.894522937253388
            ],
            [
              101.35098883314089,
              22.896577892212346
            ],
            [
              101.35150783299962,
              22.898248856288387
            ],
            [
              101.35167583322915,
              22.898791844407516
            ],
            [
              101.35253383302162,
              22.901321789018116
            ],
            [
              101.35287783297821,
              22.903219747966
            ],
            [
              101.35562383278311,
              22.904800713176662
            ],
            [
              101.35699683313473,
              22.907014665198783
            ],
            [
              101.35922883310371,
              22.906856668406217
            ],
            [
              101.3616278334773,
              22.90875562724353
            ],
            [
              101.36300083293061,
              22.908913623478224
            ],
            [
              101.36403083315054,
              22.908281637434815
            ],
            [
              101.36488883294302,
              22.907332658227087
            ],
            [
              101.36712083291204,
              22.90749065446501
            ],
            [
              101.36849383326364,
              22.905751692746364
            ],
            [
              101.37038183327606,
              22.90527670276724
            ],
            [
              101.3738148331692,
              22.903221748022087
            ],
            [
              101.37587483271072,
              22.901007796139787
            ],
            [
              101.37827883310722,
              22.901007796139787
            ],
            [
              101.38239883308864,
              22.90116579229926
            ],
            [
              101.38394383296934,
              22.902746758283932
            ],
            [
              101.38583183298181,
              22.903221748022087
            ],
            [
              101.38874983321415,
              22.904328723649847
            ],
            [
              101.39012283356575,
              22.904802713209445
            ],
            [
              101.39166783344649,
              22.904802713209445
            ],
            [
              101.39510083333965,
              22.905118706432052
            ],
            [
              101.3966458332204,
              22.905118706432052
            ],
            [
              101.39819083310111,
              22.90416972743037
            ],
            [
              101.4005948334976,
              22.90606768541254
            ],
            [
              101.40351283283162,
              22.90796564413589
            ],
            [
              101.4060878329323,
              22.908913623478224
            ],
            [
              101.40814783337214,
              22.911443568742413
            ],
            [
              101.40934883329635,
              22.911760561760897
            ],
            [
              101.41106583270621,
              22.909862603204733
            ],
            [
              101.4136408328069,
              22.907332658227087
            ],
            [
              101.41552883281932,
              22.90606768541254
            ],
            [
              101.41655883303925,
              22.905593696137128
            ],
            [
              101.41844683305166,
              22.905593696137128
            ],
            [
              101.41879083300823,
              22.90543469974582
            ],
            [
              101.41999183293241,
              22.904644716321993
            ],
            [
              101.42102183315235,
              22.903221748022087
            ],
            [
              101.42411183291381,
              22.902430765326834
            ],
            [
              101.42720183267528,
              22.90306375094769
            ],
            [
              101.43080683299591,
              22.903379744084898
            ],
            [
              101.43320983356745,
              22.903537740791133
            ],
            [
              101.43544183353646,
              22.90385373365143
            ],
            [
              101.43561383306557,
              22.90385373365143
            ],
            [
              101.43784483320971,
              22.90385373365143
            ],
            [
              101.44024783288293,
              22.904328723649847
            ],
            [
              101.44282283298358,
              22.90527670276724
            ],
            [
              101.44419683316013,
              22.90527670276724
            ],
            [
              101.44728683292162,
              22.908123640463682
            ],
            [
              101.44865983327321,
              22.908281637434815
            ],
            [
              101.44968983349315,
              22.908597630824758
            ],
            [
              101.45192083273894,
              22.90875562724353
            ],
            [
              101.45638483267693,
              22.90875562724353
            ],
            [
              101.45930283290929,
              22.909071620356258
            ],
            [
              101.46101883339259,
              22.907648651346307
            ],
            [
              101.46273583280244,
              22.906700672261792
            ],
            [
              101.46428083268319,
              22.90685866840867
            ],
            [
              101.46685583278388,
              22.906225682296956
            ],
            [
              101.4678858330038,
              22.9059096891715
            ],
            [
              101.47131883289696,
              22.905751692746364
            ],
            [
              101.47320683290937,
              22.90448672007796
            ],
            [
              101.47629683267085,
              22.902430765326834
            ],
            [
              101.47801383297906,
              22.90037481002612
            ],
            [
              101.48178983300389,
              22.893891950865154
            ],
            [
              101.48470883306113,
              22.891677998981834
            ],
            [
              101.48865683351343,
              22.889622043751142
            ],
            [
              101.4912318327158,
              22.888515068112316
            ],
            [
              101.49466483350726,
              22.88677510588071
            ],
            [
              101.49775483326876,
              22.887882081642662
            ],
            [
              101.49818183306601,
              22.888079077437055
            ],
            [
              101.50118783316191,
              22.88946404738887
            ],
            [
              101.50547983267248,
              22.89278497530127
            ],
            [
              101.50771083281656,
              22.89847785146516
            ],
            [
              101.5095998335522,
              22.904644716321993
            ],
            [
              101.51200283322542,
              22.905118706432052
            ],
            [
              101.5149208334578,
              22.9059096891715
            ],
            [
              101.51663783286763,
              22.90606768541254
            ],
            [
              101.51890783336981,
              22.905479698196967
            ],
            [
              101.52010583292093,
              22.900567805697378
            ],
            [
              101.52185883321413,
              22.893380962080194
            ],
            [
              101.52424683281875,
              22.891067012476192
            ],
            [
              101.53639183267785,
              22.890774018655353
            ],
            [
              101.54975183270481,
              22.873160402075758
            ],
            [
              101.5779178329053,
              22.86348561309061
            ],
            [
              101.58991283297657,
              22.85570578249923
            ],
            [
              101.5847258329653,
              22.843034058155123
            ],
            [
              101.56733883284332,
              22.829144359448804
            ],
            [
              101.56641983295147,
              22.82465445694418
            ],
            [
              101.57454283273844,
              22.816477634758655
            ],
            [
              101.58709083300369,
              22.813640696128072
            ],
            [
              101.58887183288601,
              22.811494742611142
            ],
            [
              101.59076483292125,
              22.809213792730084
            ],
            [
              101.59116883315232,
              22.808726802721086
            ],
            [
              101.59028383269737,
              22.804573893517272
            ],
            [
              101.56805683289372,
              22.792291159835333
            ],
            [
              101.57459583334021,
              22.78452432838771
            ],
            [
              101.57581783318078,
              22.78511531513733
            ],
            [
              101.57721183344876,
              22.78568730265905
            ],
            [
              101.57843883331219,
              22.78582029998006
            ],
            [
              101.57920883324114,
              22.784678324625325
            ],
            [
              101.57935383300608,
              22.782952362032894
            ],
            [
              101.57965883350292,
              22.782378374460713
            ],
            [
              101.57964883345718,
              22.781092402622384
            ],
            [
              101.5796438334343,
              22.780374418092048
            ],
            [
              101.58103083313132,
              22.778933449136172
            ],
            [
              101.5824098333307,
              22.778068468360964
            ],
            [
              101.58302783292368,
              22.777780474005613
            ],
            [
              101.5862678333713,
              22.777062490268634
            ],
            [
              101.58981383324236,
              22.77647350285738
            ],
            [
              101.59135483292515,
              22.775752518043895
            ],
            [
              101.59258183278857,
              22.774035555287426
            ],
            [
              101.59380983337522,
              22.77259758655102
            ],
            [
              101.59626683347513,
              22.771438611543388
            ],
            [
              101.59795983349389,
              22.770291637105263
            ],
            [
              101.59856983269091,
              22.769423655259022
            ],
            [
              101.59847083295672,
              22.76853167492846
            ],
            [
              101.59810483325884,
              22.76785168971494
            ],
            [
              101.59747183269894,
              22.76613872697292
            ],
            [
              101.59746383320135,
              22.76398777313852
            ],
            [
              101.59807383329671,
              22.762698801678347
            ],
            [
              101.60006483324126,
              22.759398873000535
            ],
            [
              101.60098083276004,
              22.75810190082597
            ],
            [
              101.60343783285998,
              22.755516956476846
            ],
            [
              101.60727683353231,
              22.752215028453236
            ],
            [
              101.6101918333916,
              22.749199093434203
            ],
            [
              101.61111583330636,
              22.747901121419932
            ],
            [
              101.612191833557,
              22.74732413414246
            ],
            [
              101.61480283274439,
              22.745029184021178
            ],
            [
              101.61587983282,
              22.744317199281067
            ],
            [
              101.61711683272915,
              22.74388320894145
            ],
            [
              101.61741483355331,
              22.743905207980966
            ],
            [
              101.61834583314072,
              22.743015227441955
            ],
            [
              101.61833883346804,
              22.74244623998414
            ],
            [
              101.61740683315739,
              22.74144126206401
            ],
            [
              101.6130778329386,
              22.739740298533174
            ],
            [
              101.61214583352628,
              22.739598301172293
            ],
            [
              101.6051848333054,
              22.73646236901471
            ],
            [
              101.60379583306027,
              22.736186375723356
            ],
            [
              101.60085783273642,
              22.736053378108817
            ],
            [
              101.59731083304047,
              22.736345371854572
            ],
            [
              101.59638783295064,
              22.736207375160408
            ],
            [
              101.59391583278212,
              22.736355371969807
            ],
            [
              101.59006383348762,
              22.737087356050445
            ],
            [
              101.58805883329934,
              22.73795133708006
            ],
            [
              101.58637283295327,
              22.738818318429622
            ],
            [
              101.58543583351809,
              22.73910731209567
            ],
            [
              101.5845138332532,
              22.739680300144705
            ],
            [
              101.58359083316334,
              22.739824296564205
            ],
            [
              101.5825158327376,
              22.74025728738093
            ],
            [
              101.58143283281422,
              22.740556281126935
            ],
            [
              101.57897083269143,
              22.740850274325968
            ],
            [
              101.57727183282492,
              22.740708277289585
            ],
            [
              101.57064183304018,
              22.73959430204964
            ],
            [
              101.56806483328964,
              22.739433304747898
            ],
            [
              101.56413483327903,
              22.736485369259
            ],
            [
              101.56108083350252,
              22.7346444087168
            ],
            [
              101.56053983300414,
              22.73229745983503
            ],
            [
              101.56100483333456,
              22.72853454066299
            ],
            [
              101.56424883308188,
              22.725153613836042
            ],
            [
              101.5643938328468,
              22.724151635896067
            ],
            [
              101.56515583327811,
              22.722720666565085
            ],
            [
              101.56576483354854,
              22.72185268579261
            ],
            [
              101.56913983281709,
              22.718255763467766
            ],
            [
              101.56959683275159,
              22.71754177906836
            ],
            [
              101.56990183324844,
              22.71668079719154
            ],
            [
              101.5705108335189,
              22.715819815698623
            ],
            [
              101.57081583311742,
              22.715103831515336
            ],
            [
              101.57096883327831,
              22.71424385021899
            ],
            [
              101.57142583321276,
              22.71352286601484
            ],
            [
              101.57218683292088,
              22.711658906097263
            ],
            [
              101.57233983308177,
              22.710798924702797
            ],
            [
              101.5729488333522,
              22.709506952424604
            ],
            [
              101.57324683327803,
              22.707783989683744
            ],
            [
              101.57215683278365,
              22.70650601703144
            ],
            [
              101.57182083322299,
              22.70629502227332
            ],
            [
              101.57047283298574,
              22.70765399246845
            ],
            [
              101.56846883352067,
              22.707803989116865
            ],
            [
              101.56769183302076,
              22.707242001778887
            ],
            [
              101.56629783275272,
              22.704667057158893
            ],
            [
              101.56567283348707,
              22.703811075937672
            ],
            [
              101.56505583282066,
              22.703524081970375
            ],
            [
              101.56259583324605,
              22.70382007569546
            ],
            [
              101.56075283343947,
              22.70454805966859
            ],
            [
              101.55998383333545,
              22.704983049916052
            ],
            [
              101.55721083286807,
              22.705712034571707
            ],
            [
              101.55598583355278,
              22.706293021810882
            ],
            [
              101.5553688328864,
              22.70672001297745
            ],
            [
              101.55352583307985,
              22.707303000530874
            ],
            [
              101.55213283353505,
              22.706453018107695
            ],
            [
              101.55105983275911,
              22.706030027869858
            ],
            [
              101.55012983299659,
              22.706462018520533
            ],
            [
              101.54905683311895,
              22.70718500306992
            ],
            [
              101.54706283280132,
              22.708773968061386
            ],
            [
              101.54645383342917,
              22.7090559624004
            ],
            [
              101.54506883338202,
              22.709351955768916
            ],
            [
              101.54137683302272,
              22.70979594586484
            ],
            [
              101.54029683347244,
              22.71009493990124
            ],
            [
              101.53676583277165,
              22.710829924217556
            ],
            [
              101.53522083289091,
              22.710840923910013
            ],
            [
              101.53414783301328,
              22.7114109112846
            ],
            [
              101.53261883302606,
              22.712711882997784
            ],
            [
              101.53139383281246,
              22.714151851660958
            ],
            [
              101.53062583343164,
              22.714869836189518
            ],
            [
              101.52940083321803,
              22.715594820580677
            ],
            [
              101.52664683301724,
              22.719330739840775
            ],
            [
              101.52634283324362,
              22.719904728017713
            ],
            [
              101.52496583269405,
              22.721201699706953
            ],
            [
              101.52434983275089,
              22.721494692964747
            ],
            [
              101.51964483278846,
              22.72258866922553
            ],
            [
              101.5184498327121,
              22.72202768139034
            ],
            [
              101.51382883331358,
              22.7194017387037
            ],
            [
              101.51023783323666,
              22.715656819916802
            ],
            [
              101.50596283344456,
              22.710066940002392
            ],
            [
              101.50049383340095,
              22.703077091490886
            ],
            [
              101.49528383292514,
              22.69563225269294
            ],
            [
              101.49406183308461,
              22.694491277333892
            ]
          ]
        ]
      },
      "properties": {
        "name": "黎明乡"
      }
    }
  ]
}
export const china = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        adcode: 530802,
        name: "思茅区",
        center: [100.973227, 22.776595],
        centroid: [100.848666, 22.733055],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 0,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [101.445861, 22.584354],
              [101.441046, 22.57985],
              [101.437182, 22.582468],
              [101.429136, 22.58213],
              [101.42128, 22.579231],
              [101.417035, 22.571152],
              [101.415357, 22.57498],
              [101.41108, 22.575205],
              [101.408166, 22.571855],
              [101.40484, 22.575825],
              [101.382889, 22.567295],
              [101.369711, 22.559975],
              [101.35929, 22.558454],
              [101.349185, 22.558849],
              [101.347031, 22.556089],
              [101.333252, 22.549529],
              [101.325523, 22.543363],
              [101.308228, 22.533479],
              [101.300752, 22.533732],
              [101.277724, 22.540378],
              [101.271769, 22.540462],
              [101.254822, 22.543644],
              [101.219693, 22.534465],
              [101.206072, 22.535028],
              [101.193782, 22.54066],
              [101.182347, 22.550205],
              [101.176075, 22.552317],
              [101.154662, 22.549248],
              [101.140122, 22.548178],
              [101.124854, 22.545475],
              [101.116935, 22.545953],
              [101.096979, 22.55043],
              [101.08716, 22.554259],
              [101.082282, 22.558933],
              [101.037745, 22.58517],
              [101.035052, 22.589393],
              [101.028179, 22.590209],
              [101.02197, 22.586184],
              [101.020608, 22.578049],
              [101.014526, 22.576303],
              [101.011264, 22.572306],
              [101.002901, 22.575262],
              [101.00043, 22.579653],
              [100.997009, 22.578274],
              [100.993525, 22.583932],
              [100.992575, 22.578612],
              [100.98833, 22.573207],
              [100.992575, 22.563128],
              [100.996661, 22.557948],
              [100.986778, 22.553781],
              [100.971193, 22.555949],
              [100.959885, 22.555217],
              [100.944965, 22.546573],
              [100.936318, 22.53897],
              [100.926561, 22.532662],
              [100.923267, 22.528748],
              [100.915031, 22.52551],
              [100.901791, 22.525988],
              [100.8895, 22.536295],
              [100.882183, 22.538548],
              [100.879332, 22.55868],
              [100.872807, 22.56828],
              [100.865173, 22.576585],
              [100.859028, 22.585565],
              [100.846009, 22.583031],
              [100.837013, 22.585762],
              [100.834954, 22.589477],
              [100.82317, 22.59187],
              [100.820541, 22.589168],
              [100.80993, 22.594488],
              [100.811862, 22.579709],
              [100.806129, 22.579034],
              [100.804481, 22.57605],
              [100.795992, 22.578949],
              [100.787661, 22.575656],
              [100.781389, 22.57757],
              [100.778127, 22.573685],
              [100.773122, 22.575853],
              [100.766407, 22.571518],
              [100.758139, 22.571152],
              [100.751931, 22.563663],
              [100.747274, 22.56417],
              [100.747844, 22.558595],
              [100.741858, 22.55409],
              [100.739925, 22.548206],
              [100.734065, 22.543475],
              [100.733622, 22.534324],
              [100.723295, 22.523285],
              [100.712684, 22.523679],
              [100.707172, 22.518863],
              [100.696687, 22.517455],
              [100.679646, 22.523172],
              [100.667228, 22.519399],
              [100.659056, 22.519511],
              [100.656047, 22.507654],
              [100.658074, 22.497712],
              [100.653038, 22.494613],
              [100.638847, 22.492416],
              [100.632195, 22.490219],
              [100.622217, 22.489881],
              [100.616357, 22.484867],
              [100.611067, 22.472077],
              [100.611067, 22.467711],
              [100.61661, 22.458385],
              [100.617275, 22.454722],
              [100.612144, 22.445959],
              [100.606917, 22.442127],
              [100.600582, 22.444719],
              [100.596717, 22.44224],
              [100.588355, 22.442832],
              [100.579834, 22.450017],
              [100.578884, 22.458779],
              [100.571915, 22.472951],
              [100.562602, 22.477881],
              [100.56238, 22.481346],
              [100.568304, 22.482782],
              [100.579074, 22.481965],
              [100.581323, 22.48712],
              [100.579295, 22.496247],
              [100.573974, 22.500162],
              [100.574196, 22.510781],
              [100.569381, 22.51999],
              [100.56558, 22.523679],
              [100.561177, 22.534324],
              [100.554366, 22.545165],
              [100.535646, 22.549585],
              [100.526364, 22.555414],
              [100.514486, 22.55989],
              [100.507961, 22.567548],
              [100.497159, 22.573376],
              [100.493073, 22.581708],
              [100.489905, 22.584298],
              [100.483507, 22.585086],
              [100.469823, 22.589477],
              [100.458926, 22.598513],
              [100.443595, 22.62266],
              [100.434567, 22.63099],
              [100.427281, 22.643427],
              [100.416416, 22.65575],
              [100.404094, 22.664866],
              [100.388826, 22.671842],
              [100.374034, 22.67609],
              [100.371436, 22.685992],
              [100.372482, 22.697777],
              [100.375142, 22.702108],
              [100.378215, 22.717351],
              [100.378215, 22.729753],
              [100.37435, 22.738244],
              [100.372355, 22.749575],
              [100.375934, 22.764026],
              [100.372228, 22.783254],
              [100.36678, 22.788875],
              [100.360666, 22.805176],
              [100.354996, 22.809645],
              [100.347742, 22.81223],
              [100.345272, 22.822431],
              [100.338398, 22.831929],
              [100.333678, 22.845078],
              [100.322845, 22.847241],
              [100.323193, 22.851568],
              [100.339443, 22.855838],
              [100.347774, 22.854715],
              [100.353919, 22.857187],
              [100.36111, 22.856541],
              [100.366685, 22.858535],
              [100.375301, 22.855726],
              [100.388858, 22.860277],
              [100.399216, 22.856569],
              [100.403968, 22.856737],
              [100.410936, 22.85404],
              [100.423924, 22.84564],
              [100.439984, 22.840161],
              [100.448536, 22.839403],
              [100.457944, 22.836509],
              [100.462759, 22.841088],
              [100.467162, 22.838897],
              [100.472325, 22.830692],
              [100.480276, 22.827573],
              [100.483317, 22.821953],
              [100.496399, 22.819424],
              [100.50511, 22.811303],
              [100.510558, 22.810516],
              [100.526681, 22.812146],
              [100.538243, 22.814619],
              [100.544673, 22.817823],
              [100.542266, 22.829765],
              [100.542361, 22.837548],
              [100.540365, 22.844207],
              [100.542741, 22.854574],
              [100.557977, 22.856709],
              [100.560987, 22.858648],
              [100.566815, 22.856232],
              [100.590477, 22.856794],
              [100.589558, 22.864575],
              [100.593201, 22.868396],
              [100.596369, 22.876205],
              [100.604161, 22.876626],
              [100.609768, 22.883142],
              [100.613506, 22.883058],
              [100.618067, 22.892917],
              [100.617877, 22.901904],
              [100.615153, 22.90724],
              [100.601754, 22.916085],
              [100.598745, 22.92611],
              [100.59526, 22.930322],
              [100.595672, 22.934421],
              [100.590635, 22.940991],
              [100.593676, 22.944304],
              [100.592916, 22.948571],
              [100.597319, 22.953147],
              [100.600804, 22.961429],
              [100.607392, 22.963366],
              [100.6098, 22.96825],
              [100.606252, 22.975352],
              [100.611415, 22.984979],
              [100.61718, 22.982144],
              [100.622597, 22.990367],
              [100.633177, 22.995419],
              [100.639195, 22.996093],
              [100.640557, 23.001144],
              [100.652467, 23.012313],
              [100.651802, 23.023341],
              [100.652562, 23.031982],
              [100.651264, 23.036219],
              [100.663364, 23.039978],
              [100.674957, 23.038407],
              [100.679455, 23.041437],
              [100.680564, 23.050471],
              [100.691271, 23.059531],
              [100.69032, 23.066376],
              [100.693488, 23.068844],
              [100.705493, 23.07019],
              [100.707014, 23.073725],
              [100.710847, 23.074566],
              [100.719209, 23.071958],
              [100.721141, 23.075351],
              [100.726621, 23.073949],
              [100.735364, 23.082139],
              [100.740274, 23.081101],
              [100.740876, 23.084859],
              [100.747401, 23.089234],
              [100.758773, 23.088786],
              [100.764886, 23.085392],
              [100.769226, 23.07681],
              [100.772679, 23.057147],
              [100.778158, 23.044495],
              [100.788358, 23.042924],
              [100.793585, 23.044018],
              [100.793775, 23.040287],
              [100.788865, 23.038519],
              [100.786838, 23.032543],
              [100.783448, 23.03173],
              [100.780883, 23.026567],
              [100.792571, 23.02205],
              [100.794884, 23.018065],
              [100.799667, 23.016943],
              [100.801631, 23.004231],
              [100.803816, 22.997328],
              [100.798716, 22.999601],
              [100.797639, 22.99396],
              [100.81012, 22.984193],
              [100.821396, 22.982088],
              [100.821111, 22.972685],
              [100.826876, 22.966903],
              [100.823804, 22.958565],
              [100.826401, 22.95573],
              [100.824849, 22.948234],
              [100.829569, 22.94217],
              [100.835429, 22.941805],
              [100.838945, 22.949161],
              [100.837773, 22.956123],
              [100.843126, 22.957162],
              [100.851869, 22.953849],
              [100.857349, 22.94669],
              [100.868119, 22.9566],
              [100.8844, 22.961345],
              [100.88798, 22.964432],
              [100.889627, 22.961232],
              [100.897198, 22.961766],
              [100.902488, 22.957555],
              [100.904546, 22.951042],
              [100.909773, 22.944641],
              [100.915633, 22.934028],
              [100.921525, 22.926644],
              [100.929697, 22.924032],
              [100.94807, 22.929143],
              [100.960265, 22.92903],
              [100.971225, 22.917546],
              [100.984592, 22.909205],
              [100.989217, 22.884547],
              [101.000272, 22.875025],
              [101.016744, 22.87112],
              [101.023491, 22.87789],
              [101.036224, 22.882131],
              [101.046519, 22.884126],
              [101.047786, 22.878873],
              [101.05485, 22.878058],
              [101.065208, 22.87053],
              [101.062959, 22.866513],
              [101.069516, 22.859659],
              [101.082091, 22.858507],
              [101.087762, 22.859322],
              [101.098563, 22.85331],
              [101.102744, 22.855698],
              [101.109523, 22.851961],
              [101.122764, 22.851371],
              [101.144399, 22.845612],
              [101.155295, 22.840808],
              [101.159888, 22.834991],
              [101.174459, 22.839656],
              [101.176645, 22.837071],
              [101.186686, 22.83561],
              [101.193687, 22.828782],
              [101.195904, 22.823499],
              [101.193085, 22.814928],
              [101.196886, 22.80897],
              [101.194035, 22.807987],
              [101.19375, 22.801326],
              [101.199832, 22.798544],
              [101.209873, 22.799303],
              [101.217285, 22.804361],
              [101.22587, 22.804333],
              [101.231571, 22.800905],
              [101.237178, 22.801495],
              [101.246396, 22.796183],
              [101.241866, 22.785839],
              [101.242595, 22.783366],
              [101.237083, 22.772291],
              [101.240631, 22.770801],
              [101.2444, 22.764448],
              [101.25422, 22.76442],
              [101.268696, 22.761552],
              [101.272624, 22.757813],
              [101.277629, 22.757897],
              [101.285358, 22.74474],
              [101.29353, 22.737991],
              [101.300847, 22.739032],
              [101.30921, 22.74578],
              [101.316179, 22.740747],
              [101.318586, 22.735123],
              [101.329071, 22.734027],
              [101.330718, 22.728122],
              [101.339999, 22.719039],
              [101.342185, 22.713499],
              [101.345004, 22.715805],
              [101.346556, 22.70658],
              [101.35042, 22.707396],
              [101.349343, 22.702643],
              [101.351751, 22.695836],
              [101.358054, 22.69443],
              [101.360335, 22.686526],
              [101.36515, 22.684473],
              [101.360589, 22.681829],
              [101.367557, 22.677581],
              [101.372119, 22.679241],
              [101.375033, 22.68467],
              [101.378929, 22.683629],
              [101.379468, 22.675499],
              [101.377535, 22.672236],
              [101.386753, 22.670014],
              [101.382762, 22.665316],
              [101.389414, 22.66239],
              [101.392677, 22.663375],
              [101.399424, 22.658564],
              [101.397808, 22.655385],
              [101.402559, 22.649364],
              [101.407628, 22.648491],
              [101.409813, 22.636055],
              [101.413741, 22.633804],
              [101.42185, 22.633944],
              [101.421407, 22.623392],
              [101.424479, 22.618467],
              [101.428502, 22.619846],
              [101.428122, 22.613204],
              [101.430244, 22.610136],
              [101.434426, 22.613514],
              [101.436041, 22.604845],
              [101.441299, 22.600398],
              [101.443263, 22.592996],
              [101.447983, 22.588942],
              [101.445861, 22.584354],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530821,
        name: "宁洱哈尼族彝族自治县",
        center: [101.04524, 23.062507],
        centroid: [101.189387, 23.094423],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 1,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [101.246396, 22.796183],
              [101.237178, 22.801495],
              [101.231571, 22.800905],
              [101.22587, 22.804333],
              [101.217285, 22.804361],
              [101.209873, 22.799303],
              [101.199832, 22.798544],
              [101.19375, 22.801326],
              [101.194035, 22.807987],
              [101.196886, 22.80897],
              [101.193085, 22.814928],
              [101.195904, 22.823499],
              [101.193687, 22.828782],
              [101.186686, 22.83561],
              [101.176645, 22.837071],
              [101.174459, 22.839656],
              [101.159888, 22.834991],
              [101.155295, 22.840808],
              [101.144399, 22.845612],
              [101.122764, 22.851371],
              [101.109523, 22.851961],
              [101.102744, 22.855698],
              [101.098563, 22.85331],
              [101.087762, 22.859322],
              [101.082091, 22.858507],
              [101.069516, 22.859659],
              [101.062959, 22.866513],
              [101.065208, 22.87053],
              [101.05485, 22.878058],
              [101.047786, 22.878873],
              [101.046519, 22.884126],
              [101.036224, 22.882131],
              [101.023491, 22.87789],
              [101.016744, 22.87112],
              [101.000272, 22.875025],
              [100.989217, 22.884547],
              [100.984592, 22.909205],
              [100.971225, 22.917546],
              [100.960265, 22.92903],
              [100.94807, 22.929143],
              [100.929697, 22.924032],
              [100.921525, 22.926644],
              [100.915633, 22.934028],
              [100.909773, 22.944641],
              [100.904546, 22.951042],
              [100.902488, 22.957555],
              [100.897198, 22.961766],
              [100.889627, 22.961232],
              [100.88798, 22.964432],
              [100.8844, 22.961345],
              [100.868119, 22.9566],
              [100.857349, 22.94669],
              [100.851869, 22.953849],
              [100.843126, 22.957162],
              [100.837773, 22.956123],
              [100.838945, 22.949161],
              [100.835429, 22.941805],
              [100.829569, 22.94217],
              [100.824849, 22.948234],
              [100.826401, 22.95573],
              [100.823804, 22.958565],
              [100.826876, 22.966903],
              [100.821111, 22.972685],
              [100.821396, 22.982088],
              [100.81012, 22.984193],
              [100.797639, 22.99396],
              [100.798716, 22.999601],
              [100.803816, 22.997328],
              [100.801631, 23.004231],
              [100.799667, 23.016943],
              [100.794884, 23.018065],
              [100.792571, 23.02205],
              [100.780883, 23.026567],
              [100.783448, 23.03173],
              [100.786838, 23.032543],
              [100.788865, 23.038519],
              [100.793775, 23.040287],
              [100.793585, 23.044018],
              [100.788358, 23.042924],
              [100.778158, 23.044495],
              [100.772679, 23.057147],
              [100.769226, 23.07681],
              [100.764886, 23.085392],
              [100.758773, 23.088786],
              [100.747401, 23.089234],
              [100.740876, 23.084859],
              [100.740274, 23.081101],
              [100.735364, 23.082139],
              [100.726621, 23.073949],
              [100.721141, 23.075351],
              [100.719209, 23.071958],
              [100.710847, 23.074566],
              [100.707014, 23.073725],
              [100.709294, 23.076137],
              [100.718987, 23.077595],
              [100.721838, 23.091394],
              [100.740781, 23.10163],
              [100.758836, 23.110323],
              [100.78405, 23.109874],
              [100.809328, 23.11394],
              [100.819338, 23.126529],
              [100.825895, 23.130146],
              [100.852629, 23.13679],
              [100.866313, 23.158684],
              [100.87306, 23.170596],
              [100.871698, 23.185647],
              [100.874201, 23.18786],
              [100.884781, 23.181331],
              [100.928367, 23.206439],
              [100.939232, 23.200303],
              [100.954468, 23.205262],
              [100.963559, 23.20515],
              [100.974836, 23.213304],
              [100.982787, 23.220505],
              [100.989914, 23.214649],
              [100.995045, 23.219552],
              [100.993588, 23.2323],
              [100.996978, 23.252525],
              [101.010218, 23.258099],
              [101.018929, 23.259276],
              [101.031536, 23.263113],
              [101.047279, 23.263365],
              [101.05371, 23.265409],
              [101.058049, 23.26919],
              [101.071005, 23.277144],
              [101.074648, 23.280673],
              [101.081331, 23.281317],
              [101.107718, 23.289382],
              [101.114591, 23.293247],
              [101.119501, 23.302543],
              [101.120546, 23.316066],
              [101.114845, 23.329645],
              [101.105025, 23.340814],
              [101.094255, 23.356992],
              [101.089947, 23.359371],
              [101.080666, 23.37468],
              [101.071258, 23.402299],
              [101.069484, 23.410496],
              [101.062421, 23.427673],
              [101.048166, 23.449659],
              [101.045759, 23.45461],
              [101.045569, 23.474298],
              [101.041419, 23.493843],
              [101.037777, 23.49717],
              [101.031853, 23.509779],
              [101.034799, 23.526356],
              [101.025201, 23.542764],
              [101.021178, 23.558415],
              [101.012182, 23.5794],
              [101.015381, 23.581105],
              [101.02821, 23.579903],
              [101.034546, 23.577361],
              [101.046614, 23.575433],
              [101.051841, 23.576271],
              [101.067109, 23.583815],
              [101.074046, 23.585408],
              [101.093305, 23.584597],
              [101.105373, 23.581943],
              [101.11684, 23.582502],
              [101.121275, 23.584206],
              [101.131475, 23.592029],
              [101.138982, 23.590716],
              [101.13762, 23.597282],
              [101.144272, 23.603596],
              [101.147154, 23.598316],
              [101.14915, 23.586749],
              [101.142245, 23.584542],
              [101.146458, 23.580714],
              [101.144589, 23.576969],
              [101.137905, 23.572275],
              [101.134706, 23.565904],
              [101.145919, 23.564786],
              [101.160617, 23.566742],
              [101.164323, 23.574399],
              [101.169264, 23.57588],
              [101.18412, 23.575572],
              [101.188619, 23.578143],
              [101.219344, 23.57968],
              [101.234581, 23.570934],
              [101.233852, 23.560091],
              [101.235784, 23.555173],
              [101.241043, 23.551679],
              [101.262424, 23.522722],
              [101.26537, 23.508381],
              [101.26423, 23.492641],
              [101.273384, 23.46465],
              [101.273226, 23.457155],
              [101.279212, 23.432233],
              [101.283362, 23.363038],
              [101.254632, 23.31923],
              [101.256406, 23.289886],
              [101.243007, 23.272887],
              [101.24364, 23.265353],
              [101.249183, 23.258463],
              [101.268696, 23.255074],
              [101.281018, 23.25936],
              [101.291629, 23.259163],
              [101.30449, 23.24992],
              [101.314785, 23.236194],
              [101.322926, 23.235297],
              [101.336958, 23.240284],
              [101.34342, 23.237931],
              [101.348171, 23.231067],
              [101.350199, 23.213752],
              [101.347918, 23.184469],
              [101.348995, 23.160394],
              [101.346366, 23.153694],
              [101.33889, 23.147051],
              [101.329514, 23.129193],
              [101.335754, 23.117052],
              [101.361317, 23.09403],
              [101.372594, 23.087776],
              [101.382445, 23.089851],
              [101.408198, 23.111893],
              [101.440666, 23.109678],
              [101.452766, 23.10564],
              [101.476017, 23.092319],
              [101.490303, 23.079923],
              [101.510005, 23.05465],
              [101.516055, 23.037201],
              [101.514978, 23.02595],
              [101.490461, 23.017532],
              [101.46965, 22.994718],
              [101.469238, 22.978186],
              [101.473958, 22.972067],
              [101.486818, 22.96651],
              [101.487388, 22.957471],
              [101.495212, 22.9445],
              [101.511874, 22.929788],
              [101.518114, 22.919876],
              [101.52011, 22.902522],
              [101.523056, 22.890417],
              [101.525463, 22.888114],
              [101.537595, 22.887805],
              [101.550962, 22.870193],
              [101.579123, 22.86053],
              [101.591128, 22.852748],
              [101.585933, 22.840077],
              [101.568543, 22.826196],
              [101.567624, 22.8217],
              [101.575765, 22.813523],
              [101.588309, 22.810685],
              [101.592395, 22.805767],
              [101.591508, 22.801607],
              [101.569271, 22.789325],
              [101.575797, 22.781567],
              [101.579661, 22.78286],
              [101.580865, 22.777407],
              [101.584222, 22.774821],
              [101.592585, 22.772797],
              [101.599174, 22.767343],
              [101.598667, 22.761046],
              [101.602183, 22.755142],
              [101.616025, 22.742068],
              [101.618623, 22.738498],
              [101.606396, 22.733493],
              [101.591286, 22.734139],
              [101.582639, 22.737598],
              [101.569271, 22.736473],
              [101.562302, 22.731693],
              [101.562207, 22.725563],
              [101.572027, 22.712149],
              [101.574466, 22.704808],
              [101.568891, 22.704274],
              [101.566896, 22.700843],
              [101.554732, 22.70433],
              [101.536423, 22.707874],
              [101.525558, 22.718533],
              [101.520838, 22.719629],
              [101.511462, 22.712683],
              [101.496479, 22.692658],
              [101.484189, 22.682532],
              [101.471424, 22.679972],
              [101.457613, 22.67941],
              [101.450074, 22.682898],
              [101.445639, 22.690098],
              [101.436865, 22.709561],
              [101.433761, 22.714539],
              [101.417954, 22.721007],
              [101.402306, 22.729528],
              [101.395717, 22.734139],
              [101.393563, 22.739116],
              [101.399519, 22.754861],
              [101.393785, 22.763857],
              [101.385929, 22.768215],
              [101.366924, 22.780752],
              [101.36024, 22.787414],
              [101.357579, 22.793288],
              [101.360715, 22.803687],
              [101.360715, 22.820183],
              [101.362046, 22.825241],
              [101.361792, 22.841032],
              [101.351751, 22.859743],
              [101.347285, 22.866261],
              [101.340696, 22.870193],
              [101.327835, 22.875306],
              [101.318111, 22.876654],
              [101.306169, 22.876289],
              [101.28672, 22.870474],
              [101.268347, 22.861485],
              [101.254283, 22.851484],
              [101.236006, 22.848927],
              [101.223431, 22.84609],
              [101.216842, 22.843168],
              [101.214086, 22.835778],
              [101.213579, 22.828894],
              [101.221277, 22.821082],
              [101.2393, 22.808296],
              [101.245762, 22.805626],
              [101.250926, 22.80068],
              [101.249912, 22.796127],
              [101.246396, 22.796183],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530822,
        name: "墨江哈尼族自治县",
        center: [101.687606, 23.428165],
        centroid: [101.549588, 23.357488],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 2,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [101.591128, 22.852748],
              [101.579123, 22.86053],
              [101.550962, 22.870193],
              [101.537595, 22.887805],
              [101.525463, 22.888114],
              [101.523056, 22.890417],
              [101.52011, 22.902522],
              [101.518114, 22.919876],
              [101.511874, 22.929788],
              [101.495212, 22.9445],
              [101.487388, 22.957471],
              [101.486818, 22.96651],
              [101.473958, 22.972067],
              [101.469238, 22.978186],
              [101.46965, 22.994718],
              [101.490461, 23.017532],
              [101.514978, 23.02595],
              [101.516055, 23.037201],
              [101.510005, 23.05465],
              [101.490303, 23.079923],
              [101.476017, 23.092319],
              [101.452766, 23.10564],
              [101.440666, 23.109678],
              [101.408198, 23.111893],
              [101.382445, 23.089851],
              [101.372594, 23.087776],
              [101.361317, 23.09403],
              [101.335754, 23.117052],
              [101.329514, 23.129193],
              [101.33889, 23.147051],
              [101.346366, 23.153694],
              [101.348995, 23.160394],
              [101.347918, 23.184469],
              [101.350199, 23.213752],
              [101.348171, 23.231067],
              [101.34342, 23.237931],
              [101.336958, 23.240284],
              [101.322926, 23.235297],
              [101.314785, 23.236194],
              [101.30449, 23.24992],
              [101.291629, 23.259163],
              [101.281018, 23.25936],
              [101.268696, 23.255074],
              [101.249183, 23.258463],
              [101.24364, 23.265353],
              [101.243007, 23.272887],
              [101.256406, 23.289886],
              [101.254632, 23.31923],
              [101.283362, 23.363038],
              [101.279212, 23.432233],
              [101.273226, 23.457155],
              [101.273384, 23.46465],
              [101.26423, 23.492641],
              [101.26537, 23.508381],
              [101.262424, 23.522722],
              [101.241043, 23.551679],
              [101.235784, 23.555173],
              [101.233852, 23.560091],
              [101.234581, 23.570934],
              [101.236925, 23.575572],
              [101.240029, 23.595103],
              [101.239459, 23.607367],
              [101.247695, 23.614742],
              [101.255835, 23.616418],
              [101.250926, 23.624072],
              [101.246586, 23.622954],
              [101.246111, 23.62706],
              [101.254948, 23.634937],
              [101.240599, 23.636976],
              [101.24478, 23.642561],
              [101.236798, 23.64636],
              [101.234106, 23.640997],
              [101.228182, 23.637339],
              [101.22286, 23.637199],
              [101.2202, 23.644433],
              [101.213389, 23.644852],
              [101.213326, 23.64985],
              [101.206421, 23.654067],
              [101.206801, 23.659513],
              [101.199674, 23.662529],
              [101.200402, 23.666214],
              [101.197139, 23.673837],
              [101.195777, 23.683609],
              [101.188777, 23.687574],
              [101.188048, 23.692683],
              [101.180573, 23.697345],
              [101.182442, 23.712335],
              [101.178514, 23.718644],
              [101.170848, 23.726626],
              [101.165146, 23.730645],
              [101.16692, 23.736422],
              [101.164513, 23.747027],
              [101.160617, 23.75099],
              [101.162834, 23.754506],
              [101.156499, 23.757938],
              [101.151684, 23.758273],
              [101.148802, 23.762598],
              [101.143702, 23.763881],
              [101.147471, 23.777469],
              [101.148675, 23.786647],
              [101.154218, 23.799591],
              [101.157069, 23.818865],
              [101.156847, 23.826172],
              [101.154313, 23.833897],
              [101.14991, 23.839028],
              [101.137842, 23.849011],
              [101.140376, 23.863008],
              [101.13781, 23.872543],
              [101.132298, 23.880182],
              [101.129289, 23.888322],
              [101.128465, 23.89791],
              [101.134294, 23.91795],
              [101.139204, 23.92815],
              [101.143322, 23.931912],
              [101.162834, 23.938126],
              [101.173541, 23.946875],
              [101.182157, 23.957824],
              [101.185166, 23.964762],
              [101.192831, 23.97479],
              [101.201637, 23.973425],
              [101.20924, 23.970417],
              [101.215353, 23.965987],
              [101.226503, 23.954175],
              [101.228499, 23.94668],
              [101.228911, 23.934587],
              [101.237812, 23.914689],
              [101.244179, 23.909199],
              [101.26008, 23.89883],
              [101.291598, 23.907944],
              [101.295241, 23.903708],
              [101.293182, 23.889938],
              [101.294765, 23.879234],
              [101.299707, 23.873658],
              [101.318586, 23.879206],
              [101.33056, 23.888489],
              [101.337687, 23.877701],
              [101.33908, 23.864932],
              [101.34966, 23.856093],
              [101.355204, 23.839335],
              [101.361475, 23.830829],
              [101.380038, 23.822184],
              [101.391568, 23.82012],
              [101.396003, 23.82224],
              [101.403225, 23.817833],
              [101.410288, 23.818698],
              [101.415262, 23.81853],
              [101.422737, 23.808685],
              [101.418999, 23.802827],
              [101.418904, 23.796021],
              [101.424384, 23.79019],
              [101.426158, 23.783662],
              [101.424258, 23.778557],
              [101.419633, 23.77652],
              [101.418081, 23.771889],
              [101.411777, 23.771721],
              [101.406646, 23.765695],
              [101.40842, 23.757659],
              [101.413044, 23.746441],
              [101.42128, 23.743706],
              [101.425556, 23.736925],
              [101.425905, 23.72498],
              [101.43072, 23.71856],
              [101.437245, 23.719928],
              [101.439177, 23.727547],
              [101.444974, 23.729585],
              [101.459735, 23.72724],
              [101.462839, 23.744013],
              [101.465278, 23.744488],
              [101.468193, 23.755873],
              [101.471994, 23.754534],
              [101.476777, 23.759082],
              [101.483049, 23.757575],
              [101.486026, 23.772224],
              [101.497398, 23.777469],
              [101.505032, 23.775655],
              [101.511431, 23.771973],
              [101.520237, 23.772921],
              [101.531228, 23.782016],
              [101.540858, 23.779254],
              [101.54827, 23.77147],
              [101.552705, 23.761398],
              [101.563791, 23.749455],
              [101.568954, 23.739046],
              [101.568859, 23.730227],
              [101.5649, 23.721407],
              [101.558216, 23.719956],
              [101.551849, 23.723696],
              [101.540002, 23.717918],
              [101.538577, 23.714568],
              [101.541238, 23.709153],
              [101.540794, 23.701588],
              [101.537912, 23.692125],
              [101.535124, 23.687769],
              [101.535885, 23.683637],
              [101.541269, 23.685592],
              [101.54713, 23.682995],
              [101.550424, 23.677355],
              [101.557298, 23.673055],
              [101.558565, 23.667276],
              [101.560624, 23.670431],
              [101.562081, 23.681767],
              [101.565375, 23.685313],
              [101.574054, 23.689277],
              [101.57719, 23.681013],
              [101.58606, 23.676239],
              [101.593282, 23.66937],
              [101.594137, 23.661998],
              [101.599459, 23.661244],
              [101.604875, 23.652531],
              [101.612414, 23.652671],
              [101.61384, 23.650604],
              [101.616025, 23.636194],
              [101.618654, 23.632674],
              [101.629234, 23.6353],
              [101.626035, 23.642506],
              [101.641588, 23.651694],
              [101.649602, 23.650912],
              [101.653562, 23.654933],
              [101.674721, 23.660881],
              [101.675988, 23.665433],
              [101.684858, 23.67057],
              [101.693442, 23.665684],
              [101.693917, 23.662417],
              [101.702913, 23.659317],
              [101.709977, 23.653844],
              [101.705415, 23.64837],
              [101.698415, 23.646611],
              [101.696198, 23.639126],
              [101.689767, 23.63435],
              [101.693442, 23.628178],
              [101.687202, 23.624798],
              [101.685016, 23.620189],
              [101.677319, 23.624463],
              [101.667657, 23.625049],
              [101.662494, 23.619072],
              [101.666802, 23.612591],
              [101.667404, 23.606361],
              [101.680645, 23.609043],
              [101.688247, 23.607842],
              [101.687455, 23.601975],
              [101.684636, 23.60069],
              [101.689546, 23.5908],
              [101.7038, 23.578618],
              [101.705954, 23.567944],
              [101.713683, 23.570151],
              [101.728602, 23.565205],
              [101.72648, 23.557828],
              [101.716629, 23.553105],
              [101.720462, 23.546397],
              [101.718783, 23.539717],
              [101.713303, 23.534351],
              [101.715869, 23.530158],
              [101.725308, 23.52781],
              [101.728666, 23.522667],
              [101.728793, 23.515259],
              [101.731738, 23.511233],
              [101.745676, 23.516489],
              [101.752201, 23.512938],
              [101.755084, 23.506117],
              [101.759107, 23.505027],
              [101.76446, 23.499463],
              [101.769085, 23.48716],
              [101.767121, 23.482743],
              [101.774723, 23.472424],
              [101.782452, 23.46739],
              [101.78166, 23.459588],
              [101.78714, 23.453463],
              [101.78261, 23.449715],
              [101.78847, 23.441184],
              [101.774565, 23.436457],
              [101.769655, 23.427198],
              [101.773107, 23.422302],
              [101.769275, 23.417127],
              [101.751694, 23.422246],
              [101.745423, 23.419589],
              [101.750776, 23.407922],
              [101.750871, 23.400956],
              [101.74726, 23.394828],
              [101.751948, 23.392813],
              [101.754862, 23.386294],
              [101.761482, 23.380669],
              [101.772949, 23.382824],
              [101.776275, 23.386014],
              [101.787267, 23.387441],
              [101.793159, 23.38509],
              [101.794901, 23.380837],
              [101.799589, 23.380893],
              [101.824771, 23.370874],
              [101.821889, 23.360295],
              [101.819038, 23.355173],
              [101.821794, 23.350443],
              [101.841591, 23.349267],
              [101.845361, 23.349939],
              [101.848719, 23.343949],
              [101.848528, 23.339694],
              [101.855339, 23.335999],
              [101.86066, 23.329925],
              [101.865602, 23.331632],
              [101.873679, 23.326957],
              [101.877956, 23.327517],
              [101.877734, 23.320742],
              [101.872412, 23.318614],
              [101.876245, 23.310999],
              [101.874693, 23.302851],
              [101.880236, 23.301339],
              [101.883277, 23.296803],
              [101.890436, 23.296607],
              [101.89221, 23.291118],
              [101.888662, 23.286554],
              [101.881155, 23.281541],
              [101.879951, 23.272299],
              [101.87691, 23.264065],
              [101.870892, 23.261964],
              [101.866521, 23.257651],
              [101.855972, 23.25978],
              [101.851759, 23.262945],
              [101.846755, 23.259612],
              [101.845963, 23.255438],
              [101.829238, 23.253421],
              [101.829871, 23.249332],
              [101.823504, 23.243589],
              [101.831043, 23.231852],
              [101.829238, 23.22975],
              [101.838297, 23.217955],
              [101.842637, 23.216975],
              [101.842732, 23.212688],
              [101.83817, 23.207224],
              [101.838107, 23.198705],
              [101.834369, 23.188169],
              [101.829238, 23.182928],
              [101.827749, 23.17637],
              [101.833577, 23.165411],
              [101.840514, 23.164991],
              [101.8478, 23.158852],
              [101.854325, 23.1586],
              [101.861389, 23.156105],
              [101.865982, 23.157198],
              [101.873616, 23.155376],
              [101.883974, 23.148789],
              [101.890151, 23.148705],
              [101.898007, 23.151564],
              [101.910139, 23.158656],
              [101.918248, 23.159357],
              [101.922207, 23.15717],
              [101.923379, 23.149574],
              [101.933706, 23.146434],
              [101.941213, 23.147275],
              [101.945046, 23.155124],
              [101.950969, 23.152237],
              [101.951825, 23.162328],
              [101.945553, 23.165271],
              [101.949164, 23.169587],
              [101.950494, 23.175053],
              [101.955246, 23.173651],
              [101.965129, 23.177855],
              [101.97121, 23.17183],
              [101.975265, 23.175361],
              [101.982202, 23.186095],
              [101.992497, 23.182452],
              [101.987143, 23.174576],
              [101.98708, 23.170736],
              [101.980682, 23.167709],
              [101.987239, 23.158796],
              [101.996298, 23.159693],
              [102.00314, 23.157843],
              [101.995379, 23.148256],
              [101.998515, 23.142621],
              [102.005484, 23.140631],
              [102.021671, 23.139061],
              [102.037287, 23.127735],
              [102.034911, 23.12123],
              [102.037572, 23.114529],
              [102.045206, 23.107855],
              [102.063673, 23.106789],
              [102.070357, 23.10306],
              [102.069185, 23.096442],
              [102.055026, 23.08141],
              [102.050084, 23.080232],
              [102.044541, 23.075015],
              [102.052111, 23.057876],
              [102.058985, 23.054482],
              [102.056641, 23.039557],
              [102.046505, 23.031028],
              [102.045206, 23.027353],
              [102.049957, 23.021657],
              [102.04736, 23.015821],
              [102.039853, 23.01756],
              [102.03263, 23.012397],
              [102.030825, 23.005494],
              [102.021259, 22.99671],
              [102.01524, 22.988712],
              [102.010806, 22.992921],
              [101.993891, 22.98902],
              [101.977324, 22.988964],
              [101.967061, 22.993735],
              [101.966934, 22.999685],
              [101.9695, 23.003502],
              [101.96535, 23.00569],
              [101.965319, 23.014165],
              [101.962214, 23.015315],
              [101.962784, 23.020675],
              [101.95873, 23.022723],
              [101.958318, 23.018851],
              [101.952997, 23.015764],
              [101.939629, 23.01164],
              [101.928764, 23.010096],
              [101.910931, 23.009816],
              [101.909252, 23.00656],
              [101.902378, 23.020591],
              [101.891957, 23.017757],
              [101.880046, 23.016129],
              [101.873648, 23.012397],
              [101.875105, 23.008328],
              [101.872412, 23.005775],
              [101.868611, 22.996963],
              [101.867788, 22.990171],
              [101.87048, 22.982481],
              [101.866235, 22.97653],
              [101.860122, 22.972685],
              [101.851221, 22.973752],
              [101.848497, 22.96912],
              [101.85366, 22.964292],
              [101.857683, 22.956432],
              [101.857303, 22.953372],
              [101.861706, 22.939559],
              [101.851063, 22.929227],
              [101.850334, 22.925829],
              [101.854389, 22.917153],
              [101.853343, 22.910104],
              [101.848433, 22.90679],
              [101.838234, 22.911031],
              [101.831645, 22.906397],
              [101.828826, 22.901117],
              [101.821699, 22.895304],
              [101.813115, 22.88376],
              [101.8051, 22.881513],
              [101.800064, 22.875362],
              [101.793602, 22.880952],
              [101.78619, 22.890726],
              [101.783592, 22.896989],
              [101.777922, 22.897804],
              [101.7688, 22.903336],
              [101.762971, 22.913221],
              [101.75765, 22.913305],
              [101.746721, 22.923162],
              [101.729679, 22.924285],
              [101.707601, 22.921],
              [101.692808, 22.915299],
              [101.675386, 22.903617],
              [101.665187, 22.886541],
              [101.645231, 22.869632],
              [101.640004, 22.856232],
              [101.631737, 22.850388],
              [101.621125, 22.849096],
              [101.591128, 22.852748],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530823,
        name: "景东彝族自治县",
        center: [100.840011, 24.448523],
        centroid: [100.791376, 24.392225],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 3,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [100.40118, 23.939407],
              [100.395732, 23.941079],
              [100.389967, 23.955679],
              [100.392121, 23.960443],
              [100.391931, 23.97557],
              [100.37831, 23.99738],
              [100.383125, 24.009969],
              [100.381889, 24.020245],
              [100.375459, 24.026065],
              [100.368554, 24.034836],
              [100.36678, 24.051123],
              [100.377265, 24.064291],
              [100.392881, 24.070555],
              [100.400135, 24.070443],
              [100.407832, 24.06624],
              [100.425032, 24.062343],
              [100.436594, 24.066073],
              [100.448885, 24.068188],
              [100.480181, 24.075732],
              [100.497856, 24.088535],
              [100.512649, 24.127244],
              [100.517749, 24.150753],
              [100.521866, 24.157791],
              [100.522057, 24.171087],
              [100.524401, 24.178847],
              [100.526079, 24.1905],
              [100.524179, 24.197174],
              [100.523102, 24.208881],
              [100.519966, 24.215582],
              [100.521676, 24.229289],
              [100.518414, 24.246997],
              [100.507612, 24.258394],
              [100.513314, 24.272735],
              [100.514993, 24.284852],
              [100.511413, 24.296829],
              [100.51154, 24.304859],
              [100.509354, 24.310388],
              [100.511762, 24.320445],
              [100.510653, 24.33053],
              [100.504096, 24.34303],
              [100.50983, 24.375025],
              [100.507802, 24.390186],
              [100.5104, 24.398155],
              [100.507771, 24.42203],
              [100.514866, 24.44529],
              [100.52098, 24.45184],
              [100.540936, 24.462996],
              [100.546922, 24.469684],
              [100.546384, 24.476454],
              [100.535994, 24.486276],
              [100.533365, 24.493129],
              [100.531496, 24.504337],
              [100.529374, 24.509636],
              [100.518129, 24.513519],
              [100.510495, 24.518734],
              [100.498806, 24.521147],
              [100.498838, 24.536596],
              [100.494213, 24.545387],
              [100.497888, 24.552015],
              [100.497539, 24.559613],
              [100.494213, 24.567349],
              [100.490032, 24.56624],
              [100.486389, 24.568653],
              [100.487181, 24.579438],
              [100.481511, 24.584539],
              [100.47904, 24.592579],
              [100.470076, 24.597513],
              [100.464406, 24.59366],
              [100.461808, 24.598511],
              [100.462157, 24.609515],
              [100.450627, 24.617027],
              [100.449265, 24.621212],
              [100.453699, 24.624067],
              [100.444862, 24.626284],
              [100.440522, 24.630219],
              [100.439889, 24.635097],
              [100.429815, 24.644491],
              [100.423037, 24.645682],
              [100.420566, 24.649866],
              [100.420313, 24.656489],
              [100.425191, 24.661337],
              [100.423227, 24.671533],
              [100.41629, 24.678819],
              [100.409416, 24.676686],
              [100.405773, 24.678209],
              [100.404221, 24.68303],
              [100.405963, 24.697544],
              [100.408973, 24.702696],
              [100.408244, 24.707321],
              [100.415149, 24.709953],
              [100.420028, 24.708402],
              [100.425412, 24.712473],
              [100.428643, 24.719286],
              [100.434947, 24.726707],
              [100.442106, 24.732578],
              [100.448694, 24.73435],
              [100.457722, 24.730446],
              [100.459338, 24.725074],
              [100.46675, 24.728701],
              [100.469664, 24.733436],
              [100.478882, 24.737285],
              [100.486072, 24.737811],
              [100.497951, 24.733492],
              [100.506187, 24.736122],
              [100.512934, 24.736261],
              [100.512459, 24.728452],
              [100.513852, 24.721086],
              [100.522943, 24.717984],
              [100.531053, 24.709897],
              [100.538085, 24.709953],
              [100.548633, 24.712501],
              [100.564471, 24.704136],
              [100.579137, 24.714965],
              [100.585789, 24.718593],
              [100.601184, 24.731636],
              [100.606917, 24.735375],
              [100.613886, 24.736482],
              [100.62399, 24.745564],
              [100.630801, 24.760432],
              [100.631466, 24.775048],
              [100.632828, 24.778813],
              [100.631276, 24.786341],
              [100.634064, 24.797551],
              [100.638086, 24.805853],
              [100.632511, 24.818998],
              [100.643756, 24.822014],
              [100.658454, 24.819358],
              [100.665296, 24.816673],
              [100.674324, 24.815345],
              [100.678822, 24.807735],
              [100.6818, 24.806379],
              [100.686709, 24.809146],
              [100.689877, 24.808012],
              [100.695864, 24.79589],
              [100.698176, 24.793538],
              [100.708471, 24.79589],
              [100.718417, 24.790438],
              [100.722028, 24.785982],
              [100.736156, 24.783906],
              [100.739767, 24.777844],
              [100.748098, 24.777705],
              [100.765076, 24.770868],
              [100.76799, 24.765276],
              [100.766977, 24.757525],
              [100.768497, 24.748416],
              [100.780851, 24.737091],
              [100.78915, 24.734765],
              [100.794535, 24.72704],
              [100.804576, 24.72247],
              [100.808726, 24.730695],
              [100.81731, 24.732882],
              [100.825641, 24.726901],
              [100.834732, 24.727981],
              [100.842905, 24.731359],
              [100.851774, 24.727593],
              [100.86096, 24.728618],
              [100.864951, 24.725184],
              [100.871667, 24.723163],
              [100.880948, 24.728424],
              [100.886554, 24.734572],
              [100.893206, 24.738836],
              [100.896216, 24.744207],
              [100.905148, 24.74872],
              [100.913289, 24.740137],
              [100.907302, 24.733381],
              [100.910185, 24.727538],
              [100.915538, 24.724215],
              [100.918896, 24.726126],
              [100.930964, 24.723883],
              [100.943793, 24.729061],
              [100.953835, 24.715076],
              [100.952853, 24.711531],
              [100.945567, 24.706297],
              [100.944965, 24.696464],
              [100.948418, 24.690287],
              [100.946011, 24.685772],
              [100.945757, 24.673555],
              [100.964795, 24.660506],
              [100.971066, 24.655075],
              [100.980316, 24.641609],
              [100.990737, 24.617138],
              [101.002458, 24.596072],
              [101.013956, 24.587173],
              [101.02102, 24.574946],
              [101.023586, 24.565575],
              [101.036604, 24.557561],
              [101.039645, 24.55049],
              [101.03955, 24.544278],
              [101.036763, 24.539369],
              [101.037586, 24.535209],
              [101.042433, 24.527721],
              [101.044112, 24.519844],
              [101.044333, 24.504948],
              [101.046171, 24.50037],
              [101.051714, 24.495071],
              [101.05371, 24.48783],
              [101.065462, 24.483946],
              [101.069231, 24.478563],
              [101.075313, 24.477925],
              [101.079241, 24.472348],
              [101.079209, 24.463912],
              [101.084341, 24.457168],
              [101.084531, 24.448343],
              [101.091753, 24.445068],
              [101.097581, 24.438601],
              [101.102808, 24.435909],
              [101.123682, 24.419587],
              [101.131443, 24.409066],
              [101.144589, 24.389464],
              [101.154693, 24.383216],
              [101.163531, 24.373858],
              [101.16711, 24.365999],
              [101.17012, 24.35214],
              [101.175315, 24.346419],
              [101.181903, 24.345752],
              [101.204583, 24.338752],
              [101.214086, 24.33253],
              [101.227105, 24.32239],
              [101.235974, 24.314],
              [101.2444, 24.303942],
              [101.253935, 24.296384],
              [101.249563, 24.28802],
              [101.237685, 24.271012],
              [101.235563, 24.253363],
              [101.216589, 24.24305],
              [101.206927, 24.235211],
              [101.200212, 24.225953],
              [101.200085, 24.208992],
              [101.18808, 24.195923],
              [101.18732, 24.184938],
              [101.200497, 24.180099],
              [101.192388, 24.163271],
              [101.191279, 24.156345],
              [101.181903, 24.150892],
              [101.161599, 24.146858],
              [101.15029, 24.146664],
              [101.136068, 24.149696],
              [101.129067, 24.149585],
              [101.123239, 24.147165],
              [101.124759, 24.13331],
              [101.131253, 24.120399],
              [101.139806, 24.109909],
              [101.138348, 24.10362],
              [101.125805, 24.098666],
              [101.091658, 24.094658],
              [101.084816, 24.091792],
              [101.067267, 24.079211],
              [101.055674, 24.064904],
              [101.045727, 24.043467],
              [101.039139, 24.03943],
              [101.023332, 24.03272],
              [101.013893, 24.034474],
              [101.005087, 24.033889],
              [100.988203, 24.030882],
              [100.981203, 24.017878],
              [100.977307, 24.016151],
              [100.969673, 24.021247],
              [100.960677, 24.02367],
              [100.951744, 24.030687],
              [100.945757, 24.055995],
              [100.935557, 24.064653],
              [100.931566, 24.066518],
              [100.913036, 24.068857],
              [100.902646, 24.075676],
              [100.901474, 24.079824],
              [100.902392, 24.089899],
              [100.895709, 24.103174],
              [100.891433, 24.117979],
              [100.89422, 24.139319],
              [100.889057, 24.145106],
              [100.892098, 24.150308],
              [100.882056, 24.165357],
              [100.874929, 24.164523],
              [100.864825, 24.167861],
              [100.865775, 24.173396],
              [100.869513, 24.173757],
              [100.877083, 24.184048],
              [100.873377, 24.195422],
              [100.858141, 24.210661],
              [100.848163, 24.227371],
              [100.834099, 24.240215],
              [100.82884, 24.254781],
              [100.823741, 24.257199],
              [100.824596, 24.274792],
              [100.820446, 24.282379],
              [100.816772, 24.284408],
              [100.81069, 24.280739],
              [100.809645, 24.289298],
              [100.803214, 24.295134],
              [100.794884, 24.312083],
              [100.794313, 24.317417],
              [100.800142, 24.335141],
              [100.788992, 24.34403],
              [100.781389, 24.354251],
              [100.771697, 24.35189],
              [100.746546, 24.349863],
              [100.738785, 24.347002],
              [100.738215, 24.340641],
              [100.751804, 24.325779],
              [100.756175, 24.318362],
              [100.756524, 24.292855],
              [100.753704, 24.274764],
              [100.75041, 24.26537],
              [100.751234, 24.256448],
              [100.744202, 24.252974],
              [100.734572, 24.236823],
              [100.726051, 24.23054],
              [100.722598, 24.239603],
              [100.713983, 24.236489],
              [100.708122, 24.231235],
              [100.705177, 24.204738],
              [100.706032, 24.198704],
              [100.701312, 24.188664],
              [100.701217, 24.1811],
              [100.707077, 24.171143],
              [100.712525, 24.167415],
              [100.704606, 24.141434],
              [100.703941, 24.131251],
              [100.706602, 24.125018],
              [100.70429, 24.119147],
              [100.701724, 24.104649],
              [100.693615, 24.092488],
              [100.685221, 24.072754],
              [100.6818, 24.060394],
              [100.675876, 24.057666],
              [100.665011, 24.060561],
              [100.652056, 24.059531],
              [100.637675, 24.054436],
              [100.63267, 24.049258],
              [100.630421, 24.040293],
              [100.625448, 24.03595],
              [100.60603, 24.036451],
              [100.59922, 24.033555],
              [100.584744, 24.019521],
              [100.579676, 24.015901],
              [100.561842, 24.008883],
              [100.55576, 24.008771],
              [100.55424, 24.00348],
              [100.540524, 24.004677],
              [100.537768, 24.003118],
              [100.532193, 24.005958],
              [100.524179, 24.000054],
              [100.518034, 23.997854],
              [100.515721, 24.000834],
              [100.499155, 24.006683],
              [100.493928, 24.006766],
              [100.481891, 24.002784],
              [100.47166, 24.00412],
              [100.455283, 23.997353],
              [100.450247, 23.987437],
              [100.42291, 23.967603],
              [100.412805, 23.949745],
              [100.40118, 23.939407],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530824,
        name: "景谷傣族彝族自治县",
        center: [100.701425, 23.500278],
        centroid: [100.557981, 23.363574],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 4,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [100.323193, 22.851568],
              [100.328832, 22.861569],
              [100.326044, 22.870559],
              [100.304504, 22.898646],
              [100.299056, 22.914513],
              [100.299278, 22.928778],
              [100.310238, 22.952698],
              [100.30216, 22.95806],
              [100.294812, 22.957386],
              [100.288191, 22.949217],
              [100.278372, 22.946325],
              [100.271973, 22.953175],
              [100.267443, 22.978046],
              [100.266145, 22.997608],
              [100.264624, 23.005887],
              [100.240899, 22.996458],
              [100.236021, 22.996514],
              [100.215019, 23.005831],
              [100.199878, 23.024098],
              [100.19123, 23.043766],
              [100.172573, 23.045561],
              [100.156545, 23.058578],
              [100.14682, 23.062477],
              [100.143684, 23.068536],
              [100.132123, 23.1138],
              [100.132408, 23.133342],
              [100.119737, 23.157591],
              [100.106908, 23.171269],
              [100.079445, 23.186655],
              [100.053471, 23.196716],
              [100.043049, 23.211091],
              [100.042986, 23.217871],
              [100.067028, 23.23188],
              [100.08274, 23.246727],
              [100.090342, 23.267678],
              [100.091355, 23.281961],
              [100.086762, 23.303047],
              [100.078907, 23.324185],
              [100.081694, 23.348931],
              [100.082549, 23.351199],
              [100.109949, 23.384643],
              [100.102949, 23.40879],
              [100.108904, 23.425995],
              [100.130792, 23.447114],
              [100.13529, 23.448177],
              [100.144413, 23.459308],
              [100.156197, 23.485427],
              [100.156957, 23.510702],
              [100.164749, 23.524651],
              [100.169469, 23.542177],
              [100.171686, 23.554306],
              [100.175361, 23.561377],
              [100.180144, 23.579875],
              [100.185655, 23.586917],
              [100.187366, 23.591806],
              [100.185022, 23.599712],
              [100.184864, 23.607814],
              [100.186859, 23.611837],
              [100.192244, 23.612591],
              [100.199751, 23.617116],
              [100.213816, 23.620552],
              [100.220658, 23.617787],
              [100.222146, 23.612116],
              [100.23922, 23.608568],
              [100.24641, 23.615887],
              [100.255153, 23.63516],
              [100.260506, 23.63854],
              [100.272607, 23.641919],
              [100.280336, 23.642422],
              [100.288635, 23.640858],
              [100.3014, 23.628206],
              [100.307387, 23.618792],
              [100.315211, 23.617647],
              [100.321895, 23.61382],
              [100.331619, 23.613206],
              [100.355883, 23.614965],
              [100.360761, 23.611306],
              [100.364689, 23.61287],
              [100.365766, 23.618401],
              [100.369947, 23.622703],
              [100.383663, 23.623653],
              [100.394813, 23.638177],
              [100.398456, 23.638651],
              [100.406787, 23.645187],
              [100.41043, 23.645829],
              [100.414357, 23.650577],
              [100.42934, 23.654514],
              [100.435676, 23.658815],
              [100.436531, 23.661803],
              [100.429847, 23.667555],
              [100.405266, 23.677523],
              [100.388922, 23.686373],
              [100.384265, 23.690561],
              [100.382808, 23.696005],
              [100.386989, 23.710549],
              [100.384994, 23.723082],
              [100.378563, 23.73405],
              [100.372133, 23.738209],
              [100.360255, 23.741669],
              [100.350562, 23.746832],
              [100.347869, 23.751101],
              [100.350815, 23.759445],
              [100.360793, 23.766169],
              [100.3613, 23.77945],
              [100.357404, 23.802185],
              [100.353349, 23.815546],
              [100.359526, 23.826033],
              [100.36282, 23.827985],
              [100.364911, 23.837634],
              [100.366115, 23.838945],
              [100.378152, 23.835347],
              [100.385089, 23.836518],
              [100.40609, 23.836965],
              [100.425824, 23.836658],
              [100.436626, 23.83518],
              [100.464216, 23.838052],
              [100.471565, 23.835291],
              [100.476728, 23.830411],
              [100.479705, 23.823885],
              [100.486548, 23.821319],
              [100.497729, 23.821654],
              [100.518192, 23.83412],
              [100.527505, 23.838749],
              [100.544167, 23.85272],
              [100.551737, 23.857515],
              [100.558389, 23.859523],
              [100.574639, 23.852469],
              [100.595925, 23.844438],
              [100.614266, 23.828766],
              [100.622153, 23.825586],
              [100.652721, 23.825196],
              [100.663206, 23.819367],
              [100.670174, 23.814096],
              [100.678949, 23.800679],
              [100.681673, 23.794124],
              [100.688166, 23.787708],
              [100.697162, 23.781821],
              [100.708122, 23.776688],
              [100.740179, 23.775628],
              [100.752944, 23.775767],
              [100.767959, 23.781486],
              [100.781548, 23.771136],
              [100.807332, 23.762709],
              [100.819433, 23.759835],
              [100.821682, 23.761816],
              [100.821872, 23.7732],
              [100.834384, 23.772865],
              [100.837615, 23.777106],
              [100.840561, 23.773563],
              [100.84528, 23.773144],
              [100.852946, 23.768541],
              [100.861182, 23.769936],
              [100.869576, 23.766281],
              [100.871477, 23.761286],
              [100.879364, 23.756961],
              [100.903881, 23.75604],
              [100.91047, 23.754171],
              [100.92653, 23.738209],
              [100.92748, 23.732515],
              [100.924534, 23.723724],
              [100.923014, 23.709293],
              [100.926815, 23.700946],
              [100.937553, 23.694637],
              [100.942114, 23.68629],
              [100.939644, 23.670459],
              [100.940436, 23.662473],
              [100.942558, 23.658647],
              [100.960011, 23.647058],
              [100.97227, 23.632814],
              [100.97303, 23.624826],
              [100.979397, 23.600774],
              [100.988615, 23.594432],
              [100.995235, 23.59189],
              [101.005055, 23.583061],
              [101.012182, 23.5794],
              [101.021178, 23.558415],
              [101.025201, 23.542764],
              [101.034799, 23.526356],
              [101.031853, 23.509779],
              [101.037777, 23.49717],
              [101.041419, 23.493843],
              [101.045569, 23.474298],
              [101.045759, 23.45461],
              [101.048166, 23.449659],
              [101.062421, 23.427673],
              [101.069484, 23.410496],
              [101.071258, 23.402299],
              [101.080666, 23.37468],
              [101.089947, 23.359371],
              [101.094255, 23.356992],
              [101.105025, 23.340814],
              [101.114845, 23.329645],
              [101.120546, 23.316066],
              [101.119501, 23.302543],
              [101.114591, 23.293247],
              [101.107718, 23.289382],
              [101.081331, 23.281317],
              [101.074648, 23.280673],
              [101.071005, 23.277144],
              [101.058049, 23.26919],
              [101.05371, 23.265409],
              [101.047279, 23.263365],
              [101.031536, 23.263113],
              [101.018929, 23.259276],
              [101.010218, 23.258099],
              [100.996978, 23.252525],
              [100.993588, 23.2323],
              [100.995045, 23.219552],
              [100.989914, 23.214649],
              [100.982787, 23.220505],
              [100.974836, 23.213304],
              [100.963559, 23.20515],
              [100.954468, 23.205262],
              [100.939232, 23.200303],
              [100.928367, 23.206439],
              [100.884781, 23.181331],
              [100.874201, 23.18786],
              [100.871698, 23.185647],
              [100.87306, 23.170596],
              [100.866313, 23.158684],
              [100.852629, 23.13679],
              [100.825895, 23.130146],
              [100.819338, 23.126529],
              [100.809328, 23.11394],
              [100.78405, 23.109874],
              [100.758836, 23.110323],
              [100.740781, 23.10163],
              [100.721838, 23.091394],
              [100.718987, 23.077595],
              [100.709294, 23.076137],
              [100.707014, 23.073725],
              [100.705493, 23.07019],
              [100.693488, 23.068844],
              [100.69032, 23.066376],
              [100.691271, 23.059531],
              [100.680564, 23.050471],
              [100.679455, 23.041437],
              [100.674957, 23.038407],
              [100.663364, 23.039978],
              [100.651264, 23.036219],
              [100.652562, 23.031982],
              [100.651802, 23.023341],
              [100.652467, 23.012313],
              [100.640557, 23.001144],
              [100.639195, 22.996093],
              [100.633177, 22.995419],
              [100.622597, 22.990367],
              [100.61718, 22.982144],
              [100.611415, 22.984979],
              [100.606252, 22.975352],
              [100.6098, 22.96825],
              [100.607392, 22.963366],
              [100.600804, 22.961429],
              [100.597319, 22.953147],
              [100.592916, 22.948571],
              [100.593676, 22.944304],
              [100.590635, 22.940991],
              [100.595672, 22.934421],
              [100.59526, 22.930322],
              [100.598745, 22.92611],
              [100.601754, 22.916085],
              [100.615153, 22.90724],
              [100.617877, 22.901904],
              [100.618067, 22.892917],
              [100.613506, 22.883058],
              [100.609768, 22.883142],
              [100.604161, 22.876626],
              [100.596369, 22.876205],
              [100.593201, 22.868396],
              [100.589558, 22.864575],
              [100.590477, 22.856794],
              [100.566815, 22.856232],
              [100.560987, 22.858648],
              [100.557977, 22.856709],
              [100.542741, 22.854574],
              [100.540365, 22.844207],
              [100.542361, 22.837548],
              [100.542266, 22.829765],
              [100.544673, 22.817823],
              [100.538243, 22.814619],
              [100.526681, 22.812146],
              [100.510558, 22.810516],
              [100.50511, 22.811303],
              [100.496399, 22.819424],
              [100.483317, 22.821953],
              [100.480276, 22.827573],
              [100.472325, 22.830692],
              [100.467162, 22.838897],
              [100.462759, 22.841088],
              [100.457944, 22.836509],
              [100.448536, 22.839403],
              [100.439984, 22.840161],
              [100.423924, 22.84564],
              [100.410936, 22.85404],
              [100.403968, 22.856737],
              [100.399216, 22.856569],
              [100.388858, 22.860277],
              [100.375301, 22.855726],
              [100.366685, 22.858535],
              [100.36111, 22.856541],
              [100.353919, 22.857187],
              [100.347774, 22.854715],
              [100.339443, 22.855838],
              [100.323193, 22.851568],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530825,
        name: "镇沅彝族哈尼族拉祜族自治县",
        center: [101.108512, 24.005712],
        centroid: [100.975498, 23.942649],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 5,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [101.012182, 23.5794],
              [101.005055, 23.583061],
              [100.995235, 23.59189],
              [100.988615, 23.594432],
              [100.979397, 23.600774],
              [100.97303, 23.624826],
              [100.97227, 23.632814],
              [100.960011, 23.647058],
              [100.942558, 23.658647],
              [100.940436, 23.662473],
              [100.939644, 23.670459],
              [100.942114, 23.68629],
              [100.937553, 23.694637],
              [100.926815, 23.700946],
              [100.923014, 23.709293],
              [100.924534, 23.723724],
              [100.92748, 23.732515],
              [100.92653, 23.738209],
              [100.91047, 23.754171],
              [100.903881, 23.75604],
              [100.879364, 23.756961],
              [100.871477, 23.761286],
              [100.869576, 23.766281],
              [100.861182, 23.769936],
              [100.852946, 23.768541],
              [100.84528, 23.773144],
              [100.840561, 23.773563],
              [100.837615, 23.777106],
              [100.834384, 23.772865],
              [100.821872, 23.7732],
              [100.821682, 23.761816],
              [100.819433, 23.759835],
              [100.807332, 23.762709],
              [100.781548, 23.771136],
              [100.767959, 23.781486],
              [100.752944, 23.775767],
              [100.740179, 23.775628],
              [100.708122, 23.776688],
              [100.697162, 23.781821],
              [100.688166, 23.787708],
              [100.681673, 23.794124],
              [100.678949, 23.800679],
              [100.670174, 23.814096],
              [100.663206, 23.819367],
              [100.652721, 23.825196],
              [100.622153, 23.825586],
              [100.614266, 23.828766],
              [100.595925, 23.844438],
              [100.574639, 23.852469],
              [100.558389, 23.859523],
              [100.551737, 23.857515],
              [100.544167, 23.85272],
              [100.527505, 23.838749],
              [100.518192, 23.83412],
              [100.497729, 23.821654],
              [100.486548, 23.821319],
              [100.479705, 23.823885],
              [100.476728, 23.830411],
              [100.471565, 23.835291],
              [100.464216, 23.838052],
              [100.436626, 23.83518],
              [100.425824, 23.836658],
              [100.40609, 23.836965],
              [100.385089, 23.836518],
              [100.378152, 23.835347],
              [100.366115, 23.838945],
              [100.364911, 23.837634],
              [100.358734, 23.838777],
              [100.35091, 23.844661],
              [100.351544, 23.849541],
              [100.359969, 23.861781],
              [100.363992, 23.861865],
              [100.365988, 23.856233],
              [100.374446, 23.855647],
              [100.378342, 23.860359],
              [100.377676, 23.866214],
              [100.381351, 23.871539],
              [100.388288, 23.872013],
              [100.389745, 23.875498],
              [100.394623, 23.876836],
              [100.404158, 23.873407],
              [100.410208, 23.892782],
              [100.413756, 23.897632],
              [100.410556, 23.902091],
              [100.412108, 23.912153],
              [100.414864, 23.915943],
              [100.410366, 23.932664],
              [100.405678, 23.938627],
              [100.40118, 23.939407],
              [100.412805, 23.949745],
              [100.42291, 23.967603],
              [100.450247, 23.987437],
              [100.455283, 23.997353],
              [100.47166, 24.00412],
              [100.481891, 24.002784],
              [100.493928, 24.006766],
              [100.499155, 24.006683],
              [100.515721, 24.000834],
              [100.518034, 23.997854],
              [100.524179, 24.000054],
              [100.532193, 24.005958],
              [100.537768, 24.003118],
              [100.540524, 24.004677],
              [100.55424, 24.00348],
              [100.55576, 24.008771],
              [100.561842, 24.008883],
              [100.579676, 24.015901],
              [100.584744, 24.019521],
              [100.59922, 24.033555],
              [100.60603, 24.036451],
              [100.625448, 24.03595],
              [100.630421, 24.040293],
              [100.63267, 24.049258],
              [100.637675, 24.054436],
              [100.652056, 24.059531],
              [100.665011, 24.060561],
              [100.675876, 24.057666],
              [100.6818, 24.060394],
              [100.685221, 24.072754],
              [100.693615, 24.092488],
              [100.701724, 24.104649],
              [100.70429, 24.119147],
              [100.706602, 24.125018],
              [100.703941, 24.131251],
              [100.704606, 24.141434],
              [100.712525, 24.167415],
              [100.707077, 24.171143],
              [100.701217, 24.1811],
              [100.701312, 24.188664],
              [100.706032, 24.198704],
              [100.705177, 24.204738],
              [100.708122, 24.231235],
              [100.713983, 24.236489],
              [100.722598, 24.239603],
              [100.726051, 24.23054],
              [100.734572, 24.236823],
              [100.744202, 24.252974],
              [100.751234, 24.256448],
              [100.75041, 24.26537],
              [100.753704, 24.274764],
              [100.756524, 24.292855],
              [100.756175, 24.318362],
              [100.751804, 24.325779],
              [100.738215, 24.340641],
              [100.738785, 24.347002],
              [100.746546, 24.349863],
              [100.771697, 24.35189],
              [100.781389, 24.354251],
              [100.788992, 24.34403],
              [100.800142, 24.335141],
              [100.794313, 24.317417],
              [100.794884, 24.312083],
              [100.803214, 24.295134],
              [100.809645, 24.289298],
              [100.81069, 24.280739],
              [100.816772, 24.284408],
              [100.820446, 24.282379],
              [100.824596, 24.274792],
              [100.823741, 24.257199],
              [100.82884, 24.254781],
              [100.834099, 24.240215],
              [100.848163, 24.227371],
              [100.858141, 24.210661],
              [100.873377, 24.195422],
              [100.877083, 24.184048],
              [100.869513, 24.173757],
              [100.865775, 24.173396],
              [100.864825, 24.167861],
              [100.874929, 24.164523],
              [100.882056, 24.165357],
              [100.892098, 24.150308],
              [100.889057, 24.145106],
              [100.89422, 24.139319],
              [100.891433, 24.117979],
              [100.895709, 24.103174],
              [100.902392, 24.089899],
              [100.901474, 24.079824],
              [100.902646, 24.075676],
              [100.913036, 24.068857],
              [100.931566, 24.066518],
              [100.935557, 24.064653],
              [100.945757, 24.055995],
              [100.951744, 24.030687],
              [100.960677, 24.02367],
              [100.969673, 24.021247],
              [100.977307, 24.016151],
              [100.981203, 24.017878],
              [100.988203, 24.030882],
              [101.005087, 24.033889],
              [101.013893, 24.034474],
              [101.023332, 24.03272],
              [101.039139, 24.03943],
              [101.045727, 24.043467],
              [101.055674, 24.064904],
              [101.067267, 24.079211],
              [101.084816, 24.091792],
              [101.091658, 24.094658],
              [101.125805, 24.098666],
              [101.138348, 24.10362],
              [101.139806, 24.109909],
              [101.131253, 24.120399],
              [101.124759, 24.13331],
              [101.123239, 24.147165],
              [101.129067, 24.149585],
              [101.136068, 24.149696],
              [101.15029, 24.146664],
              [101.161599, 24.146858],
              [101.181903, 24.150892],
              [101.191279, 24.156345],
              [101.192388, 24.163271],
              [101.200497, 24.180099],
              [101.18732, 24.184938],
              [101.18808, 24.195923],
              [101.200085, 24.208992],
              [101.200212, 24.225953],
              [101.206927, 24.235211],
              [101.216589, 24.24305],
              [101.235563, 24.253363],
              [101.237685, 24.271012],
              [101.249563, 24.28802],
              [101.253935, 24.296384],
              [101.264325, 24.293856],
              [101.27709, 24.292716],
              [101.281018, 24.287131],
              [101.288589, 24.282768],
              [101.289697, 24.278266],
              [101.307721, 24.249888],
              [101.318206, 24.240187],
              [101.319346, 24.231402],
              [101.316622, 24.228205],
              [101.323052, 24.218835],
              [101.331858, 24.208964],
              [101.343072, 24.199677],
              [101.345099, 24.186885],
              [101.34266, 24.182296],
              [101.346176, 24.174981],
              [101.347538, 24.161797],
              [101.352384, 24.152255],
              [101.352669, 24.1448],
              [101.359417, 24.139208],
              [101.372942, 24.135786],
              [101.381938, 24.131139],
              [101.383617, 24.128051],
              [101.379784, 24.118841],
              [101.381717, 24.103564],
              [101.384251, 24.098443],
              [101.391314, 24.092543],
              [101.397048, 24.090567],
              [101.400754, 24.082384],
              [101.409465, 24.073199],
              [101.411967, 24.068383],
              [101.411746, 24.060477],
              [101.406931, 24.053824],
              [101.409623, 24.047671],
              [101.409655, 24.040237],
              [101.412126, 24.036395],
              [101.422737, 24.029323],
              [101.431702, 24.029685],
              [101.443422, 24.02548],
              [101.443834, 24.013923],
              [101.448237, 24.007657],
              [101.454889, 23.994846],
              [101.449504, 23.984429],
              [101.455775, 23.983091],
              [101.466165, 23.984707],
              [101.473736, 23.981866],
              [101.481401, 23.973983],
              [101.492013, 23.948602],
              [101.504018, 23.937652],
              [101.507724, 23.93676],
              [101.512856, 23.942249],
              [101.519255, 23.937206],
              [101.519603, 23.93141],
              [101.533034, 23.91795],
              [101.532368, 23.914884],
              [101.523436, 23.914104],
              [101.519635, 23.909422],
              [101.511652, 23.904823],
              [101.502434, 23.897241],
              [101.496384, 23.886872],
              [101.497113, 23.880795],
              [101.483714, 23.867553],
              [101.47779, 23.863147],
              [101.47665, 23.855145],
              [101.462808, 23.83953],
              [101.45926, 23.847366],
              [101.454762, 23.848453],
              [101.447255, 23.846613],
              [101.445196, 23.85127],
              [101.432588, 23.847617],
              [101.438924, 23.84402],
              [101.430371, 23.842124],
              [101.413171, 23.834343],
              [101.408198, 23.828794],
              [101.400849, 23.826507],
              [101.40332, 23.822295],
              [101.410288, 23.818698],
              [101.403225, 23.817833],
              [101.396003, 23.82224],
              [101.391568, 23.82012],
              [101.380038, 23.822184],
              [101.361475, 23.830829],
              [101.355204, 23.839335],
              [101.34966, 23.856093],
              [101.33908, 23.864932],
              [101.337687, 23.877701],
              [101.33056, 23.888489],
              [101.318586, 23.879206],
              [101.299707, 23.873658],
              [101.294765, 23.879234],
              [101.293182, 23.889938],
              [101.295241, 23.903708],
              [101.291598, 23.907944],
              [101.26008, 23.89883],
              [101.244179, 23.909199],
              [101.237812, 23.914689],
              [101.228911, 23.934587],
              [101.228499, 23.94668],
              [101.226503, 23.954175],
              [101.215353, 23.965987],
              [101.20924, 23.970417],
              [101.201637, 23.973425],
              [101.192831, 23.97479],
              [101.185166, 23.964762],
              [101.182157, 23.957824],
              [101.173541, 23.946875],
              [101.162834, 23.938126],
              [101.143322, 23.931912],
              [101.139204, 23.92815],
              [101.134294, 23.91795],
              [101.128465, 23.89791],
              [101.129289, 23.888322],
              [101.132298, 23.880182],
              [101.13781, 23.872543],
              [101.140376, 23.863008],
              [101.137842, 23.849011],
              [101.14991, 23.839028],
              [101.154313, 23.833897],
              [101.156847, 23.826172],
              [101.157069, 23.818865],
              [101.154218, 23.799591],
              [101.148675, 23.786647],
              [101.147471, 23.777469],
              [101.143702, 23.763881],
              [101.148802, 23.762598],
              [101.151684, 23.758273],
              [101.156499, 23.757938],
              [101.162834, 23.754506],
              [101.160617, 23.75099],
              [101.164513, 23.747027],
              [101.16692, 23.736422],
              [101.165146, 23.730645],
              [101.170848, 23.726626],
              [101.178514, 23.718644],
              [101.182442, 23.712335],
              [101.180573, 23.697345],
              [101.188048, 23.692683],
              [101.188777, 23.687574],
              [101.195777, 23.683609],
              [101.197139, 23.673837],
              [101.200402, 23.666214],
              [101.199674, 23.662529],
              [101.206801, 23.659513],
              [101.206421, 23.654067],
              [101.213326, 23.64985],
              [101.213389, 23.644852],
              [101.2202, 23.644433],
              [101.22286, 23.637199],
              [101.228182, 23.637339],
              [101.234106, 23.640997],
              [101.236798, 23.64636],
              [101.24478, 23.642561],
              [101.240599, 23.636976],
              [101.254948, 23.634937],
              [101.246111, 23.62706],
              [101.246586, 23.622954],
              [101.250926, 23.624072],
              [101.255835, 23.616418],
              [101.247695, 23.614742],
              [101.239459, 23.607367],
              [101.240029, 23.595103],
              [101.236925, 23.575572],
              [101.234581, 23.570934],
              [101.219344, 23.57968],
              [101.188619, 23.578143],
              [101.18412, 23.575572],
              [101.169264, 23.57588],
              [101.164323, 23.574399],
              [101.160617, 23.566742],
              [101.145919, 23.564786],
              [101.134706, 23.565904],
              [101.137905, 23.572275],
              [101.144589, 23.576969],
              [101.146458, 23.580714],
              [101.142245, 23.584542],
              [101.14915, 23.586749],
              [101.147154, 23.598316],
              [101.144272, 23.603596],
              [101.13762, 23.597282],
              [101.138982, 23.590716],
              [101.131475, 23.592029],
              [101.121275, 23.584206],
              [101.11684, 23.582502],
              [101.105373, 23.581943],
              [101.093305, 23.584597],
              [101.074046, 23.585408],
              [101.067109, 23.583815],
              [101.051841, 23.576271],
              [101.046614, 23.575433],
              [101.034546, 23.577361],
              [101.02821, 23.579903],
              [101.015381, 23.581105],
              [101.012182, 23.5794],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530826,
        name: "江城哈尼族彝族自治县",
        center: [101.859144, 22.58336],
        centroid: [101.787533, 22.620518],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 6,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [101.445861, 22.584354],
              [101.447983, 22.588942],
              [101.443263, 22.592996],
              [101.441299, 22.600398],
              [101.436041, 22.604845],
              [101.434426, 22.613514],
              [101.430244, 22.610136],
              [101.428122, 22.613204],
              [101.428502, 22.619846],
              [101.424479, 22.618467],
              [101.421407, 22.623392],
              [101.42185, 22.633944],
              [101.413741, 22.633804],
              [101.409813, 22.636055],
              [101.407628, 22.648491],
              [101.402559, 22.649364],
              [101.397808, 22.655385],
              [101.399424, 22.658564],
              [101.392677, 22.663375],
              [101.389414, 22.66239],
              [101.382762, 22.665316],
              [101.386753, 22.670014],
              [101.377535, 22.672236],
              [101.379468, 22.675499],
              [101.378929, 22.683629],
              [101.375033, 22.68467],
              [101.372119, 22.679241],
              [101.367557, 22.677581],
              [101.360589, 22.681829],
              [101.36515, 22.684473],
              [101.360335, 22.686526],
              [101.358054, 22.69443],
              [101.351751, 22.695836],
              [101.349343, 22.702643],
              [101.35042, 22.707396],
              [101.346556, 22.70658],
              [101.345004, 22.715805],
              [101.342185, 22.713499],
              [101.339999, 22.719039],
              [101.330718, 22.728122],
              [101.329071, 22.734027],
              [101.318586, 22.735123],
              [101.316179, 22.740747],
              [101.30921, 22.74578],
              [101.300847, 22.739032],
              [101.29353, 22.737991],
              [101.285358, 22.74474],
              [101.277629, 22.757897],
              [101.272624, 22.757813],
              [101.268696, 22.761552],
              [101.25422, 22.76442],
              [101.2444, 22.764448],
              [101.240631, 22.770801],
              [101.237083, 22.772291],
              [101.242595, 22.783366],
              [101.241866, 22.785839],
              [101.246396, 22.796183],
              [101.249912, 22.796127],
              [101.250926, 22.80068],
              [101.245762, 22.805626],
              [101.2393, 22.808296],
              [101.221277, 22.821082],
              [101.213579, 22.828894],
              [101.214086, 22.835778],
              [101.216842, 22.843168],
              [101.223431, 22.84609],
              [101.236006, 22.848927],
              [101.254283, 22.851484],
              [101.268347, 22.861485],
              [101.28672, 22.870474],
              [101.306169, 22.876289],
              [101.318111, 22.876654],
              [101.327835, 22.875306],
              [101.340696, 22.870193],
              [101.347285, 22.866261],
              [101.351751, 22.859743],
              [101.361792, 22.841032],
              [101.362046, 22.825241],
              [101.360715, 22.820183],
              [101.360715, 22.803687],
              [101.357579, 22.793288],
              [101.36024, 22.787414],
              [101.366924, 22.780752],
              [101.385929, 22.768215],
              [101.393785, 22.763857],
              [101.399519, 22.754861],
              [101.393563, 22.739116],
              [101.395717, 22.734139],
              [101.402306, 22.729528],
              [101.417954, 22.721007],
              [101.433761, 22.714539],
              [101.436865, 22.709561],
              [101.445639, 22.690098],
              [101.450074, 22.682898],
              [101.457613, 22.67941],
              [101.471424, 22.679972],
              [101.484189, 22.682532],
              [101.496479, 22.692658],
              [101.511462, 22.712683],
              [101.520838, 22.719629],
              [101.525558, 22.718533],
              [101.536423, 22.707874],
              [101.554732, 22.70433],
              [101.566896, 22.700843],
              [101.568891, 22.704274],
              [101.574466, 22.704808],
              [101.572027, 22.712149],
              [101.562207, 22.725563],
              [101.562302, 22.731693],
              [101.569271, 22.736473],
              [101.582639, 22.737598],
              [101.591286, 22.734139],
              [101.606396, 22.733493],
              [101.618623, 22.738498],
              [101.616025, 22.742068],
              [101.602183, 22.755142],
              [101.598667, 22.761046],
              [101.599174, 22.767343],
              [101.592585, 22.772797],
              [101.584222, 22.774821],
              [101.580865, 22.777407],
              [101.579661, 22.78286],
              [101.575797, 22.781567],
              [101.569271, 22.789325],
              [101.591508, 22.801607],
              [101.592395, 22.805767],
              [101.588309, 22.810685],
              [101.575765, 22.813523],
              [101.567624, 22.8217],
              [101.568543, 22.826196],
              [101.585933, 22.840077],
              [101.591128, 22.852748],
              [101.621125, 22.849096],
              [101.631737, 22.850388],
              [101.640004, 22.856232],
              [101.645231, 22.869632],
              [101.665187, 22.886541],
              [101.675386, 22.903617],
              [101.692808, 22.915299],
              [101.707601, 22.921],
              [101.729679, 22.924285],
              [101.746721, 22.923162],
              [101.75765, 22.913305],
              [101.762971, 22.913221],
              [101.7688, 22.903336],
              [101.777922, 22.897804],
              [101.783592, 22.896989],
              [101.78619, 22.890726],
              [101.793602, 22.880952],
              [101.800064, 22.875362],
              [101.812513, 22.862496],
              [101.817708, 22.855529],
              [101.823314, 22.840555],
              [101.833039, 22.832659],
              [101.839279, 22.82614],
              [101.846311, 22.824848],
              [101.851379, 22.821644],
              [101.857968, 22.811949],
              [101.867693, 22.807621],
              [101.874281, 22.800989],
              [101.879666, 22.800876],
              [101.886191, 22.796829],
              [101.899147, 22.796801],
              [101.904279, 22.800905],
              [101.911596, 22.815153],
              [101.922302, 22.820773],
              [101.934973, 22.818188],
              [101.948562, 22.809982],
              [101.955784, 22.801129],
              [101.961708, 22.797223],
              [101.968835, 22.79489],
              [101.977007, 22.796857],
              [101.985306, 22.79652],
              [101.99161, 22.794075],
              [101.998895, 22.783788],
              [102.012516, 22.776704],
              [102.022589, 22.758966],
              [102.031712, 22.746848],
              [102.05889, 22.725141],
              [102.059619, 22.719207],
              [102.0587, 22.698255],
              [102.064655, 22.678903],
              [102.068963, 22.674234],
              [102.070515, 22.669198],
              [102.078719, 22.656257],
              [102.084706, 22.65108],
              [102.0931, 22.648435],
              [102.102762, 22.647563],
              [102.112581, 22.643342],
              [102.133392, 22.632059],
              [102.144036, 22.629554],
              [102.154552, 22.624996],
              [102.165924, 22.625362],
              [102.170675, 22.626994],
              [102.17568, 22.624067],
              [102.18192, 22.624433],
              [102.190156, 22.620578],
              [102.198867, 22.613767],
              [102.212741, 22.623617],
              [102.219583, 22.62418],
              [102.229245, 22.620015],
              [102.2371, 22.611656],
              [102.248535, 22.606337],
              [102.254364, 22.608138],
              [102.258102, 22.604676],
              [102.263613, 22.60493],
              [102.270139, 22.609714],
              [102.276886, 22.611966],
              [102.287402, 22.589196],
              [102.287941, 22.582806],
              [102.292249, 22.577007],
              [102.292819, 22.572503],
              [102.304507, 22.565465],
              [102.31363, 22.554485],
              [102.322531, 22.554372],
              [102.32345, 22.546685],
              [102.316829, 22.539787],
              [102.302512, 22.527678],
              [102.29019, 22.509429],
              [102.278628, 22.489994],
              [102.28094, 22.482923],
              [102.284203, 22.479233],
              [102.276569, 22.477486],
              [102.256201, 22.457371],
              [102.266021, 22.43652],
              [102.270234, 22.419611],
              [102.269062, 22.414425],
              [102.262663, 22.415102],
              [102.236435, 22.426854],
              [102.205329, 22.430602],
              [102.179418, 22.430517],
              [102.167349, 22.425529],
              [102.153317, 22.403151],
              [102.145303, 22.397796],
              [102.135356, 22.40363],
              [102.131809, 22.408337],
              [102.128198, 22.417131],
              [102.128514, 22.423556],
              [102.131429, 22.430855],
              [102.120183, 22.433955],
              [102.106721, 22.439337],
              [102.095318, 22.441986],
              [102.088697, 22.439309],
              [102.077927, 22.441282],
              [102.072416, 22.446241],
              [102.046473, 22.457906],
              [102.040074, 22.458131],
              [102.031142, 22.455962],
              [102.024901, 22.449876],
              [102.014195, 22.443423],
              [102.002728, 22.439619],
              [101.992053, 22.432377],
              [101.978559, 22.42784],
              [101.967187, 22.430038],
              [101.956196, 22.435477],
              [101.936272, 22.438971],
              [101.907921, 22.437196],
              [101.904437, 22.429728],
              [101.908777, 22.422908],
              [101.911406, 22.409634],
              [101.911152, 22.396978],
              [101.901428, 22.38435],
              [101.895758, 22.383109],
              [101.879349, 22.384237],
              [101.862688, 22.389226],
              [101.855244, 22.396104],
              [101.848465, 22.405913],
              [101.829396, 22.418765],
              [101.823029, 22.426797],
              [101.822902, 22.443395],
              [101.82417, 22.456864],
              [101.81001, 22.467682],
              [101.806431, 22.476895],
              [101.79886, 22.477881],
              [101.79262, 22.482416],
              [101.782199, 22.501401],
              [101.774343, 22.506218],
              [101.764555, 22.506359],
              [101.757871, 22.502641],
              [101.749065, 22.49312],
              [101.732055, 22.490726],
              [101.715267, 22.478162],
              [101.705669, 22.475233],
              [101.69661, 22.474613],
              [101.677921, 22.477205],
              [101.672504, 22.474895],
              [101.670857, 22.47081],
              [101.674373, 22.46078],
              [101.67054, 22.450383],
              [101.667087, 22.432772],
              [101.657046, 22.418765],
              [101.64862, 22.411748],
              [101.648462, 22.400473],
              [101.662779, 22.384913],
              [101.671839, 22.372735],
              [101.669811, 22.365405],
              [101.662811, 22.362247],
              [101.648873, 22.363008],
              [101.648177, 22.357116],
              [101.64862, 22.334755],
              [101.647955, 22.331681],
              [101.635253, 22.332696],
              [101.63066, 22.336785],
              [101.606174, 22.339718],
              [101.602943, 22.33687],
              [101.59702, 22.336165],
              [101.594992, 22.331878],
              [101.588974, 22.32982],
              [101.581023, 22.336475],
              [101.562746, 22.329284],
              [101.551944, 22.329481],
              [101.550709, 22.335234],
              [101.554827, 22.351364],
              [101.560972, 22.359991],
              [101.563189, 22.370367],
              [101.560782, 22.37313],
              [101.553813, 22.370564],
              [101.552705, 22.375188],
              [101.548333, 22.375131],
              [101.54431, 22.379332],
              [101.540193, 22.378627],
              [101.532242, 22.380826],
              [101.529454, 22.384998],
              [101.518368, 22.393342],
              [101.509815, 22.404391],
              [101.513489, 22.411015],
              [101.511462, 22.420625],
              [101.509023, 22.424599],
              [101.506141, 22.436238],
              [101.496669, 22.445339],
              [101.493027, 22.451905],
              [101.495181, 22.456525],
              [101.493914, 22.463964],
              [101.48875, 22.479289],
              [101.484411, 22.484275],
              [101.477569, 22.497148],
              [101.476492, 22.504612],
              [101.478171, 22.509626],
              [101.474084, 22.520356],
              [101.468731, 22.529537],
              [101.468826, 22.536211],
              [101.463948, 22.533169],
              [101.460559, 22.534465],
              [101.459735, 22.539026],
              [101.453875, 22.547136],
              [101.453875, 22.55105],
              [101.449884, 22.558145],
              [101.453083, 22.569096],
              [101.449028, 22.572756],
              [101.450581, 22.579344],
              [101.445861, 22.584354],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530827,
        name: "孟连傣族拉祜族佤族自治县",
        center: [99.585406, 22.325924],
        centroid: [99.470443, 22.288801],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 7,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [99.381017, 22.49236],
              [99.385768, 22.487768],
              [99.396887, 22.480163],
              [99.404742, 22.472162],
              [99.414024, 22.474303],
              [99.42606, 22.479036],
              [99.432681, 22.472725],
              [99.439301, 22.470415],
              [99.452067, 22.475402],
              [99.457927, 22.476557],
              [99.463153, 22.469373],
              [99.474778, 22.466386],
              [99.477598, 22.455145],
              [99.482507, 22.450496],
              [99.488019, 22.448354],
              [99.498282, 22.449425],
              [99.505188, 22.44796],
              [99.511079, 22.441845],
              [99.521342, 22.438548],
              [99.552955, 22.43852],
              [99.571929, 22.440126],
              [99.577029, 22.441451],
              [99.585487, 22.457568],
              [99.588369, 22.465231],
              [99.601642, 22.478754],
              [99.605284, 22.480501],
              [99.620045, 22.48312],
              [99.634173, 22.488923],
              [99.654034, 22.500218],
              [99.660718, 22.511485],
              [99.660306, 22.521539],
              [99.666895, 22.529565],
              [99.672565, 22.530719],
              [99.681149, 22.527594],
              [99.686502, 22.523707],
              [99.699838, 22.508189],
              [99.697684, 22.50388],
              [99.700978, 22.500866],
              [99.711843, 22.499683],
              [99.714916, 22.504641],
              [99.715454, 22.521454],
              [99.717608, 22.522187],
              [99.730595, 22.518835],
              [99.734238, 22.512696],
              [99.734555, 22.506077],
              [99.72917, 22.494613],
              [99.71992, 22.490304],
              [99.721346, 22.478754],
              [99.720111, 22.474162],
              [99.72274, 22.459343],
              [99.723215, 22.450496],
              [99.732654, 22.452806],
              [99.737722, 22.451313],
              [99.74051, 22.44734],
              [99.73655, 22.442353],
              [99.742284, 22.43852],
              [99.7458, 22.440211],
              [99.753941, 22.437309],
              [99.75657, 22.443508],
              [99.761955, 22.441704],
              [99.760086, 22.426938],
              [99.763982, 22.422965],
              [99.763634, 22.418906],
              [99.756158, 22.413608],
              [99.755746, 22.407633],
              [99.742632, 22.402813],
              [99.73408, 22.401855],
              [99.731546, 22.396753],
              [99.721378, 22.388945],
              [99.711241, 22.384209],
              [99.696353, 22.383448],
              [99.697525, 22.379726],
              [99.710101, 22.374934],
              [99.711273, 22.371015],
              [99.703132, 22.362557],
              [99.702562, 22.360189],
              [99.705761, 22.34313],
              [99.709024, 22.319441],
              [99.704938, 22.299613],
              [99.710133, 22.288358],
              [99.718527, 22.277469],
              [99.720016, 22.265845],
              [99.717576, 22.258679],
              [99.712857, 22.253684],
              [99.705444, 22.253402],
              [99.693598, 22.257747],
              [99.685298, 22.265422],
              [99.681624, 22.263927],
              [99.670569, 22.264717],
              [99.662935, 22.256308],
              [99.658659, 22.259017],
              [99.663917, 22.263532],
              [99.656822, 22.267115],
              [99.654794, 22.259299],
              [99.644975, 22.246602],
              [99.656061, 22.237628],
              [99.659862, 22.230432],
              [99.653464, 22.219679],
              [99.655808, 22.214684],
              [99.66189, 22.211382],
              [99.659894, 22.206527],
              [99.664487, 22.199329],
              [99.663727, 22.196422],
              [99.652989, 22.190719],
              [99.651658, 22.183436],
              [99.641807, 22.178101],
              [99.640762, 22.174233],
              [99.648332, 22.159862],
              [99.649536, 22.154412],
              [99.658849, 22.140124],
              [99.656156, 22.133403],
              [99.653432, 22.116119],
              [99.648807, 22.100583],
              [99.643106, 22.102815],
              [99.6311, 22.100047],
              [99.62467, 22.093691],
              [99.61295, 22.093917],
              [99.607977, 22.103041],
              [99.604999, 22.103097],
              [99.600945, 22.109057],
              [99.592234, 22.11256],
              [99.592139, 22.10773],
              [99.584156, 22.104538],
              [99.578233, 22.099256],
              [99.575635, 22.09451],
              [99.562617, 22.113181],
              [99.555363, 22.112899],
              [99.540253, 22.106487],
              [99.526062, 22.098578],
              [99.516559, 22.099567],
              [99.496508, 22.11674],
              [99.487259, 22.128658],
              [99.471959, 22.130918],
              [99.463914, 22.126455],
              [99.458085, 22.11979],
              [99.448646, 22.113351],
              [99.435753, 22.109594],
              [99.421689, 22.108492],
              [99.399896, 22.100216],
              [99.391248, 22.098945],
              [99.375125, 22.100386],
              [99.364989, 22.104199],
              [99.361156, 22.09903],
              [99.354694, 22.09564],
              [99.336924, 22.097843],
              [99.328023, 22.097815],
              [99.308257, 22.101855],
              [99.300971, 22.100329],
              [99.293021, 22.110328],
              [99.278386, 22.105244],
              [99.272336, 22.100414],
              [99.263815, 22.100979],
              [99.256213, 22.112136],
              [99.246393, 22.115638],
              [99.237207, 22.113831],
              [99.227166, 22.115864],
              [99.219025, 22.111119],
              [99.211328, 22.118858],
              [99.20249, 22.125072],
              [99.199829, 22.130663],
              [99.195711, 22.131511],
              [99.187539, 22.139785],
              [99.179556, 22.141536],
              [99.175122, 22.14676],
              [99.169262, 22.146421],
              [99.16508, 22.14964],
              [99.162388, 22.15509],
              [99.155863, 22.160935],
              [99.158428, 22.16565],
              [99.165365, 22.164549],
              [99.173665, 22.166327],
              [99.178574, 22.162601],
              [99.188014, 22.163081],
              [99.195141, 22.165226],
              [99.200938, 22.169123],
              [99.200843, 22.17172],
              [99.190105, 22.168727],
              [99.187792, 22.173979],
              [99.183421, 22.172539],
              [99.17585, 22.175842],
              [99.17905, 22.182476],
              [99.175248, 22.185864],
              [99.184244, 22.195688],
              [99.190136, 22.199301],
              [99.191277, 22.208192],
              [99.196408, 22.205257],
              [99.195078, 22.213273],
              [99.200621, 22.219369],
              [99.204169, 22.218466],
              [99.204105, 22.224506],
              [99.208223, 22.232182],
              [99.21893, 22.232436],
              [99.22631, 22.237318],
              [99.232551, 22.244514],
              [99.23575, 22.250637],
              [99.2316, 22.261726],
              [99.231949, 22.271996],
              [99.235497, 22.279754],
              [99.235623, 22.28754],
              [99.233786, 22.296454],
              [99.24199, 22.308075],
              [99.2469, 22.310783],
              [99.252348, 22.319046],
              [99.254471, 22.329791],
              [99.263403, 22.338787],
              [99.269929, 22.343017],
              [99.277753, 22.344991],
              [99.278671, 22.357905],
              [99.276707, 22.362303],
              [99.269548, 22.367717],
              [99.264607, 22.373891],
              [99.253615, 22.380347],
              [99.249529, 22.386718],
              [99.251588, 22.393455],
              [99.260806, 22.396809],
              [99.272589, 22.397796],
              [99.282187, 22.40146],
              [99.302207, 22.416933],
              [99.309555, 22.427755],
              [99.309049, 22.431785],
              [99.312565, 22.437647],
              [99.326281, 22.441761],
              [99.334453, 22.446607],
              [99.338888, 22.454046],
              [99.345508, 22.458639],
              [99.351336, 22.467654],
              [99.362328, 22.474359],
              [99.367143, 22.484247],
              [99.381017, 22.49236],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530828,
        name: "澜沧拉祜族自治县",
        center: [99.931201, 22.553083],
        centroid: [99.97593, 22.662218],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 8,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [99.648807, 22.100583],
              [99.653432, 22.116119],
              [99.656156, 22.133403],
              [99.658849, 22.140124],
              [99.649536, 22.154412],
              [99.648332, 22.159862],
              [99.640762, 22.174233],
              [99.641807, 22.178101],
              [99.651658, 22.183436],
              [99.652989, 22.190719],
              [99.663727, 22.196422],
              [99.664487, 22.199329],
              [99.659894, 22.206527],
              [99.66189, 22.211382],
              [99.655808, 22.214684],
              [99.653464, 22.219679],
              [99.659862, 22.230432],
              [99.656061, 22.237628],
              [99.644975, 22.246602],
              [99.654794, 22.259299],
              [99.656822, 22.267115],
              [99.663917, 22.263532],
              [99.658659, 22.259017],
              [99.662935, 22.256308],
              [99.670569, 22.264717],
              [99.681624, 22.263927],
              [99.685298, 22.265422],
              [99.693598, 22.257747],
              [99.705444, 22.253402],
              [99.712857, 22.253684],
              [99.717576, 22.258679],
              [99.720016, 22.265845],
              [99.718527, 22.277469],
              [99.710133, 22.288358],
              [99.704938, 22.299613],
              [99.709024, 22.319441],
              [99.705761, 22.34313],
              [99.702562, 22.360189],
              [99.703132, 22.362557],
              [99.711273, 22.371015],
              [99.710101, 22.374934],
              [99.697525, 22.379726],
              [99.696353, 22.383448],
              [99.711241, 22.384209],
              [99.721378, 22.388945],
              [99.731546, 22.396753],
              [99.73408, 22.401855],
              [99.742632, 22.402813],
              [99.755746, 22.407633],
              [99.756158, 22.413608],
              [99.763634, 22.418906],
              [99.763982, 22.422965],
              [99.760086, 22.426938],
              [99.761955, 22.441704],
              [99.75657, 22.443508],
              [99.753941, 22.437309],
              [99.7458, 22.440211],
              [99.742284, 22.43852],
              [99.73655, 22.442353],
              [99.74051, 22.44734],
              [99.737722, 22.451313],
              [99.732654, 22.452806],
              [99.723215, 22.450496],
              [99.72274, 22.459343],
              [99.720111, 22.474162],
              [99.721346, 22.478754],
              [99.71992, 22.490304],
              [99.72917, 22.494613],
              [99.734555, 22.506077],
              [99.734238, 22.512696],
              [99.730595, 22.518835],
              [99.717608, 22.522187],
              [99.715454, 22.521454],
              [99.714916, 22.504641],
              [99.711843, 22.499683],
              [99.700978, 22.500866],
              [99.697684, 22.50388],
              [99.699838, 22.508189],
              [99.686502, 22.523707],
              [99.681149, 22.527594],
              [99.672565, 22.530719],
              [99.666895, 22.529565],
              [99.660306, 22.521539],
              [99.660718, 22.511485],
              [99.654034, 22.500218],
              [99.634173, 22.488923],
              [99.620045, 22.48312],
              [99.605284, 22.480501],
              [99.601642, 22.478754],
              [99.588369, 22.465231],
              [99.585487, 22.457568],
              [99.577029, 22.441451],
              [99.571929, 22.440126],
              [99.552955, 22.43852],
              [99.521342, 22.438548],
              [99.511079, 22.441845],
              [99.505188, 22.44796],
              [99.498282, 22.449425],
              [99.496762, 22.450411],
              [99.499391, 22.46109],
              [99.502527, 22.464302],
              [99.498757, 22.469288],
              [99.505504, 22.473655],
              [99.503477, 22.483515],
              [99.50655, 22.488726],
              [99.516939, 22.4965],
              [99.517446, 22.507091],
              [99.526347, 22.518723],
              [99.534583, 22.523116],
              [99.546652, 22.525172],
              [99.548964, 22.530663],
              [99.556503, 22.532324],
              [99.560146, 22.537196],
              [99.568857, 22.544348],
              [99.571423, 22.557272],
              [99.577378, 22.562143],
              [99.576712, 22.570617],
              [99.579247, 22.575909],
              [99.587704, 22.575881],
              [99.586532, 22.566563],
              [99.60047, 22.56797],
              [99.6139, 22.558595],
              [99.619127, 22.55074],
              [99.62372, 22.553471],
              [99.624005, 22.567492],
              [99.625367, 22.5698],
              [99.651785, 22.58137],
              [99.661288, 22.595529],
              [99.66946, 22.596289],
              [99.678171, 22.601215],
              [99.691982, 22.614808],
              [99.705476, 22.624236],
              [99.710259, 22.629245],
              [99.714377, 22.636955],
              [99.716088, 22.649139],
              [99.708707, 22.658704],
              [99.686439, 22.673896],
              [99.679755, 22.684388],
              [99.675004, 22.70253],
              [99.674909, 22.708605],
              [99.666419, 22.714455],
              [99.655269, 22.713049],
              [99.627363, 22.715467],
              [99.627965, 22.73144],
              [99.625937, 22.735236],
              [99.62806, 22.739341],
              [99.641902, 22.740522],
              [99.647414, 22.743362],
              [99.64754, 22.746933],
              [99.643771, 22.752556],
              [99.639526, 22.762761],
              [99.634965, 22.767203],
              [99.621376, 22.76962],
              [99.621408, 22.784603],
              [99.636834, 22.787329],
              [99.644436, 22.785896],
              [99.655586, 22.780246],
              [99.674402, 22.785362],
              [99.680737, 22.79177],
              [99.687896, 22.8029],
              [99.688751, 22.806694],
              [99.676968, 22.833867],
              [99.678076, 22.83738],
              [99.674275, 22.840414],
              [99.666039, 22.840189],
              [99.658595, 22.827011],
              [99.649504, 22.820689],
              [99.641554, 22.823499],
              [99.638861, 22.832884],
              [99.636422, 22.835694],
              [99.625747, 22.840021],
              [99.621408, 22.850697],
              [99.622041, 22.867946],
              [99.62315, 22.873283],
              [99.626761, 22.878087],
              [99.63639, 22.886429],
              [99.63997, 22.891737],
              [99.638956, 22.906706],
              [99.635662, 22.910525],
              [99.627965, 22.906229],
              [99.614122, 22.903617],
              [99.605094, 22.895557],
              [99.59651, 22.897944],
              [99.585202, 22.898478],
              [99.565024, 22.902016],
              [99.554444, 22.907099],
              [99.561413, 22.916788],
              [99.563313, 22.925605],
              [99.558879, 22.939306],
              [99.544941, 22.958762],
              [99.533538, 22.961429],
              [99.532271, 22.969962],
              [99.527013, 22.978776],
              [99.518016, 22.999404],
              [99.517066, 23.006785],
              [99.523718, 23.026623],
              [99.529452, 23.04601],
              [99.528058, 23.06559],
              [99.513962, 23.073192],
              [99.510034, 23.086402],
              [99.508038, 23.098237],
              [99.503192, 23.106537],
              [99.509274, 23.114753],
              [99.515831, 23.117753],
              [99.53376, 23.121791],
              [99.54076, 23.127146],
              [99.539081, 23.136061],
              [99.548964, 23.145677],
              [99.553589, 23.147387],
              [99.560843, 23.153274],
              [99.578328, 23.165047],
              [99.591727, 23.170008],
              [99.600184, 23.165327],
              [99.611366, 23.162776],
              [99.615547, 23.158039],
              [99.616783, 23.149265],
              [99.621946, 23.147695],
              [99.622801, 23.153218],
              [99.626888, 23.153386],
              [99.639716, 23.148873],
              [99.633254, 23.158656],
              [99.633318, 23.164066],
              [99.62391, 23.17183],
              [99.623276, 23.177715],
              [99.618462, 23.179565],
              [99.618747, 23.184582],
              [99.613932, 23.188421],
              [99.624163, 23.196352],
              [99.629137, 23.204086],
              [99.635408, 23.208205],
              [99.661605, 23.230955],
              [99.66756, 23.248351],
              [99.674212, 23.247371],
              [99.707567, 23.235802],
              [99.734555, 23.231431],
              [99.775797, 23.21633],
              [99.799174, 23.198761],
              [99.807347, 23.200891],
              [99.818022, 23.209017],
              [99.842476, 23.214733],
              [99.88527, 23.255494],
              [99.904814, 23.256026],
              [99.942287, 23.249612],
              [99.971366, 23.227537],
              [100.002409, 23.226501],
              [100.028447, 23.217255],
              [100.042986, 23.217871],
              [100.043049, 23.211091],
              [100.053471, 23.196716],
              [100.079445, 23.186655],
              [100.106908, 23.171269],
              [100.119737, 23.157591],
              [100.132408, 23.133342],
              [100.132123, 23.1138],
              [100.143684, 23.068536],
              [100.14682, 23.062477],
              [100.156545, 23.058578],
              [100.172573, 23.045561],
              [100.19123, 23.043766],
              [100.199878, 23.024098],
              [100.215019, 23.005831],
              [100.236021, 22.996514],
              [100.240899, 22.996458],
              [100.264624, 23.005887],
              [100.266145, 22.997608],
              [100.267443, 22.978046],
              [100.271973, 22.953175],
              [100.278372, 22.946325],
              [100.288191, 22.949217],
              [100.294812, 22.957386],
              [100.30216, 22.95806],
              [100.310238, 22.952698],
              [100.299278, 22.928778],
              [100.299056, 22.914513],
              [100.304504, 22.898646],
              [100.326044, 22.870559],
              [100.328832, 22.861569],
              [100.323193, 22.851568],
              [100.322845, 22.847241],
              [100.333678, 22.845078],
              [100.338398, 22.831929],
              [100.345272, 22.822431],
              [100.347742, 22.81223],
              [100.354996, 22.809645],
              [100.360666, 22.805176],
              [100.36678, 22.788875],
              [100.372228, 22.783254],
              [100.375934, 22.764026],
              [100.372355, 22.749575],
              [100.37435, 22.738244],
              [100.378215, 22.729753],
              [100.378215, 22.717351],
              [100.375142, 22.702108],
              [100.372482, 22.697777],
              [100.371436, 22.685992],
              [100.374034, 22.67609],
              [100.388826, 22.671842],
              [100.404094, 22.664866],
              [100.416416, 22.65575],
              [100.427281, 22.643427],
              [100.434567, 22.63099],
              [100.443595, 22.62266],
              [100.458926, 22.598513],
              [100.469823, 22.589477],
              [100.483507, 22.585086],
              [100.489905, 22.584298],
              [100.493073, 22.581708],
              [100.497159, 22.573376],
              [100.507961, 22.567548],
              [100.514486, 22.55989],
              [100.526364, 22.555414],
              [100.535646, 22.549585],
              [100.554366, 22.545165],
              [100.561177, 22.534324],
              [100.56558, 22.523679],
              [100.569381, 22.51999],
              [100.574196, 22.510781],
              [100.573974, 22.500162],
              [100.579295, 22.496247],
              [100.581323, 22.48712],
              [100.579074, 22.481965],
              [100.568304, 22.482782],
              [100.56238, 22.481346],
              [100.562602, 22.477881],
              [100.571915, 22.472951],
              [100.578884, 22.458779],
              [100.566847, 22.45985],
              [100.562032, 22.457117],
              [100.553226, 22.460385],
              [100.542044, 22.458836],
              [100.529405, 22.462132],
              [100.520473, 22.4583],
              [100.510178, 22.457934],
              [100.502607, 22.4563],
              [100.486041, 22.456695],
              [100.480149, 22.454497],
              [100.477203, 22.450862],
              [100.470298, 22.45275],
              [100.464469, 22.45027],
              [100.460066, 22.444691],
              [100.456677, 22.444043],
              [100.448251, 22.437759],
              [100.448251, 22.42908],
              [100.446604, 22.426093],
              [100.436721, 22.425445],
              [100.431178, 22.435871],
              [100.423607, 22.438971],
              [100.414231, 22.437393],
              [100.409353, 22.42846],
              [100.401117, 22.409465],
              [100.393863, 22.406731],
              [100.388731, 22.402728],
              [100.382586, 22.402024],
              [100.377581, 22.392778],
              [100.382491, 22.384406],
              [100.369916, 22.376541],
              [100.390442, 22.372312],
              [100.391012, 22.364644],
              [100.386514, 22.34595],
              [100.389587, 22.343525],
              [100.387116, 22.339041],
              [100.389745, 22.329227],
              [100.383568, 22.325364],
              [100.38512, 22.318285],
              [100.384328, 22.310416],
              [100.378057, 22.300375],
              [100.380369, 22.287568],
              [100.374477, 22.280854],
              [100.376599, 22.273688],
              [100.375237, 22.267679],
              [100.371468, 22.261698],
              [100.358607, 22.255772],
              [100.35148, 22.245981],
              [100.346095, 22.243159],
              [100.329339, 22.250016],
              [100.325949, 22.253205],
              [100.319171, 22.254587],
              [100.312233, 22.259158],
              [100.304314, 22.260118],
              [100.29383, 22.263644],
              [100.276281, 22.272024],
              [100.276788, 22.276227],
              [100.27267, 22.276792],
              [100.264181, 22.287681],
              [100.248501, 22.287794],
              [100.242894, 22.290981],
              [100.230129, 22.293492],
              [100.219137, 22.289543],
              [100.208811, 22.292646],
              [100.203964, 22.292533],
              [100.196996, 22.287625],
              [100.195443, 22.276199],
              [100.204123, 22.262685],
              [100.201494, 22.255631],
              [100.193226, 22.254051],
              [100.183565, 22.254136],
              [100.180461, 22.251314],
              [100.174094, 22.239942],
              [100.169786, 22.237798],
              [100.151097, 22.236895],
              [100.143304, 22.232012],
              [100.133643, 22.233452],
              [100.126548, 22.237261],
              [100.117045, 22.238249],
              [100.108397, 22.246574],
              [100.100953, 22.247223],
              [100.093161, 22.24172],
              [100.092591, 22.230432],
              [100.088219, 22.229557],
              [100.083405, 22.224393],
              [100.082708, 22.2157],
              [100.074599, 22.215728],
              [100.072635, 22.213047],
              [100.079984, 22.204128],
              [100.080744, 22.200402],
              [100.077038, 22.197297],
              [100.066838, 22.160201],
              [100.046185, 22.130381],
              [100.034212, 22.121118],
              [100.014952, 22.11126],
              [99.997309, 22.112814],
              [99.993983, 22.106826],
              [99.9892, 22.077306],
              [99.98296, 22.066994],
              [99.976529, 22.062982],
              [99.973932, 22.052386],
              [99.963384, 22.056511],
              [99.953279, 22.054646],
              [99.941971, 22.055776],
              [99.932721, 22.058772],
              [99.919385, 22.05993],
              [99.89604, 22.066683],
              [99.881152, 22.067898],
              [99.871459, 22.066909],
              [99.865789, 22.062812],
              [99.864807, 22.058404],
              [99.866708, 22.05134],
              [99.874437, 22.03885],
              [99.873613, 22.033961],
              [99.869971, 22.029468],
              [99.853087, 22.02503],
              [99.843014, 22.025454],
              [99.834588, 22.028111],
              [99.82499, 22.043145],
              [99.815361, 22.048317],
              [99.797052, 22.052244],
              [99.779472, 22.058432],
              [99.763127, 22.06787],
              [99.753022, 22.069367],
              [99.73408, 22.067022],
              [99.721441, 22.06058],
              [99.720459, 22.052047],
              [99.716658, 22.0434],
              [99.712223, 22.037013],
              [99.704146, 22.037409],
              [99.695276, 22.040772],
              [99.69043, 22.045293],
              [99.691412, 22.051736],
              [99.696163, 22.067615],
              [99.694294, 22.073209],
              [99.690493, 22.076148],
              [99.676587, 22.074961],
              [99.671202, 22.08112],
              [99.648807, 22.100583],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        adcode: 530829,
        name: "西盟佤族自治县",
        center: [99.594372, 22.644423],
        centroid: [99.510936, 22.694105],
        childrenNum: 0,
        level: "district",
        subFeatureIndex: 9,
        acroutes: [100000, 530000, 530800],
        parent: {
          adcode: 530800,
        },
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [99.498282, 22.449425],
              [99.488019, 22.448354],
              [99.482507, 22.450496],
              [99.477598, 22.455145],
              [99.474778, 22.466386],
              [99.463153, 22.469373],
              [99.457927, 22.476557],
              [99.452067, 22.475402],
              [99.439301, 22.470415],
              [99.432681, 22.472725],
              [99.42606, 22.479036],
              [99.414024, 22.474303],
              [99.404742, 22.472162],
              [99.396887, 22.480163],
              [99.385768, 22.487768],
              [99.381017, 22.49236],
              [99.381397, 22.50326],
              [99.379275, 22.50588],
              [99.367491, 22.511372],
              [99.359762, 22.520778],
              [99.359699, 22.535338],
              [99.366573, 22.543926],
              [99.36936, 22.550374],
              [99.381365, 22.566929],
              [99.38561, 22.570335],
              [99.383868, 22.586691],
              [99.371926, 22.601524],
              [99.374428, 22.608757],
              [99.368822, 22.612444],
              [99.367111, 22.620634],
              [99.367365, 22.628035],
              [99.365464, 22.628316],
              [99.363563, 22.642273],
              [99.361314, 22.644862],
              [99.359445, 22.655497],
              [99.361568, 22.66118],
              [99.352825, 22.666947],
              [99.349277, 22.675837],
              [99.346997, 22.686414],
              [99.341453, 22.697327],
              [99.339109, 22.709393],
              [99.33043, 22.713246],
              [99.325615, 22.723482],
              [99.320579, 22.725928],
              [99.314845, 22.737092],
              [99.321307, 22.739032],
              [99.324728, 22.742715],
              [99.326661, 22.751628],
              [99.331697, 22.749857],
              [99.338032, 22.752499],
              [99.344653, 22.75815],
              [99.34782, 22.756632],
              [99.360269, 22.757672],
              [99.367428, 22.764391],
              [99.37842, 22.762171],
              [99.386275, 22.762367],
              [99.389918, 22.779431],
              [99.386845, 22.787919],
              [99.391312, 22.798263],
              [99.392484, 22.806048],
              [99.388049, 22.81223],
              [99.397362, 22.815996],
              [99.396982, 22.818975],
              [99.401195, 22.826056],
              [99.411426, 22.825663],
              [99.41982, 22.827096],
              [99.424825, 22.834429],
              [99.430083, 22.834795],
              [99.440505, 22.844151],
              [99.458148, 22.846033],
              [99.462932, 22.844769],
              [99.458529, 22.854293],
              [99.454031, 22.856962],
              [99.451877, 22.862328],
              [99.451338, 22.875306],
              [99.445098, 22.885109],
              [99.443894, 22.895725],
              [99.440346, 22.902129],
              [99.441075, 22.905274],
              [99.43664, 22.913193],
              [99.440283, 22.918837],
              [99.438604, 22.928104],
              [99.446777, 22.934758],
              [99.456913, 22.932737],
              [99.475697, 22.922712],
              [99.489254, 22.912323],
              [99.50598, 22.902831],
              [99.531447, 22.897101],
              [99.539556, 22.89932],
              [99.554444, 22.907099],
              [99.565024, 22.902016],
              [99.585202, 22.898478],
              [99.59651, 22.897944],
              [99.605094, 22.895557],
              [99.614122, 22.903617],
              [99.627965, 22.906229],
              [99.635662, 22.910525],
              [99.638956, 22.906706],
              [99.63997, 22.891737],
              [99.63639, 22.886429],
              [99.626761, 22.878087],
              [99.62315, 22.873283],
              [99.622041, 22.867946],
              [99.621408, 22.850697],
              [99.625747, 22.840021],
              [99.636422, 22.835694],
              [99.638861, 22.832884],
              [99.641554, 22.823499],
              [99.649504, 22.820689],
              [99.658595, 22.827011],
              [99.666039, 22.840189],
              [99.674275, 22.840414],
              [99.678076, 22.83738],
              [99.676968, 22.833867],
              [99.688751, 22.806694],
              [99.687896, 22.8029],
              [99.680737, 22.79177],
              [99.674402, 22.785362],
              [99.655586, 22.780246],
              [99.644436, 22.785896],
              [99.636834, 22.787329],
              [99.621408, 22.784603],
              [99.621376, 22.76962],
              [99.634965, 22.767203],
              [99.639526, 22.762761],
              [99.643771, 22.752556],
              [99.64754, 22.746933],
              [99.647414, 22.743362],
              [99.641902, 22.740522],
              [99.62806, 22.739341],
              [99.625937, 22.735236],
              [99.627965, 22.73144],
              [99.627363, 22.715467],
              [99.655269, 22.713049],
              [99.666419, 22.714455],
              [99.674909, 22.708605],
              [99.675004, 22.70253],
              [99.679755, 22.684388],
              [99.686439, 22.673896],
              [99.708707, 22.658704],
              [99.716088, 22.649139],
              [99.714377, 22.636955],
              [99.710259, 22.629245],
              [99.705476, 22.624236],
              [99.691982, 22.614808],
              [99.678171, 22.601215],
              [99.66946, 22.596289],
              [99.661288, 22.595529],
              [99.651785, 22.58137],
              [99.625367, 22.5698],
              [99.624005, 22.567492],
              [99.62372, 22.553471],
              [99.619127, 22.55074],
              [99.6139, 22.558595],
              [99.60047, 22.56797],
              [99.586532, 22.566563],
              [99.587704, 22.575881],
              [99.579247, 22.575909],
              [99.576712, 22.570617],
              [99.577378, 22.562143],
              [99.571423, 22.557272],
              [99.568857, 22.544348],
              [99.560146, 22.537196],
              [99.556503, 22.532324],
              [99.548964, 22.530663],
              [99.546652, 22.525172],
              [99.534583, 22.523116],
              [99.526347, 22.518723],
              [99.517446, 22.507091],
              [99.516939, 22.4965],
              [99.50655, 22.488726],
              [99.503477, 22.483515],
              [99.505504, 22.473655],
              [99.498757, 22.469288],
              [99.502527, 22.464302],
              [99.499391, 22.46109],
              [99.496762, 22.450411],
              [99.498282, 22.449425],
            ],
          ],
        ],
      },
    },
  ],
}
